var k7 = (l) => {
  throw TypeError(l);
};
var ut = (l, e, t) => e.has(l) || k7("Cannot " + t);
var k5 = (l, e, t) => (ut(l, e, "read from private field"), t ? t.call(l) : e.get(l)), O7 = (l, e, t) => e.has(l) ? k7("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(l) : e.set(l, t);
import { defineComponent as q, ref as I, computed as k, mergeModels as c5, useModel as H5, useTemplateRef as R5, createBlock as F, openBlock as B, resolveDynamicComponent as S5, normalizeClass as Y, unref as _, withCtx as T, createCommentVNode as $, renderSlot as L, withDirectives as B3, createElementVNode as U, vModelText as vt, createElementBlock as R, createTextVNode as a5, toDisplayString as Q, Fragment as p5, createVNode as X, renderList as J5, watch as r5, createSlots as N5, toRaw as pt, nextTick as q2, toValue as s5, onBeforeUnmount as G1, normalizeStyle as F5, Transition as d7, withKeys as ht, normalizeProps as h0, guardReactiveProps as f0, mergeProps as X1, resolveComponent as p1, toHandlers as ft, withModifiers as z3, TransitionGroup as mt, readonly as wt, Teleport as gt, vModelCheckbox as bt, shallowRef as C3, shallowReadonly as t1, getCurrentScope as L3, onScopeDispose as S3, getCurrentInstance as Mt, onMounted as xt, inject as E3, reactive as T3, provide as yt, isRef as At } from "vue";
function Vt(l) {
  return l.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const $7 = (l) => l.toLowerCase().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), ""), Ht = (l, e) => [...l.matchAll(new RegExp(Vt(e), "gi"))].length > 0, V1 = (l, e) => Ht(l, e), Bt = (l, e) => e ? l.filter(
  (t) => V1($7(t.label || ""), e) || V1($7(t.detail || ""), e) || V1(t.label || "", e) || V1(t.detail || "", e)
) : l, s1 = Math.min, P5 = Math.max, k1 = Math.round, H1 = Math.floor, V5 = (l) => ({
  x: l,
  y: l
}), zt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ct = {
  start: "end",
  end: "start"
};
function P2(l, e, t) {
  return P5(l, s1(e, t));
}
function G5(l, e) {
  return typeof l == "function" ? l(e) : l;
}
function D5(l) {
  return l.split("-")[0];
}
function g1(l) {
  return l.split("-")[1];
}
function c7(l) {
  return l === "x" ? "y" : "x";
}
function u7(l) {
  return l === "y" ? "height" : "width";
}
function X5(l) {
  return ["top", "bottom"].includes(D5(l)) ? "y" : "x";
}
function v7(l) {
  return c7(X5(l));
}
function Lt(l, e, t) {
  t === void 0 && (t = !1);
  const a = g1(l), r = v7(l), o = u7(r);
  let i = r === "x" ? a === (t ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (i = O1(i)), [i, O1(i)];
}
function St(l) {
  const e = O1(l);
  return [U2(l), e, U2(e)];
}
function U2(l) {
  return l.replace(/start|end/g, (e) => Ct[e]);
}
function Et(l, e, t) {
  const a = ["left", "right"], r = ["right", "left"], o = ["top", "bottom"], i = ["bottom", "top"];
  switch (l) {
    case "top":
    case "bottom":
      return t ? e ? r : a : e ? a : r;
    case "left":
    case "right":
      return e ? o : i;
    default:
      return [];
  }
}
function Tt(l, e, t, a) {
  const r = g1(l);
  let o = Et(D5(l), t === "start", a);
  return r && (o = o.map((i) => i + "-" + r), e && (o = o.concat(o.map(U2)))), o;
}
function O1(l) {
  return l.replace(/left|right|bottom|top/g, (e) => zt[e]);
}
function _t(l) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...l
  };
}
function _3(l) {
  return typeof l != "number" ? _t(l) : {
    top: l,
    right: l,
    bottom: l,
    left: l
  };
}
function $1(l) {
  const {
    x: e,
    y: t,
    width: a,
    height: r
  } = l;
  return {
    width: a,
    height: r,
    top: t,
    left: e,
    right: e + a,
    bottom: t + r,
    x: e,
    y: t
  };
}
function N7(l, e, t) {
  let {
    reference: a,
    floating: r
  } = l;
  const o = X5(e), i = v7(e), c = u7(i), v = D5(e), u = o === "y", h = a.x + a.width / 2 - r.width / 2, p = a.y + a.height / 2 - r.height / 2, m = a[c] / 2 - r[c] / 2;
  let g;
  switch (v) {
    case "top":
      g = {
        x: h,
        y: a.y - r.height
      };
      break;
    case "bottom":
      g = {
        x: h,
        y: a.y + a.height
      };
      break;
    case "right":
      g = {
        x: a.x + a.width,
        y: p
      };
      break;
    case "left":
      g = {
        x: a.x - r.width,
        y: p
      };
      break;
    default:
      g = {
        x: a.x,
        y: a.y
      };
  }
  switch (g1(e)) {
    case "start":
      g[i] -= m * (t && u ? -1 : 1);
      break;
    case "end":
      g[i] += m * (t && u ? -1 : 1);
      break;
  }
  return g;
}
const Rt = async (l, e, t) => {
  const {
    placement: a = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: i
  } = t, c = o.filter(Boolean), v = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let u = await i.getElementRects({
    reference: l,
    floating: e,
    strategy: r
  }), {
    x: h,
    y: p
  } = N7(u, a, v), m = a, g = {}, w = 0;
  for (let x = 0; x < c.length; x++) {
    const {
      name: f,
      fn: M
    } = c[x], {
      x: V,
      y: C,
      data: S,
      reset: A
    } = await M({
      x: h,
      y: p,
      initialPlacement: a,
      placement: m,
      strategy: r,
      middlewareData: g,
      rects: u,
      platform: i,
      elements: {
        reference: l,
        floating: e
      }
    });
    h = V ?? h, p = C ?? p, g = {
      ...g,
      [f]: {
        ...g[f],
        ...S
      }
    }, A && w <= 50 && (w++, typeof A == "object" && (A.placement && (m = A.placement), A.rects && (u = A.rects === !0 ? await i.getElementRects({
      reference: l,
      floating: e,
      strategy: r
    }) : A.rects), {
      x: h,
      y: p
    } = N7(u, m, v)), x = -1);
  }
  return {
    x: h,
    y: p,
    placement: m,
    strategy: r,
    middlewareData: g
  };
};
async function R3(l, e) {
  var t;
  e === void 0 && (e = {});
  const {
    x: a,
    y: r,
    platform: o,
    rects: i,
    elements: c,
    strategy: v
  } = l, {
    boundary: u = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: p = "floating",
    altBoundary: m = !1,
    padding: g = 0
  } = G5(e, l), w = _3(g), x = c[m ? p === "floating" ? "reference" : "floating" : p], f = $1(await o.getClippingRect({
    element: (t = await (o.isElement == null ? void 0 : o.isElement(x))) == null || t ? x : x.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(c.floating)),
    boundary: u,
    rootBoundary: h,
    strategy: v
  })), M = p === "floating" ? {
    x: a,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, V = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c.floating)), C = await (o.isElement == null ? void 0 : o.isElement(V)) ? await (o.getScale == null ? void 0 : o.getScale(V)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = $1(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: M,
    offsetParent: V,
    strategy: v
  }) : M);
  return {
    top: (f.top - S.top + w.top) / C.y,
    bottom: (S.bottom - f.bottom + w.bottom) / C.y,
    left: (f.left - S.left + w.left) / C.x,
    right: (S.right - f.right + w.right) / C.x
  };
}
const kt = (l) => ({
  name: "arrow",
  options: l,
  async fn(e) {
    const {
      x: t,
      y: a,
      placement: r,
      rects: o,
      platform: i,
      elements: c,
      middlewareData: v
    } = e, {
      element: u,
      padding: h = 0
    } = G5(l, e) || {};
    if (u == null)
      return {};
    const p = _3(h), m = {
      x: t,
      y: a
    }, g = v7(r), w = u7(g), x = await i.getDimensions(u), f = g === "y", M = f ? "top" : "left", V = f ? "bottom" : "right", C = f ? "clientHeight" : "clientWidth", S = o.reference[w] + o.reference[g] - m[g] - o.floating[w], A = m[g] - o.reference[g], y = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let E = y ? y[C] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(y))) && (E = c.floating[C] || o.floating[w]);
    const H = S / 2 - A / 2, j = E / 2 - x[w] / 2 - 1, Z = s1(p[M], j), K = s1(p[V], j), J = Z, z = E - x[w] - K, O = E / 2 - x[w] / 2 + H, D = P2(J, O, z), P = !v.arrow && g1(r) != null && O !== D && o.reference[w] / 2 - (O < J ? Z : K) - x[w] / 2 < 0, G = P ? O < J ? O - J : O - z : 0;
    return {
      [g]: m[g] + G,
      data: {
        [g]: D,
        centerOffset: O - D - G,
        ...P && {
          alignmentOffset: G
        }
      },
      reset: P
    };
  }
}), Ot = function(l) {
  return l === void 0 && (l = {}), {
    name: "flip",
    options: l,
    async fn(e) {
      var t, a;
      const {
        placement: r,
        middlewareData: o,
        rects: i,
        initialPlacement: c,
        platform: v,
        elements: u
      } = e, {
        mainAxis: h = !0,
        crossAxis: p = !0,
        fallbackPlacements: m,
        fallbackStrategy: g = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: x = !0,
        ...f
      } = G5(l, e);
      if ((t = o.arrow) != null && t.alignmentOffset)
        return {};
      const M = D5(r), V = X5(c), C = D5(c) === c, S = await (v.isRTL == null ? void 0 : v.isRTL(u.floating)), A = m || (C || !x ? [O1(c)] : St(c)), y = w !== "none";
      !m && y && A.push(...Tt(c, x, w, S));
      const E = [c, ...A], H = await R3(e, f), j = [];
      let Z = ((a = o.flip) == null ? void 0 : a.overflows) || [];
      if (h && j.push(H[M]), p) {
        const O = Lt(r, i, S);
        j.push(H[O[0]], H[O[1]]);
      }
      if (Z = [...Z, {
        placement: r,
        overflows: j
      }], !j.every((O) => O <= 0)) {
        var K, J;
        const O = (((K = o.flip) == null ? void 0 : K.index) || 0) + 1, D = E[O];
        if (D)
          return {
            data: {
              index: O,
              overflows: Z
            },
            reset: {
              placement: D
            }
          };
        let P = (J = Z.filter((G) => G.overflows[0] <= 0).sort((G, e5) => G.overflows[1] - e5.overflows[1])[0]) == null ? void 0 : J.placement;
        if (!P)
          switch (g) {
            case "bestFit": {
              var z;
              const G = (z = Z.filter((e5) => {
                if (y) {
                  const f5 = X5(e5.placement);
                  return f5 === V || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  f5 === "y";
                }
                return !0;
              }).map((e5) => [e5.placement, e5.overflows.filter((f5) => f5 > 0).reduce((f5, A1) => f5 + A1, 0)]).sort((e5, f5) => e5[1] - f5[1])[0]) == null ? void 0 : z[0];
              G && (P = G);
              break;
            }
            case "initialPlacement":
              P = c;
              break;
          }
        if (r !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
};
async function $t(l, e) {
  const {
    placement: t,
    platform: a,
    elements: r
  } = l, o = await (a.isRTL == null ? void 0 : a.isRTL(r.floating)), i = D5(t), c = g1(t), v = X5(t) === "y", u = ["left", "top"].includes(i) ? -1 : 1, h = o && v ? -1 : 1, p = G5(e, l);
  let {
    mainAxis: m,
    crossAxis: g,
    alignmentAxis: w
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return c && typeof w == "number" && (g = c === "end" ? w * -1 : w), v ? {
    x: g * h,
    y: m * u
  } : {
    x: m * u,
    y: g * h
  };
}
const Nt = function(l) {
  return l === void 0 && (l = 0), {
    name: "offset",
    options: l,
    async fn(e) {
      var t, a;
      const {
        x: r,
        y: o,
        placement: i,
        middlewareData: c
      } = e, v = await $t(e, l);
      return i === ((t = c.offset) == null ? void 0 : t.placement) && (a = c.arrow) != null && a.alignmentOffset ? {} : {
        x: r + v.x,
        y: o + v.y,
        data: {
          ...v,
          placement: i
        }
      };
    }
  };
}, Ft = function(l) {
  return l === void 0 && (l = {}), {
    name: "shift",
    options: l,
    async fn(e) {
      const {
        x: t,
        y: a,
        placement: r
      } = e, {
        mainAxis: o = !0,
        crossAxis: i = !1,
        limiter: c = {
          fn: (f) => {
            let {
              x: M,
              y: V
            } = f;
            return {
              x: M,
              y: V
            };
          }
        },
        ...v
      } = G5(l, e), u = {
        x: t,
        y: a
      }, h = await R3(e, v), p = X5(D5(r)), m = c7(p);
      let g = u[m], w = u[p];
      if (o) {
        const f = m === "y" ? "top" : "left", M = m === "y" ? "bottom" : "right", V = g + h[f], C = g - h[M];
        g = P2(V, g, C);
      }
      if (i) {
        const f = p === "y" ? "top" : "left", M = p === "y" ? "bottom" : "right", V = w + h[f], C = w - h[M];
        w = P2(V, w, C);
      }
      const x = c.fn({
        ...e,
        [m]: g,
        [p]: w
      });
      return {
        ...x,
        data: {
          x: x.x - t,
          y: x.y - a,
          enabled: {
            [m]: o,
            [p]: i
          }
        }
      };
    }
  };
}, Dt = function(l) {
  return l === void 0 && (l = {}), {
    options: l,
    fn(e) {
      const {
        x: t,
        y: a,
        placement: r,
        rects: o,
        middlewareData: i
      } = e, {
        offset: c = 0,
        mainAxis: v = !0,
        crossAxis: u = !0
      } = G5(l, e), h = {
        x: t,
        y: a
      }, p = X5(r), m = c7(p);
      let g = h[m], w = h[p];
      const x = G5(c, e), f = typeof x == "number" ? {
        mainAxis: x,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...x
      };
      if (v) {
        const C = m === "y" ? "height" : "width", S = o.reference[m] - o.floating[C] + f.mainAxis, A = o.reference[m] + o.reference[C] - f.mainAxis;
        g < S ? g = S : g > A && (g = A);
      }
      if (u) {
        var M, V;
        const C = m === "y" ? "width" : "height", S = ["top", "left"].includes(D5(r)), A = o.reference[p] - o.floating[C] + (S && ((M = i.offset) == null ? void 0 : M[p]) || 0) + (S ? 0 : f.crossAxis), y = o.reference[p] + o.reference[C] + (S ? 0 : ((V = i.offset) == null ? void 0 : V[p]) || 0) - (S ? f.crossAxis : 0);
        w < A ? w = A : w > y && (w = y);
      }
      return {
        [m]: g,
        [p]: w
      };
    }
  };
};
function Y1() {
  return typeof window < "u";
}
function e1(l) {
  return p7(l) ? (l.nodeName || "").toLowerCase() : "#document";
}
function d5(l) {
  var e;
  return (l == null || (e = l.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function C5(l) {
  var e;
  return (e = (p7(l) ? l.ownerDocument : l.document) || window.document) == null ? void 0 : e.documentElement;
}
function p7(l) {
  return Y1() ? l instanceof Node || l instanceof d5(l).Node : !1;
}
function b5(l) {
  return Y1() ? l instanceof Element || l instanceof d5(l).Element : !1;
}
function B5(l) {
  return Y1() ? l instanceof HTMLElement || l instanceof d5(l).HTMLElement : !1;
}
function F7(l) {
  return !Y1() || typeof ShadowRoot > "u" ? !1 : l instanceof ShadowRoot || l instanceof d5(l).ShadowRoot;
}
function b1(l) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: a,
    display: r
  } = M5(l);
  return /auto|scroll|overlay|hidden|clip/.test(e + a + t) && !["inline", "contents"].includes(r);
}
function It(l) {
  return ["table", "td", "th"].includes(e1(l));
}
function Q1(l) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return l.matches(e);
    } catch {
      return !1;
    }
  });
}
function h7(l) {
  const e = f7(), t = b5(l) ? M5(l) : l;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((a) => t[a] ? t[a] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !e && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !e && (t.filter ? t.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((a) => (t.willChange || "").includes(a)) || ["paint", "layout", "strict", "content"].some((a) => (t.contain || "").includes(a));
}
function jt(l) {
  let e = I5(l);
  for (; B5(e) && !d1(e); ) {
    if (h7(e))
      return e;
    if (Q1(e))
      return null;
    e = I5(e);
  }
  return null;
}
function f7() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function d1(l) {
  return ["html", "body", "#document"].includes(e1(l));
}
function M5(l) {
  return d5(l).getComputedStyle(l);
}
function e0(l) {
  return b5(l) ? {
    scrollLeft: l.scrollLeft,
    scrollTop: l.scrollTop
  } : {
    scrollLeft: l.scrollX,
    scrollTop: l.scrollY
  };
}
function I5(l) {
  if (e1(l) === "html")
    return l;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    l.assignedSlot || // DOM Element detected.
    l.parentNode || // ShadowRoot detected.
    F7(l) && l.host || // Fallback.
    C5(l)
  );
  return F7(e) ? e.host : e;
}
function k3(l) {
  const e = I5(l);
  return d1(e) ? l.ownerDocument ? l.ownerDocument.body : l.body : B5(e) && b1(e) ? e : k3(e);
}
function h1(l, e, t) {
  var a;
  e === void 0 && (e = []), t === void 0 && (t = !0);
  const r = k3(l), o = r === ((a = l.ownerDocument) == null ? void 0 : a.body), i = d5(r);
  if (o) {
    const c = Z2(i);
    return e.concat(i, i.visualViewport || [], b1(r) ? r : [], c && t ? h1(c) : []);
  }
  return e.concat(r, h1(r, [], t));
}
function Z2(l) {
  return l.parent && Object.getPrototypeOf(l.parent) ? l.frameElement : null;
}
function O3(l) {
  const e = M5(l);
  let t = parseFloat(e.width) || 0, a = parseFloat(e.height) || 0;
  const r = B5(l), o = r ? l.offsetWidth : t, i = r ? l.offsetHeight : a, c = k1(t) !== o || k1(a) !== i;
  return c && (t = o, a = i), {
    width: t,
    height: a,
    $: c
  };
}
function m7(l) {
  return b5(l) ? l : l.contextElement;
}
function o1(l) {
  const e = m7(l);
  if (!B5(e))
    return V5(1);
  const t = e.getBoundingClientRect(), {
    width: a,
    height: r,
    $: o
  } = O3(e);
  let i = (o ? k1(t.width) : t.width) / a, c = (o ? k1(t.height) : t.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: i,
    y: c
  };
}
const qt = /* @__PURE__ */ V5(0);
function $3(l) {
  const e = d5(l);
  return !f7() || !e.visualViewport ? qt : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Pt(l, e, t) {
  return e === void 0 && (e = !1), !t || e && t !== d5(l) ? !1 : e;
}
function Y5(l, e, t, a) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  const r = l.getBoundingClientRect(), o = m7(l);
  let i = V5(1);
  e && (a ? b5(a) && (i = o1(a)) : i = o1(l));
  const c = Pt(o, t, a) ? $3(o) : V5(0);
  let v = (r.left + c.x) / i.x, u = (r.top + c.y) / i.y, h = r.width / i.x, p = r.height / i.y;
  if (o) {
    const m = d5(o), g = a && b5(a) ? d5(a) : a;
    let w = m, x = Z2(w);
    for (; x && a && g !== w; ) {
      const f = o1(x), M = x.getBoundingClientRect(), V = M5(x), C = M.left + (x.clientLeft + parseFloat(V.paddingLeft)) * f.x, S = M.top + (x.clientTop + parseFloat(V.paddingTop)) * f.y;
      v *= f.x, u *= f.y, h *= f.x, p *= f.y, v += C, u += S, w = d5(x), x = Z2(w);
    }
  }
  return $1({
    width: h,
    height: p,
    x: v,
    y: u
  });
}
function w7(l, e) {
  const t = e0(l).scrollLeft;
  return e ? e.left + t : Y5(C5(l)).left + t;
}
function N3(l, e, t) {
  t === void 0 && (t = !1);
  const a = l.getBoundingClientRect(), r = a.left + e.scrollLeft - (t ? 0 : (
    // RTL <body> scrollbar.
    w7(l, a)
  )), o = a.top + e.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Ut(l) {
  let {
    elements: e,
    rect: t,
    offsetParent: a,
    strategy: r
  } = l;
  const o = r === "fixed", i = C5(a), c = e ? Q1(e.floating) : !1;
  if (a === i || c && o)
    return t;
  let v = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = V5(1);
  const h = V5(0), p = B5(a);
  if ((p || !p && !o) && ((e1(a) !== "body" || b1(i)) && (v = e0(a)), B5(a))) {
    const g = Y5(a);
    u = o1(a), h.x = g.x + a.clientLeft, h.y = g.y + a.clientTop;
  }
  const m = i && !p && !o ? N3(i, v, !0) : V5(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - v.scrollLeft * u.x + h.x + m.x,
    y: t.y * u.y - v.scrollTop * u.y + h.y + m.y
  };
}
function Zt(l) {
  return Array.from(l.getClientRects());
}
function Wt(l) {
  const e = C5(l), t = e0(l), a = l.ownerDocument.body, r = P5(e.scrollWidth, e.clientWidth, a.scrollWidth, a.clientWidth), o = P5(e.scrollHeight, e.clientHeight, a.scrollHeight, a.clientHeight);
  let i = -t.scrollLeft + w7(l);
  const c = -t.scrollTop;
  return M5(a).direction === "rtl" && (i += P5(e.clientWidth, a.clientWidth) - r), {
    width: r,
    height: o,
    x: i,
    y: c
  };
}
function Kt(l, e) {
  const t = d5(l), a = C5(l), r = t.visualViewport;
  let o = a.clientWidth, i = a.clientHeight, c = 0, v = 0;
  if (r) {
    o = r.width, i = r.height;
    const u = f7();
    (!u || u && e === "fixed") && (c = r.offsetLeft, v = r.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: c,
    y: v
  };
}
function Jt(l, e) {
  const t = Y5(l, !0, e === "fixed"), a = t.top + l.clientTop, r = t.left + l.clientLeft, o = B5(l) ? o1(l) : V5(1), i = l.clientWidth * o.x, c = l.clientHeight * o.y, v = r * o.x, u = a * o.y;
  return {
    width: i,
    height: c,
    x: v,
    y: u
  };
}
function D7(l, e, t) {
  let a;
  if (e === "viewport")
    a = Kt(l, t);
  else if (e === "document")
    a = Wt(C5(l));
  else if (b5(e))
    a = Jt(e, t);
  else {
    const r = $3(l);
    a = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return $1(a);
}
function F3(l, e) {
  const t = I5(l);
  return t === e || !b5(t) || d1(t) ? !1 : M5(t).position === "fixed" || F3(t, e);
}
function Gt(l, e) {
  const t = e.get(l);
  if (t)
    return t;
  let a = h1(l, [], !1).filter((c) => b5(c) && e1(c) !== "body"), r = null;
  const o = M5(l).position === "fixed";
  let i = o ? I5(l) : l;
  for (; b5(i) && !d1(i); ) {
    const c = M5(i), v = h7(i);
    !v && c.position === "fixed" && (r = null), (o ? !v && !r : !v && c.position === "static" && r && ["absolute", "fixed"].includes(r.position) || b1(i) && !v && F3(l, i)) ? a = a.filter((u) => u !== i) : r = c, i = I5(i);
  }
  return e.set(l, a), a;
}
function Xt(l) {
  let {
    element: e,
    boundary: t,
    rootBoundary: a,
    strategy: r
  } = l;
  const o = [...t === "clippingAncestors" ? Q1(e) ? [] : Gt(e, this._c) : [].concat(t), a], i = o[0], c = o.reduce((v, u) => {
    const h = D7(e, u, r);
    return v.top = P5(h.top, v.top), v.right = s1(h.right, v.right), v.bottom = s1(h.bottom, v.bottom), v.left = P5(h.left, v.left), v;
  }, D7(e, i, r));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Yt(l) {
  const {
    width: e,
    height: t
  } = O3(l);
  return {
    width: e,
    height: t
  };
}
function Qt(l, e, t) {
  const a = B5(e), r = C5(e), o = t === "fixed", i = Y5(l, !0, o, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const v = V5(0);
  if (a || !a && !o)
    if ((e1(e) !== "body" || b1(r)) && (c = e0(e)), a) {
      const m = Y5(e, !0, o, e);
      v.x = m.x + e.clientLeft, v.y = m.y + e.clientTop;
    } else r && (v.x = w7(r));
  const u = r && !a && !o ? N3(r, c) : V5(0), h = i.left + c.scrollLeft - v.x - u.x, p = i.top + c.scrollTop - v.y - u.y;
  return {
    x: h,
    y: p,
    width: i.width,
    height: i.height
  };
}
function m0(l) {
  return M5(l).position === "static";
}
function I7(l, e) {
  if (!B5(l) || M5(l).position === "fixed")
    return null;
  if (e)
    return e(l);
  let t = l.offsetParent;
  return C5(l) === t && (t = t.ownerDocument.body), t;
}
function D3(l, e) {
  const t = d5(l);
  if (Q1(l))
    return t;
  if (!B5(l)) {
    let r = I5(l);
    for (; r && !d1(r); ) {
      if (b5(r) && !m0(r))
        return r;
      r = I5(r);
    }
    return t;
  }
  let a = I7(l, e);
  for (; a && It(a) && m0(a); )
    a = I7(a, e);
  return a && d1(a) && m0(a) && !h7(a) ? t : a || jt(l) || t;
}
const en = async function(l) {
  const e = this.getOffsetParent || D3, t = this.getDimensions, a = await t(l.floating);
  return {
    reference: Qt(l.reference, await e(l.floating), l.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function ln(l) {
  return M5(l).direction === "rtl";
}
const tn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ut,
  getDocumentElement: C5,
  getClippingRect: Xt,
  getOffsetParent: D3,
  getElementRects: en,
  getClientRects: Zt,
  getDimensions: Yt,
  getScale: o1,
  isElement: b5,
  isRTL: ln
};
function I3(l, e) {
  return l.x === e.x && l.y === e.y && l.width === e.width && l.height === e.height;
}
function nn(l, e) {
  let t = null, a;
  const r = C5(l);
  function o() {
    var c;
    clearTimeout(a), (c = t) == null || c.disconnect(), t = null;
  }
  function i(c, v) {
    c === void 0 && (c = !1), v === void 0 && (v = 1), o();
    const u = l.getBoundingClientRect(), {
      left: h,
      top: p,
      width: m,
      height: g
    } = u;
    if (c || e(), !m || !g)
      return;
    const w = H1(p), x = H1(r.clientWidth - (h + m)), f = H1(r.clientHeight - (p + g)), M = H1(h), V = {
      rootMargin: -w + "px " + -x + "px " + -f + "px " + -M + "px",
      threshold: P5(0, s1(1, v)) || 1
    };
    let C = !0;
    function S(A) {
      const y = A[0].intersectionRatio;
      if (y !== v) {
        if (!C)
          return i();
        y ? i(!1, y) : a = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      y === 1 && !I3(u, l.getBoundingClientRect()) && i(), C = !1;
    }
    try {
      t = new IntersectionObserver(S, {
        ...V,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(S, V);
    }
    t.observe(l);
  }
  return i(!0), o;
}
function j3(l, e, t, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: v = !1
  } = a, u = m7(l), h = r || o ? [...u ? h1(u) : [], ...h1(e)] : [];
  h.forEach((M) => {
    r && M.addEventListener("scroll", t, {
      passive: !0
    }), o && M.addEventListener("resize", t);
  });
  const p = u && c ? nn(u, t) : null;
  let m = -1, g = null;
  i && (g = new ResizeObserver((M) => {
    let [V] = M;
    V && V.target === u && g && (g.unobserve(e), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var C;
      (C = g) == null || C.observe(e);
    })), t();
  }), u && !v && g.observe(u), g.observe(e));
  let w, x = v ? Y5(l) : null;
  v && f();
  function f() {
    const M = Y5(l);
    x && !I3(x, M) && t(), x = M, w = requestAnimationFrame(f);
  }
  return t(), () => {
    var M;
    h.forEach((V) => {
      r && V.removeEventListener("scroll", t), o && V.removeEventListener("resize", t);
    }), p == null || p(), (M = g) == null || M.disconnect(), g = null, v && cancelAnimationFrame(w);
  };
}
const an = Nt, q3 = Ft, rn = Ot, on = kt, sn = Dt, dn = (l, e, t) => {
  const a = /* @__PURE__ */ new Map(), r = {
    platform: tn,
    ...t
  }, o = {
    ...r.platform,
    _c: a
  };
  return Rt(l, e, {
    ...r,
    platform: o
  });
};
function cn(l) {
  return l != null && typeof l == "object" && "$el" in l;
}
function W2(l) {
  if (cn(l)) {
    const e = l.$el;
    return p7(e) && e1(e) === "#comment" ? null : e;
  }
  return l;
}
function n1(l) {
  return typeof l == "function" ? l() : _(l);
}
function un(l) {
  return {
    name: "arrow",
    options: l,
    fn(e) {
      const t = W2(n1(l.element));
      return t == null ? {} : on({
        element: t,
        padding: l.padding
      }).fn(e);
    }
  };
}
function P3(l) {
  return typeof window > "u" ? 1 : (l.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function j7(l, e) {
  const t = P3(l);
  return Math.round(e * t) / t;
}
function U3(l, e, t) {
  t === void 0 && (t = {});
  const a = t.whileElementsMounted, r = k(() => {
    var E;
    return (E = n1(t.open)) != null ? E : !0;
  }), o = k(() => n1(t.middleware)), i = k(() => {
    var E;
    return (E = n1(t.placement)) != null ? E : "bottom";
  }), c = k(() => {
    var E;
    return (E = n1(t.strategy)) != null ? E : "absolute";
  }), v = k(() => {
    var E;
    return (E = n1(t.transform)) != null ? E : !0;
  }), u = k(() => W2(l.value)), h = k(() => W2(e.value)), p = I(0), m = I(0), g = I(c.value), w = I(i.value), x = C3({}), f = I(!1), M = k(() => {
    const E = {
      position: g.value,
      left: "0",
      top: "0"
    };
    if (!h.value)
      return E;
    const H = j7(h.value, p.value), j = j7(h.value, m.value);
    return v.value ? {
      ...E,
      transform: "translate(" + H + "px, " + j + "px)",
      ...P3(h.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: g.value,
      left: H + "px",
      top: j + "px"
    };
  });
  let V;
  function C() {
    if (u.value == null || h.value == null)
      return;
    const E = r.value;
    dn(u.value, h.value, {
      middleware: o.value,
      placement: i.value,
      strategy: c.value
    }).then((H) => {
      p.value = H.x, m.value = H.y, g.value = H.strategy, w.value = H.placement, x.value = H.middlewareData, f.value = E !== !1;
    });
  }
  function S() {
    typeof V == "function" && (V(), V = void 0);
  }
  function A() {
    if (S(), a === void 0) {
      C();
      return;
    }
    if (u.value != null && h.value != null) {
      V = a(u.value, h.value, C);
      return;
    }
  }
  function y() {
    r.value || (f.value = !1);
  }
  return r5([o, i, c, r], C, {
    flush: "sync"
  }), r5([u, h], A, {
    flush: "sync"
  }), r5(r, y, {
    flush: "sync"
  }), L3() && S3(S), {
    x: t1(p),
    y: t1(m),
    strategy: t1(g),
    placement: t1(w),
    middlewareData: t1(x),
    isPositioned: t1(f),
    floatingStyles: M,
    update: C
  };
}
function Z3(l) {
  return L3() ? (S3(l), !0) : !1;
}
const vn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const pn = Object.prototype.toString, hn = (l) => pn.call(l) === "[object Object]";
function w0(l) {
  return Array.isArray(l) ? l : [l];
}
function fn(l, e, t) {
  return r5(
    l,
    e,
    {
      ...t,
      immediate: !0
    }
  );
}
const W3 = vn ? window : void 0;
function K2(l) {
  var e;
  const t = s5(l);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
function mn(...l) {
  const e = [], t = () => {
    e.forEach((c) => c()), e.length = 0;
  }, a = (c, v, u, h) => (c.addEventListener(v, u, h), () => c.removeEventListener(v, u, h)), r = k(() => {
    const c = w0(s5(l[0])).filter((v) => v != null);
    return c.every((v) => typeof v != "string") ? c : void 0;
  }), o = fn(
    () => {
      var c, v;
      return [
        (v = (c = r.value) == null ? void 0 : c.map((u) => K2(u))) != null ? v : [W3].filter((u) => u != null),
        w0(s5(r.value ? l[1] : l[0])),
        w0(_(r.value ? l[2] : l[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        s5(r.value ? l[3] : l[2])
      ];
    },
    ([c, v, u, h]) => {
      if (t(), !(c != null && c.length) || !(v != null && v.length) || !(u != null && u.length))
        return;
      const p = hn(h) ? { ...h } : h;
      e.push(
        ...c.flatMap(
          (m) => v.flatMap(
            (g) => u.map((w) => a(m, g, w, p))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    o(), t();
  };
  return Z3(t), i;
}
function wn() {
  const l = C3(!1), e = Mt();
  return e && xt(() => {
    l.value = !0;
  }, e), l;
}
function gn(l) {
  const e = wn();
  return k(() => (e.value, !!l()));
}
function K3(l, e, t = {}) {
  const { window: a = W3, ...r } = t;
  let o;
  const i = gn(() => a && "ResizeObserver" in a), c = () => {
    o && (o.disconnect(), o = void 0);
  }, v = k(() => {
    const p = s5(l);
    return Array.isArray(p) ? p.map((m) => K2(m)) : [K2(p)];
  }), u = r5(
    v,
    (p) => {
      if (c(), i.value && a) {
        o = new ResizeObserver(e);
        for (const m of p)
          m && o.observe(m, r);
      }
    },
    { immediate: !0, flush: "post" }
  ), h = () => {
    c(), u();
  };
  return Z3(h), {
    isSupported: i,
    stop: h
  };
}
const bn = (l, e) => {
  const t = I(), a = (i) => {
    if (!i.target) {
      console.warn("Target de l'évènement body click introuvable.");
      return;
    }
    const c = i.target;
    l.every((v) => {
      var u;
      return !((u = v.value) != null && u.contains(c));
    }) && e();
  }, r = () => {
    setTimeout(() => {
      t.value || (t.value = mn(document.body, ["click", "touchestart"], a));
    }, 0);
  }, o = () => {
    var i;
    (i = t.value) == null || i.call(t), t.value = void 0;
  };
  return G1(() => {
    o();
  }), { observe: r, stopObserve: o };
};
function J2(l) {
  return `${l}px`;
}
const Mn = (l, e, t, a) => {
  const r = () => {
    l.value || (l.value = !0);
  }, o = () => {
    l.value && (l.value = !1);
  }, i = () => {
    l.value = !l.value;
  }, c = U3(t, a, {
    open: l,
    placement: e,
    middleware: [
      // https://floating-ui.com/docs/flip#flip
      rn(),
      // https://floating-ui.com/docs/shift#shift
      q3({
        limiter: sn()
      })
    ],
    // https://floating-ui.com/docs/autoupdate#autoupdate
    whileElementsMounted: j3
  });
  return {
    style: c.floatingStyles,
    placement: c.placement,
    isPositioned: c.isPositioned,
    open: r,
    close: o,
    toggle: i
  };
}, xn = (l, e) => {
  const t = I();
  let a;
  const r = () => {
    a || (a = K3(e, ([{ target: i }]) => {
      t.value = J2(i.getBoundingClientRect().width);
    }));
  }, o = () => {
    a && (a.stop(), a = void 0, t.value = void 0);
  };
  return r5(
    () => s5(l),
    (i) => {
      i ? r() : o();
    },
    { immediate: !0 }
  ), t;
}, yn = (l, e, t, a, r) => {
  const { style: o, placement: i, isPositioned: c, open: v, close: u, toggle: h } = Mn(
    l,
    e,
    a,
    r
  ), p = xn(t, a), m = k(() => ({
    ...o.value,
    width: p.value
  })), { observe: g, stopObserve: w } = bn([a, r], u);
  return r5(l, (x) => {
    x ? g() : w();
  }), {
    style: m,
    placement: i,
    isPositioned: c,
    open: v,
    close: u,
    toggle: h
  };
}, An = Object.freeze(
  (() => {
    const l = "totem-teleport-target";
    return {
      destination: `#${l}`,
      destinationId: l
    };
  })()
), Vn = I(), Hn = k(
  () => Vn.value !== void 0
), g7 = /* @__PURE__ */ q({
  __name: "TotemTeleport",
  setup(l) {
    return (e, t) => _(Hn) ? (B(), F(gt, {
      key: 0,
      to: _(An).destination
    }, [
      L(e.$slots, "default")
    ], 8, ["to"])) : $("", !0);
  }
}), Bn = {
  key: 0,
  class: "totem-dropdown__transition"
}, zn = { class: "totem-dropdown__visual" }, Cn = /* @__PURE__ */ q({
  __name: "TotemDropdown",
  props: /* @__PURE__ */ c5({
    position: {},
    sameWidth: { type: Boolean }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const e = l, t = k(() => ({
      open: u,
      close: h,
      toggle: p,
      isExpanded: a.value,
      triggerElement: r.value,
      targetElement: o.value
    })), a = H5(l, "modelValue"), r = R5("trigger"), o = R5("target"), { style: i, placement: c, isPositioned: v, open: u, close: h, toggle: p } = yn(
      a,
      () => e.position ?? "bottom-start",
      () => e.sameWidth,
      r,
      o
    );
    return (m, g) => (B(), R("div", {
      ref: "trigger",
      class: "totem-dropdown",
      onKeydown: g[0] || (g[0] = ht(
        //@ts-ignore
        (...w) => _(h) && _(h)(...w),
        ["esc"]
      ))
    }, [
      L(m.$slots, "trigger", h0(f0(t.value)), () => [
        L(m.$slots, "default", h0(f0(t.value)))
      ]),
      X(g7, null, {
        default: T(() => [
          a.value ? (B(), R("div", {
            key: 0,
            ref: "target",
            style: F5(_(i)),
            class: Y(["totem-dropdown__target", { [`totem-dropdown__target--placement-${_(c)}`]: _(c) }]),
            "data-test": "target"
          }, [
            X(d7, { name: "totem-dropdown__transition-" }, {
              default: T(() => [
                _(v) ? (B(), R("div", Bn, [
                  U("div", zn, [
                    L(m.$slots, "target", h0(f0(t.value)))
                  ])
                ])) : $("", !0)
              ]),
              _: 3
            })
          ], 6)) : $("", !0)
        ]),
        _: 3
      })
    ], 544));
  }
}), Ln = (l, e) => {
  const t = l.__vccOpts || l;
  for (const [a, r] of e)
    t[a] = r;
  return t;
};
/**
* @vue/shared v3.5.15
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const G2 = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, Sn = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], En = () => {
}, Tn = (l) => l.charCodeAt(0) === 111 && l.charCodeAt(1) === 110 && // uppercase letter
(l.charCodeAt(2) > 122 || l.charCodeAt(2) < 97), l0 = Object.assign, z5 = Array.isArray, l1 = (l) => typeof l == "function", j5 = (l) => typeof l == "string", _n = (l) => typeof l == "symbol", U5 = (l) => l !== null && typeof l == "object";
let q7;
const t0 = () => q7 || (q7 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function b7(l) {
  if (z5(l)) {
    const e = {};
    for (let t = 0; t < l.length; t++) {
      const a = l[t], r = j5(a) ? $n(a) : b7(a);
      if (r)
        for (const o in r)
          e[o] = r[o];
    }
    return e;
  } else if (j5(l) || U5(l))
    return l;
}
const Rn = /;(?![^(]*\))/g, kn = /:([^]+)/, On = /\/\*[^]*?\*\//g;
function $n(l) {
  const e = {};
  return l.replace(On, "").split(Rn).forEach((t) => {
    if (t) {
      const a = t.split(kn);
      a.length > 1 && (e[a[0].trim()] = a[1].trim());
    }
  }), e;
}
function M7(l) {
  let e = "";
  if (j5(l))
    e = l;
  else if (z5(l))
    for (let t = 0; t < l.length; t++) {
      const a = M7(l[t]);
      a && (e += a + " ");
    }
  else if (U5(l))
    for (const t in l)
      l[t] && (e += t + " ");
  return e.trim();
}
/**
* @vue/reactivity v3.5.15
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
);
Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
);
Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((l) => l !== "arguments" && l !== "caller").map((l) => Symbol[l]).filter(_n)
);
function J3(l) {
  return X2(l) ? J3(l.__v_raw) : !!(l && l.__v_isReactive);
}
function X2(l) {
  return !!(l && l.__v_isReadonly);
}
function g0(l) {
  return !!(l && l.__v_isShallow);
}
function Y2(l) {
  return l ? !!l.__v_raw : !1;
}
function Z5(l) {
  const e = l && l.__v_raw;
  return e ? Z5(e) : l;
}
function x7(l) {
  return l ? l.__v_isRef === !0 : !1;
}
/**
* @vue/runtime-core v3.5.15
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const W5 = [];
function Nn(l) {
  W5.push(l);
}
function Fn() {
  W5.pop();
}
let b0 = !1;
function N1(l, ...e) {
  if (b0) return;
  b0 = !0;
  const t = W5.length ? W5[W5.length - 1].component : null, a = t && t.appContext.config.warnHandler, r = Dn();
  if (a)
    y7(
      a,
      t,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        l + e.map((o) => {
          var i, c;
          return (c = (i = o.toString) == null ? void 0 : i.call(o)) != null ? c : JSON.stringify(o);
        }).join(""),
        t && t.proxy,
        r.map(
          ({ vnode: o }) => `at <${cl(t, o.type)}>`
        ).join(`
`),
        r
      ]
    );
  else {
    const o = [`[Vue warn]: ${l}`, ...e];
    r.length && o.push(`
`, ...In(r)), console.warn(...o);
  }
  b0 = !1;
}
function Dn() {
  let l = W5[W5.length - 1];
  if (!l)
    return [];
  const e = [];
  for (; l; ) {
    const t = e[0];
    t && t.vnode === l ? t.recurseCount++ : e.push({
      vnode: l,
      recurseCount: 0
    });
    const a = l.component && l.component.parent;
    l = a && a.vnode;
  }
  return e;
}
function In(l) {
  const e = [];
  return l.forEach((t, a) => {
    e.push(...a === 0 ? [] : [`
`], ...jn(t));
  }), e;
}
function jn({ vnode: l, recurseCount: e }) {
  const t = e > 0 ? `... (${e} recursive calls)` : "", a = l.component ? l.component.parent == null : !1, r = ` at <${cl(
    l.component,
    l.type,
    a
  )}`, o = ">" + t;
  return l.props ? [r, ...qn(l.props), o] : [r + o];
}
function qn(l) {
  const e = [], t = Object.keys(l);
  return t.slice(0, 3).forEach((a) => {
    e.push(...G3(a, l[a]));
  }), t.length > 3 && e.push(" ..."), e;
}
function G3(l, e, t) {
  return j5(e) ? (e = JSON.stringify(e), t ? e : [`${l}=${e}`]) : typeof e == "number" || typeof e == "boolean" || e == null ? t ? e : [`${l}=${e}`] : x7(e) ? (e = G3(l, Z5(e.value), !0), t ? e : [`${l}=Ref<`, e, ">"]) : l1(e) ? [`${l}=fn${e.name ? `<${e.name}>` : ""}`] : (e = Z5(e), t ? e : [`${l}=`, e]);
}
const X3 = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function y7(l, e, t, a) {
  try {
    return a ? l(...a) : l();
  } catch (r) {
    Y3(r, e, t);
  }
}
function Y3(l, e, t, a = !0) {
  const r = e ? e.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: i } = e && e.appContext.config || G2;
  if (e) {
    let c = e.parent;
    const v = e.proxy, u = process.env.NODE_ENV !== "production" ? X3[t] : `https://vuejs.org/error-reference/#runtime-${t}`;
    for (; c; ) {
      const h = c.ec;
      if (h) {
        for (let p = 0; p < h.length; p++)
          if (h[p](l, v, u) === !1)
            return;
      }
      c = c.parent;
    }
    if (o) {
      y7(o, null, 10, [
        l,
        v,
        u
      ]);
      return;
    }
  }
  Pn(l, t, r, a, i);
}
function Pn(l, e, t, a = !0, r = !1) {
  if (process.env.NODE_ENV !== "production") {
    const o = X3[e];
    if (t && Nn(t), N1(`Unhandled error${o ? ` during execution of ${o}` : ""}`), t && Fn(), a)
      throw l;
    console.error(l);
  } else {
    if (r)
      throw l;
    console.error(l);
  }
}
const u5 = [];
let L5 = -1;
const i1 = [];
let O5 = null, a1 = 0;
const Un = /* @__PURE__ */ Promise.resolve();
let Q2 = null;
const Zn = 100;
function Wn(l) {
  let e = L5 + 1, t = u5.length;
  for (; e < t; ) {
    const a = e + t >>> 1, r = u5[a], o = f1(r);
    o < l || o === l && r.flags & 2 ? e = a + 1 : t = a;
  }
  return e;
}
function Kn(l) {
  if (!(l.flags & 1)) {
    const e = f1(l), t = u5[u5.length - 1];
    !t || // fast path when the job id is larger than the tail
    !(l.flags & 2) && e >= f1(t) ? u5.push(l) : u5.splice(Wn(e), 0, l), l.flags |= 1, Q3();
  }
}
function Q3() {
  Q2 || (Q2 = Un.then(el));
}
function Jn(l) {
  z5(l) ? i1.push(...l) : O5 && l.id === -1 ? O5.splice(a1 + 1, 0, l) : l.flags & 1 || (i1.push(l), l.flags |= 1), Q3();
}
function Gn(l) {
  if (i1.length) {
    const e = [...new Set(i1)].sort(
      (t, a) => f1(t) - f1(a)
    );
    if (i1.length = 0, O5) {
      O5.push(...e);
      return;
    }
    for (O5 = e, process.env.NODE_ENV !== "production" && (l = l || /* @__PURE__ */ new Map()), a1 = 0; a1 < O5.length; a1++) {
      const t = O5[a1];
      process.env.NODE_ENV !== "production" && ll(l, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
    }
    O5 = null, a1 = 0;
  }
}
const f1 = (l) => l.id == null ? l.flags & 2 ? -1 : 1 / 0 : l.id;
function el(l) {
  process.env.NODE_ENV !== "production" && (l = l || /* @__PURE__ */ new Map());
  const e = process.env.NODE_ENV !== "production" ? (t) => ll(l, t) : En;
  try {
    for (L5 = 0; L5 < u5.length; L5++) {
      const t = u5[L5];
      if (t && !(t.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && e(t))
          continue;
        t.flags & 4 && (t.flags &= -2), y7(
          t,
          t.i,
          t.i ? 15 : 14
        ), t.flags & 4 || (t.flags &= -2);
      }
    }
  } finally {
    for (; L5 < u5.length; L5++) {
      const t = u5[L5];
      t && (t.flags &= -2);
    }
    L5 = -1, u5.length = 0, Gn(l), Q2 = null, (u5.length || i1.length) && el(l);
  }
}
function ll(l, e) {
  const t = l.get(e) || 0;
  if (t > Zn) {
    const a = e.i, r = a && dl(a.type);
    return Y3(
      `Maximum recursive updates exceeded${r ? ` in component <${r}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return l.set(e, t + 1), !1;
}
const M0 = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (t0().__VUE_HMR_RUNTIME__ = {
  createRecord: x0(Xn),
  rerender: x0(Yn),
  reload: x0(Qn)
});
const F1 = /* @__PURE__ */ new Map();
function Xn(l, e) {
  return F1.has(l) ? !1 : (F1.set(l, {
    initialDef: D1(e),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function D1(l) {
  return ul(l) ? l.__vccOpts : l;
}
function Yn(l, e) {
  const t = F1.get(l);
  t && (t.initialDef.render = e, [...t.instances].forEach((a) => {
    e && (a.render = e, D1(a.type).render = e), a.renderCache = [], a.update();
  }));
}
function Qn(l, e) {
  const t = F1.get(l);
  if (!t) return;
  e = D1(e), P7(t.initialDef, e);
  const a = [...t.instances];
  for (let r = 0; r < a.length; r++) {
    const o = a[r], i = D1(o.type);
    let c = M0.get(i);
    c || (i !== t.initialDef && P7(i, e), M0.set(i, c = /* @__PURE__ */ new Set())), c.add(o), o.appContext.propsCache.delete(o.type), o.appContext.emitsCache.delete(o.type), o.appContext.optionsCache.delete(o.type), o.ceReload ? (c.add(o), o.ceReload(e.styles), c.delete(o)) : o.parent ? Kn(() => {
      o.parent.update(), c.delete(o);
    }) : o.appContext.reload ? o.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), o.root.ce && o !== o.root && o.root.ce._removeChildStyle(i);
  }
  Jn(() => {
    M0.clear();
  });
}
function P7(l, e) {
  l0(l, e);
  for (const t in l)
    t !== "__file" && !(t in e) && delete l[t];
}
function x0(l) {
  return (e, t) => {
    try {
      return l(e, t);
    } catch (a) {
      console.error(a), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let I1 = null, ea = null;
const la = (l) => l.__isTeleport;
function tl(l, e) {
  l.shapeFlag & 6 && l.component ? (l.transition = e, tl(l.component.subTree, e)) : l.shapeFlag & 128 ? (l.ssContent.transition = e.clone(l.ssContent), l.ssFallback.transition = e.clone(l.ssFallback)) : l.transition = e;
}
t0().requestIdleCallback;
t0().cancelIdleCallback;
const ta = Symbol.for("v-ndc");
process.env.NODE_ENV;
const na = {}, nl = (l) => Object.getPrototypeOf(l) === na, aa = (l) => l.__isSuspense, al = Symbol.for("v-fgt"), ra = Symbol.for("v-txt"), oa = Symbol.for("v-cmt"), ia = Symbol.for("v-stc"), L1 = [];
let w5 = null;
function s(l = !1) {
  L1.push(w5 = l ? null : []);
}
function sa() {
  L1.pop(), w5 = L1[L1.length - 1] || null;
}
function da(l) {
  return l.dynamicChildren = w5 || Sn, sa(), w5 && w5.push(l), l;
}
function d(l, e, t, a, r, o) {
  return da(
    n(
      l,
      e,
      t,
      a,
      r,
      o,
      !0
    )
  );
}
function ca(l) {
  return l ? l.__v_isVNode === !0 : !1;
}
const ua = (...l) => il(
  ...l
), rl = ({ key: l }) => l ?? null, S1 = ({
  ref: l,
  ref_key: e,
  ref_for: t
}) => (typeof l == "number" && (l = "" + l), l != null ? j5(l) || x7(l) || l1(l) ? { i: I1, r: l, k: e, f: !!t } : l : null);
function n(l, e = null, t = null, a = 0, r = null, o = l === al ? 0 : 1, i = !1, c = !1) {
  const v = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: l,
    props: e,
    key: e && rl(e),
    ref: e && S1(e),
    scopeId: ea,
    slotScopeIds: null,
    children: t,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: a,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: I1
  };
  return c ? (A7(v, t), o & 128 && l.normalize(v)) : t && (v.shapeFlag |= j5(t) ? 8 : 16), process.env.NODE_ENV !== "production" && v.key !== v.key && N1("VNode created with invalid key (NaN). VNode type:", v.type), // avoid a block node from tracking itself
  !i && // has current parent block
  w5 && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (v.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  v.patchFlag !== 32 && w5.push(v), v;
}
const ol = process.env.NODE_ENV !== "production" ? ua : il;
function il(l, e = null, t = null, a = 0, r = null, o = !1) {
  if ((!l || l === ta) && (process.env.NODE_ENV !== "production" && !l && N1(`Invalid vnode type when creating vnode: ${l}.`), l = oa), ca(l)) {
    const c = j1(
      l,
      e,
      !0
      /* mergeRef: true */
    );
    return t && A7(c, t), !o && w5 && (c.shapeFlag & 6 ? w5[w5.indexOf(l)] = c : w5.push(c)), c.patchFlag = -2, c;
  }
  if (ul(l) && (l = l.__vccOpts), e) {
    e = va(e);
    let { class: c, style: v } = e;
    c && !j5(c) && (e.class = M7(c)), U5(v) && (Y2(v) && !z5(v) && (v = l0({}, v)), e.style = b7(v));
  }
  const i = j5(l) ? 1 : aa(l) ? 128 : la(l) ? 64 : U5(l) ? 4 : l1(l) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && i & 4 && Y2(l) && (l = Z5(l), N1(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    l
  )), n(
    l,
    e,
    t,
    a,
    r,
    i,
    o,
    !0
  );
}
function va(l) {
  return l ? Y2(l) || nl(l) ? l0({}, l) : l : null;
}
function j1(l, e, t = !1, a = !1) {
  const { props: r, ref: o, patchFlag: i, children: c, transition: v } = l, u = e ? ha(r || {}, e) : r, h = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: l.type,
    props: u,
    key: u && rl(u),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      t && o ? z5(o) ? o.concat(S1(e)) : [o, S1(e)] : S1(e)
    ) : o,
    scopeId: l.scopeId,
    slotScopeIds: l.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && i === -1 && z5(c) ? c.map(sl) : c,
    target: l.target,
    targetStart: l.targetStart,
    targetAnchor: l.targetAnchor,
    staticCount: l.staticCount,
    shapeFlag: l.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && l.type !== al ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: l.dynamicProps,
    dynamicChildren: l.dynamicChildren,
    appContext: l.appContext,
    dirs: l.dirs,
    transition: v,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: l.component,
    suspense: l.suspense,
    ssContent: l.ssContent && j1(l.ssContent),
    ssFallback: l.ssFallback && j1(l.ssFallback),
    el: l.el,
    anchor: l.anchor,
    ctx: l.ctx,
    ce: l.ce
  };
  return v && a && tl(
    h,
    v.clone(h)
  ), h;
}
function sl(l) {
  const e = j1(l);
  return z5(l.children) && (e.children = l.children.map(sl)), e;
}
function pa(l = " ", e = 0) {
  return ol(ra, null, l, e);
}
function h5(l, e) {
  const t = ol(ia, null, l);
  return t.staticCount = e, t;
}
function A7(l, e) {
  let t = 0;
  const { shapeFlag: a } = l;
  if (e == null)
    e = null;
  else if (z5(e))
    t = 16;
  else if (typeof e == "object")
    if (a & 65) {
      const r = e.default;
      r && (r._c && (r._d = !1), A7(l, r()), r._c && (r._d = !0));
      return;
    } else
      t = 32, !e._ && !nl(e) && (e._ctx = I1);
  else l1(e) ? (e = { default: e, _ctx: I1 }, t = 32) : (e = String(e), a & 64 ? (t = 16, e = [pa(e)]) : t = 8);
  l.children = e, l.shapeFlag |= t;
}
function ha(...l) {
  const e = {};
  for (let t = 0; t < l.length; t++) {
    const a = l[t];
    for (const r in a)
      if (r === "class")
        e.class !== a.class && (e.class = M7([e.class, a.class]));
      else if (r === "style")
        e.style = b7([e.style, a.style]);
      else if (Tn(r)) {
        const o = e[r], i = a[r];
        i && o !== i && !(z5(o) && o.includes(i)) && (e[r] = o ? [].concat(o, i) : i);
      } else r !== "" && (e[r] = a[r]);
  }
  return e;
}
{
  const l = t0(), e = (t, a) => {
    let r;
    return (r = l[t]) || (r = l[t] = []), r.push(a), (o) => {
      r.length > 1 ? r.forEach((i) => i(o)) : r[0](o);
    };
  };
  e(
    "__VUE_INSTANCE_SETTERS__",
    (t) => t
  ), e(
    "__VUE_SSR_SETTERS__",
    (t) => t
  );
}
process.env.NODE_ENV;
const fa = /(?:^|[-_])(\w)/g, ma = (l) => l.replace(fa, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function dl(l, e = !0) {
  return l1(l) ? l.displayName || l.name : l.name || e && l.__name;
}
function cl(l, e, t = !1) {
  let a = dl(e);
  if (!a && e.__file) {
    const r = e.__file.match(/([^/\\]+)\.\w+$/);
    r && (a = r[1]);
  }
  if (!a && l && l.parent) {
    const r = (o) => {
      for (const i in o)
        if (o[i] === e)
          return i;
    };
    a = r(
      l.components || l.parent.type.components
    ) || r(l.appContext.components);
  }
  return a ? ma(a) : t ? "App" : "Anonymous";
}
function ul(l) {
  return l1(l) && "__vccOpts" in l;
}
function wa() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const l = { style: "color:#3ba776" }, e = { style: "color:#1677ff" }, t = { style: "color:#f5222d" }, a = { style: "color:#eb2f96" }, r = {
    __vue_custom_formatter: !0,
    header(p) {
      if (!U5(p))
        return null;
      if (p.__isVue)
        return ["div", l, "VueInstance"];
      if (x7(p)) {
        const m = p.value;
        return [
          "div",
          {},
          ["span", l, h(p)],
          "<",
          c(m),
          ">"
        ];
      } else {
        if (J3(p))
          return [
            "div",
            {},
            ["span", l, g0(p) ? "ShallowReactive" : "Reactive"],
            "<",
            c(p),
            `>${X2(p) ? " (readonly)" : ""}`
          ];
        if (X2(p))
          return [
            "div",
            {},
            ["span", l, g0(p) ? "ShallowReadonly" : "Readonly"],
            "<",
            c(p),
            ">"
          ];
      }
      return null;
    },
    hasBody(p) {
      return p && p.__isVue;
    },
    body(p) {
      if (p && p.__isVue)
        return [
          "div",
          {},
          ...o(p.$)
        ];
    }
  };
  function o(p) {
    const m = [];
    p.type.props && p.props && m.push(i("props", Z5(p.props))), p.setupState !== G2 && m.push(i("setup", p.setupState)), p.data !== G2 && m.push(i("data", Z5(p.data)));
    const g = v(p, "computed");
    g && m.push(i("computed", g));
    const w = v(p, "inject");
    return w && m.push(i("injected", w)), m.push([
      "div",
      {},
      [
        "span",
        {
          style: a.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: p }]
    ]), m;
  }
  function i(p, m) {
    return m = l0({}, m), Object.keys(m).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        p
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(m).map((g) => [
          "div",
          {},
          ["span", a, g + ": "],
          c(m[g], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function c(p, m = !0) {
    return typeof p == "number" ? ["span", e, p] : typeof p == "string" ? ["span", t, JSON.stringify(p)] : typeof p == "boolean" ? ["span", a, p] : U5(p) ? ["object", { object: m ? Z5(p) : p }] : ["span", t, String(p)];
  }
  function v(p, m) {
    const g = p.type;
    if (l1(g))
      return;
    const w = {};
    for (const x in p.ctx)
      u(g, x, m) && (w[x] = p.ctx[x]);
    return w;
  }
  function u(p, m, g) {
    const w = p[g];
    if (z5(w) && w.includes(m) || U5(w) && m in w || p.extends && u(p.extends, m, g) || p.mixins && p.mixins.some((x) => u(x, m, g)))
      return !0;
  }
  function h(p) {
    return g0(p) ? "ShallowRef" : p.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(r) : window.devtoolsFormatters = [r];
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* vue v3.5.15
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function ga() {
  wa();
}
process.env.NODE_ENV !== "production" && ga();
const ba = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ma(l, e) {
  return s(), d("svg", ba, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm14.814 10.526a.65.65 0 0 0 .186-.455 7.1 7.1 0 0 0-2.05-5A6.96 6.96 0 0 0 12 3a6.96 6.96 0 0 0-4.95 2.071 7.1 7.1 0 0 0-2.05 5c0 2.69.989 3.655 1.784 4.43l.003.003c.625.608 1.077 1.049 1.077 2.317a4.2 4.2 0 0 0 1.213 2.954A4.12 4.12 0 0 0 12 21c1.193 0 2.212-.511 3.036-1.52a.64.64 0 0 0 .08-.717.64.64 0 0 0-.38-.317.63.63 0 0 0-.681.216c-.587.718-1.24 1.052-2.055 1.052-.76 0-1.488-.304-2.025-.847a2.9 2.9 0 0 1-.839-2.046c0-1.81-.774-2.567-1.46-3.237l-.006-.006c-.719-.7-1.397-1.362-1.397-3.507 0-1.534.603-3.006 1.677-4.09A5.7 5.7 0 0 1 12 4.285c1.519 0 2.976.61 4.05 1.694a5.82 5.82 0 0 1 1.677 4.091c0 .17.067.334.187.455a.633.633 0 0 0 .9 0Zm-3.082 4.051a.63.63 0 0 1 .53.472c.044.164.02.34-.064.487a1.894 1.894 0 0 1-2.147.897 1.9 1.9 0 0 1-1.02-.688 1.94 1.94 0 0 1-.395-1.174c0-1.177.574-1.95 1.08-2.633l.002-.002c.444-.598.828-1.115.828-1.865 0-.682-.269-1.336-.746-1.818A2.53 2.53 0 0 0 12 7.5a2.53 2.53 0 0 0-1.8.753 2.6 2.6 0 0 0-.745 1.818.65.65 0 0 1-.187.455.633.633 0 0 1-.9 0 .65.65 0 0 1-.186-.455c0-1.023.402-2.004 1.118-2.727a3.8 3.8 0 0 1 2.7-1.13 3.8 3.8 0 0 1 2.7 1.13 3.88 3.88 0 0 1 1.118 2.727c0 1.178-.574 1.951-1.08 2.634l-.002.002c-.444.598-.827 1.115-.827 1.864a.65.65 0 0 0 .472.622.63.63 0 0 0 .716-.3.64.64 0 0 1 .635-.316",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const xa = { render: Ma }, ya = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Aa(l, e) {
  return s(), d("svg", ya, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm1.371 8.824c0-1.07.216-1.965.584-2.568.352-.574.832-.878 1.474-.878.735 0 1.196.167 1.774.38.683.25 1.47.54 2.797.54s2.114-.29 2.797-.54c.578-.213 1.04-.38 1.774-.38.642 0 1.122.304 1.474.878.368.603.584 1.498.584 2.568 0 1.326-.328 2.126-.71 3.053l-.006.013c-.218.526-.458 1.109-.635 1.821-.151.607-.21 1.448-.265 2.25l-.004.052c-.07 1.014-.142 2.003-.338 2.74-.098.367-.21.604-.32.737-.087.109-.152.132-.237.132-.006 0-.024.002-.072-.043-.067-.062-.156-.182-.26-.397-.209-.436-.382-1.05-.586-1.787l-.012-.044c-.234-.844-.508-1.833-.93-2.61-.436-.8-1.132-1.552-2.254-1.552s-1.818.752-2.254 1.552c-.422.777-.696 1.766-.93 2.61l-.012.044c-.204.737-.377 1.351-.587 1.787-.103.215-.192.335-.259.397-.048.045-.066.043-.071.043h-.001c-.085 0-.15-.023-.238-.132-.108-.133-.221-.37-.319-.738-.196-.736-.268-1.724-.338-2.739l-.004-.053c-.055-.8-.114-1.642-.265-2.249-.177-.712-.418-1.295-.635-1.82l-.005-.014c-.383-.927-.71-1.727-.71-3.053ZM7.43 4c-1.187 0-2.079.615-2.642 1.534C4.242 6.425 4 7.598 4 8.824c0 1.607.417 2.616.811 3.57l.004.011c.22.534.426 1.034.577 1.64.118.475.17 1.196.23 2.064l.004.044c.067.961.144 2.077.378 2.956.12.446.295.9.581 1.253.307.378.743.638 1.3.638.844 0 1.31-.682 1.567-1.218.27-.56.472-1.292.66-1.974l.013-.043c.249-.898.486-1.74.825-2.362.333-.612.662-.835 1.05-.835s.717.223 1.05.835c.34.623.576 1.464.825 2.362l.012.043c.19.682.392 1.414.661 1.974.258.536.723 1.218 1.566 1.218.558 0 .994-.26 1.3-.638.287-.353.463-.807.582-1.253.234-.879.311-1.995.378-2.956l.003-.044c.06-.868.113-1.589.231-2.064.151-.606.356-1.106.577-1.64l.004-.01c.394-.955.811-1.964.811-3.57 0-1.227-.242-2.4-.787-3.29C18.65 4.614 17.758 4 16.57 4c-.984 0-1.636.24-2.232.458l-.014.005c-.633.233-1.24.456-2.325.456s-1.692-.223-2.325-.456l-.014-.005C9.065 4.24 8.413 4 7.43 4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Va = { render: Aa }, Ha = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ba(l, e) {
  return s(), d("svg", Ha, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm14.575 12.616c.225.058.436.16.62.302h.003a1.73 1.73 0 0 1-.276 2.923l-.031.014-2.733 1.163-.084.028-4.5 1.125a.6.6 0 0 1-.136.017H4.125A1.125 1.125 0 0 1 3 17.063V14.25a1.125 1.125 0 0 1 1.125-1.125h2.017l1.59-1.589a2.24 2.24 0 0 1 1.038-.59c-.48-.796-.707-1.547-.707-2.32 0-1.862 1.496-3.376 3.336-3.376a3.35 3.35 0 0 1 2.57 1.178 3.34 3.34 0 0 1 2.569-1.178c1.84 0 3.337 1.514 3.337 3.375 0 1.3-.668 2.625-1.988 3.958a1.7 1.7 0 0 1 .688.033M12.628 6.73a2.2 2.2 0 0 0-1.229-.355c-1.198 0-2.211 1.03-2.211 2.25 0 .712.284 1.432.891 2.25h2.765a1.968 1.968 0 0 1 1.916 2.422l.78-.179c2.1-1.57 3.21-3.121 3.21-4.493 0-1.22-1.013-2.25-2.212-2.25a2.19 2.19 0 0 0-2.049 1.336.562.562 0 0 1-1.04 0 2.2 2.2 0 0 0-.821-.98Zm-6.816 7.52H4.125v2.813h1.688zm9.945 1.715 2.672-1.138h-.002a.604.604 0 0 0-.443-1.118l-.022.006-4.711 1.084a.6.6 0 0 1-.126.014h-2.25a.562.562 0 1 1 0-1.125h1.969a.844.844 0 0 0 0-1.688h-3.52a1.12 1.12 0 0 0-.795.33l-1.591 1.59v3.143h4.43z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const za = { render: Ba }, Ca = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function La(l, e) {
  return s(), d("svg", Ca, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm.256 12a7.744 7.744 0 1 1 15.488 0 7.744 7.744 0 0 1-15.488 0M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M9.28 7.814a.628.628 0 0 0-1.257 0v8.372a.628.628 0 1 0 1.256 0v-3.558h5.442v3.558a.628.628 0 0 0 1.256 0V7.814a.628.628 0 1 0-1.256 0v3.558H9.279z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Sa = { render: La }, Ea = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ta(l, e) {
  return s(), d("svg", Ea, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm17.041 2.96c.306.283.459.655.459 1.07s-.153.788-.437 1.094l-1.07 1.071.459.46c.262.24.393.568.393.917s-.153.678-.393.919l-.611.612.152.153c.59.59.59 1.574 0 2.165a1.5 1.5 0 0 1-1.091.459c-.306 0-.568-.066-.808-.219v.765c0 .59-.218 1.137-.633 1.553l-6.9 6.887a2.16 2.16 0 0 1-1.55.634 2.16 2.16 0 0 1-1.55-.634l-4.322-4.33a2.18 2.18 0 0 1 0-3.082l6.92-6.91a2.16 2.16 0 0 1 1.55-.633h.765a1.526 1.526 0 0 1 .218-1.88c.306-.307.699-.46 1.092-.46s.786.175 1.07.46l.152.153.612-.613a1.22 1.22 0 0 1 .917-.393c.35 0 .677.153.917.393l.458.46 1.07-1.072a1.54 1.54 0 0 1 1.092-.459c.393 0 .786.175 1.07.46Zm-3.82 9.466c0 .35-.131.678-.393.919l-6.9 6.909c-.24.24-.567.393-.916.393s-.677-.13-.917-.393l-4.323-4.33a1.3 1.3 0 0 1-.393-.918c0-.35.13-.678.393-.918l1.55 1.552a.43.43 0 0 0 .306.132.43.43 0 0 0 .305-.132.423.423 0 0 0 0-.612l-1.55-1.552.917-.919.917.919a.43.43 0 0 0 .306.131.43.43 0 0 0 .305-.131.423.423 0 0 0 0-.612l-.917-.919.917-.918 1.55 1.552a.43.43 0 0 0 .306.132.43.43 0 0 0 .306-.132.423.423 0 0 0 0-.612l-1.55-1.552.917-.918.917.918a.43.43 0 0 0 .305.131.43.43 0 0 0 .306-.131.423.423 0 0 0 0-.612l-.917-.919.917-.918 1.55 1.552a.43.43 0 0 0 .306.132.43.43 0 0 0 .305-.132.423.423 0 0 0 0-.612l-1.55-1.552.11-.11c.24-.24.567-.393.916-.393h1.572l4.061 4.067zm2.14-1.596a.673.673 0 0 1-.918 0l-.458-.459-4.345-4.329-.458-.46a.635.635 0 0 1 0-.917.63.63 0 0 1 .458-.197c.175 0 .35.065.459.197l5.24 5.247c.262.24.262.656.021.918Zm1.07-6.34-1.376 1.399a.423.423 0 0 0 0 .612l.764.765a.43.43 0 0 1 .13.306c0 .11-.043.22-.13.307l-.611.634-3.712-3.717.611-.612c.175-.175.459-.175.612 0l.764.765a.42.42 0 0 0 .611 0l1.397-1.4c.24-.24.677-.24.917 0a.63.63 0 0 1 .197.46.54.54 0 0 1-.175.48Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _a = { render: Ta }, Ra = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ka(l, e) {
  return s(), d("svg", Ra, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm17.487 11.745a1.39 1.39 0 0 1 .465 1.44c-.283 1.071-1.15 3.109-3.779 4.714-2.61 1.601-4.924 1.601-6.167 1.601h-.012c-1.246 0-3.549 0-6.168-1.6-2.628-1.606-3.496-3.644-3.778-4.715a1.39 1.39 0 0 1 .468-1.44c.136-.107.292-.186.458-.23a6 6 0 0 1 1.848-.19c-.328-1.693-.078-3.03.172-3.823a1.37 1.37 0 0 1 .608-.773 1.32 1.32 0 0 1 .958-.155 7 7 0 0 1 2.38 1.033 8 8 0 0 1 2.259-2.833 1.32 1.32 0 0 1 1.605 0 8 8 0 0 1 2.26 2.833 7 7 0 0 1 2.38-1.033 1.32 1.32 0 0 1 .957.155c.29.171.507.447.608.773.255.793.505 2.131.172 3.823a6 6 0 0 1 1.848.19c.166.044.322.123.458.23M6.262 7.92l.007-.01a.02.02 0 0 1 .013-.003c.775.18 1.507.518 2.15.995-.292.98-.438 2-.431 3.026 0 1.597.314 2.898.76 3.945a10.5 10.5 0 0 1-1.63-2.17C5.63 11.03 5.943 8.932 6.263 7.921Zm.25 8.808c-2.222-1.357-2.943-3.02-3.178-3.902a4.9 4.9 0 0 1 1.875-.1q.314.86.763 1.654a12 12 0 0 0 2.833 3.372 9.5 9.5 0 0 1-2.296-1.024zM12.002 18c-.778-.591-2.667-2.406-2.667-6.07 0-3.62 1.865-5.45 2.667-6.066.801.618 2.667 2.447 2.667 6.067 0 3.663-1.89 5.478-2.667 6.069m3.568-9.097a5.8 5.8 0 0 1 2.152-.994q.006 0 .012.003l.007.01c.32 1.01.632 3.108-.87 5.782a10.5 10.5 0 0 1-1.628 2.172c.445-1.045.76-2.347.76-3.944a10.3 10.3 0 0 0-.433-3.03Zm5.1 3.925c-.231.874-.95 2.541-3.175 3.901a9.5 9.5 0 0 1-2.296 1.023c1.14-.936 2.1-2.079 2.833-3.372.3-.528.554-1.082.763-1.654a4.9 4.9 0 0 1 1.875.102",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Oa = { render: ka }, $a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Na(l, e) {
  return s(), d("svg", $a, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4zm18.799 1.203a4.106 4.106 0 0 0-5.807 0l-7.826 7.824a4.106 4.106 0 0 0 5.807 5.807l7.827-7.825a4.11 4.11 0 0 0-.001-5.806m-10.73 13.6c.763 0 1.494-.303 2.032-.841l3.477-3.477-4.063-4.062-3.477 3.476a2.873 2.873 0 0 0 2.032 4.904Zm6.38-5.19 3.478-3.476a2.872 2.872 0 0 0-4.063-4.062L10.387 9.55zm2.422-4.915a.617.617 0 0 0-1.006-.2l-1.85 1.85a.617.617 0 0 0 .872.873l1.85-1.85a.62.62 0 0 0 .134-.673",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fa = { render: Na }, Da = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ia(l, e) {
  return s(), d("svg", Da, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4zm12 4.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m-1.389 5.829a2.5 2.5 0 1 0 2.778-4.157 2.5 2.5 0 0 0-2.778 4.157m8.55-5.333c1.471 1.471 2.133 2.94 2.16 3a.63.63 0 0 1 0 .509c-.027.061-.689 1.529-2.16 3-1.96 1.96-4.436 2.995-7.161 2.995s-5.2-1.036-7.16-2.995c-1.472-1.471-2.134-2.939-2.161-3a.63.63 0 0 1 0-.508c.024-.06.689-1.53 2.16-3C6.8 6.785 9.275 5.75 12 5.75s5.2 1.036 7.16 2.996ZM12 17c-2.405 0-4.505-.874-6.245-2.598A10.4 10.4 0 0 1 3.953 12a10.4 10.4 0 0 1 1.802-2.402C7.495 7.874 9.595 7 12 7s4.506.874 6.244 2.598A10.4 10.4 0 0 1 20.051 12c-.563 1.052-3.017 5-8.051 5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ja = { render: Ia }, qa = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pa(l, e) {
  return s(), d("svg", qa, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm13.904 14.52a.937.937 0 1 0-1.558-1.04.937.937 0 0 0 1.558 1.04m-1.463 4.825a3.76 3.76 0 0 0 1.266-2.275v-.002a3.125 3.125 0 1 0-1.268-.021A2.505 2.505 0 0 1 14 19h-1.875a2.5 2.5 0 0 1-2.5-2.5v-3.166C12.084 13.02 14 10.876 14 8.31V5.25A1.25 1.25 0 0 0 12.75 4H11.5a.625.625 0 1 0 0 1.25h1.25v3.06c0 2.077-1.66 3.788-3.7 3.815a3.75 3.75 0 0 1-3.8-3.75V5.25H6.5A.625.625 0 0 0 6.5 4H5.25A1.25 1.25 0 0 0 4 5.25v3.125a5 5 0 0 0 4.375 4.96V16.5a3.754 3.754 0 0 0 3.75 3.75H14a3.76 3.76 0 0 0 2.441-.905m2.243-6.387a1.875 1.875 0 1 1-3.118 2.084 1.875 1.875 0 0 1 3.118-2.084",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ua = { render: Pa }, Za = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Wa(l, e) {
  return s(), d("svg", Za, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm-.308 5h16.616a.69.69 0 0 1 .692.7v12.6a.7.7 0 0 1-.203.495.7.7 0 0 1-.49.205H3.693a.7.7 0 0 1-.49-.205A.7.7 0 0 1 3 18.3V5.7c0-.186.073-.364.203-.495A.7.7 0 0 1 3.693 5Zm4.846 5.6v2.8h6.923v-2.8zm-4.153 0v2.8h2.769v-2.8zm15.23 0h-2.769v2.8h2.77v-2.8Zm-6.923-1.4h6.923V6.4h-6.923zm-1.384 0V6.4H4.385v2.8zm0 5.6H4.385v2.8h6.923zm1.384 0v2.8h6.923v-2.8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ka = { render: Wa }, Ja = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ga(l, e) {
  return s(), d("svg", Ja, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.294 1.279a.75.75 0 0 1 .927.515l2.845 9.956H18a.75.75 0 0 1 0 1.5H6.5a.75.75 0 0 1-.721-.544l-3-10.5a.75.75 0 0 1 .515-.927",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.853 11.838a.75.75 0 0 1 .309 1.015l-4 7.5a.75.75 0 0 1-1.324-.706l4-7.5a.75.75 0 0 1 1.015-.309m4.83-.018a.75.75 0 0 1 .997.363l3.5 7.5a.75.75 0 1 1-1.36.634l-3.5-7.5a.75.75 0 0 1 .363-.996Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.223 17.466a.75.75 0 0 1 1.06.007 12.25 12.25 0 0 0 17.433 0 .75.75 0 0 1 1.068 1.054 13.75 13.75 0 0 1-19.568 0 .75.75 0 0 1 .007-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xa = { render: Ga }, Ya = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Qa(l, e) {
  return s(), d("svg", Ya, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M6.166 4.329a.562.562 0 1 0-1.082.309l2.25 7.875c.07.241.29.408.541.408h1.312l-2.312 4.337a9 9 0 0 1-1.412-1.17.562.562 0 1 0-.8.79 10.314 10.314 0 0 0 14.675 0 .562.562 0 1 0-.8-.79 9 9 0 0 1-1.389 1.153l-2.016-4.32H16.5a.563.563 0 0 0 0-1.125H8.3zm10.01 13.487-2.284-4.895h-3.43l-2.616 4.906a9.19 9.19 0 0 0 8.33-.011",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const e4 = { render: Qa }, l4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function t4(l, e) {
  return s(), d("svg", l4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.625 3.45a5.253 5.253 0 0 0-7.175 1.925l-.011.017-8.593 13.99a1.265 1.265 0 1 0 2.214 1.226l8.566-13.99a2.75 2.75 0 0 1 3.76-1.011 2.75 2.75 0 0 1 .997 3.772 1.249 1.249 0 1 0 2.165 1.25l.002-.004a5.254 5.254 0 0 0-1.925-7.175M14.25 1.477a6.753 6.753 0 0 1 7.6 9.896 2.751 2.751 0 1 1-4.76-2.753 1.249 1.249 0 1 0-2.165-1.25l-.012.02-8.568 13.994a2.765 2.765 0 1 1-4.784-2.776l8.595-13.991a6.75 6.75 0 0 1 4.094-3.139Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const n4 = { render: t4 }, a4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function r4(l, e) {
  return s(), d("svg", a4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m1.971-18.804a3.94 3.94 0 0 1 4.434 5.774l-.002.003a.938.938 0 1 1-1.624-.937 2.06 2.06 0 0 0-1.513-3.088 2.06 2.06 0 0 0-2.054 1.017L6.787 18.458l-.008.015a.95.95 0 0 1-1.652-.935l6.445-10.492.007-.013a3.94 3.94 0 0 1 2.392-1.837m3.552-.582a5.065 5.065 0 0 0-6.914 1.85L4.163 16.957l-.01.015a2.074 2.074 0 0 0 3.598 2.067l6.425-10.494.01-.015a.937.937 0 1 1 1.623.937 2.063 2.063 0 1 0 3.571 2.064 5.065 5.065 0 0 0-1.857-6.917",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const o4 = { render: r4 }, i4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s4(l, e) {
  return s(), d("svg", i4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.75 3.75V5a.75.75 0 0 1-.75.75H3.75v14.5h10.5V3.75zm6 16.5h4.5V9.75h-4.5v2.5H17a.75.75 0 0 1 0 1.5h-1.25v2.5H17a.75.75 0 0 1 0 1.5h-1.25zm0-12V3.6a1.35 1.35 0 0 0-1.35-1.35H9.6A1.35 1.35 0 0 0 8.25 3.6v.65H3.6A1.35 1.35 0 0 0 2.25 5.6v14.8a1.35 1.35 0 0 0 1.35 1.35h16.8a1.35 1.35 0 0 0 1.35-1.35V9.6a1.35 1.35 0 0 0-1.35-1.35zm-8.236.194a.75.75 0 0 1 .051 1.06l-.01.01a.75.75 0 0 1-1.11-1.008l.01-.011a.75.75 0 0 1 1.06-.051Zm4 0a.75.75 0 0 1 .051 1.06l-.01.01a.75.75 0 0 1-1.11-1.008l.01-.011a.75.75 0 0 1 1.06-.051Zm-4 4a.75.75 0 0 1 .051 1.06l-.01.01a.75.75 0 1 1-1.11-1.008l.01-.011a.75.75 0 0 1 1.06-.051Zm4 0a.75.75 0 0 1 .051 1.06l-.01.01a.75.75 0 0 1-1.11-1.008l.01-.011a.75.75 0 0 1 1.06-.051Zm-4 4a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.109-1.008l.01-.012a.75.75 0 0 1 1.06-.05Zm4 0a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.109-1.008l.01-.012a.75.75 0 0 1 1.06-.05Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d4 = { render: s4 }, c4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function u4(l, e) {
  return s(), d("svg", c4, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#e539b086-e8f4-455b-af4c-861174a74256-d8c7630d-e0fe-42db-aa5b-6d6795a44294-ae9d8820-0ec7-4e36-85ec-54286a747648-cdf12561-1be6-4a3d-b6c4-01997d376b1f-b1b6b2d1-7dc7-42ec-89f8-04a20424f2f4-8fdfab9d-05cf-4859-b31b-7faedf97f3e7-d71973-97dc65b8-0d5d-477f-83c1-fb1068df1dae-705da02b-5b11-4e2e-b1f8-937431371b42-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M10.27 6.615v-.961h3.46v12.692H5.655V7.192h4.038a.577.577 0 0 0 .577-.577m8.076 11.731h-3.461v-1.923h.961a.577.577 0 0 0 0-1.154h-.961v-1.923h.961a.577.577 0 0 0 0-1.154h-.961V10.27h3.461v8.077ZM14.885 5.538v3.577h3.577a1.04 1.04 0 0 1 1.038 1.039v8.308a1.04 1.04 0 0 1-1.038 1.038H5.538A1.04 1.04 0 0 1 4.5 18.462V7.077a1.04 1.04 0 0 1 1.038-1.039h3.577v-.5A1.04 1.04 0 0 1 10.154 4.5h3.692a1.04 1.04 0 0 1 1.039 1.038M8.588 10.08a.577.577 0 1 0-.853-.777l-.008.009a.577.577 0 0 0 .854.776zm3.077 0a.577.577 0 0 0-.853-.777l-.008.009a.577.577 0 1 0 .854.776zm-3.077 3.076a.577.577 0 1 0-.853-.776l-.008.009a.577.577 0 1 0 .854.776l.007-.008Zm3.077 0a.577.577 0 0 0-.853-.776l-.008.009a.577.577 0 1 0 .854.776l.007-.008Zm-3.077 3.077a.577.577 0 0 0-.853-.776l-.008.009a.577.577 0 1 0 .854.776zm3.077 0a.577.577 0 1 0-.853-.776l-.008.009a.577.577 0 1 0 .854.776z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const v4 = { render: u4 }, p4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function h4(l, e) {
  return s(), d("svg", p4, e[0] || (e[0] = [
    n("path", { d: "M3.75 9.187a.75.75 0 0 1 .75.75V21h3.75v-5.625a1.875 1.875 0 0 1 1.875-1.875h3.75a1.875 1.875 0 0 1 1.875 1.875V21h3.75V9.937a.75.75 0 0 1 1.5 0V21a1.5 1.5 0 0 1-1.5 1.5H15a.75.75 0 0 1-.75-.75v-6.375a.375.375 0 0 0-.375-.375h-3.75a.375.375 0 0 0-.375.375v6.375a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 21V9.937a.75.75 0 0 1 .75-.75" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 9.187a.75.75 0 0 1 .75.75v.23L11.985 3h.03l7.485 7.165v-.229a.75.75 0 0 1 1.5 0v1.665l.981.94a.75.75 0 1 0 1.038-1.084L19.5 8.09V3a.75.75 0 0 0-.75-.75H16.5a.75.75 0 0 0-.75.75v1.5l-2.71-2.595c-.304-.308-.72-.404-1.037-.404-.319 0-.736.094-1.042.404l-9.98 9.553a.75.75 0 0 0 1.038 1.084l.981-.94V9.937a.75.75 0 0 1 .75-.75M18 3.75v2.904l-.75-.718V3.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const f4 = { render: h4 }, m4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function w4(l, e) {
  return s(), d("svg", m4, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#ca75ecae-6800-4c05-b2f4-f5a2ad7af383-d2c109e6-0241-4c6e-b7ff-e8774f715d98-beef50f9-c5b4-49d9-823c-a8f60317e887-3102c3c9-0ccb-4a48-8a50-13219ac7f395-e8c9f64b-142b-4678-9327-b15f44a83f2a-79a55bc4-43d1-4b5e-b7ed-9006339f09d3-ce5ca3-16e33f95-6ee3-439f-b38e-95d64e3efae0-2e5f503e-85c3-4d1a-a721-6a04bf2ac275-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m.766-19.21 1.936 1.853V5.571c0-.295.24-.535.536-.535h1.607c.296 0 .536.24.536.535v3.636l2.513 2.406a.536.536 0 1 1-.74.774l-.702-.67v6.712a1.07 1.07 0 0 1-1.071 1.072h-3.215a.536.536 0 0 1-.535-.536V14.41a.27.27 0 0 0-.268-.268h-2.679a.27.27 0 0 0-.268.268v4.554c0 .296-.24.535-.536.535H6.666a1.07 1.07 0 0 1-1.071-1.07v-6.714l-.701.671a.536.536 0 1 1-.741-.774L11.28 4.79c.219-.221.517-.289.744-.289s.524.069.74.29Zm-.732.782 5.347 5.119v7.738h-2.679v-4.018a1.34 1.34 0 0 0-1.34-1.34h-2.678a1.34 1.34 0 0 0-1.34 1.34v4.018H6.667V10.69l5.347-5.118zm4.275 2.61V6.107h-.536V7.67z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const g4 = { render: w4 }, b4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function M4(l, e) {
  return s(), d("svg", b4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.513 3.971C4.371 2.606 5.495 1.5 6.825 1.5h10.35c1.328 0 2.456 1.105 2.311 2.472-.32 3.074-1.55 4.624-2.697 5.713a24 24 0 0 1-.572.521l-.2.18a7 7 0 0 0-.582.575C15.14 11.298 15 11.598 15 12c0 .406.141.709.432 1.051.154.182.344.366.577.58l.212.193c.174.158.365.332.552.512 1.137 1.092 2.367 2.638 2.713 5.686.156 1.376-.989 2.478-2.312 2.478H6.825c-1.322 0-2.468-1.102-2.31-2.478m-.002-16.05c.32 3.074 1.553 4.613 2.7 5.697.19.179.383.35.558.507l.213.19c.234.212.425.393.58.573.292.339.436.643.436 1.061 0 .421-.144.73-.434 1.072-.215.255-.458.474-.758.745-.173.156-.364.329-.58.535-1.136 1.086-2.367 2.621-2.714 5.67M6.825 3c-.526 0-.861.42-.82.816.275 2.64 1.288 3.866 2.238 4.762.173.164.338.311.506.46l.24.214c.242.22.491.453.71.708.458.53.801 1.169.801 2.04 0 .867-.337 1.508-.789 2.042-.278.328-.647.663-.997.98-.157.142-.31.281-.45.414-.948.906-1.962 2.135-2.26 4.755-.043.384.288.809.821.809h10.35c.533 0 .864-.425.82-.809-.297-2.621-1.313-3.862-2.26-4.774-.173-.165-.337-.314-.504-.466l-.238-.216a8 8 0 0 1-.703-.712c-.45-.529-.79-1.163-.79-2.023 0-.863.346-1.497.801-2.022a8 8 0 0 1 .71-.705l.225-.201c.172-.154.342-.306.52-.475.95-.902 1.964-2.14 2.239-4.781v-.002c.042-.393-.293-.814-.82-.814H6.824Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M16.092 20.25H7.928c-.731 0-.938-.844-.425-1.367 1.242-1.258 3.747-2.159 3.747-3.602V10.5c0-.93-1.781-1.64-2.883-3.15-.182-.249-.164-.6.298-.6h6.69c.395 0 .48.348.3.598C14.57 8.859 12.75 9.565 12.75 10.5v4.781c0 1.431 2.611 2.203 3.769 3.603.466.565.303 1.366-.427 1.366" }, null, -1)
  ]));
}
const x4 = { render: M4 }, y4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function A4(l, e) {
  return s(), d("svg", y4, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#26415438-0c80-4a52-aee4-1652b4181470-4ad34fef-a0cc-45e3-906d-1c5754cbf7f8-e8b9171e-c4b8-4ce5-9235-6021d5a8930f-f17aba34-6961-40ed-ae9a-5d98a243a113-83c139e3-9cdd-4484-b71a-dfad7da050c2-5c63421e-7584-476b-aa58-03523f993d7d-57d932-ef1d9f9a-1c86-49b2-babb-eb9c2dcb3c21-110cf655-b0e9-477e-a84a-a87c43b753e0-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M8.304 4.5c-.95 0-1.753.79-1.652 1.765.23 2.197 1.11 3.296 1.929 4.07.135.128.273.25.399.362l.151.136c.168.15.304.28.415.41.208.241.311.458.311.757 0 .301-.103.522-.31.766-.153.182-.327.338-.541.532-.124.111-.26.235-.415.382-.811.776-1.69 1.872-1.938 4.05-.112.983.706 1.77 1.65 1.77h7.393c.945 0 1.763-.787 1.651-1.77-.247-2.177-1.126-3.282-1.937-4.062-.134-.128-.27-.252-.395-.365l-.152-.138a5 5 0 0 1-.411-.414c-.208-.245-.31-.461-.31-.751 0-.287.101-.5.311-.742a5 5 0 0 1 .416-.41l.143-.13c.128-.114.27-.24.409-.372.819-.778 1.698-1.885 1.927-4.08.103-.977-.703-1.766-1.652-1.766zm-.586 1.654c-.03-.283.21-.583.586-.583h7.392c.377 0 .616.301.586.582v.001c-.197 1.887-.92 2.771-1.6 3.415-.126.12-.248.23-.37.34l-.161.143a6 6 0 0 0-.507.504c-.325.375-.573.827-.573 1.444 0 .614.243 1.067.565 1.445.154.182.33.35.502.508l.17.155c.118.108.236.215.36.333.677.651 1.402 1.538 1.615 3.41.03.274-.206.578-.587.578H8.304c-.381 0-.618-.304-.586-.578.212-1.872.937-2.75 1.614-3.396q.152-.144.32-.296c.251-.227.515-.466.713-.7.323-.382.564-.84.564-1.459 0-.622-.245-1.079-.572-1.457a6 6 0 0 0-.508-.506l-.17-.152a16 16 0 0 1-.363-.33c-.678-.64-1.402-1.515-1.598-3.401m1.373 11.739h5.832c.521 0 .638-.572.305-.976-.33-.4-.828-.728-1.304-1.043-.716-.473-1.388-.917-1.388-1.53v-3.415c0-.367.391-.684.873-1.074.396-.321.852-.691 1.202-1.178.129-.178.068-.427-.214-.427H9.618c-.33 0-.343.25-.213.429.351.481.8.849 1.188 1.167.482.395.871.715.871 1.083v3.415c0 .668-.752 1.174-1.523 1.691-.418.281-.841.566-1.153.881-.366.374-.219.977.303.977",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const V4 = { render: A4 }, H4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function B4(l, e) {
  return s(), d("svg", H4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.8 9.403c-.825.413-1.05.844-1.05 1.097s.225.684 1.05 1.097c.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097s-.225-.684-1.05-1.097c-.78-.39-1.91-.653-3.2-.653s-2.42.263-3.2.653m-.67-1.341c1.029-.515 2.398-.812 3.87-.812s2.841.297 3.87.812c.985.492 1.88 1.31 1.88 2.438 0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812a4.5 4.5 0 0 1-1.018-.68c-.9.315-1.973.492-3.112.492-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438a.75.75 0 0 1 1.5 0c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.851 0 1.636-.115 2.298-.307a2 2 0 0 1-.048-.443c0-1.127.895-1.946 1.88-2.438M3 12.25a.75.75 0 0 1 .75.75c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.831 0 1.6-.11 2.251-.293a.75.75 0 0 1 1.499.043c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097a.75.75 0 1 1 1.5 0c0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.526-.262-1.027-.618-1.378-1.065A9.8 9.8 0 0 1 8 16.25c-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3 4.75a.75.75 0 0 1 .75.75v11c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.83 0 1.598-.11 2.25-.293V10.5a.75.75 0 1 1 1.5 0v8c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097v-8a.75.75 0 1 1 1.5 0v8c0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.684-.341-1.323-.84-1.651-1.49A10 10 0 0 1 8 19.75c-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438v-11A.75.75 0 0 1 3 4.75m10 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.8 4.403c-.825.413-1.05.844-1.05 1.097s.225.684 1.05 1.097c.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097s-.225-.684-1.05-1.097c-.78-.39-1.91-.653-3.2-.653s-2.42.263-3.2.653m-.67-1.341C5.158 2.547 6.527 2.25 8 2.25s2.841.297 3.87.812c.985.492 1.88 1.31 1.88 2.438 0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.985-.492-1.88-1.31-1.88-2.438 0-1.127.895-1.946 1.88-2.438",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const z4 = { render: B4 }, C4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function L4(l, e) {
  return s(), d("svg", C4, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#8e8c748a-e32b-4751-adef-167b43796694-e4d30d68-b262-4662-9ea9-5d30fc1bd364-748352c2-157f-4e73-8d1f-d361fbfe115a-ce186941-91f7-4f96-85d2-483d74d98a53-6dad263e-f7e2-4d98-a349-705229ba3aa7-1ecdbce8-1059-4152-9261-d7f230e0a621-124266-fbfef5d1-9a7e-402b-a343-4fead240da4e-c49a1bd3-ccb3-44ef-bd3c-c4d51c34c402-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M5.654 7c0-.195.173-.526.808-.844.6-.3 1.47-.502 2.461-.502.992 0 1.861.202 2.462.502.634.318.807.65.807.844s-.173.526-.807.844c-.6.3-1.47.502-2.462.502s-1.861-.202-2.461-.502c-.635-.318-.808-.65-.808-.844M4.5 7c0-.867.688-1.497 1.446-1.876.791-.396 1.845-.624 2.977-.624s2.186.228 2.978.624c.757.38 1.445 1.009 1.445 1.876v1.535a7.8 7.8 0 0 1 1.73-.189c1.133 0 2.187.229 2.979.625.757.378 1.445 1.008 1.445 1.875V17c0 .867-.688 1.497-1.445 1.875-.792.396-1.846.625-2.978.625s-2.186-.229-2.978-.625c-.525-.262-1.017-.646-1.27-1.145a7.7 7.7 0 0 1-1.906.231c-1.132 0-2.186-.228-2.977-.624-.758-.379-1.446-1.009-1.446-1.876zm7.692 1.714v.211l-.093.046c-.757.378-1.445 1.008-1.445 1.875v.352a6.5 6.5 0 0 1-1.73.225c-.993 0-1.862-.202-2.462-.502-.635-.318-.808-.65-.808-.844V8.714q.143.087.292.162c.791.396 1.845.624 2.977.624s2.186-.228 2.978-.624a4 4 0 0 0 .291-.162M5.654 12.77v-.978q.143.087.292.162c.791.396 1.845.624 2.977.624a7.7 7.7 0 0 0 1.73-.189v1.502a6.4 6.4 0 0 1-1.73.225c-.992 0-1.861-.202-2.461-.502-.635-.318-.808-.65-.808-.844m6.154 1.154v-1.362q.143.087.291.16c.792.397 1.846.625 2.978.625s2.186-.228 2.978-.624q.148-.075.291-.161v1.362c0 .194-.173.526-.808.844-.6.3-1.47.502-2.461.502-.992 0-1.861-.202-2.462-.502-.634-.318-.807-.65-.807-.844m6.247 1.876q.148-.075.291-.161V17c0 .194-.173.526-.808.843-.6.3-1.47.503-2.461.503-.992 0-1.861-.202-2.462-.503-.634-.317-.807-.649-.807-.843v-1.362q.143.086.291.16c.792.397 1.846.625 2.978.625s2.186-.228 2.978-.624Zm-9.132-.53a7.7 7.7 0 0 0 1.73-.189v1.502a6.4 6.4 0 0 1-1.73.226c-.992 0-1.861-.203-2.461-.503-.635-.317-.808-.65-.808-.844v-.977q.143.087.292.16c.791.397 1.845.625 2.977.625m3.692-5.267q.165-.082.354-.153l.006-.002c.566-.213 1.293-.347 2.102-.347.992 0 1.861.202 2.461.502.635.318.808.65.808.844 0 .195-.173.526-.808.844-.6.3-1.47.502-2.461.502-.992 0-1.861-.202-2.462-.502-.634-.318-.807-.65-.807-.844s.173-.526.807-.844",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const S4 = { render: L4 }, E4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function T4(l, e) {
  return s(), d("svg", E4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 1.25a.75.75 0 0 1 .554.244 16.05 16.05 0 0 1 4.196 10.522 16.05 16.05 0 0 1-4.196 10.49.75.75 0 0 1-1.108 0A16.05 16.05 0 0 1 7.25 11.984a16.05 16.05 0 0 1 4.196-10.49A.75.75 0 0 1 12 1.25M8.75 12A14.55 14.55 0 0 0 12 20.851 14.55 14.55 0 0 0 15.25 12 14.55 14.55 0 0 0 12 3.149 14.55 14.55 0 0 0 8.75 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _4 = { render: T4 }, R4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function k4(l, e) {
  return s(), d("svg", R4, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#fb35ee65-1f3e-46dc-ae0c-0a010d12dff3-0febc703-73ce-429e-9012-31e83d95dea9-88e4aa94-5923-48c7-a2e2-95dd4e838dc0-39b5c902-11b3-4f14-a133-ace3f2db37b3-75f38bb3-d7b0-432a-a1f6-ef2113a4e168-43b8e639-12a1-4853-9e22-4f27cf6db690-12b762-1a216548-36a6-4091-97a8-b32242ef2d93-231168c2-6203-4e3d-b2cd-fbdca797c007-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M10.722 5.18a6.94 6.94 0 0 0-5.637 6.258h3.377c.15-2.262.937-4.43 2.26-6.258M12 3.938a8.063 8.063 0 1 0 0 16.125 8.063 8.063 0 0 0 0-16.125m1.278 1.242a12.04 12.04 0 0 1 2.26 6.258h3.377a6.94 6.94 0 0 0-5.637-6.258m1.133 6.258A10.9 10.9 0 0 0 12 5.362a10.9 10.9 0 0 0-2.41 6.075zm0 1.124A10.9 10.9 0 0 1 12 18.64a10.9 10.9 0 0 1-2.41-6.076h4.82Zm-5.95 0H5.086a6.94 6.94 0 0 0 5.637 6.258 12.04 12.04 0 0 1-2.26-6.258Zm4.817 6.258a12.04 12.04 0 0 0 2.26-6.258h3.377a6.94 6.94 0 0 1-5.637 6.258",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const O4 = { render: k4 }, $4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function N4(l, e) {
  return s(), d("svg", $4, e[0] || (e[0] = [
    n("path", { d: "M19.3 6a.3.3 0 0 0-.3-.3c-2.226 0-4.874-1.295-6.701-2.893h-.001a.47.47 0 0 0-.604.005C9.991 4.298 7.553 5.536 5.422 5.685L5 5.7a.3.3 0 0 0-.3.3v7c0 2.315.802 4.015 2.072 5.316 1.128 1.155 2.65 2.019 4.376 2.687l.75.275.016.006a.3.3 0 0 0 .2.003c2.027-.708 3.827-1.648 5.115-2.97 1.269-1.301 2.07-3.002 2.07-5.318zm1.4 7c0 2.684-.948 4.734-2.469 6.294-1.501 1.541-3.53 2.574-5.66 3.317l-.006.002a1.7 1.7 0 0 1-1.124-.012v.001c-2.135-.737-4.167-1.768-5.67-3.308C4.248 17.735 3.3 15.684 3.3 13V6A1.7 1.7 0 0 1 5 4.3l.339-.012c1.725-.126 3.88-1.173 5.44-2.536l.006-.004.131-.103a1.87 1.87 0 0 1 2.168 0l.13.103.007.005.321.27C15.183 3.347 17.337 4.3 19 4.3A1.7 1.7 0 0 1 20.7 6z" }, null, -1),
    n("path", { d: "M14.615 9.415a.7.7 0 0 1 .97.97l-.09.11-4 4a.7.7 0 0 1-.88.09l-.11-.09-2-2-.09-.11a.7.7 0 0 1 .97-.97l.11.09L11 13.01l3.505-3.505z" }, null, -1)
  ]));
}
const F4 = { render: N4 }, D4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function I4(l, e) {
  return s(), d("svg", D4, e[0] || (e[0] = [
    n("path", { d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m0 3.975c-.292 0-.576.091-.812.26l-.1.077-.003.003c-1.17 1.022-2.788 1.807-4.081 1.9l-.254.01A1.275 1.275 0 0 0 5.475 7.5v5.25c0 2.014.711 3.551 1.853 4.72 1.125 1.152 2.644 1.924 4.241 2.476v.001c.275.102.577.107.855.013l.004-.001c1.597-.557 3.12-1.332 4.246-2.487 1.14-1.17 1.851-2.709 1.851-4.722V7.5a1.277 1.277 0 0 0-1.275-1.274c-1.247 0-2.863-.715-4.094-1.708l-.24-.203-.005-.003-.098-.078a1.4 1.4 0 0 0-.813-.26m0 1.05c.084 0 .165.03.229.084 1.37 1.196 3.353 2.166 5.021 2.166a.226.226 0 0 1 .225.225v5.25c0 1.736-.601 3.012-1.553 3.988-.966.991-2.317 1.697-3.839 2.228a.2.2 0 0 1-.072.011l-.075-.014-.012-.004-.564-.206c-1.294-.501-2.435-1.15-3.28-2.016-.953-.975-1.555-2.25-1.555-3.987V7.5a.225.225 0 0 1 .225-.225l.316-.011c1.599-.112 3.427-1.041 4.705-2.156v.001A.35.35 0 0 1 12 5.025m2.621 5.104a.525.525 0 0 0-.742 0l-2.629 2.629-1.129-1.13-.082-.066a.525.525 0 0 0-.727.727l.067.082 1.5 1.5a.525.525 0 0 0 .742 0l3-3a.525.525 0 0 0 0-.742" }, null, -1)
  ]));
}
const j4 = { render: I4 }, q4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function P4(l, e) {
  return s(), d("svg", q4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.906 12.844a7.03 7.03 0 0 0-7.03 7.031V21a.844.844 0 1 1-1.688 0v-1.125a8.719 8.719 0 0 1 17.437 0V21a.844.844 0 1 1-1.687 0v-1.125a7.03 7.03 0 0 0-7.032-7.031",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.906 3.844a3.656 3.656 0 1 0 0 7.312 3.656 3.656 0 0 0 0-7.312M6.563 7.5a5.344 5.344 0 1 1 10.687 0 5.344 5.344 0 0 1-10.687 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const U4 = { render: P4 }, Z4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function W4(l, e) {
  return s(), d("svg", Z4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M9.164 8.625a2.742 2.742 0 1 1 5.485 0 2.742 2.742 0 0 1-5.485 0m5.154 3.201a4.008 4.008 0 1 0-4.823 0 6.54 6.54 0 0 0-4.128 6.08v.844a.633.633 0 1 0 1.266 0v-.844a5.273 5.273 0 0 1 10.547 0v.844a.633.633 0 1 0 1.265 0v-.844c0-2.76-1.71-5.12-4.127-6.08",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const K4 = { render: W4 }, J4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function G4(l, e) {
  return s(), d("svg", J4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.906 12.631A3.577 3.577 0 0 0 8.33 16.21v.841a.631.631 0 0 1-1.263 0v-.841a4.84 4.84 0 0 1 9.68 0v.841a.631.631 0 0 1-1.262 0v-.841a3.577 3.577 0 0 0-3.578-3.578Zm-6.733 1.684a1.894 1.894 0 0 0-1.894 1.894v.841a.631.631 0 0 1-1.263 0v-.841a3.157 3.157 0 0 1 3.157-3.157zm13.467 0c1.046 0 1.894.848 1.894 1.894v.841a.631.631 0 0 0 1.263 0v-.841a3.157 3.157 0 0 0-3.157-3.157z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.906 7.581a1.894 1.894 0 1 0 0 3.788 1.894 1.894 0 0 0 0-3.788M8.75 9.475a3.156 3.156 0 1 1 6.313 0 3.156 3.156 0 0 1-6.313 0m-3.577 1.473a1.052 1.052 0 1 0 0 2.104 1.052 1.052 0 0 0 0-2.104M2.858 12a2.315 2.315 0 1 1 4.63 0 2.315 2.315 0 0 1-4.63 0m15.782-1.052a1.052 1.052 0 1 0 0 2.104 1.052 1.052 0 0 0 0-2.104M16.326 12a2.315 2.315 0 1 1 4.629 0 2.315 2.315 0 0 1-4.63 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X4 = { render: G4 }, Y4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Q4(l, e) {
  return s(), d("svg", Y4, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m-1.514-13.894a1.42 1.42 0 1 1 2.84 0 1.42 1.42 0 0 1-2.84 0m2.987 1.775a2.367 2.367 0 1 0-3.133 0 3.63 3.63 0 0 0-2.064 3.275v.632a.473.473 0 1 0 .947 0v-.632a2.683 2.683 0 0 1 5.366 0v.632a.474.474 0 0 0 .947 0v-.632a3.63 3.63 0 0 0-2.063-3.275m-8.037 3.275c0-.784.636-1.42 1.42-1.42a1.736 1.736 0 1 0-1.285-.568 2.37 2.37 0 0 0-1.082 1.988v.632a.473.473 0 0 0 .947 0zm11.52-1.42a1.42 1.42 0 0 1 1.421 1.42v.632a.473.473 0 0 0 .947 0v-.632c0-.834-.43-1.567-1.082-1.988a1.736 1.736 0 1 0-1.285.568Zm-10.1-2.525a.79.79 0 1 0 0 1.578.79.79 0 0 0 0-1.578m9.312.79a.79.79 0 1 1 1.578 0 .79.79 0 0 1-1.578 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const e6 = { render: Q4 }, l6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function t6(l, e) {
  return s(), d("svg", l6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a.75.75 0 0 1 .75.75v.026c5.45.385 9.75 4.927 9.75 10.474a.75.75 0 0 1-1.28.53 2.434 2.434 0 0 0-3.44 0 .75.75 0 0 1-1.06 0 2.92 2.92 0 0 0-3.816-.27l-.154.115v7.125a2.25 2.25 0 0 1-4.5 0 .75.75 0 0 1 1.5 0 .75.75 0 1 0 1.5 0v-7.125l-.154-.116a2.92 2.92 0 0 0-3.816.271.75.75 0 0 1-1.06 0 2.43 2.43 0 0 0-3.44 0 .75.75 0 0 1-1.28-.53c0-5.547 4.3-10.09 9.75-10.474V2.25A.75.75 0 0 1 12 1.5m0 10.312.004-.003a4.42 4.42 0 0 1 5.252-.038 3.93 3.93 0 0 1 3.631-.45 9.002 9.002 0 0 0-17.774 0 3.93 3.93 0 0 1 3.631.45 4.42 4.42 0 0 1 5.252.038z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const n6 = { render: t6 }, a6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function r6(l, e) {
  return s(), d("svg", a6, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#51d717ea-d42a-4736-8e39-70a845a169eb-d813afb9-0ced-4fd3-be00-5fecd4e0b949-a451124e-b4cf-463f-9706-a566cc5f19e6-af7f97eb-3ed7-46ec-93a1-41d84635f58d-c0673fda-d8c7-4e7a-b5fd-e7cd47ece59b-70534381-1ed7-44cd-89fd-643cb24c3a68-760368-09e0e970-5e9f-4d4a-bbfd-b47350605f43-76083302-0ada-4a0c-b187-91cd8f681b1d-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m.536-18.964a.536.536 0 1 0-1.072 0v.019a7.5 7.5 0 0 0-6.964 7.48.536.536 0 0 0 .915.38 1.737 1.737 0 0 1 2.456 0c.21.209.549.209.758 0a2.085 2.085 0 0 1 2.725-.194l.11.082v5.09a.536.536 0 0 1-1.071 0 .536.536 0 0 0-1.072 0 1.607 1.607 0 0 0 3.215 0v-5.09l.11-.082a2.086 2.086 0 0 1 2.725.194c.21.209.549.209.758 0a1.737 1.737 0 0 1 2.456 0 .536.536 0 0 0 .915-.38 7.5 7.5 0 0 0-6.964-7.48zm-.533 6.828-.003.002-.003-.002a3.16 3.16 0 0 0-3.751-.027 2.81 2.81 0 0 0-2.594-.322 6.43 6.43 0 0 1 12.696 0 2.8 2.8 0 0 0-2.594.322 3.16 3.16 0 0 0-3.751.027",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const o6 = { render: r6 }, i6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s6(l, e) {
  return s(), d("svg", i6, e[0] || (e[0] = [
    n("path", { d: "M19 17.583c1.25-1.5 2-3.5 2-5.583 0-4.917-4-9-9-9s-9 4.083-9 9 4 9 9 9c2.833 0 5.333-1.333 7-3.417M12 4.25a7.647 7.647 0 0 1 7.667 7.667c0 1.583-.5 3.083-1.334 4.333-.916-.75-2.916-2.083-6.333-2.083s-5.5 1.25-6.333 2.083a7.83 7.83 0 0 1-1.334-4.333C4.333 7.75 7.75 4.25 12 4.25m0 15.5a7.68 7.68 0 0 1-5.583-2.417c.666-.583 2.416-1.75 5.583-1.75s4.917 1.167 5.583 1.75C16.167 18.75 14.167 19.75 12 19.75" }, null, -1),
    n("path", { d: "M12.004 12.563c1.71 0 3.094-1.403 3.094-3.136 0-1.732-1.385-3.052-3.094-3.052-1.71 0-3.094 1.402-3.094 3.135s1.384 3.053 3.094 3.053m0-4.95c.977 0 1.79.824 1.79 1.814s-.813 1.816-1.79 1.816-1.791-.825-1.791-1.816c0-.99.814-1.814 1.79-1.814Z" }, null, -1)
  ]));
}
const d6 = { render: s6 }, c6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function u6(l, e) {
  return s(), d("svg", c6, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#2813df66-36be-4a96-a301-629e5b92ea14-afcda85d-57be-45d5-a906-d133d9c42349-92424616-fbde-4ce0-838d-1ad82effc8ca-867d095e-b92c-4899-9420-473564afa918-d236ada5-078f-4fcf-8b80-b22484e096d2-c8f92bb8-378b-4e72-8cf3-88f0cb3bdb89-ae6272-ef9c8ac0-b106-4613-b5fd-d4c06e252037-b9accdae-36f7-4843-b6f3-758a20a54d9d-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m6.75-12a6.6 6.6 0 0 1-1.5 4.188C16 17.75 14.125 18.75 12 18.75c-3.75 0-6.75-3.063-6.75-6.75 0-3.688 3-6.75 6.75-6.75s6.75 3.063 6.75 6.75m-1-.063A5.735 5.735 0 0 0 12 6.188c-3.188 0-5.75 2.625-5.75 5.75a5.87 5.87 0 0 0 1 3.25c.625-.624 2.188-1.562 4.75-1.562 2.563 0 4.063 1 4.75 1.563a5.87 5.87 0 0 0 1-3.25ZM7.812 16A5.76 5.76 0 0 0 12 17.813c1.625 0 3.125-.75 4.188-1.813-.5-.438-1.813-1.313-4.188-1.313S8.312 15.563 7.812 16m6.511-5.93c0 1.3-1.038 2.352-2.32 2.352s-2.32-.99-2.32-2.29c0-1.299 1.038-2.35 2.32-2.35s2.32.99 2.32 2.289Zm-.977 0c0-.742-.61-1.36-1.343-1.36s-1.344.618-1.344 1.36.611 1.362 1.344 1.362 1.343-.619 1.343-1.361Z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const v6 = { render: u6 }, p6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function h6(l, e) {
  return s(), d("svg", p6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.055 2.055A2.75 2.75 0 0 1 11 1.25h2A2.75 2.75 0 0 1 15.75 4v4.25H20A2.75 2.75 0 0 1 22.75 11v2A2.75 2.75 0 0 1 20 15.75h-4.25V20A2.75 2.75 0 0 1 13 22.75h-2A2.756 2.756 0 0 1 8.25 20v-4.25H4A2.756 2.756 0 0 1 1.25 13v-2A2.75 2.75 0 0 1 4 8.25h4.25V4c0-.73.29-1.429.805-1.945M11 2.75A1.25 1.25 0 0 0 9.75 4v5a.75.75 0 0 1-.75.75H4A1.25 1.25 0 0 0 2.75 11v2c0 .686.564 1.25 1.25 1.25h5a.75.75 0 0 1 .75.75v5c0 .686.564 1.25 1.25 1.25h2A1.25 1.25 0 0 0 14.25 20v-5a.75.75 0 0 1 .75-.75h5A1.25 1.25 0 0 0 21.25 13v-2A1.25 1.25 0 0 0 20 9.75h-5a.75.75 0 0 1-.75-.75V4A1.25 1.25 0 0 0 13 2.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const f6 = { render: h6 }, m6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function w6(l, e) {
  return s(), d("svg", m6, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#baea3703-60f6-4f03-86c0-ac6a1f3c07d0-2ab5e10f-5ede-457d-9fd8-464a6fd97d6d-670bfb58-f415-4d42-b684-bb17defc1039-b70df7ac-90c7-4900-9d9e-a497a417654b-ccc8902c-b825-4ce9-9d21-3b2dc53a8678-b81491c4-a493-4deb-b012-e24bf28252b5-39cd42-124e4bf7-2808-4ec4-a611-9fa9d948aeea-b57f0583-1773-497d-90ab-95f2eb2c8a63-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M9.946 5.062c.36-.36.848-.562 1.356-.562h1.396a1.92 1.92 0 0 1 1.918 1.919v2.965h2.965a1.92 1.92 0 0 1 1.919 1.918v1.396a1.92 1.92 0 0 1-1.919 1.918h-2.965v2.965a1.92 1.92 0 0 1-1.918 1.919h-1.396a1.923 1.923 0 0 1-1.918-1.919v-2.965H6.419A1.923 1.923 0 0 1 4.5 12.698v-1.396a1.92 1.92 0 0 1 1.919-1.918h2.965V6.419c0-.51.202-.997.562-1.357m.74.74a.87.87 0 0 1 .616-.255h1.396a.87.87 0 0 1 .872.872v3.488c0 .289.234.523.523.523h3.488a.87.87 0 0 1 .872.872v1.396a.87.87 0 0 1-.872.872h-3.488a.523.523 0 0 0-.523.523v3.488a.87.87 0 0 1-.872.872h-1.396a.876.876 0 0 1-.872-.872v-3.488a.523.523 0 0 0-.523-.523H6.419a.876.876 0 0 1-.872-.872v-1.396a.87.87 0 0 1 .872-.872h3.488a.523.523 0 0 0 .523-.523V6.419a.87.87 0 0 1 .256-.617",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const g6 = { render: w6 }, b6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function M6(l, e) {
  return s(), d("svg", b6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a.75.75 0 0 1 .75.75v3.25H16a.75.75 0 0 1 0 1.5h-3.25V16a.75.75 0 0 1-1.5 0v-3.25H8a.75.75 0 0 1 0-1.5h3.25V8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const x6 = { render: M6 }, y6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function A6(l, e) {
  return s(), d("svg", y6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5H13a.75.75 0 0 1 0 1.5H3.6a1.35 1.35 0 0 1-1.35-1.35V3.6A1.35 1.35 0 0 1 3.6 2.25h16.8a1.35 1.35 0 0 1 1.35 1.35V13a.75.75 0 0 1-1.5 0V3.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-1.945-.695a2.75 2.75 0 1 1 3.89 3.89 2.75 2.75 0 0 1-3.89-3.89m-4.35 6.256a.75.75 0 0 1 .605.006l5.5 2.5a.75.75 0 0 1-.62 1.366l-5.2-2.363-6.696 2.87a.75.75 0 0 1-.59-1.38zM19 15.25a.75.75 0 0 1 .75.75v2.25H22a.75.75 0 1 1 0 1.5h-2.25V22a.75.75 0 1 1-1.5 0v-2.25H16a.75.75 0 0 1 0-1.5h2.25V16a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const V6 = { render: A6 }, H6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function B6(l, e) {
  return s(), d("svg", H6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "m12 6.015 1.832 1.56 2.4.192.192 2.4L17.986 12l-1.563 1.832-.191 2.4-2.4.192L12 17.985l-1.832-1.562-2.4-.191-.192-2.4L6.015 12l1.56-1.832.192-2.4 2.4-.192zm0 1.97-1.23 1.047-1.61.129-.128 1.61-1.047 1.23 1.047 1.228.129 1.61 1.611.128 1.229 1.048 1.229-1.047 1.608-.129.129-1.61 1.048-1.23-1.047-1.228-.129-1.61-1.61-.129z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M10.47 15.695 12 17V7l-1.53 1.304-2.006.16-.16 2.005L7 12l1.304 1.53.16 2.006z" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5h16.5V3.75zM2.646 2.645A1.35 1.35 0 0 1 3.6 2.25h16.8a1.35 1.35 0 0 1 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V3.6c0-.358.142-.701.396-.955",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const z6 = { render: B6 }, C6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function L6(l, e) {
  return s(), d("svg", C6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7 1.25a.75.75 0 0 1 .75.75v4a.75.75 0 1 1-1.5 0V4.75H5A1.25 1.25 0 0 0 3.75 6v3.25h16.5V6A1.25 1.25 0 0 0 19 4.75h-.5a.75.75 0 0 1 0-1.5h.5A2.75 2.75 0 0 1 21.75 6v13A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V6A2.75 2.75 0 0 1 5 3.25h1.25V2A.75.75 0 0 1 7 1.25m13.25 9.5H3.75V19A1.25 1.25 0 0 0 5 20.25h14A1.25 1.25 0 0 0 20.25 19zM15 1.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V4.75H10.5a.75.75 0 0 1 0-1.5h3.75V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const S6 = { render: L6 }, E6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function T6(l, e) {
  return s(), d("svg", E6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.227 6.227a.75.75 0 0 1 1.06 0L12 10.939l4.712-4.712a.75.75 0 0 1 1.061 1.06L13.061 12l4.712 4.712a.75.75 0 1 1-1.06 1.06L12 13.062l-4.712 4.712a.75.75 0 0 1-1.06-1.06L10.94 12 6.227 7.288a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _6 = { render: T6 }, R6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function k6(l, e) {
  return s(), d("svg", R6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.47 12.47a.75.75 0 0 1 1.06 0L9 15.94l9.47-9.47a.75.75 0 0 1 1.06 1.06l-10 10a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const O6 = { render: k6 }, $6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function N6(l, e) {
  return s(), d("svg", $6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.47 11.97a.75.75 0 0 1 1.06 0L10 14.44l6.47-6.47a.75.75 0 1 1 1.06 1.06l-7 7a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const F6 = { render: N6 }, D6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function I6(l, e) {
  return s(), d("svg", D6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6 4.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 20V6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5zM14.75 4a.75.75 0 0 1 .75-.75H18A2.75 2.75 0 0 1 20.75 6v9a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.319 2.417c-.32.377-.466.855-.529 1.215-.086.5-.475.982-1.04 1.094V6.25h6.5V4.726c-.565-.112-.954-.594-1.04-1.094-.063-.36-.21-.838-.529-1.215-.293-.346-.781-.667-1.68-.667-.9 0-1.389.321-1.682.667m-1.144-.97C9.762.755 10.674.25 12 .25s2.238.505 2.826 1.197c.52.614.742 1.322.84 1.814A1.25 1.25 0 0 1 16.75 4.5v1.9a1.35 1.35 0 0 1-1.35 1.35H8.6A1.35 1.35 0 0 1 7.25 6.4V4.5a1.25 1.25 0 0 1 1.084-1.24c.098-.491.32-1.2.84-1.813ZM14.97 19.97a.75.75 0 0 1 1.06 0l1.47 1.47 4.47-4.47a.75.75 0 0 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const j6 = { render: I6 }, q6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function P6(l, e) {
  return s(), d("svg", q6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.75 9.75v10.5h10.5V9.75zM8.645 8.645A1.35 1.35 0 0 1 9.6 8.25h10.8a1.35 1.35 0 0 1 1.35 1.35v10.8a1.35 1.35 0 0 1-1.35 1.35H9.6a1.35 1.35 0 0 1-1.35-1.35V9.6c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v10.5h10.5V3.75zM2.645 2.645A1.35 1.35 0 0 1 3.6 2.25h10.8a1.35 1.35 0 0 1 1.35 1.35v10.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V3.6c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const U6 = { render: P6 }, Z6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function W6(l, e) {
  return s(), d("svg", Z6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.75 9.75v9.5h9.5v-9.5zM8.645 8.645A1.35 1.35 0 0 1 9.6 8.25h9.8a1.35 1.35 0 0 1 1.35 1.35v9.8a1.35 1.35 0 0 1-1.35 1.35H9.6a1.35 1.35 0 0 1-1.35-1.35V9.6c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.645 3.645A1.35 1.35 0 0 1 4.6 3.25h9.8a1.35 1.35 0 0 1 1.35 1.35V9a.75.75 0 0 1-1.5 0V4.75h-9.5v9.5H9a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V4.6c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const K6 = { render: W6 }, J6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function G6(l, e) {
  return s(), d("svg", J6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.35 3A1.35 1.35 0 0 0 3 4.35v9.8a1.35 1.35 0 0 0 1.35 1.35H8v3.65a1.35 1.35 0 0 0 1.35 1.35h9.8a1.35 1.35 0 0 0 1.35-1.35v-9.8A1.35 1.35 0 0 0 19.15 8H15.5V4.35A1.35 1.35 0 0 0 14.15 3zM14 8V4.5H4.5V14H8V9.35A1.35 1.35 0 0 1 9.35 8zm-4.5 6.75V19H19V9.5H9.5zm4.75-4.25a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5H15v2.25a.75.75 0 0 1-1.5 0V15h-2.25a.75.75 0 0 1 0-1.5h2.25v-2.25a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X6 = { render: G6 }, Y6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Q6(l, e) {
  return s(), d("svg", Y6, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.64 8.641a.75.75 0 0 1 1.062 0L12 10.94l2.298-2.298a.75.75 0 0 1 1.06 1.06L13.06 12l2.298 2.298a.75.75 0 1 1-1.06 1.06L12 13.062 9.702 15.36a.75.75 0 0 1-1.061-1.06l2.298-2.3-2.298-2.298a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const er = { render: Q6 }, lr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function tr(l, e) {
  return s(), d("svg", lr, e[0] || (e[0] = [
    n("path", { d: "M21.9 6.975c0-.75-.3-1.425-.825-1.95l-2.1-2.1a2.7 2.7 0 0 0-.9-.6c-.675-.3-1.425-.3-2.1 0-.3.15-.6.375-.9.6L12.3 5.7c-.075 0-.15 0-.15.075l-5.4 2.25c-.15.075-.375.15-.45.3a.51.51 0 0 0-.3.45L2.175 20.1c-.075.225-.075.45 0 .75.075.225.15.45.375.675.15.15.375.3.6.375.15 0 .225.075.375.075s.225 0 .375-.075l11.7-3.45c.225-.075.375-.15.525-.3s.3-.3.375-.525l1.875-5.7v-.15L21.075 9c.525-.6.825-1.275.825-2.025M15 16.95l-9.825 2.925L9.75 15.3c.3.15.6.225.975.225.6 0 1.2-.225 1.575-.675q.675-.675.675-1.575c0-.9-.225-1.2-.675-1.575-.225-.225-.45-.375-.75-.45a2.3 2.3 0 0 0-1.725 0c-.3.15-.525.3-.75.525s-.375.45-.45.75c-.15.3-.15.6-.15.825s.075.6.15.825l.075.075-4.425 4.425L7.425 9.3l5.25-2.175L16.95 11.4zm-5.1-3.6c0-.075 0-.225.075-.3 0-.075.075-.15.15-.225s.15-.15.225-.15c.075-.075.225-.075.3-.075s.225 0 .3.075.15.075.225.15c.15.15.225.3.225.525a.68.68 0 0 1-.225.525c-.3.3-.75.3-1.05 0-.075-.075-.15-.15-.15-.225-.075-.15-.075-.225-.075-.3m10.125-5.475L17.7 10.2l-3.9-3.9 2.325-2.325c.15-.15.225-.225.375-.3.3-.15.675-.15.975 0 .15.075.3.15.375.3l2.1 2.1c.225.225.375.525.375.9s-.075.6-.3.9" }, null, -1)
  ]));
}
const nr = { render: tr }, ar = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function rr(l, e) {
  return s(), d("svg", ar, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#8e8294d8-9cbe-4197-bb18-ebeb1f694c11-e2eb61a6-6858-4cb0-a7a3-458d2a9c847f-ed556040-23d7-4f96-a499-437cde2d4308-144ceb68-c179-45cb-8e10-89df8e61744f-b52a2461-65f6-4c95-bafe-0f87cc673dc7-20b49c93-f94f-49fc-9898-2c50947c09f8-c77862-42e7dc49-90f6-452d-bf08-7730f133a2cc-ae3ce0b2-00a1-4b6c-834b-ff0bed82da3a-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M16.53 6.47a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0M.97 11.97a.75.75 0 0 1 1.06 0L6 15.94 7.94 14l-1.47-1.47a.75.75 0 1 1 1.06-1.06L12 15.94l9.47-9.47a.75.75 0 0 1 1.06 1.06l-9.575 9.576a1.35 1.35 0 0 1-1.91 0L9 15.061l-2.045 2.045a1.35 1.35 0 0 1-1.91 0L.97 13.03a.75.75 0 0 1 0-1.06",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const or = { render: rr }, ir = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sr(l, e) {
  return s(), d("svg", ir, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 20a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m6.22-3.47a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 0 0-1.06-1.06l-2.22 2.22V4a.75.75 0 0 0-1.5 0v10.19l-2.22-2.22a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dr = { render: sr }, cr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ur(l, e) {
  return s(), d("svg", cr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m3.22-3.47a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22V6a.75.75 0 0 0-1.5 0v5.19L9.03 8.97a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vr = { render: ur }, pr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function hr(l, e) {
  return s(), d("svg", pr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M17.258 4.336a1.25 1.25 0 0 0-.884.366l-.95.95 3.182 3.181.95-.95a1.25 1.25 0 0 0 0-1.767l-1.414-1.414a1.25 1.25 0 0 0-.884-.366m.288 5.558-3.183-3.181-9.085 9.084a1.25 1.25 0 0 0-.362.774l-.242 2.74a.25.25 0 0 0 .072.2.25.25 0 0 0 .2.072l2.74-.242c.292-.026.567-.154.775-.361zm-1.341-6.849a2.75 2.75 0 0 1 2.998.597l1.413 1.414a2.75 2.75 0 0 1 0 3.888l-1.48 1.48-9.614 9.616a2.75 2.75 0 0 1-1.705.795l-2.74.242A1.75 1.75 0 0 1 3.18 19.18l.242-2.74a2.75 2.75 0 0 1 .795-1.702l9.616-9.615 1.48-1.48a2.8 2.8 0 0 1 .892-.597Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const fr = { render: hr }, mr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function wr(l, e) {
  return s(), d("svg", mr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 21a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M7.934 6.934a.75.75 0 0 1 1.06 0l7.425 7.425a.75.75 0 1 1-1.06 1.06L7.934 7.995a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.384 3.945a1.25 1.25 0 0 0-1.768 0l-9.192 9.192a1.25 1.25 0 0 0 0 1.768l5 5a1.18 1.18 0 0 0 1.667 0l9.243-9.243a1.25 1.25 0 0 0 0-1.768zM9.257 21.75a2.68 2.68 0 0 0 1.895-.785l9.242-9.242a2.75 2.75 0 0 0 0-3.89l-4.95-4.95a2.75 2.75 0 0 0-3.889 0l-9.192 9.193a2.75 2.75 0 0 0 0 3.89l5 5a2.68 2.68 0 0 0 1.894.784",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const gr = { render: wr }, br = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Mr(l, e) {
  return s(), d("svg", br, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.316 13.308c-3.334-7.41-13.297-7.41-16.632 0a.75.75 0 0 1-1.368-.616c3.865-8.59 15.503-8.59 19.368 0a.75.75 0 1 1-1.368.616",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 11.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5M15.75 14a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const xr = { render: Mr }, yr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ar(l, e) {
  return s(), d("svg", yr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M19.942 16.606a.75.75 0 0 0 .164-1.048l-2.475-3.396a.75.75 0 0 0-1.212.883l2.475 3.397a.75.75 0 0 0 1.048.164M12 18.25a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-1.5 0v3.5c0 .414.336.75.75.75m-7.942-1.644a.75.75 0 0 0 1.048-.164l2.47-3.388a.75.75 0 0 0-1.213-.883l-2.47 3.387a.75.75 0 0 0 .165 1.048",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.316 7.692c-3.335 7.41-13.297 7.41-16.632 0a.75.75 0 1 0-1.368.616c3.865 8.59 15.503 8.59 19.368 0a.75.75 0 0 0-1.368-.616",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Vr = { render: Ar }, Hr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Br(l, e) {
  return s(), d("svg", Hr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M9.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.928 12.047c.872 1.273 2.018 2.516 3.327 3.468 1.464 1.064 3.09 1.735 4.745 1.735s3.281-.671 4.745-1.735c1.31-.952 2.455-2.195 3.327-3.468C17.829 9.305 15.42 6.75 12 6.75s-5.829 2.556-8.072 5.297m-1.511-.519C4.67 8.741 7.58 5.25 12 5.25s7.329 3.49 9.583 6.278c.202.25.223.6.051.872-.988 1.565-2.37 3.139-4.007 4.328-1.634 1.188-3.564 2.022-5.627 2.022s-3.993-.834-5.627-2.022c-1.636-1.19-3.02-2.763-4.007-4.328a.75.75 0 0 1 .05-.872Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const zr = { render: Br }, Cr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Lr(l, e) {
  return s(), d("svg", Cr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 0 1-1.06 1.06l-4.034-4.034c-1.35.763-2.854 1.254-4.436 1.254-2.063 0-3.993-.834-5.627-2.022-1.636-1.19-3.02-2.763-4.007-4.328a.75.75 0 0 1 .05-.872c1.128-1.393 2.404-2.934 3.917-4.134L2.47 3.53a.75.75 0 0 1 0-1.06m4.932 5.992c-1.278.983-2.4 2.272-3.474 3.585.872 1.273 2.018 2.516 3.327 3.468 1.464 1.064 3.09 1.735 4.745 1.735 1.137 0 2.26-.316 3.329-.86L13.34 14.4a2.75 2.75 0 0 1-3.742-3.742zm3.36 3.36 1.415 1.416a1.25 1.25 0 0 1-1.415-1.415ZM11.25 6a.75.75 0 0 1 .75-.75c4.42 0 7.329 3.49 9.583 6.278.202.25.223.6.051.872-.334.53-.713 1.059-1.13 1.573a.75.75 0 0 1-1.164-.946q.392-.484.732-.98C17.829 9.305 15.42 6.75 12 6.75a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Sr = { render: Lr }, Er = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Tr(l, e) {
  return s(), d("svg", Er, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.345 7.603C10 7.895 9.75 8.341 9.75 9a.75.75 0 0 1-1.5 0c0-1.091.437-1.958 1.124-2.54.67-.57 1.538-.835 2.376-.835s1.705.265 2.376.834c.687.583 1.124 1.45 1.124 2.541 0 .766-.196 1.35-.517 1.83-.269.404-.619.716-.894.962l-.087.078c-.308.276-.539.504-.709.804-.162.287-.293.688-.293 1.326a.75.75 0 1 1-1.5 0c0-.862.181-1.524.488-2.065.299-.528.692-.894 1.01-1.18l.072-.065c.3-.27.508-.455.665-.692.149-.223.265-.514.265-.998 0-.659-.25-1.105-.595-1.397-.36-.306-.868-.478-1.405-.478s-1.045.172-1.405.478m2.167 9.838a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _r = { render: Tr }, Rr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function kr(l, e) {
  return s(), d("svg", Rr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.513 3.971C4.371 2.606 5.495 1.5 6.825 1.5h10.35c1.328 0 2.456 1.105 2.311 2.472-.32 3.074-1.55 4.624-2.697 5.713a24 24 0 0 1-.572.521l-.2.18a7 7 0 0 0-.582.575C15.14 11.298 15 11.598 15 12c0 .406.141.709.432 1.051.154.182.344.366.577.58l.212.193c.174.158.365.332.552.512 1.137 1.092 2.367 2.638 2.713 5.686.156 1.376-.989 2.478-2.312 2.478H6.825c-1.322 0-2.468-1.102-2.31-2.478m-.002-16.05c.32 3.074 1.553 4.613 2.7 5.697.19.179.383.35.558.507l.213.19c.234.212.425.393.58.573.292.339.436.643.436 1.061 0 .421-.144.73-.434 1.072-.215.255-.458.474-.758.745-.173.156-.364.329-.58.535-1.136 1.086-2.367 2.62-2.714 5.67M6.825 3c-.526 0-.861.42-.82.816.275 2.64 1.288 3.866 2.238 4.762.173.164.338.311.507.46l.238.214c.243.22.493.453.712.708.457.53.8 1.169.8 2.04 0 .867-.337 1.508-.789 2.042-.278.328-.647.663-.997.98-.157.142-.31.281-.45.414-.948.906-1.962 2.135-2.26 4.755-.043.384.288.809.821.809h10.35c.533 0 .864-.425.82-.809-.297-2.621-1.313-3.862-2.26-4.774-.173-.165-.337-.314-.504-.466l-.238-.216a8 8 0 0 1-.703-.712c-.45-.529-.79-1.163-.79-2.023 0-.863.346-1.497.801-2.022a9 9 0 0 1 .71-.705l.225-.201c.172-.154.342-.306.52-.475.95-.902 1.964-2.14 2.239-4.781v-.002c.042-.393-.293-.814-.82-.814H6.824Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M16.092 20.25H7.928c-.731 0-.938-.844-.425-1.367 1.242-1.258 3.747-2.159 3.747-3.602V10.5c0-.93-1.781-1.64-2.883-3.15-.182-.249-.164-.6.298-.6h6.69c.395 0 .48.348.3.598C14.57 8.859 12.75 9.565 12.75 10.5v4.781c0 1.431 2.611 2.203 3.769 3.603.466.565.303 1.366-.427 1.366" }, null, -1)
  ]));
}
const Or = { render: kr }, $r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Nr(l, e) {
  return s(), d("svg", $r, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 10.75a.75.75 0 0 1 .75.75v5a.75.75 0 1 1-1.5 0v-5a.75.75 0 0 1 .75-.75m.512-3.809a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fr = { render: Nr }, Dr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ir(l, e) {
  return s(), d("svg", Dr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.25 6a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75M5.53 4.47a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06l.72-.72v10.052l-.664-.83a.75.75 0 1 0-1.172.936l2 2.5a.75.75 0 0 0 1.172 0l2-2.5a.75.75 0 1 0-1.172-.936l-.664.83V6.81l.72.72a.75.75 0 0 0 1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const jr = { render: Ir }, qr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pr(l, e) {
  return s(), d("svg", qr, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#8d7287bc-c4ec-432f-b370-114019e13d09-f7d03d08-759c-427d-b6aa-ca103bc7d47e-d20ef25d-2b79-418a-9947-0b4cde2fd788-b13cffca-3f4f-4888-9b39-e0993bfa3e4e-8f0f1500-18cf-485c-ae78-890c9df89296-69d140ad-3b0b-4d31-99cb-f6b0de4aa003-7c1711-9ac95eed-70f0-4708-9cba-6dadc07a4861-c052145b-6d6e-41ce-b860-7aca1d4b2cfe-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v1.5a.75.75 0 0 1-1.5 0V5A2.75 2.75 0 0 1 5 2.25h11.172c.729 0 1.428.29 1.944.805l2.829 2.829a2.75 2.75 0 0 1 .805 1.944V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-1.5a.75.75 0 0 1 1.5 0V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V7.828c0-.331-.132-.65-.366-.883l-2.829-2.829a1.25 1.25 0 0 0-.883-.366z" }),
      n("path", { d: "M7.25 3A.75.75 0 0 1 8 2.25h8a.75.75 0 0 1 .75.75v5.4a1.35 1.35 0 0 1-1.35 1.35H8.6A1.35 1.35 0 0 1 7.25 8.4zm1.5.75v4.5h6.5v-4.5zm5.5 9.25a.75.75 0 0 1 .75-.75h2.4c.746 0 1.35.604 1.35 1.35V21a.75.75 0 0 1-1.5 0v-7.25H15a.75.75 0 0 1-.75-.75M6 16.75a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75" }),
      n("path", { d: "M.47 12.53a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 1.06l-1.72 1.72H12a.75.75 0 0 1 0 1.5H2.81l1.72 1.72a.75.75 0 0 1-1.06 1.06z" })
    ], -1)
  ]));
}
const Ur = { render: Pr }, Zr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Wr(l, e) {
  return s(), d("svg", Zr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.648 1.308a.75.75 0 0 1 .404.98l-1.04 2.5a.75.75 0 1 1-1.385-.576l1.04-2.5a.75.75 0 0 1 .981-.404m3.655.006a.75.75 0 0 1 .383.989l-3.435 7.781A6.749 6.749 0 0 1 12 22.75a6.75 6.75 0 0 1-3.67-12.415l-4-8a.75.75 0 0 1 1.34-.67l4 8a6.8 6.8 0 0 1 1.875-.4L8.16 2.33a.75.75 0 1 1 1.348-.658l3.755 7.698q.305.059.6.143l3.45-7.815a.75.75 0 0 1 .989-.383ZM12 10.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Kr = { render: Wr }, Jr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Gr(l, e) {
  return s(), d("svg", Jr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.5 3.5v11.113l5.955-2.552a.75.75 0 0 1 .605.006L20 16.585V3.5zM2 15.767V3.35C2 2.604 2.605 2 3.35 2h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.35A1.35 1.35 0 0 1 2 20.15zM20 20v-1.767L9.741 13.57l-6.24 2.674V20zM14.5 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M15.75 5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xr = { render: Gr }, Yr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Qr(l, e) {
  return s(), d("svg", Yr, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 5A.75.75 0 0 1 3 4.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 5m0 7a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m0 7a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const eo = { render: Qr }, lo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function to(l, e) {
  return s(), d("svg", lo, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 5A.75.75 0 0 1 3 4.25h8a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 5m0 7a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m0 7a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const no = { render: to }, ao = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ro(l, e) {
  return s(), d("svg", ao, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const oo = { render: ro }, io = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function so(l, e) {
  return s(), d("svg", io, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const co = { render: so }, uo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vo(l, e) {
  return s(), d("svg", uo, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 3.6c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H8a.75.75 0 0 1 0-1.5h12.25V3.75H3.75V16a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-2.19l-7.22 7.22a.75.75 0 1 1-1.06-1.06l7.22-7.22H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const po = { render: vo }, ho = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fo(l, e) {
  return s(), d("svg", ho, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 3.6c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H8a.75.75 0 0 1 0-1.5h12.25V3.75H3.75V16a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-2.19l-7.22 7.22a.75.75 0 1 1-1.06-1.06l7.22-7.22H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mo = { render: fo }, wo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function go(l, e) {
  return s(), d("svg", wo, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M21 2.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V4.81l-7.72 7.72a.75.75 0 1 1-1.06-1.06l7.72-7.72H15a.75.75 0 0 1 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6a.75.75 0 0 1 1.5 0v6A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h6a.75.75 0 0 1 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bo = { render: go }, Mo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xo(l, e) {
  return s(), d("svg", Mo, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6 4.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1 0-1.5H18A2.75 2.75 0 0 1 20.75 6v14A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20V6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.319 2.417c-.32.377-.466.855-.529 1.215-.086.5-.475.982-1.04 1.094V6.25h6.5V4.726c-.565-.112-.954-.594-1.04-1.094-.063-.36-.21-.838-.529-1.215-.293-.346-.781-.667-1.681-.667s-1.388.321-1.681.667m-1.145-.97C9.762.755 10.674.25 12 .25s2.238.505 2.825 1.197c.52.614.743 1.322.841 1.814A1.25 1.25 0 0 1 16.75 4.5v1.9a1.35 1.35 0 0 1-1.35 1.35H8.6A1.35 1.35 0 0 1 7.25 6.4V4.5a1.25 1.25 0 0 1 1.084-1.24c.098-.491.32-1.2.84-1.813",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yo = { render: xo }, Ao = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vo(l, e) {
  return s(), d("svg", Ao, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-5.25V18a.75.75 0 0 1-1.5 0v-5.25H6a.75.75 0 0 1 0-1.5h5.25V6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ho = { render: Vo }, Bo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zo(l, e) {
  return s(), d("svg", Bo, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12a9.2 9.2 0 0 0 2.14 5.918L18.06 5.011A9.2 9.2 0 0 0 12 2.75m7.11 3.332L5.94 18.989A9.2 9.2 0 0 0 12 21.25 9.25 9.25 0 0 0 21.25 12a9.2 9.2 0 0 0-2.14-5.918M1.25 12C1.25 6.063 6.063 1.25 12 1.25a10.72 10.72 0 0 1 7.677 3.225A10.72 10.72 0 0 1 22.75 12c0 5.937-4.813 10.75-10.75 10.75a10.72 10.72 0 0 1-7.677-3.225A10.72 10.72 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Co = { render: zo }, Lo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function So(l, e) {
  return s(), d("svg", Lo, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.557 5.967c-.532.451-.907 1.135-.907 2.113a.75.75 0 0 1-1.5 0c0-1.41.563-2.515 1.437-3.257.858-.728 1.975-1.073 3.063-1.073s2.205.345 3.063 1.073c.875.742 1.437 1.847 1.437 3.257 0 .993-.253 1.735-.658 2.344-.347.52-.798.922-1.176 1.26l-.119.106c-.42.38-.766.715-1.02 1.165-.248.438-.436 1.032-.436 1.943a.75.75 0 0 1-1.5 0c0-1.135.238-1.99.63-2.682.384-.678.891-1.152 1.323-1.54l.106-.096c.4-.36.708-.636.943-.988.234-.35.407-.801.407-1.512 0-.978-.375-1.662-.907-2.113-.548-.465-1.306-.717-2.093-.717s-1.545.252-2.093.717m2.955 12.474a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Eo = { render: So }, To = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _o(l, e) {
  return s(), d("svg", To, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.383 4.367-9.75 9.75-9.75s9.75 4.367 9.75 9.75-4.367 9.75-9.75 9.75S2.25 17.383 2.25 12M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ro = { render: _o }, ko = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Oo(l, e) {
  return s(), d("svg", ko, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.383 4.367-9.75 9.75-9.75s9.75 4.367 9.75 9.75-4.367 9.75-9.75 9.75S2.25 17.383 2.25 12M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M12 18.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5" }, null, -1)
  ]));
}
const $o = { render: Oo }, No = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fo(l, e) {
  return s(), d("svg", No, e[0] || (e[0] = [
    n("path", { d: "M15.975 12a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225l3.525-3.525a.68.68 0 0 0 .225-.525.68.68 0 0 0-.225-.525L17.025 3.9c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05l2.25 2.25H9c-2.025 0-5.775 1.125-5.775 5.475 0 4.8 3.75 6.075 5.775 6.075h8.7c.45 0 .75-.3.75-.75s-.3-.75-.75-.75H9c-.45 0-4.275-.15-4.275-4.575C4.725 8.85 8.55 8.7 9 8.7h9.225l-2.25 2.25c-.3.3-.3.75 0 1.05" }, null, -1)
  ]));
}
const Do = { render: Fo }, Io = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jo(l, e) {
  return s(), d("svg", Io, e[0] || (e[0] = [
    n("path", { d: "M18.975 4.275c-.45 0-.75.3-.75.75v6c0 .45.3.75.75.75s.75-.3.75-.75v-6c0-.45-.3-.75-.75-.75M17.7 17.25H9c-.45 0-4.275-.15-4.275-4.575C4.725 8.85 8.55 8.7 9 8.7h5.175l-2.25 2.25c-.3.3-.3.75 0 1.05a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225L16.5 8.475c.3-.3.3-.75 0-1.05L12.975 3.9c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05l2.25 2.25H9c-2.025 0-5.775 1.125-5.775 5.475 0 4.8 3.75 6.075 5.775 6.075h8.7c.45 0 .75-.3.75-.75s-.3-.75-.75-.75" }, null, -1)
  ]));
}
const qo = { render: jo }, Po = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Uo(l, e) {
  return s(), d("svg", Po, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M17.75 10.625a.75.75 0 0 1-.75.75H9.795l-.058.004a2.5 2.5 0 0 0-.983.282c-.257.138-.5.336-.68.626-.179.288-.324.71-.324 1.338 0 1.435.571 2.03 1.037 2.31a2.3 2.3 0 0 0 1.012.315h.801a.75.75 0 0 1 0 1.5h-.8V17v.75h-.023a2 2 0 0 1-.162-.01 3.8 3.8 0 0 1-1.602-.52c-.934-.562-1.763-1.655-1.763-3.595 0-.871.205-1.575.55-2.13a3.26 3.26 0 0 1 1.246-1.156 4 4 0 0 1 1.733-.464h.02l.001.75v-.75H17a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M17.75 10.638a.75.75 0 0 1-.23.527l-3.5 3.375a.75.75 0 1 1-1.04-1.08l2.96-2.854-2.98-3.085a.75.75 0 0 1 1.08-1.042l3.5 3.625a.75.75 0 0 1 .21.534",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zo = { render: Uo }, Wo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ko(l, e) {
  return s(), d("svg", Wo, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.75 12a9.25 9.25 0 0 1 17.19-4.75H17a.75.75 0 0 0 0 1.5h4.4a1.35 1.35 0 0 0 1.35-1.35V3a.75.75 0 0 0-1.5 0v3.52A10.75 10.75 0 0 0 12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75c5.39 0 9.852-3.966 10.63-9.138a.75.75 0 0 0-1.483-.224A9.25 9.25 0 0 1 2.75 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jo = { render: Ko }, Go = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xo(l, e) {
  return s(), d("svg", Go, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.745 11.084c.202-1.802 1.956-3.334 4.243-3.334 1.274 0 2.394.482 3.164 1.222h-.658a.75.75 0 0 0 0 1.5H16.4a1.35 1.35 0 0 0 1.35-1.35V7.5a.75.75 0 0 0-1.5 0v.447c-1.064-1.053-2.592-1.697-4.262-1.697-2.912 0-5.432 1.976-5.733 4.666a.75.75 0 0 0 1.49.168m8.508.849c-.223 2.49-2.095 4.317-4.24 4.317-1.353 0-2.59-.719-3.38-1.878h.873a.75.75 0 0 0 0-1.5H7.6a1.35 1.35 0 0 0-1.35 1.35V16.4a.75.75 0 0 0 1.5 0v-.712c1.044 1.255 2.554 2.062 4.262 2.062 3.053 0 5.455-2.557 5.735-5.683a.75.75 0 1 0-1.494-.134",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Yo = { render: Xo }, Qo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ei(l, e) {
  return s(), d("svg", Qo, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.796 11.074A9.251 9.251 0 0 1 19.939 7.25H17a.75.75 0 0 0 0 1.5h4.4a1.35 1.35 0 0 0 1.35-1.35V3a.75.75 0 0 0-1.5 0v3.52A10.75 10.75 0 0 0 12 1.25c-5.575 0-10.158 4.243-10.697 9.676a.75.75 0 1 0 1.493.148m9.253 10.176c4.796 0 8.74-3.65 9.205-8.324a.75.75 0 0 1 1.492.148c-.539 5.433-5.122 9.676-10.697 9.676a10.75 10.75 0 0 1-9.25-5.27V21a.75.75 0 0 1-1.5 0v-4.4c0-.746.605-1.35 1.35-1.35H7.05a.75.75 0 0 1 0 1.5H4.11a9.24 9.24 0 0 0 7.94 4.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const li = { render: ei }, ti = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ni(l, e) {
  return s(), d("svg", ti, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#819fd33c-6850-41b9-8ce2-892538d90874-4cafdf1c-92d4-4e89-8adf-d9e83c7e1adb-4df63818-ef22-45a5-a651-18e859fc7e1b-6e385855-6bee-4225-a17f-f0e2c4e25528-d7dc5d10-ce45-4af5-b629-cb340e0edc2a-ee95c360-696c-417a-86c0-cd1b000f9422-ee6201-045a8f37-2c88-4f98-9be2-bc0eb128f83a-dc12d5ce-9d3f-4ce9-b122-bf84da456e13-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M20.436 15.665A9.25 9.25 0 1 0 7.07 19.928a.75.75 0 1 1-.785 1.278C1.827 18.47-.08 12.812 2.026 7.851c2.32-5.465 8.631-8.015 14.096-5.695s8.015 8.63 5.695 14.096a10.7 10.7 0 0 1-4.26 4.954.75.75 0 0 1-.785-1.278 9.2 9.2 0 0 0 3.665-4.263Z" }),
      n("path", { d: "M22.75 21a.75.75 0 0 1-.75.75h-4.4a1.35 1.35 0 0 1-1.35-1.35V16a.75.75 0 0 1 1.5 0v4.25H22a.75.75 0 0 1 .75.75" })
    ], -1)
  ]));
}
const ai = { render: ni }, ri = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function oi(l, e) {
  return s(), d("svg", ri, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0V5A2.75 2.75 0 0 1 5 2.25h11.172c.729 0 1.428.29 1.944.805l2.829 2.829a2.75 2.75 0 0 1 .805 1.944V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-2.5a.75.75 0 0 1 1.5 0V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V7.828c0-.331-.132-.65-.366-.883l-2.829-2.829a1.25 1.25 0 0 0-.883-.366z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6 16.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M14.25 13a.75.75 0 0 1 .75-.75h2.4c.746 0 1.35.604 1.35 1.35V21a.75.75 0 0 1-1.5 0v-7.25H15a.75.75 0 0 1-.75-.75M16 2.25a.75.75 0 0 1 .75.75v5.4a1.35 1.35 0 0 1-1.35 1.35h-1.9a.75.75 0 0 1 0-1.5h1.75V3a.75.75 0 0 1 .75-.75m-3.47 10.28a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 1.06l1.72 1.72H1a.75.75 0 0 0 0 1.5h9.19l-1.72 1.72a.75.75 0 0 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ii = { render: oi }, si = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function di(l, e) {
  return s(), d("svg", si, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.348 9.348a3.75 3.75 0 1 1 5.304 5.303 3.75 3.75 0 0 1-5.304-5.303M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.256 1.81a.75.75 0 0 1 .725-.56h1.954c.34 0 .639.23.725.56l.528 2.008 1.938.797 1.387-1.185a.75.75 0 0 1 1.017.04l2 2a.75.75 0 0 1 .043 1.014l-1.18 1.396.778 1.88 2.014.513a.75.75 0 0 1 .565.727v1.978a.75.75 0 0 1-.561.726l-2.025.526-.78 1.884 1.188 1.4a.75.75 0 0 1-.042 1.016l-2 2a.75.75 0 0 1-1.03.028l-.056-.05-.152-.135-.491-.431c-.232-.203-.47-.406-.664-.566l-1.898.786-.512 2.022a.75.75 0 0 1-.727.566h-2a.75.75 0 0 1-.727-.566l-.51-2.022-1.844-.758-1.445 1.177a.75.75 0 0 1-1.004-.05l-2-2a.75.75 0 0 1-.03-1.03l1.2-1.346-.788-1.873-2.05-.558A.75.75 0 0 1 1.25 13v-2a.75.75 0 0 1 .58-.73l1.994-.466.767-1.886-1.173-1.445A.75.75 0 0 1 3.47 5.47l2-2a.75.75 0 0 1 1.029-.03l1.35 1.201 1.869-.788.538-2.044Zm1.303.94-.485 1.842a.75.75 0 0 1-.434.5L7.995 6.207a.75.75 0 0 1-.79-.13L6.03 5.03 5.01 6.052l1.026 1.264a.75.75 0 0 1 .113.755l-1.08 2.657a.75.75 0 0 1-.524.448l-1.794.42v.831l1.848.504a.75.75 0 0 1 .494.433l1.115 2.645a.75.75 0 0 1-.131.79L5.03 17.971l1.02 1.02 1.266-1.032a.75.75 0 0 1 .76-.113l2.605 1.072c.22.09.384.28.442.51l.46 1.822h.832l.46-1.821a.75.75 0 0 1 .441-.509l2.651-1.098a.75.75 0 0 1 .723.083c.257.183.723.581 1.095.905l.183.16 1.012-1.012-1.037-1.223a.75.75 0 0 1-.121-.772l1.098-2.652a.75.75 0 0 1 .504-.439l1.825-.474v-.815l-1.813-.461a.75.75 0 0 1-.508-.44l-1.097-2.65a.75.75 0 0 1 .12-.771l1.03-1.218L17.96 5.02l-1.208 1.032a.75.75 0 0 1-.772.124l-2.707-1.113a.75.75 0 0 1-.44-.503l-.476-1.811h-.798Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ci = { render: di }, ui = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vi(l, e) {
  return s(), d("svg", ui, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18 2.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14.25 5a3.75 3.75 0 1 1 .974 2.521l-5.681 3.247a3.75 3.75 0 0 1 0 2.464l5.681 3.247a3.75 3.75 0 1 1-.767 1.29L8.776 14.52a3.75 3.75 0 1 1 0-5.043l5.681-3.246A3.8 3.8 0 0 1 14.25 5M18 16.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const pi = { render: vi }, hi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fi(l, e) {
  return s(), d("svg", hi, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 12.25a.75.75 0 0 1 .75.75v6c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-6a.75.75 0 0 1 1.5 0v6A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.53 2.47a.75.75 0 0 0-1.06 0l-3.5 3.5a.75.75 0 0 0 1.06 1.06l2.22-2.22V15a.75.75 0 0 0 1.5 0V4.81l2.22 2.22a.75.75 0 1 0 1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mi = { render: fi }, wi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gi(l, e) {
  return s(), d("svg", wi, e[0] || (e[0] = [
    n("path", { d: "M7 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7 7.75a4.25 4.25 0 0 0 0 8.5h10a4.25 4.25 0 0 0 0-8.5zm-4.066.184A5.75 5.75 0 0 1 7 6.25h10a5.75 5.75 0 0 1 0 11.5H7a5.75 5.75 0 0 1-4.066-9.816",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bi = { render: gi }, Mi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xi(l, e) {
  return s(), d("svg", Mi, e[0] || (e[0] = [
    n("path", { d: "M16.75 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7 7.75a4.25 4.25 0 0 0 0 8.5h10a4.25 4.25 0 0 0 0-8.5zm-4.066.184A5.75 5.75 0 0 1 7 6.25h10a5.75 5.75 0 0 1 0 11.5H7a5.75 5.75 0 0 1-4.066-9.816",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yi = { render: xi }, Ai = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vi(l, e) {
  return s(), d("svg", Ai, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.87 8.261a.75.75 0 0 1 .869.61l1.995 11.345a1.25 1.25 0 0 0 1.23 1.034h8.071a1.25 1.25 0 0 0 1.231-1.034L19.261 8.87a.75.75 0 0 1 1.478.26l-1.995 11.346a2.75 2.75 0 0 1-2.709 2.274h-8.07a2.75 2.75 0 0 1-2.709-2.274L3.261 9.13a.75.75 0 0 1 .609-.869m6.755-5.511c-.69 0-1.25.56-1.25 1.25v1.25h5.25V4c0-.69-.56-1.25-1.25-1.25zm-2.75 2.5V4a2.75 2.75 0 0 1 2.75-2.75h2.75A2.75 2.75 0 0 1 16.125 4v1.25H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hi = { render: Vi }, Bi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zi(l, e) {
  return s(), d("svg", Bi, e[0] || (e[0] = [
    n("path", { d: "M15 7.275H5.775l2.25-2.25c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0L3.45 7.5a.68.68 0 0 0-.225.525.68.68 0 0 0 .225.525L6.975 12a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.3-.3.3-.75 0-1.05L5.775 8.7H15c.45 0 4.275.15 4.275 3.975 0 4.35-3.825 4.575-4.275 4.575H6.3c-.45 0-.75.3-.75.75s.3.75.75.75H15c2.025 0 5.775-1.275 5.775-6.075 0-4.275-3.75-5.4-5.775-5.4" }, null, -1)
  ]));
}
const Ci = { render: zi }, Li = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Si(l, e) {
  return s(), d("svg", Li, e[0] || (e[0] = [
    n("path", { d: "M5.775 5.025c0-.45-.3-.75-.75-.75s-.75.3-.75.75v6c0 .45.3.75.75.75s.75-.3.75-.75zM15 7.275H9.825l2.25-2.25c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0L7.5 7.5a.68.68 0 0 0-.225.525.68.68 0 0 0 .225.525l3.525 3.525a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.3-.3.3-.75 0-1.05l-2.25-2.25H15c.45 0 4.275.15 4.275 3.975 0 4.35-3.825 4.575-4.275 4.575H6.3c-.45 0-.75.3-.75.75s.3.75.75.75H15c2.025 0 5.775-1.275 5.775-6.075 0-4.35-3.75-5.475-5.775-5.475" }, null, -1)
  ]));
}
const Ei = { render: Si }, Ti = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _i(l, e) {
  return s(), d("svg", Ti, e[0] || (e[0] = [
    n("path", { d: "M14.175 9.9h-5.4l2.25-2.325c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0c-.075 0-.15.15-.225.225l-.6.6c-.225.3-.525.525-.75.825L7.575 9l-.675.675c-.15.15-.225.3-.375.375a.85.85 0 0 0-.225.6c0 .3.225.525.375.675.225.15.375.375.6.525.3.225.525.525.825.75.3.3.6.525.825.825l.675.675.375.375c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.3-.3.3-.75 0-1.05l-2.175-2.1h5.325c.375 0 2.025.15 2.025 2.25 0 2.475-1.725 2.625-2.025 2.625h-.825c-.45 0-.75.3-.75.75s.3.75.75.75h.825c1.2 0 3.525-.825 3.525-4.125.075-2.925-2.25-3.675-3.525-3.675" }, null, -1),
    n("path", { d: "M12 1.275C6.075 1.275 1.275 6.075 1.275 12S6.075 22.725 12 22.725 22.725 17.925 22.725 12 17.925 1.275 12 1.275m0 19.95A9.22 9.22 0 0 1 2.775 12C2.775 6.9 6.9 2.775 12 2.775S21.225 6.9 21.225 12 17.1 21.225 12 21.225" }, null, -1)
  ]));
}
const Ri = { render: _i }, ki = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Oi(l, e) {
  return s(), d("svg", ki, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 20a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m6.22-16.53a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1-1.06 1.06l-2.22-2.22V16a.75.75 0 0 1-1.5 0V5.81L9.03 8.03a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $i = { render: Oi }, Ni = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fi(l, e) {
  return s(), d("svg", Ni, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m.512 10.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Di = { render: Fi }, Ii = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ji(l, e) {
  return s(), d("svg", Ii, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.616 3.641c1.057-1.838 3.71-1.839 4.768 0l8.043 13.988c1.054 1.833-.27 4.121-2.384 4.121H3.957c-2.115 0-3.438-2.288-2.384-4.12zm3.468.748a1.25 1.25 0 0 0-2.168 0L2.873 18.377a1.25 1.25 0 0 0 1.084 1.873h16.086a1.25 1.25 0 0 0 1.084-1.873z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m.512 8.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qi = { render: ji }, Pi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ui(l, e) {
  return s(), d("svg", Pi, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 7A.75.75 0 0 1 4 6.25h16a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 7m0 10a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75M4 11.25a.75.75 0 0 0 0 1.5h13.5a1.75 1.75 0 1 1 0 3.5h-1.75v-.75a.75.75 0 0 0-1.136-.643l-2.487 1.492a.75.75 0 0 0 0 1.302l2.487 1.492a.75.75 0 0 0 1.136-.643v-.75h1.75a3.25 3.25 0 0 0 0-6.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zi = { render: Ui }, Wi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ki(l, e) {
  return s(), d("svg", Wi, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.306 5.75a1.25 1.25 0 0 0-1.238 1.427l1.43 10a1.25 1.25 0 0 0 1.237 1.073h.53a1.25 1.25 0 0 0 1.237-1.073l1.43-10a1.25 1.25 0 0 0-1.238-1.427zm0-1.5a2.75 2.75 0 0 0-2.722 3.14l1.429 10a2.75 2.75 0 0 0 2.722 2.36h.53M7.306 4.25h3.388a2.75 2.75 0 0 1 2.722 3.14l-1.428 10a2.75 2.75 0 0 1-2.723 2.36",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75m10 0a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ji = { render: Ki }, Gi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xi(l, e) {
  return s(), d("svg", Gi, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v3.5h5.5v-3.5zM2.645 2.645A1.35 1.35 0 0 1 3.6 2.25h5.8a1.35 1.35 0 0 1 1.35 1.35v3.8A1.35 1.35 0 0 1 9.4 8.75H3.6A1.35 1.35 0 0 1 2.25 7.4V3.6c0-.358.142-.701.395-.955M14.75 3.75v8.5h5.5v-8.5zm-1.105-1.105a1.35 1.35 0 0 1 .955-.395h5.8a1.35 1.35 0 0 1 1.35 1.35v8.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35V3.6c0-.358.142-.701.395-.955M3.75 11.75v8.5h5.5v-8.5zm-1.105-1.105a1.35 1.35 0 0 1 .955-.395h5.8a1.35 1.35 0 0 1 1.35 1.35v8.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35v-8.8c0-.358.142-.701.395-.955M14.75 16.75v3.5h5.5v-3.5zm-1.105-1.105a1.35 1.35 0 0 1 .955-.395h5.8a1.35 1.35 0 0 1 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Yi = { render: Xi }, Qi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function e8(l, e) {
  return s(), d("svg", Qi, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75A9.25 9.25 0 0 0 2.75 14v.001a9.2 9.2 0 0 0 1.633 5.25H8.5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.6-.3A10.7 10.7 0 0 1 1.25 14H2h-.75C1.25 8.061 6.063 3.25 12 3.25S22.75 8.063 22.75 14c0 2.42-.8 4.655-2.15 6.452a.75.75 0 0 1-.6.299l-4.5-.001a.75.75 0 0 1 0-1.5h4.116A9.2 9.2 0 0 0 21.25 14 9.25 9.25 0 0 0 12 4.75m1.123 5.51a.75.75 0 0 1 .617.863l-1 6a.75.75 0 1 1-1.48-.246l1-6a.75.75 0 0 1 .863-.617",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.348 17.348a3.75 3.75 0 1 1 5.304 5.304 3.75 3.75 0 0 1-5.304-5.304M12 17.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const l8 = { render: e8 }, t8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n8(l, e) {
  return s(), d("svg", t8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 20c0 .414.336.75.75.75h16a.75.75 0 0 0 0-1.5H4.75V4a.75.75 0 0 0-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.03 17.03a.75.75 0 0 0 0-1.06l-4.5-4.5a.75.75 0 0 0-1.06 0L12 13.94 4.53 6.47a.75.75 0 0 0-1.06 1.06l8 8a.75.75 0 0 0 1.06 0L15 13.06l3.97 3.97a.75.75 0 0 0 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a8 = { render: n8 }, r8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function o8(l, e) {
  return s(), d("svg", r8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 20c0 .414.336.75.75.75h16a.75.75 0 0 0 0-1.5H4.75V4a.75.75 0 0 0-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.453 17.013a.75.75 0 0 0 1.06.034l7.47-7.003 2.487 2.486a.75.75 0 0 0 1.06 0l4.5-4.5a.75.75 0 0 0-1.06-1.06L15 10.94l-2.47-2.47a.75.75 0 0 0-1.043-.017l-8 7.5a.75.75 0 0 0-.034 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i8 = { render: o8 }, s8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function d8(l, e) {
  return s(), d("svg", s8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M17 15.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M19.75 17a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0M7 5.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M9.75 7a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0m9.78-2.53a.75.75 0 0 0-1.06 0l-14 14a.75.75 0 1 0 1.06 1.06l14-14a.75.75 0 0 0 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c8 = { render: d8 }, u8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function v8(l, e) {
  return s(), d("svg", u8, e[0] || (e[0] = [
    h5('<path fill-rule="evenodd" d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12" clip-rule="evenodd"></path><path d="M15.5 16a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M15.5 15.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5m-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M8.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M8.5 8.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M7.25 8.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m9.28-1.03a.75.75 0 0 0-1.06 0l-8 8a.75.75 0 1 0 1.06 1.06l8-8a.75.75 0 0 0 0-1.06" clip-rule="evenodd"></path>', 5)
  ]));
}
const p8 = { render: v8 }, h8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function f8(l, e) {
  return s(), d("svg", h8, e[0] || (e[0] = [
    h5('<path fill-rule="evenodd" d="M3.75 3.75v16.5h16.5V3.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z" clip-rule="evenodd"></path><path d="M15.5 16a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M15.5 15.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5m-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M8.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M8.5 8.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M7.25 8.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m9.28-1.03a.75.75 0 0 0-1.06 0l-8 8a.75.75 0 1 0 1.06 1.06l8-8a.75.75 0 0 0 0-1.06" clip-rule="evenodd"></path>', 5)
  ]));
}
const m8 = { render: f8 }, w8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function g8(l, e) {
  return s(), d("svg", w8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v3.5h5.5v-3.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h5.8c.746 0 1.35.604 1.35 1.35v3.8A1.35 1.35 0 0 1 9.4 8.75H3.6A1.35 1.35 0 0 1 2.25 7.4zm12.5 13.15v3.5h5.5v-3.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h5.8c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35zm1.5-12.85v8.5h5.5v-8.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h5.8c.746 0 1.35.604 1.35 1.35v8.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35zm-9.5 8.15v8.5h5.5v-8.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h5.8c.746 0 1.35.604 1.35 1.35v8.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const b8 = { render: g8 }, M8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function x8(l, e) {
  return s(), d("svg", M8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.25 3.6c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h4.65V9.6c0-.746.604-1.35 1.35-1.35h4.65zm0 6.15h-4.5v10.5h4.5zm1.5 10.5h4.5V3.75h-4.5zm-7.5 0v-3.5h-4.5v3.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const y8 = { render: x8 }, A8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function V8(l, e) {
  return s(), d("svg", A8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.53 20.53a.75.75 0 0 1-1.06 0L15 16.06l-2.47 2.47a.75.75 0 0 1-1.06 0l-8-8a.75.75 0 1 1 1.06-1.06L12 16.94l2.47-2.47a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1 0 1.06m-5.06-8a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.72 1.72V4a.75.75 0 0 0-1.5 0v6.19l-1.72-1.72a.75.75 0 1 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const H8 = { render: V8 }, B8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function z8(l, e) {
  return s(), d("svg", B8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.47 11.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06l-1.72-1.72V20a.75.75 0 0 1-1.5 0v-6.19l-1.72 1.72a.75.75 0 1 1-1.06-1.06zm5.06-8a.75.75 0 0 0-1.06 0L15 7.94l-2.47-2.47a.75.75 0 0 0-1.06 0l-8 8a.75.75 0 1 0 1.06 1.06L12 7.06l2.47 2.47a.75.75 0 0 0 1.06 0l5-5a.75.75 0 0 0 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const C8 = { render: z8 }, L8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function S8(l, e) {
  return s(), d("svg", L8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 7.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 8 7.25m4 3a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m4 2a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5h16.5V3.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const E8 = { render: S8 }, T8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _8(l, e) {
  return s(), d("svg", T8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 9A.75.75 0 0 1 6 8.25h4a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 9M15.5 6.75a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m3.25 1.75a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0m-9-2.5a.75.75 0 0 1-.75.75H6a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75m8.874 12.416a.75.75 0 0 1-1.04.208l-4.044-2.696-2.071 1.658a.75.75 0 0 1-.938 0l-5-4a.75.75 0 0 1 .938-1.172L11 16.04l2.031-1.626a.75.75 0 0 1 .885-.038l4.5 3a.75.75 0 0 1 .208 1.04",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5h16.5V3.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const R8 = { render: _8 }, k8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function O8(l, e) {
  return s(), d("svg", k8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 7.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75m-4 3a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m-4 2a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5h16.5V3.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $8 = { render: O8 }, N8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function F8(l, e) {
  return s(), d("svg", N8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.038 12.24c.845-.87 2.144-1.49 3.962-1.49h12.19l-5.72 5.72a.75.75 0 1 0 1.06 1.06l7-7a.75.75 0 0 0 0-1.06l-7-7a.75.75 0 1 0-1.06 1.06l5.72 5.72H8c-2.182 0-3.883.755-5.038 1.947-1.147 1.182-1.712 2.75-1.712 4.303s.565 3.12 1.712 4.303C4.117 20.995 5.818 21.75 8 21.75a.75.75 0 0 0 0-1.5c-1.818 0-3.117-.62-3.962-1.49-.853-.88-1.288-2.063-1.288-3.26s.435-2.38 1.288-3.26",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D8 = { render: F8 }, I8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function j8(l, e) {
  return s(), d("svg", I8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75A8.25 8.25 0 0 1 20.25 12c0 2.435-1.284 3.454-2.373 3.635-.577.096-1.12-.03-1.5-.306-.364-.262-.627-.69-.627-1.329V8h-1.5v6c0 1.111.487 1.995 1.248 2.546.744.537 1.702.723 2.625.569 1.91-.319 3.627-2.05 3.627-5.115 0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12s4.365 9.75 9.75 9.75a9.7 9.7 0 0 0 5.959-2.032.75.75 0 1 0-.918-1.187A8.25 8.25 0 1 1 12 3.75m3 3.5a.75.75 0 0 0-.75.75h1.5a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 8.75c-1.377 0-2.25.906-2.25 1.75V12a.75.75 0 0 1-1.5 0v-1.5c0-1.917 1.813-3.25 3.75-3.25s3.75 1.333 3.75 3.25V12a.75.75 0 0 1-1.5 0v-1.5c0-.844-.873-1.75-2.25-1.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 15.25c-1.377 0-2.25-.906-2.25-1.75V12a.75.75 0 0 0-1.5 0v1.5c0 1.917 1.813 3.25 3.75 3.25s3.75-1.333 3.75-3.25V12a.75.75 0 0 0-1.5 0v1.5c0 .844-.873 1.75-2.25 1.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q8 = { render: j8 }, P8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function U8(l, e) {
  return s(), d("svg", P8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.21 3.362C8.472 2.016 10.194 1.25 12 1.25s3.528.766 4.79 2.112c1.26 1.344 1.96 3.157 1.96 5.038 0 3.63.729 5.91 1.418 7.259a6.7 6.7 0 0 0 .924 1.393 3.4 3.4 0 0 0 .34.335l.01.007A.75.75 0 0 1 21 18.75H3a.75.75 0 0 1-.441-1.356l.008-.007.064-.054c.06-.054.157-.145.277-.281.24-.27.579-.718.924-1.393C4.522 14.31 5.25 12.03 5.25 8.4c0-1.881.7-3.694 1.96-5.038M19.361 17.25a9 9 0 0 1-.529-.909c-.81-1.585-1.582-4.105-1.582-7.941 0-1.514-.564-2.956-1.555-4.013C14.708 3.333 13.377 2.75 12 2.75s-2.707.583-3.695 1.637C7.315 5.444 6.75 6.887 6.75 8.4c0 3.836-.771 6.356-1.582 7.942a9 9 0 0 1-.53.908zm-9.467 3.101a.75.75 0 0 1 1.025.273 1.25 1.25 0 0 0 2.162 0 .75.75 0 1 1 1.298.752 2.752 2.752 0 0 1-4.758 0 .75.75 0 0 1 .273-1.025",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z8 = { render: U8 }, W8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function K8(l, e) {
  return s(), d("svg", W8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.48 5.78a.75.75 0 0 1 .51.93 6 6 0 0 0-.24 1.69c0 3.836-.771 6.356-1.582 7.941a9 9 0 0 1-.53.909H18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.441-1.356l.008-.007.064-.054c.06-.054.157-.145.277-.281.24-.27.579-.718.924-1.393C4.522 14.31 5.25 12.03 5.25 8.4c0-.722.103-1.432.3-2.11a.75.75 0 0 1 .93-.51m.73-2.418C8.472 2.016 10.194 1.25 12 1.25s3.528.766 4.79 2.112c1.26 1.344 1.96 3.157 1.96 5.038 0 3.63.729 5.91 1.418 7.258.345.676.684 1.123.924 1.394a3.4 3.4 0 0 0 .34.335l.01.007a.75.75 0 0 1-.877 1.217L21 18c-.435.611-.435.61-.436.61l-.003-.002-.006-.004-.014-.01a2 2 0 0 1-.168-.14 5 5 0 0 1-.402-.406 8 8 0 0 1-1.139-1.706c-.81-1.586-1.582-4.106-1.582-7.942 0-1.514-.564-2.956-1.555-4.013C14.707 3.333 13.377 2.75 12 2.75s-2.707.583-3.695 1.637A.75.75 0 1 1 7.21 3.362m2.684 16.989a.75.75 0 0 1 1.025.273 1.25 1.25 0 0 0 2.162 0 .75.75 0 1 1 1.298.752 2.75 2.75 0 0 1-4.758 0 .75.75 0 0 1 .273-1.025",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 1 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const J8 = { render: K8 }, G8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function X8(l, e) {
  return s(), d("svg", G8, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 1 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y8 = { render: X8 }, Q8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function es(l, e) {
  return s(), d("svg", Q8, e[0] || (e[0] = [
    h5('<path d="M17 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M17 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M15.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M7 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M7 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M5.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12" clip-rule="evenodd"></path>', 7)
  ]));
}
const ls = { render: es }, ts = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ns(l, e) {
  return s(), d("svg", ts, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.47 11.47a.75.75 0 0 1 1.06 0L11 13.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const as = { render: ns }, rs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function os(l, e) {
  return s(), d("svg", rs, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const is = { render: os }, ss = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ds(l, e) {
  return s(), d("svg", ss, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.97 8.969a.75.75 0 0 1 1.061.001l1.963 1.97 1.976-1.971a.75.75 0 0 1 1.06 1.062L13.055 12l1.975 1.969a.75.75 0 1 1-1.06 1.062l-1.976-1.97-1.963 1.969a.75.75 0 1 1-1.062-1.06L10.934 12l-1.965-1.97a.75.75 0 0 1 .001-1.061",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cs = { render: ds }, us = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vs(l, e) {
  return s(), d("svg", us, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.345 7.603C10 7.895 9.75 8.341 9.75 9a.75.75 0 0 1-1.5 0c0-1.091.437-1.958 1.124-2.54.67-.57 1.538-.835 2.376-.835s1.705.265 2.376.834c.687.583 1.124 1.45 1.124 2.541 0 .766-.196 1.35-.517 1.83-.269.404-.619.716-.894.962l-.087.078c-.308.276-.539.504-.709.804-.162.287-.293.688-.293 1.326a.75.75 0 1 1-1.5 0c0-.862.181-1.524.488-2.065.299-.528.693-.894 1.01-1.18l.072-.065c.3-.27.508-.455.665-.692.149-.222.265-.514.265-.998 0-.659-.25-1.105-.595-1.397-.36-.306-.868-.478-1.405-.478s-1.045.172-1.405.478m2.167 9.838a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ps = { render: vs }, hs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fs(l, e) {
  return s(), d("svg", hs, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .512.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 1 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v.767H17a.75.75 0 1 1 0 1.5h-1.233c-.6 1.79-1.62 3.468-2.77 4.96l1.684 1.733a.75.75 0 1 1-1.076 1.045l-1.564-1.61a37 37 0 0 1-3.108 3.16.75.75 0 1 1-1.01-1.11 35 35 0 0 0 3.101-3.168 26 26 0 0 1-.791-1.03c-.374-.514-.735-1.053-.912-1.428a.75.75 0 0 1 1.357-.639c.11.232.392.668.767 1.184.173.237.358.48.541.713.901-1.2 1.675-2.484 2.187-3.81H7a.75.75 0 1 1 0-1.5h4.25V7a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ms = { render: fs }, ws = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gs(l, e) {
  return s(), d("svg", ws, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75m.512 8.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bs = { render: gs }, Ms = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xs(l, e) {
  return s(), d("svg", Ms, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 10A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ys = { render: xs }, As = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vs(l, e) {
  return s(), d("svg", As, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hs = { render: Vs }, Bs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zs(l, e) {
  return s(), d("svg", Bs, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 2.75A5.25 5.25 0 0 0 2.75 8v8c0 2.9 2.35 5.25 5.25 5.25h8c2.9 0 5.25-2.35 5.25-5.25V8c0-2.9-2.35-5.25-5.25-5.25zM1.25 8A6.75 6.75 0 0 1 8 1.25h8A6.75 6.75 0 0 1 22.75 8v8A6.75 6.75 0 0 1 16 22.75H8A6.75 6.75 0 0 1 1.25 16z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 9.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zM5.25 11A2.75 2.75 0 0 1 8 8.25h3A2.75 2.75 0 0 1 13.75 11v2A2.75 2.75 0 0 1 11 15.75H8A2.75 2.75 0 0 1 5.25 13z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "m17.25 10-2.667 2 2.667 2zm-.66-1.38c.89-.667 2.16-.032 2.16 1.08v4.6c0 1.112-1.27 1.747-2.16 1.08l-3.067-2.3a1.35 1.35 0 0 1 0-2.16z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cs = { render: zs }, Ls = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ss(l, e) {
  return s(), d("svg", Ls, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.357 7.614a.75.75 0 0 1 1.029-.257L12 10.125l4.614-2.768a.75.75 0 0 1 .772 1.286l-5 3a.75.75 0 0 1-.772 0l-5-3a.75.75 0 0 1-.257-1.029",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5H4A2.75 2.75 0 0 1 1.25 18V6A2.75 2.75 0 0 1 4 3.25h16A2.75 2.75 0 0 1 22.75 6v6.857a.75.75 0 1 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.21 18.4c.294-.299.769-.539 1.49-.539h4.473l-1.85 1.828a.75.75 0 1 0 1.054 1.067l3.15-3.111a.75.75 0 0 0 0-1.067l-3.15-3.112a.75.75 0 1 0-1.054 1.068l1.85 1.827H15.7c-1.079 0-1.954.371-2.56.989a3.14 3.14 0 0 0-.89 2.206c0 .792.292 1.596.89 2.206.606.617 1.481.988 2.56.988a.75.75 0 0 0 0-1.5c-.721 0-1.196-.24-1.49-.54a1.64 1.64 0 0 1-.46-1.154c0-.43.158-.848.46-1.156",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Es = { render: Ss }, Ts = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _s(l, e) {
  return s(), d("svg", Ts, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.795 12.244a.75.75 0 0 1 .961-.449l5.5 2a.75.75 0 0 1 .465.911l-.936 3.277.926 2.78a.75.75 0 0 1-1.423.474l-1-3a.75.75 0 0 1-.01-.443l.809-2.828-4.843-1.761a.75.75 0 0 1-.449-.961m14.968-.455a.75.75 0 0 1 .32-.034l4.5.5a.75.75 0 1 1-.166 1.49l-4.336-.481-2.331.777v2.451l2.029.812a.75.75 0 0 1 .456.549l.5 2.5a.75.75 0 1 1-1.47.294l-.42-2.101-2.123-.85A.75.75 0 0 1 13.25 17v-3.5a.75.75 0 0 1 .513-.711zm2.474-7a.75.75 0 0 1 .475.948l-.5 1.5a.75.75 0 0 1-.606.505l-2.856.408v1.242l1.471-.588a.8.8 0 0 1 .279-.054h2a.75.75 0 0 1 .335.08l2 1a.75.75 0 1 1-.67 1.34l-1.842-.92h-1.679l-2.365.946a.75.75 0 0 1-1.029-.696v-3a.75.75 0 0 1 .644-.742l3.041-.435.354-1.06a.75.75 0 0 1 .948-.474M8.165 2.33a.75.75 0 0 1 1.006.335l1 2a.75.75 0 0 1-.047.751l-2 3a.75.75 0 0 1-.477.32L5.326 9.2l-2.357 1.886a.75.75 0 1 1-.937-1.172l2.5-2a.75.75 0 0 1 .32-.15l2.196-.439 1.587-2.379-.806-1.61a.75.75 0 0 1 .336-1.007Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Rs = { render: _s }, ks = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Os(l, e) {
  return s(), d("svg", ks, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75A7.25 7.25 0 0 0 4.75 11a.75.75 0 0 1-1.5 0 8.75 8.75 0 0 1 17.5 0 .75.75 0 0 1-1.5 0A7.25 7.25 0 0 0 12 3.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.073 10.459a1.35 1.35 0 0 1 1.677 1.31v5.463a1.35 1.35 0 0 1-1.677 1.31l-1.74-.436a2.75 2.75 0 0 1-2.083-2.668v-1.877a2.75 2.75 0 0 1 2.083-2.667zm.177 1.502-1.553.388a1.25 1.25 0 0 0-.947 1.213v1.876c0 .574.39 1.074.947 1.213l1.553.388zm13.5-.001v5.08l1.553-.389a1.25 1.25 0 0 0 .947-1.213v-1.877a1.25 1.25 0 0 0-.947-1.212zm-1.5-.192a1.35 1.35 0 0 1 1.677-1.31l1.74.436a2.75 2.75 0 0 1 2.083 2.668v1.876a2.75 2.75 0 0 1-2.083 2.668l-1.74.435a1.35 1.35 0 0 1-1.677-1.31z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M19.25 18.5V18h1.5v.5A2.75 2.75 0 0 1 18 21.25h-3.5v-1.5H18c.69 0 1.25-.56 1.25-1.25",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.5 19.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zm-2.25.75a2.25 2.25 0 0 1 2.25-2.25h3a2.25 2.25 0 0 1 0 4.5h-3a2.25 2.25 0 0 1-2.25-2.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $s = { render: Os }, Ns = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fs(l, e) {
  return s(), d("svg", Ns, e[0] || (e[0] = [
    n("path", { d: "M12 16.275c.45 0 .75-.3.75-.75s-.3-.75-.75-.75H9c-.15-.825-.225-1.8-.225-2.775S8.85 10.125 9 9.225h6c.15.825.225 1.8.225 2.775 0 .45.3.75.75.75s.75-.3.75-.75c0-.975-.075-1.875-.225-2.775h4.275c.3.9.45 1.8.45 2.775 0 .45.3.75.75.75s.75-.3.75-.75c0-1.275-.225-2.55-.675-3.675 0-.075 0-.075-.075-.15-1.425-3.675-4.8-6.45-8.925-6.825-.375 0-.75-.075-1.125-.075s-.75 0-1.125.075a10.8 10.8 0 0 0-8.925 6.825c0 .075-.075.075-.075.15-.3 1.125-.525 2.4-.525 3.675s.225 2.55.675 3.675c0 .075 0 .075.075.15a10.65 10.65 0 0 0 9 6.825c.3 0 .675.075.975.075.45 0 .75-.3.75-.75s-.3-.75-.75-.75h-.6c-.45-.675-1.5-2.4-2.1-4.95zm-4.575-1.5H3.15c-.3-.9-.45-1.8-.45-2.775s.15-1.875.45-2.775h4.275c-.15.825-.225 1.8-.225 2.775s.15 1.875.225 2.775m12.75-7.05H16.2c-.45-2.025-1.2-3.6-1.725-4.65 2.55.75 4.575 2.475 5.7 4.65M12.6 2.775c.45.675 1.5 2.4 2.1 4.95H9.3c.675-2.55 1.725-4.35 2.1-4.95zm-3.15.3c-.6 1.05-1.275 2.625-1.725 4.65h-3.9c1.125-2.175 3.15-3.9 5.625-4.65m0 17.85c-2.475-.675-4.5-2.4-5.7-4.65h3.975c.45 1.95 1.2 3.525 1.725 4.65" }, null, -1),
    n("path", { d: "m22.275 17.25-5.325-3.3c-.45-.3-.975-.3-1.425 0-.375.3-.6.75-.45 1.275l1.275 6.15c.15.6.6 1.125 1.2 1.2h.15c.45 0 .825-.225 1.05-.675l.975-1.95 2.175-.225c.525-.075.9-.45 1.05-.9.15-.6-.15-1.2-.675-1.575M18.75 18.6l-1.05 2.1-1.05-5.175 4.5 2.775z" }, null, -1)
  ]));
}
const Ds = { render: Fs }, Is = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function js(l, e) {
  return s(), d("svg", Is, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.386 8.57a.75.75 0 0 1 1.044-.184L12 11.585l4.57-3.2a.75.75 0 1 1 .86 1.23l-5 3.5a.75.75 0 0 1-.86 0l-5-3.5a.75.75 0 0 1-.184-1.045",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 5.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25zM1.25 7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qs = { render: js }, Ps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Us(l, e) {
  return s(), d("svg", Ps, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.376 8.584a.75.75 0 0 1 1.04-.208L9.5 11.099l4.084-2.723a.75.75 0 0 1 .832 1.248l-4.5 3a.75.75 0 0 1-.832 0l-4.5-3a.75.75 0 0 1-.208-1.04",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3 5.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14a.75.75 0 0 1 0 1.5H3A2.75 2.75 0 0 1 .25 17V7A2.75 2.75 0 0 1 3 4.25h13A2.75 2.75 0 0 1 18.75 7v2a.75.75 0 0 1-1.5 0V7c0-.69-.56-1.25-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.53 10.47a.75.75 0 0 1 0 1.06l-1.72 1.72H23a.75.75 0 0 1 0 1.5h-4.19l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zs = { render: Us }, Ws = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ks(l, e) {
  return s(), d("svg", Ws, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.386 11.57a.75.75 0 0 1 1.044-.184L12 14.585l4.57-3.2a.75.75 0 1 1 .86 1.23l-5 3.5a.75.75 0 0 1-.86 0l-5-3.5a.75.75 0 0 1-.184-1.045",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.585 1.974a2.75 2.75 0 0 1 2.83 0l8 4.8a2.75 2.75 0 0 1 1.335 2.358V20A2.75 2.75 0 0 1 20 22.75H4A2.75 2.75 0 0 1 1.25 20V9.132a2.75 2.75 0 0 1 1.335-2.358zm2.058 1.287a1.25 1.25 0 0 0-1.286 0l-8 4.8a1.25 1.25 0 0 0-.607 1.071V20c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V9.132c0-.439-.23-.846-.607-1.071z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Js = { render: Ks }, Gs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xs(l, e) {
  return s(), d("svg", Gs, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.376 8.584a.75.75 0 0 1 1.04-.208L9.5 11.099l4.084-2.723a.75.75 0 0 1 .832 1.248l-4.5 3a.75.75 0 0 1-.832 0l-4.5-3a.75.75 0 0 1-.208-1.04",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3 5.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14a.75.75 0 0 1 0 1.5H3A2.75 2.75 0 0 1 .25 17V7A2.75 2.75 0 0 1 3 4.25h13A2.75 2.75 0 0 1 18.75 7v2a.75.75 0 0 1-1.5 0V7c0-.69-.56-1.25-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M23.53 14.53a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H17a.75.75 0 0 0 0 1.5h4.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ys = { render: Xs }, Qs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ed(l, e) {
  return s(), d("svg", Qs, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14.862l2.064-2.58A2.75 2.75 0 0 1 7.96 16.25H19c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75H7.961c-.38 0-.739.173-.976.47l-2.33 2.913c-.798.996-2.405.433-2.405-.843z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ld = { render: ed }, td = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nd(l, e) {
  return s(), d("svg", td, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m.512 6.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14.862l2.064-2.58a2.75 2.75 0 0 1 2.147-1.032h11.04c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75H7.961c-.38 0-.739.173-.976.47l-2.33 2.913c-.798.996-2.405.433-2.405-.843z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ad = { render: nd }, rd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function od(l, e) {
  return s(), d("svg", rd, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m0-4A.75.75 0 0 1 7 7.25h6a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14.862l2.064-2.58a2.75 2.75 0 0 1 2.147-1.032h11.04c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75H7.961c-.38 0-.739.173-.976.47l-2.33 2.913c-.798.996-2.405.433-2.405-.843z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const id = { render: od }, sd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function dd(l, e) {
  return s(), d("svg", sd, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.5 11.75a4.75 4.75 0 0 0-4.115 7.125.75.75 0 0 1 .088.512l-.26 1.4 1.4-.26a.75.75 0 0 1 .513.088A4.75 4.75 0 1 0 7.5 11.75M1.25 16.5a6.25 6.25 0 1 1 3.374 5.55l-2.212.412a.75.75 0 0 1-.874-.874l.412-2.212a6.2 6.2 0 0 1-.7-2.876",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14 2.75a7.25 7.25 0 0 1 6.28 10.874.75.75 0 0 0-.088.513l.47 2.526-2.525-.47a.75.75 0 0 0-.512.087 7.2 7.2 0 0 1-2.462.877.75.75 0 0 0 .239 1.481 8.7 8.7 0 0 0 2.726-.921l3.335.62a.75.75 0 0 0 .874-.874l-.62-3.335A8.75 8.75 0 1 0 5.34 8.742a.75.75 0 1 0 1.485.215A7.25 7.25 0 0 1 14 2.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cd = { render: dd }, ud = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vd(l, e) {
  return s(), d("svg", ud, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.064 1.25h3.75a.75.75 0 0 1 .702.486l1.456 3.87a.75.75 0 0 1 .035.401l-.73 3.912c.897 2.108 2.378 3.525 4.834 4.796l3.864-.75a.75.75 0 0 1 .41.036l3.882 1.48a.75.75 0 0 1 .483.7v3.584c0 1.626-1.432 2.945-3.108 2.58-3.053-.664-8.71-2.353-12.672-6.315-3.796-3.795-5.067-9.037-5.495-11.87-.245-1.618 1.052-2.91 2.589-2.91m3.231 1.5H4.064c-.72 0-1.198.572-1.106 1.185.413 2.732 1.62 7.583 5.072 11.035 3.649 3.648 8.953 5.262 11.931 5.91.655.142 1.289-.356 1.289-1.114v-3.068l-3.2-1.219-3.907.757a.75.75 0 0 1-.48-.066c-2.894-1.452-4.773-3.175-5.86-5.892a.75.75 0 0 1-.04-.415l.731-3.925z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const pd = { render: vd }, hd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fd(l, e) {
  return s(), d("svg", hd, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5 7.25a.25.25 0 0 0-.25.25V11c0 .138.112.25.25.25h4.25V7.5A.25.25 0 0 0 9 7.25zm4.213 5.5c-.084.774-.308 1.392-.698 1.94-.523.731-1.4 1.414-2.85 2.14a.75.75 0 1 0 .67 1.34c1.55-.774 2.673-1.591 3.4-2.61.741-1.036 1.015-2.203 1.015-3.56V7.5A1.75 1.75 0 0 0 9 5.75H5A1.75 1.75 0 0 0 3.25 7.5V11c0 .966.784 1.75 1.75 1.75zM15 7.25a.25.25 0 0 0-.25.25V11c0 .138.112.25.25.25h4.25V7.5a.25.25 0 0 0-.25-.25zm4.212 5.5c-.083.774-.307 1.392-.697 1.94-.523.731-1.4 1.414-2.85 2.14a.75.75 0 1 0 .67 1.34c1.55-.774 2.673-1.591 3.4-2.61.741-1.036 1.015-2.203 1.015-3.56V7.5A1.75 1.75 0 0 0 19 5.75h-4a1.75 1.75 0 0 0-1.75 1.75V11c0 .966.784 1.75 1.75 1.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const md = { render: fd }, wd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gd(l, e) {
  return s(), d("svg", wd, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14.862l2.064-2.58A2.75 2.75 0 0 1 7.96 16.25H19c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75H7.961c-.38 0-.739.173-.976.47l-2.33 2.913c-.798.996-2.405.433-2.405-.843z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.5 7.75a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h1.25V8a.25.25 0 0 0-.25-.25zm.981 3a4 4 0 0 1-.206.3c-.337.449-.796.91-1.305 1.42a.75.75 0 1 0 1.06 1.06l.022-.021c.484-.485 1.016-1.016 1.423-1.559s.775-1.205.775-1.95V8A1.75 1.75 0 0 0 9.5 6.25h-1A1.75 1.75 0 0 0 6.75 8v1c0 .966.784 1.75 1.75 1.75zm5.019-3a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h1.25V8a.25.25 0 0 0-.25-.25zm.981 3a4 4 0 0 1-.206.3c-.337.449-.796.91-1.305 1.42a.75.75 0 1 0 1.06 1.06l.022-.021c.484-.485 1.016-1.016 1.423-1.559s.775-1.205.775-1.95V8a1.75 1.75 0 0 0-1.75-1.75h-1A1.75 1.75 0 0 0 12.75 8v1c0 .966.784 1.75 1.75 1.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bd = { render: gd }, Md = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xd(l, e) {
  return s(), d("svg", Md, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.53 2.47a.75.75 0 0 1 0 1.06L3.81 9.25H16c2.182 0 3.883.755 5.038 1.947 1.147 1.182 1.712 2.75 1.712 4.303s-.565 3.12-1.712 4.303C19.883 20.995 18.182 21.75 16 21.75a.75.75 0 0 1 0-1.5c1.818 0 3.117-.62 3.962-1.49.853-.88 1.288-2.063 1.288-3.26s-.435-2.38-1.288-3.26c-.845-.87-2.144-1.49-3.962-1.49H3.81l5.72 5.72a.75.75 0 1 1-1.06 1.06l-7-7a.75.75 0 0 1 0-1.06l7-7a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yd = { render: xd }, Ad = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vd(l, e) {
  return s(), d("svg", Ad, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.357 7.614a.75.75 0 0 1 1.029-.257L12 10.125l4.614-2.768a.75.75 0 1 1 .772 1.286l-5 3a.75.75 0 0 1-.772 0l-5-3a.75.75 0 0 1-.257-1.029",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5H4A2.75 2.75 0 0 1 1.25 18V6A2.75 2.75 0 0 1 4 3.25h16A2.75 2.75 0 0 1 22.75 6v6.857a.75.75 0 1 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16.684 13.473a.75.75 0 0 1-.007 1.06l-1.85 1.828H19.3c1.079 0 1.954.371 2.56.989.598.609.89 1.413.89 2.206s-.292 1.596-.89 2.206c-.606.617-1.481.988-2.56.988a.75.75 0 0 1 0-1.5c.721 0 1.196-.24 1.49-.54a1.64 1.64 0 0 0 .46-1.154c0-.43-.158-.848-.46-1.156-.294-.299-.769-.539-1.49-.539h-4.473l1.85 1.828a.75.75 0 1 1-1.054 1.067l-3.15-3.111a.75.75 0 0 1 0-1.067l3.15-3.112a.75.75 0 0 1 1.06.007Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hd = { render: Vd }, Bd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zd(l, e) {
  return s(), d("svg", Bd, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.464 3.475a.75.75 0 0 1 .827-.166l19 8a.75.75 0 0 1 0 1.382l-19 8L3 20l.291.691a.75.75 0 0 1-.976-.996L5.742 12 2.315 4.305a.75.75 0 0 1 .15-.83Zm1.993 15.098L20.066 12 4.457 5.427l2.79 6.268a.75.75 0 0 1 0 .61z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.75 12a.75.75 0 0 1 .75-.75H22a.75.75 0 0 1 0 1.5H6.5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cd = { render: zd }, Ld = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Sd(l, e) {
  return s(), d("svg", Ld, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#b01bfb9d-4e37-47f1-b993-fe6d5baca5db-e7840692-71bb-4f3f-b381-8691ac01b938-c9c4d150-22c9-45f1-9e7e-f42d0b8442d3-90abee58-2705-40ac-b3e3-15a80246f2a5-c7403231-ad25-45b8-b09d-8338b542b493-927b7cb0-3291-496c-b344-21180e786572-591db4-fded80d8-30e1-4a6f-8444-1a448e6daefc-9377e2a8-b9b6-4f4d-8c1d-aa76e7b12e99-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M1.26 7.775a.75.75 0 0 1 .582-.61L21.994 2.82a.75.75 0 0 1 .793 1.132L11.812 21.404l-.635-.4.635.4a.75.75 0 0 1-1.371-.257L8.834 12.88l-7.22-4.34a.75.75 0 0 1-.354-.766ZM11.552 19l9.017-14.338-16.558 3.57 5.882 3.533a.75.75 0 0 1 .35.5z" }),
      n("path", { d: "M8.841 12.874a.75.75 0 0 1 .184-1.045l12.697-8.89a.75.75 0 0 1 .86 1.229l-12.696 8.89a.75.75 0 0 1-1.045-.184" })
    ], -1)
  ]));
}
const Ed = { render: Sd }, Td = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _d(l, e) {
  return s(), d("svg", Td, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.376 8.584a.75.75 0 0 1 1.04-.208l4.084 2.723 4.084-2.723a.75.75 0 1 1 .832 1.248l-4.5 3a.75.75 0 0 1-.832 0l-4.5-3a.75.75 0 0 1-.208-1.04M5.75 13.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75m0-3a.75.75 0 0 1-.75.75H1a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M20 5.75c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25v-.5a.75.75 0 0 0-1.5 0v.5A2.75 2.75 0 0 0 7 19.75h13A2.75 2.75 0 0 0 22.75 17V7A2.75 2.75 0 0 0 20 4.25H7A2.75 2.75 0 0 0 4.25 7v.5a.75.75 0 0 0 1.5 0V7c0-.69.56-1.25 1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Rd = { render: _d }, kd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Od(l, e) {
  return s(), d("svg", kd, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.862 4.648 6.863 8.604a1.75 1.75 0 0 1-.963.289H3c-.69 0-1.25.56-1.25 1.25v3.714c0 .69.56 1.25 1.25 1.25h2.9c.343 0 .678.1.963.29l6 3.955a.25.25 0 0 0 .387-.21V4.858a.25.25 0 0 0-.388-.209m-.825-1.252c1.163-.767 2.713.067 2.713 1.461v14.286c0 1.393-1.55 2.228-2.713 1.46l-6-3.955a.25.25 0 0 0-.137-.04H3a2.75 2.75 0 0 1-2.75-2.75v-3.715A2.75 2.75 0 0 1 3 7.393h2.9a.25.25 0 0 0 .138-.041zM16.97 6.97a.75.75 0 0 1 1.06 0h.001l.001.002.003.002.007.007.02.02.062.069c.05.057.12.138.201.241A6.87 6.87 0 0 1 19.75 11.5a6.87 6.87 0 0 1-1.425 4.189 5 5 0 0 1-.264.31l-.02.02-.006.007-.003.002v.001l.01-.01-.012.011a.75.75 0 0 1-1.063-1.058l.003-.002.035-.04c.016-.016-.035.04-.035.04h-.001l-.002.002.005-.005.033-.036c.031-.035.08-.09.139-.167a5.37 5.37 0 0 0 .448-5.843 5 5 0 0 0-.448-.685 3 3 0 0 0-.172-.203l-.005-.005a.75.75 0 0 1 .003-1.058",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M19.97 3.97a.75.75 0 0 1 1.06 0h.001l.002.002.003.003.009.01a2 2 0 0 1 .124.134c.079.089.188.218.316.385.257.333.594.823.929 1.46.67 1.274 1.336 3.143 1.336 5.536s-.666 4.262-1.336 5.537a10 10 0 0 1-.929 1.46 7 7 0 0 1-.44.518l-.01.01-.002.003-.002.001.043-.044-.044.045a.75.75 0 0 1-1.061-1.06l.014-.014.063-.07q.089-.098.25-.304c.212-.276.5-.693.79-1.244.58-1.1 1.164-2.731 1.164-4.838s-.584-3.738-1.164-4.838a8.7 8.7 0 0 0-.79-1.244 6 6 0 0 0-.313-.374l-.014-.014a.75.75 0 0 1 0-1.06" }, null, -1)
  ]));
}
const $d = { render: Od }, Nd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fd(l, e) {
  return s(), d("svg", Nd, e[0] || (e[0] = [
    n("path", { d: "M12 16.275c.45 0 .75-.3.75-.75s-.3-.75-.75-.75H9c-.15-.825-.225-1.8-.225-2.775S8.85 10.125 9 9.225h6c.15.825.225 1.8.225 2.775 0 .45.3.75.75.75s.75-.3.75-.75c0-.975-.075-1.875-.225-2.775h4.275c.3.9.45 1.8.45 2.775 0 .45.3.75.75.75s.75-.3.75-.75c0-1.275-.225-2.55-.675-3.675 0-.075 0-.075-.075-.15-1.425-3.675-4.8-6.45-8.925-6.825-.375 0-.75-.075-1.125-.075s-.75 0-1.125.075a10.8 10.8 0 0 0-8.925 6.825c0 .075-.075.075-.075.15-.3 1.125-.525 2.4-.525 3.675s.225 2.55.675 3.675c0 .075 0 .075.075.15a10.65 10.65 0 0 0 9 6.825c.3 0 .675.075.975.075.45 0 .75-.3.75-.75s-.3-.75-.75-.75h-.6c-.45-.675-1.5-2.4-2.1-4.95zm-4.575-1.5H3.15c-.3-.9-.45-1.8-.45-2.775s.15-1.875.45-2.775h4.275c-.15.825-.225 1.8-.225 2.775s.15 1.875.225 2.775m12.75-7.05H16.2c-.45-2.025-1.2-3.6-1.725-4.65 2.55.75 4.575 2.475 5.7 4.65M12.6 2.775c.45.675 1.5 2.4 2.1 4.95H9.3c.675-2.55 1.725-4.35 2.1-4.95zm-3.15.3c-.6 1.05-1.275 2.625-1.725 4.65h-3.9c1.125-2.175 3.15-3.9 5.625-4.65m0 17.85c-2.475-.675-4.5-2.4-5.7-4.65h3.975c.45 1.95 1.2 3.525 1.725 4.65m11.025-2.7h-.75v-.75c0-.45-.3-.75-.75-.75s-.75.3-.75.75v1.5c0 .45.3.75.75.75h1.5c.45 0 .75-.3.75-.75s-.3-.75-.75-.75" }, null, -1),
    n("path", { d: "M18.975 14.25a4.705 4.705 0 0 0-4.725 4.725c0 2.625 2.1 4.725 4.725 4.725s4.725-2.1 4.725-4.725-2.1-4.725-4.725-4.725m0 8.025a3.2 3.2 0 0 1-3.225-3.225c0-1.8 1.425-3.225 3.225-3.225S22.2 17.25 22.2 19.05s-1.425 3.225-3.225 3.225" }, null, -1)
  ]));
}
const Dd = { render: Fd }, Id = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jd(l, e) {
  return s(), d("svg", Id, e[0] || (e[0] = [
    n("path", { d: "M14.4 11.325 10.875 9.3a.68.68 0 0 0-.75 0 .9.9 0 0 0-.375.675v3.975c0 .3.15.525.375.675.15.075.225.075.375.075s.225 0 .375-.075L14.4 12.6a.79.79 0 0 0 .375-.675c0-.3-.15-.45-.375-.6" }, null, -1),
    n("path", { d: "M21.6 5.475c-1.125-1.125-2.775-1.2-5.7-1.275-1.5-.075-2.85-.075-3.9-.075s-2.4 0-3.975.075C5.1 4.275 3.45 4.35 2.4 5.475 1.275 6.6 1.275 8.25 1.275 11.25v1.425c0 3 0 4.65 1.125 5.775s2.775 1.2 5.7 1.275c1.5.075 2.85.075 3.9.075 1.125 0 2.4 0 3.9-.075 2.925-.075 4.575-.15 5.7-1.275s1.125-2.775 1.125-5.775V11.25c0-2.925 0-4.575-1.125-5.775m-.375 7.2c0 2.7 0 4.05-.675 4.725s-1.875.75-4.65.825c-1.5.075-2.775.075-3.9.075-1.05 0-2.4 0-3.9-.075-2.85-.075-3.975-.15-4.65-.825-.675-.75-.675-2.1-.675-4.725V11.25c0-2.7 0-4.05.675-4.725s1.875-.75 4.65-.825c1.5-.075 2.85-.075 3.9-.075s2.4 0 3.9.075c2.85.075 3.975.15 4.65.825.675.75.675 2.1.675 4.725z" }, null, -1)
  ]));
}
const qd = { render: jd }, Pd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ud(l, e) {
  return s(), d("svg", Pd, e[0] || (e[0] = [
    n("path", { d: "M21.075 16.35c-.375-.225-.825-.075-1.05.3-1.2 2.1-3.225 3.6-5.475 4.275.45-.9 1.05-2.1 1.5-3.675.15-.375-.15-.825-.525-.9-.375-.15-.825.15-.9.525-.675 2.25-1.575 3.825-1.95 4.425-.225 0-.375.075-.6.075s-.375 0-.6-.075c-.375-.6-1.35-2.175-1.95-4.425-.15-.375-.525-.6-.9-.525-.375.15-.6.525-.525.9.45 1.575.975 2.775 1.5 3.675-2.25-.675-4.275-2.175-5.475-4.275-.375-.375-.825-.525-1.125-.3-.375.225-.45.675-.3 1.05 1.725 3 4.875 5.025 8.325 5.325.3 0 .675.075.975.075s.675 0 .975-.075c3.45-.3 6.525-2.325 8.325-5.325.225-.375.075-.825-.225-1.05M3 7.65c.375.225.825.075 1.05-.3 1.125-2.1 3.15-3.6 5.4-4.2-.45.9-1.05 2.1-1.5 3.675-.15.375.15.825.525.9H8.7c.3 0 .6-.225.75-.525.675-2.25 1.575-3.825 1.95-4.425.225 0 .375-.075.6-.075s.375 0 .6.075c.375.6 1.35 2.175 1.95 4.425.075.3.375.525.75.525h.225c.375-.15.6-.525.525-.9-.45-1.575-.975-2.775-1.5-3.675 2.25.675 4.275 2.175 5.475 4.275.15.225.375.375.675.375.15 0 .225 0 .375-.075.375-.225.45-.675.3-1.05-1.725-3-4.8-4.95-8.175-5.325h-.075c-.375 0-.675-.075-1.05-.075s-.675 0-1.05.075h-.075C7.5 1.65 4.425 3.675 2.7 6.6c-.225.375-.075.825.3 1.05M15.225 9.3a.666.666 0 0 0-.9.525l-.75 2.625-.825-2.7c-.075-.3-.375-.525-.75-.525s-.6.225-.75.525l-.75 2.625-.75-2.625c-.15-.375-.525-.6-.9-.525-.375.15-.6.525-.525.9l1.5 5.025c.075.3.375.525.75.525s.6-.225.75-.525l.75-2.625.75 2.625c.075.3.375.525.75.525s.6-.225.75-.525l1.5-5.025c0-.3-.225-.75-.6-.825m-12 5.925.75-2.625.75 2.625c.075.3.375.525.75.525s.6-.225.75-.525l1.5-5.025a.666.666 0 0 0-.525-.9.666.666 0 0 0-.9.525l-.75 2.625-.75-2.625c-.075-.3-.375-.525-.75-.525s-.6.225-.75.525l-.75 2.625-.75-2.625c-.15-.375-.525-.6-.9-.525-.375.15-.6.525-.525.9l1.5 5.025c.075.3.375.525.75.525s.525-.225.6-.525M23.25 9.3a.666.666 0 0 0-.9.525l-.75 2.625-.75-2.625c-.075-.3-.375-.525-.75-.525s-.6.225-.75.525l-.75 2.625-.75-2.625c-.15-.375-.525-.6-.9-.525-.375.15-.6.525-.525.9l1.5 5.025c.075.3.375.525.75.525s.6-.225.75-.525l.75-2.625.75 2.625c.075.3.375.525.75.525s.6-.225.75-.525l1.5-5.025c-.075-.375-.3-.825-.675-.9" }, null, -1)
  ]));
}
const Zd = { render: Ud }, Wd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kd(l, e) {
  return s(), d("svg", Wd, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 4A.75.75 0 0 1 3 3.25h18a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V4.75H3.75v11.5H6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.877 14.333a1.35 1.35 0 0 1 2.246 0l2.88 4.318a1.35 1.35 0 0 1-1.124 2.099H9.12a1.35 1.35 0 0 1-1.123-2.099l2.879-4.318ZM12 15.353 9.401 19.25H14.6z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jd = { render: Kd }, Gd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xd(l, e) {
  return s(), d("svg", Gd, e[0] || (e[0] = [
    n("path", { d: "M15.6 6.375c-.375.225-.45.675-.225 1.05.15.225.375.3.6.3.15 0 .3-.075.45-.15.075-.075 1.8-1.275 1.8-3.6S16.5.45 16.425.375C16.05.15 15.6.225 15.375.6s-.15.825.225 1.05c.075 0 1.2.825 1.2 2.4s-1.2 2.325-1.2 2.325M7.575 7.65c.15.075.3.15.45.15.225 0 .45-.15.6-.3.225-.375.15-.825-.225-1.05-.075 0-1.2-.825-1.2-2.4s1.125-2.325 1.2-2.4c.375-.225.45-.675.225-1.05S7.95.15 7.575.375c-.075.075-1.8 1.275-1.8 3.6s1.725 3.6 1.8 3.675m9.075 11.175L15.225 13.8 12.9 5.475c.525-.3.825-.825.825-1.5 0-.975-.75-1.725-1.725-1.725s-1.725.75-1.725 1.725c0 .6.3 1.2.825 1.5L8.775 13.8l-1.35 4.95L6.3 22.725c-.075.375.15.825.525.9s.825-.15.9-.525l.975-3.45h6.675l.975 3.45c.075.3.375.525.75.525h.225c.375-.075.6-.525.525-.9zM12 7.8l1.5 5.475h-3zM9.075 18.225l.975-3.525h3.825l.975 3.525z" }, null, -1)
  ]));
}
const Yd = { render: Xd }, Qd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ec(l, e) {
  return s(), d("svg", Qd, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 4.25a.75.75 0 0 1 .723.55l1.046 3.767a.75.75 0 1 1-1.445.401l-.39-1.4a.75.75 0 0 1-1.212-.769l.555-2A.75.75 0 0 1 12 4.25m-1.5 6.148a.75.75 0 0 1 .522.924l-.535 1.928H13.5a.75.75 0 0 1 .735.901.75.75 0 0 1 1.192.384l2.296 8.264a.75.75 0 1 1-1.446.402l-.958-3.451H8.68l-.958 3.45a.75.75 0 0 1-1.446-.4l3.3-11.88a.75.75 0 0 1 .924-.522M9.099 18.25h5.804l-.92-3.313a.75.75 0 0 1-.012-.352.75.75 0 0 1-.47.165h-3.43z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 0 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M10.25 4a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const lc = { render: ec }, tc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nc(l, e) {
  return s(), d("svg", tc, e[0] || (e[0] = [
    n("path", { d: "M18 7.5c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05c0 0 1.275 1.35 1.275 3.45s-1.275 3.45-1.275 3.45c-.3.3-.3.75 0 1.05a.8.8 0 0 0 .525.225A.8.8 0 0 0 18 16.5c.075-.075 1.725-1.725 1.725-4.5S18.075 7.575 18 7.5" }, null, -1),
    n("path", { d: "M21 4.5c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05c0 0 2.25 2.4 2.25 6.45s-2.25 6.45-2.25 6.45c-.3.3-.3.75 0 1.05a.8.8 0 0 0 .525.225A.8.8 0 0 0 21 19.5c.075-.075 2.7-2.775 2.7-7.5.075-4.725-2.55-7.425-2.7-7.5m-13.95 3c-.3-.3-.75-.3-1.05 0-.075.075-1.725 1.725-1.725 4.5S5.925 16.425 6 16.5c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.3-.3.3-.75 0-1.05 0 0-1.275-1.35-1.275-3.45S7.05 8.55 7.05 8.55c.3-.3.3-.825 0-1.05" }, null, -1),
    n("path", { d: "M1.725 12c0-4.125 2.25-6.45 2.25-6.45.3-.3.3-.75 0-1.05-.225-.3-.675-.3-.975 0C2.85 4.575.225 7.275.225 12S2.85 19.425 3 19.5a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.3-.3.3-.75 0-1.05-.075 0-2.325-2.325-2.325-6.45M12 10.275c-.975 0-1.725.75-1.725 1.725s.75 1.725 1.725 1.725 1.725-.75 1.725-1.725-.75-1.725-1.725-1.725" }, null, -1)
  ]));
}
const ac = { render: nc }, rc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function oc(l, e) {
  return s(), d("svg", rc, e[0] || (e[0] = [
    n("path", { d: "M15.975 2.25h-7.95c-3.75 0-6.75 3-6.75 6.75v6c0 3.75 3 6.75 6.75 6.75h8.025c3.75 0 6.75-3 6.75-6.75V9c-.075-3.75-3.075-6.75-6.825-6.75M21.225 15a5.22 5.22 0 0 1-5.25 5.25h-7.95A5.22 5.22 0 0 1 2.775 15V9a5.22 5.22 0 0 1 5.25-5.25h8.025A5.22 5.22 0 0 1 21.3 9v6z" }, null, -1),
    n("path", { d: "M15.525 8.475c-.3-.3-.75-.3-1.05-.075s-.375.75-.075 1.05c0 .075.825.975.825 2.475 0 1.575-.75 2.475-.825 2.475-.3.3-.225.75.075 1.05.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.075-.075 1.2-1.35 1.2-3.525 0-2.025-1.125-3.375-1.2-3.45m-4.05 3c-.3.3-.225.825.075 1.05.15.15.3.15.525.15s.45-.075.6-.225c.3-.3.225-.75-.075-1.05-.375-.225-.9-.225-1.125.075" }, null, -1),
    n("path", { d: "M17.475 6.45c-.3-.3-.75-.225-1.05.075s-.225.75.075 1.05c0 0 1.725 1.575 1.725 4.425s-1.65 4.35-1.725 4.425c-.3.3-.3.75-.075 1.05a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.075-.075 2.25-2.025 2.25-5.55 0-3.45-2.1-5.4-2.25-5.475M8.775 12c0-1.575.75-2.475.825-2.475.3-.3.225-.75-.075-1.05s-.75-.225-1.05.075c-.075.075-1.2 1.35-1.2 3.525 0 2.1 1.125 3.45 1.2 3.525a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.3-.3.3-.75.075-1.05-.075-.075-.825-.975-.825-2.55" }, null, -1),
    n("path", { d: "M5.775 12c0-2.775 1.65-4.35 1.725-4.425.3-.3.3-.75.075-1.05-.3-.3-.75-.3-1.05-.075-.075.075-2.25 2.025-2.25 5.55s2.175 5.475 2.25 5.55c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.3-.3.225-.75-.075-1.05-.075-.15-1.725-1.65-1.725-4.5" }, null, -1)
  ]));
}
const ic = { render: oc }, sc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function dc(l, e) {
  return s(), d("svg", sc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.463 1.307a.75.75 0 0 1 .817.163l5.5 5.5a.75.75 0 0 1-.058 1.113L12.883 12l4.839 3.917a.75.75 0 0 1 .058 1.113l-5.5 5.5A.75.75 0 0 1 11 22v-8.476l-3.778 3.059a.75.75 0 0 1-.944-1.166L10.5 12 6.28 8.583a.75.75 0 0 1 .943-1.166L11 10.476V2a.75.75 0 0 1 .463-.693M12.5 13.62l3.63 2.939-3.63 3.63v-6.57Zm0-3.24V3.81l3.63 3.631z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cc = { render: dc }, uc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vc(l, e) {
  return s(), d("svg", uc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.579 5.304a.75.75 0 0 1 .821.179l3.143 3.3a.75.75 0 0 1-.057 1.089L12.982 12l2.504 2.129a.75.75 0 0 1 .057 1.088l-3.143 3.3A.75.75 0 0 1 11.107 18v-4.407l-1.621 1.379a.75.75 0 1 1-.972-1.143L10.666 12l-2.152-1.829a.75.75 0 1 1 .972-1.142l1.621 1.378V6a.75.75 0 0 1 .472-.696m1.028 8.346 1.303 1.107-1.303 1.368zm0-3.3V7.875l1.303 1.368z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 3.75A5.25 5.25 0 0 0 2.75 9v6c0 2.9 2.35 5.25 5.25 5.25h8c2.9 0 5.25-2.35 5.25-5.25V9c0-2.9-2.35-5.25-5.25-5.25zM1.25 9A6.75 6.75 0 0 1 8 2.25h8A6.75 6.75 0 0 1 22.75 9v6A6.75 6.75 0 0 1 16 21.75H8A6.75 6.75 0 0 1 1.25 15z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const pc = { render: vc }, hc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fc(l, e) {
  return s(), d("svg", hc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 3.75A5.25 5.25 0 0 0 2.75 9v6c0 2.9 2.35 5.25 5.25 5.25h8c2.9 0 5.25-2.35 5.25-5.25V9c0-2.9-2.35-5.25-5.25-5.25zM1.25 9A6.75 6.75 0 0 1 8 2.25h8A6.75 6.75 0 0 1 22.75 9v6A6.75 6.75 0 0 1 16 21.75H8A6.75 6.75 0 0 1 1.25 15z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.955 7.308a.75.75 0 0 1 .404.98l-1.234 2.962H14a.75.75 0 0 1 .692 1.039l-1.666 4a.75.75 0 0 1-1.385-.577l1.234-2.962H10a.75.75 0 0 1-.692-1.038l1.666-4a.75.75 0 0 1 .981-.404",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mc = { render: fc }, wc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gc(l, e) {
  return s(), d("svg", wc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16.47 3.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V20a.75.75 0 0 1-1.5 0V5.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06zm-10 17.06a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V4a.75.75 0 0 0-1.5 0v14.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bc = { render: gc }, Mc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xc(l, e) {
  return s(), d("svg", Mc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M13.47 18.47a.75.75 0 0 1 1.06 0L17 20.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06m3-15a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V14a.75.75 0 0 1-1.5 0V5.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06zm-10 17.06a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V4a.75.75 0 0 0-1.5 0v14.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yc = { render: xc }, Ac = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vc(l, e) {
  return s(), d("svg", Ac, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M17 20.75a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 1.5 0v1a.75.75 0 0 1-.75.75m0-5a.75.75 0 0 1-.75-.75v-1a.75.75 0 1 1 1.5 0v1a.75.75 0 0 1-.75.75m-9.47 4.78a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V4a.75.75 0 0 1 1.5 0v14.19l1.72-1.72a.75.75 0 1 1 1.06 1.06zm10-17.06a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 1.06 1.06l1.72-1.72V10a.75.75 0 0 0 1.5 0V5.81l1.72 1.72a.75.75 0 1 0 1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hc = { render: Vc }, Bc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zc(l, e) {
  return s(), d("svg", Bc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7 3.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V4A.75.75 0 0 1 7 3.25m0 5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V9A.75.75 0 0 1 7 8.25m9.47-4.78a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V20a.75.75 0 0 1-1.5 0V5.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06zm-10 17.06a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V14a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cc = { render: zc }, Lc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Sc(l, e) {
  return s(), d("svg", Lc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7 3.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V4A.75.75 0 0 1 7 3.25m0 5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V9A.75.75 0 0 1 7 8.25m9.47-4.78a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V12a.75.75 0 0 1-1.5 0V5.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06zM20 15.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m.512 6.191a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057M6.47 20.53a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V14a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ec = { render: Sc }, Tc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _c(l, e) {
  return s(), d("svg", Tc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 2.6c0-.746.604-1.35 1.35-1.35h5.8c.745 0 1.35.604 1.35 1.35v3.8A1.35 1.35 0 0 1 9.4 7.75H3.6A1.35 1.35 0 0 1 2.25 6.4zm1.5.15v3.5h5.5v-3.5zm4 14.85c0-.746.604-1.35 1.35-1.35h5.8c.745 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35H9.1a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v3.5h5.5v-3.5zm4-15.15c0-.746.604-1.35 1.35-1.35h5.8c.745 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v3.5h5.5v-3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.75 10.5V7h1.5v3.5c0 .69.56 1.25 1.25 1.25h7c.69 0 1.25-.56 1.25-1.25V7h1.5v3.5a2.75 2.75 0 0 1-2.75 2.75h-7a2.75 2.75 0 0 1-2.75-2.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.25 17v-4.5h1.5V17z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Rc = { render: _c }, kc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Oc(l, e) {
  return s(), d("svg", kc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 21.4c0 .746.604 1.35 1.35 1.35h5.8a1.35 1.35 0 0 0 1.35-1.35v-3.8a1.35 1.35 0 0 0-1.35-1.35H3.6a1.35 1.35 0 0 0-1.35 1.35zm1.5-.15v-3.5h5.5v3.5zm4-14.85c0 .746.604 1.35 1.35 1.35h5.8a1.35 1.35 0 0 0 1.35-1.35V2.6a1.35 1.35 0 0 0-1.35-1.35H9.1A1.35 1.35 0 0 0 7.75 2.6zm1.5-.15v-3.5h5.5v3.5zm4 15.15c0 .746.604 1.35 1.35 1.35h5.8a1.35 1.35 0 0 0 1.35-1.35v-3.8a1.35 1.35 0 0 0-1.35-1.35h-5.8a1.35 1.35 0 0 0-1.35 1.35zm1.5-.15v-3.5h5.5v3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.75 13.5V17h1.5v-3.5c0-.69.56-1.25 1.25-1.25h7c.69 0 1.25.56 1.25 1.25V17h1.5v-3.5a2.75 2.75 0 0 0-2.75-2.75h-7a2.75 2.75 0 0 0-2.75 2.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.25 7v4.5h1.5V7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $c = { render: Oc }, Nc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fc(l, e) {
  return s(), d("svg", Nc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.6 21.75a1.35 1.35 0 0 1-1.35-1.35v-5.8c0-.745.604-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v5.8a1.35 1.35 0 0 1-1.35 1.35zm.15-1.5h3.5v-5.5h-3.5zm14.85-4a1.35 1.35 0 0 1-1.35-1.35V9.1c0-.746.605-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v5.8a1.35 1.35 0 0 1-1.35 1.35zm.15-1.5h3.5v-5.5h-3.5zm-15.15-4A1.35 1.35 0 0 1 1.25 9.4V3.6c0-.746.604-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v5.8a1.35 1.35 0 0 1-1.35 1.35zm.15-1.5h3.5v-5.5h-3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.5 18.25H7v-1.5h3.5c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25H7v-1.5h3.5a2.75 2.75 0 0 1 2.75 2.75v7a2.75 2.75 0 0 1-2.75 2.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M17 12.75h-4.5v-1.5H17z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dc = { render: Fc }, Ic = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jc(l, e) {
  return s(), d("svg", Ic, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M21.4 21.75a1.35 1.35 0 0 0 1.35-1.35v-5.8a1.35 1.35 0 0 0-1.35-1.35h-3.8a1.35 1.35 0 0 0-1.35 1.35v5.8c0 .746.604 1.35 1.35 1.35zm-.15-1.5h-3.5v-5.5h3.5zm-14.85-4a1.35 1.35 0 0 0 1.35-1.35V9.1A1.35 1.35 0 0 0 6.4 7.75H2.6A1.35 1.35 0 0 0 1.25 9.1v5.8c0 .746.604 1.35 1.35 1.35zm-.15-1.5h-3.5v-5.5h3.5zm15.15-4a1.35 1.35 0 0 0 1.35-1.35V3.6a1.35 1.35 0 0 0-1.35-1.35h-3.8a1.35 1.35 0 0 0-1.35 1.35v5.8c0 .746.604 1.35 1.35 1.35zm-.15-1.5h-3.5v-5.5h3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M13.5 18.25H17v-1.5h-3.5c-.69 0-1.25-.56-1.25-1.25v-7c0-.69.56-1.25 1.25-1.25H17v-1.5h-3.5a2.75 2.75 0 0 0-2.75 2.75v7a2.75 2.75 0 0 0 2.75 2.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7 12.75h4.5v-1.5H7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qc = { render: jc }, Pc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Uc(l, e) {
  return s(), d("svg", Pc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 9 9.25m6 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zc = { render: Uc }, Wc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kc(l, e) {
  return s(), d("svg", Wc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M5.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0M16 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M13.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jc = { render: Kc }, Gc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xc(l, e) {
  return s(), d("svg", Gc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75M13.25 14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m-7 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Yc = { render: Xc }, Qc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function eu(l, e) {
  return s(), d("svg", Qc, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.75 3.75H10a.75.75 0 0 0 0-1.5H5.6A1.35 1.35 0 0 0 4.25 3.6v16.8c0 .746.604 1.35 1.35 1.35H10a.75.75 0 0 0 0-1.5H5.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.25 7a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.25 3.75H14a.75.75 0 0 1 0-1.5h4.4c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H14a.75.75 0 0 1 0-1.5h4.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const lu = { render: eu }, tu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nu(l, e) {
  return s(), d("svg", tu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.512 17.941a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057M21.55 7.6c-5.733-4.3-13.367-4.3-19.1 0a.75.75 0 1 1-.9-1.2c6.267-4.7 14.633-4.7 20.9 0a.75.75 0 1 1-.9 1.2",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.55 11.6c-3.733-2.8-9.367-2.8-13.1 0a.75.75 0 1 1-.9-1.2c4.267-3.2 10.633-3.2 14.9 0a.75.75 0 1 1-.9 1.2m-3.446 3.537c-2.008-1.25-4.2-1.25-6.208 0a.75.75 0 0 1-.792-1.274c2.493-1.55 5.3-1.551 7.793 0a.75.75 0 0 1-.793 1.274m2.444.095c.383-.557 1.025-.982 1.952-.982s1.57.425 1.952.982c.355.518.465 1.114.465 1.518v1.102c.489.203.833.686.833 1.248v2.3a1.35 1.35 0 0 1-1.35 1.35h-3.8a1.35 1.35 0 0 1-1.35-1.35v-2.3c0-.563.344-1.045.833-1.248V16.75c0-.404.11-1 .465-1.518m1.035 2.518h1.834v-1a1.3 1.3 0 0 0-.202-.67c-.118-.171-.309-.33-.715-.33s-.597.159-.715.33a1.3 1.3 0 0 0-.202.67zm-.833 1.5v2h3.5v-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const au = { render: nu }, ru = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ou(l, e) {
  return s(), d("svg", ru, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.512 17.442a.75.75 0 0 1 .055 1.059l-.01.01a.75.75 0 0 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056m0-12.001a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 0 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.75 2.75v6.5h18.5v-6.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v6.8a1.35 1.35 0 0 1-1.35 1.35H2.6A1.35 1.35 0 0 1 1.25 9.4zm1.5 12.15v6.5h18.5v-6.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v6.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const iu = { render: ou }, su = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function du(l, e) {
  return s(), d("svg", su, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 5A.75.75 0 0 1 6 4.25h12a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75h-5.25v4.5H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h8.25v-4.5H6a.75.75 0 0 1-.75-.75zm1.5.75v6.5h10.5v-6.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.512 8.441a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 0 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056Zm3 0a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cu = { render: du }, uu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vu(l, e) {
  return s(), d("svg", uu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.512 15.442a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.75 4.75v14.5h8.5V4.75zm-1.5-.15c0-.745.604-1.35 1.35-1.35h8.8c.746 0 1.35.605 1.35 1.35v14.8a1.35 1.35 0 0 1-1.35 1.35H7.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const pu = { render: vu }, hu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fu(l, e) {
  return s(), d("svg", hu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.5 1.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M18 7.75a.75.75 0 0 1 .75.75V12a.75.75 0 0 1-.494.705l-5.5 2a.75.75 0 1 1-.512-1.41l5.006-1.82V8.5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7 10.75a.75.75 0 0 1 .75.75v2.427l4.947 1.35a.75.75 0 1 1-.394 1.447l-5.5-1.5a.75.75 0 0 1-.553-.724v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.5 17.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M9.25 19.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m6.5-14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75zm1.5.75v1.5h1.5v-1.5zm-5.28-4.78a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06L12.5 3.06l-1.47 1.47a.75.75 0 1 1-1.06-1.06zM7 7.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M4.25 9a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mu = { render: fu }, wu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gu(l, e) {
  return s(), d("svg", wu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.512 18.942A.75.75 0 0 1 12.568 20l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056ZM21.55 8.6c-5.733-4.3-13.367-4.3-19.1 0a.75.75 0 1 1-.9-1.2c6.267-4.7 14.633-4.7 20.9 0a.75.75 0 1 1-.9 1.2",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.55 12.6c-3.733-2.8-9.367-2.8-13.1 0a.75.75 0 0 1-.9-1.2c4.267-3.2 10.633-3.2 14.9 0a.75.75 0 1 1-.9 1.2m-3.446 3.537c-2.008-1.25-4.2-1.25-6.208 0a.75.75 0 1 1-.792-1.274c2.493-1.55 5.3-1.551 7.793 0a.75.75 0 0 1-.793 1.274",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bu = { render: gu }, Mu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xu(l, e) {
  return s(), d("svg", Mu, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#5ba1406c-f1ea-4b8f-a4b9-99ee95bcc0af-ccc1a3d5-993b-4687-9c4b-9a063fcf0840-f3a25e20-d8c2-4156-acfd-26ce73b5bca2-20848c94-49bd-4a1e-9cdb-36e936c97383-ad13adb2-2e37-49af-90c9-30b7ded07778-e3dcd603-3515-48a0-896c-0849ecf00844-2ed9f6-3780f961-a18c-4680-b564-16d24186088d-24180cb2-0f77-4a1e-86ac-9fa10b97d3e4-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M12.512 17.941a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057M21.55 7.6c-5.733-4.3-13.367-4.3-19.1 0a.75.75 0 1 1-.9-1.2c6.267-4.7 14.633-4.7 20.9 0a.75.75 0 1 1-.9 1.2" }),
      n("path", { d: "M18.55 11.6c-3.733-2.8-9.367-2.8-13.1 0a.75.75 0 1 1-.9-1.2c4.267-3.2 10.633-3.2 14.9 0a.75.75 0 1 1-.9 1.2m-3.446 3.537c-2.008-1.25-4.2-1.25-6.208 0a.75.75 0 0 1-.792-1.274c2.493-1.55 5.3-1.551 7.793 0a.75.75 0 0 1-.793 1.274m1.487 1.454a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.591a.75.75 0 0 1 1.061 1.06l-1.59 1.592 1.59 1.59a.75.75 0 1 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 1 1-1.061-1.06l1.591-1.591-1.591-1.591a.75.75 0 0 1 0-1.061" })
    ], -1)
  ]));
}
const yu = { render: xu }, Au = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vu(l, e) {
  return s(), d("svg", Au, e[0] || (e[0] = [
    n("path", { d: "M22.275 6.975C19.05 4.5 15.6 3.225 12 3.225S4.95 4.5 1.725 6.975c-.225.15-.45.45-.45.825-.075.375.075.675.3.975l9.45 11.175q.338.45.9.45H12c.3 0 .6-.075.825-.3l.15-.15 9.45-11.175c.225-.3.3-.6.3-.975 0-.3-.15-.6-.45-.825M12 18.825l-9.15-10.8C5.7 5.85 8.85 4.8 12 4.8c3.225 0 6.3 1.125 9.15 3.225z" }, null, -1),
    n("path", { d: "M11.25 8.025v2.025c0 .45.3.75.75.75s.75-.3.75-.75V8.025c0-.45-.3-.75-.75-.75s-.75.3-.75.75m.225 5.475c-.3.3-.3.75 0 1.05.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0" }, null, -1)
  ]));
}
const Hu = { render: Vu }, Bu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zu(l, e) {
  return s(), d("svg", Bu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.512 18.942A.75.75 0 0 1 12.568 20l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056ZM2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 0 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M21.55 8.6c-3.417-2.563-7.504-3.595-11.458-3.108a.75.75 0 0 1-.184-1.488c4.339-.535 8.815.6 12.542 3.396a.75.75 0 0 1-.9 1.2M6.451 5.576a.75.75 0 0 1-.409.979A16.3 16.3 0 0 0 2.45 8.6a.75.75 0 1 1-.9-1.2 17.8 17.8 0 0 1 3.923-2.233.75.75 0 0 1 .978.409m3.802 4.274a.75.75 0 0 1-.584.885c-1.53.313-2.981.937-4.219 1.865a.75.75 0 1 1-.9-1.2c1.43-1.072 3.09-1.781 4.818-2.135a.75.75 0 0 1 .885.585m3.734.036a.75.75 0 0 1 .896-.567c1.639.37 3.207 1.061 4.567 2.081a.75.75 0 0 1-.9 1.2 10.5 10.5 0 0 0-3.997-1.817.75.75 0 0 1-.566-.897m1.117 6.251c-2.008-1.25-4.2-1.25-6.208 0a.75.75 0 1 1-.792-1.274c2.493-1.55 5.3-1.551 7.793 0a.75.75 0 0 1-.793 1.274",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cu = { render: zu }, Lu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Su(l, e) {
  return s(), d("svg", Lu, e[0] || (e[0] = [
    n("path", { d: "M12 20.475h-.075c-.375 0-.675-.225-.9-.45L1.5 8.775c-.225-.3-.3-.675-.3-.975.075-.375.3-.675.525-.825C4.95 4.5 8.4 3.225 12 3.225S19.05 4.5 22.275 6.9c.3.225.45.6.525.9 0 .375-.075.675-.3.975L12.975 19.95l-.15.15c-.225.225-.525.375-.825.375M2.85 8.025l9.15 10.8 9.15-10.8c-2.85-2.175-5.925-3.3-9.15-3.3s-6.3 1.125-9.15 3.3" }, null, -1)
  ]));
}
const Eu = { render: Su }, Tu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _u(l, e) {
  return s(), d("svg", Tu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 3.75A5.25 5.25 0 0 0 2.75 9v6c0 2.9 2.35 5.25 5.25 5.25h8c2.9 0 5.25-2.35 5.25-5.25V9c0-2.9-2.35-5.25-5.25-5.25zM1.25 9A6.75 6.75 0 0 1 8 2.25h8A6.75 6.75 0 0 1 22.75 9v6A6.75 6.75 0 0 1 16 21.75H8A6.75 6.75 0 0 1 1.25 15z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.512 14.191a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.06-.057m3.912-2.461c-2.2-2.64-6.648-2.64-8.848 0a.75.75 0 1 1-1.152-.96c2.8-3.36 8.352-3.36 11.152 0a.75.75 0 1 1-1.152.96",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.4 13.7a3 3 0 0 0-4.8 0 .75.75 0 1 1-1.2-.9c1.8-2.4 5.4-2.4 7.2 0a.75.75 0 1 1-1.2.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ru = { render: _u }, ku = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ou(l, e) {
  return s(), d("svg", ku, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 3.75A2.25 2.25 0 0 0 6.75 6v7a.75.75 0 0 1-1.5 0V6A3.75 3.75 0 0 1 9 2.25h5a.75.75 0 0 1 0 1.5zm13 4a.75.75 0 0 1 .75.75V14a.75.75 0 0 1-1.5 0V8.5a.75.75 0 0 1 .75-.75M19.992.25a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25V7a.75.75 0 0 1-1.5 0V4.75h-2.25a.75.75 0 0 1 0-1.5h2.25V1a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6 13.75a3.25 3.25 0 0 0 0 6.5h6a.75.75 0 0 1 0 1.5H6a4.75 4.75 0 1 1 0-9.5h12a.75.75 0 0 1 0 1.5A3.25 3.25 0 1 0 21.25 17v-3a.75.75 0 0 1 1.5 0v3a4.75 4.75 0 1 1-8.214-3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $u = { render: Ou }, Nu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fu(l, e) {
  return s(), d("svg", Nu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.75 12a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.122.651L12 20.864 8.872 22.65A.75.75 0 0 1 7.75 22zm1.5.75v7.958l2.378-1.36a.75.75 0 0 1 .744 0l2.378 1.36V12.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.548 1.397c-.844-.331-1.719-.884-2.384-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.025-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.548-1.397c.65-.255 1.275-.66 1.737-1.27.455-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Du = { render: Fu }, Iu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ju(l, e) {
  return s(), d("svg", Iu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.47 17.47a.75.75 0 0 1 1.06 0L11 19.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.548 1.397c-.844-.331-1.719-.884-2.384-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.025-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.548-1.397c.65-.255 1.275-.66 1.737-1.27.455-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qu = { render: ju }, Pu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Uu(l, e) {
  return s(), d("svg", Pu, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#73c92a9f-e0ac-48c0-bf5d-d83f94110b14-82dd2dba-b562-4908-a517-a37479c7ef5b-80f2d8d5-29b2-4ffa-8ebc-b1dfe02755d9-d9d10b45-3547-4483-a393-ea576a041c24-f859762c-b2d1-4e16-95af-e678e5b050df-c6f18f29-ac65-4513-9588-6970537daa2b-86d94f-fb15c7c7-c2f0-41bf-9505-983b6e7b3145-7184a306-adc4-4f81-a4f2-e2781e5e9f6c-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.548 1.397c-.844-.331-1.719-.884-2.384-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.025-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.548-1.397c.65-.255 1.275-.66 1.737-1.27.455-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886m9.557 14.321a.75.75 0 0 1 0 1.06l-1.767 1.768a4.75 4.75 0 0 1-6.718 0l-.353-.353a.75.75 0 1 1 1.06-1.06l.354.353a3.25 3.25 0 0 0 4.596 0l1.768-1.768a.75.75 0 0 1 1.06 0" }),
      n("path", { d: "M16.95 18.957a.75.75 0 0 1 .213.636l-.354 2.475a.75.75 0 0 1-1.273.425l-2.12-2.122a.75.75 0 0 1 .423-1.272l2.475-.354a.75.75 0 0 1 .637.212Zm-9.9-1.525a.75.75 0 0 1 0-1.06l1.768-1.768a4.75 4.75 0 0 1 6.718 0l.353.353a.75.75 0 0 1-1.06 1.06l-.354-.353a3.25 3.25 0 0 0-4.596 0L8.11 17.432a.75.75 0 0 1-1.06 0" }),
      n("path", { d: "M7.05 17.432a.75.75 0 0 1-.212-.636l.354-2.475a.75.75 0 0 1 1.272-.425l2.122 2.122a.75.75 0 0 1-.425 1.273l-2.474.353a.75.75 0 0 1-.637-.212" })
    ], -1)
  ]));
}
const Zu = { render: Uu }, Wu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ku(l, e) {
  return s(), d("svg", Wu, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 22.53a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22V13a.75.75 0 0 0-1.5 0v7.19l-2.22-2.22a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.548 1.397c-.844-.331-1.719-.884-2.384-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.025-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.385 1.76a.75.75 0 1 1-.547-1.397c.65-.255 1.275-.66 1.737-1.27.455-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.016-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ju = { render: Ku }, Gu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xu(l, e) {
  return s(), d("svg", Gu, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#ffcbc0ca-fdc3-4cfe-adb2-df3bd43fbc44-13c35f2c-545a-4e69-9f8f-d8bdb5d0d1fc-7c49024d-6e7a-48c7-a404-07cb3b49fc27-4fafa5b5-cb09-4681-9b3d-43730520cfe3-3004014c-7278-41f4-b5f5-745956a40439-cfc51ffe-6f0f-4f08-816a-ee87dbf1af16-d845c6-eda47688-661d-4de9-a470-92a20ed70fda-80320c74-c632-4f32-9d00-3a7e6005b524-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M8.47 15.47a.75.75 0 0 1 1.06 0L12 17.94l2.47-2.47a.75.75 0 0 1 1.06 1.06L13.061 19l2.47 2.47a.75.75 0 1 1-1.061 1.06L12 20.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 19l-2.47-2.47a.75.75 0 0 1 0-1.06" }),
      n("path", { d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.547 1.397c-.845-.331-1.72-.884-2.385-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.026-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.547-1.397c.649-.255 1.274-.66 1.736-1.27.456-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886" })
    ], -1)
  ]));
}
const Yu = { render: Xu }, Qu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function e9(l, e) {
  return s(), d("svg", Qu, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#8073e4aa-432d-4b95-95af-9ef3268caa9b-022dfe03-3b8e-4fa8-be6e-1d2720943727-a53c682b-d312-4336-a767-2353219bbfa7-f6324bd8-b71e-4722-b6c5-04c4d5954cae-40a7a95c-45a2-4db0-843c-3687821c54e2-06b9949f-9af6-46f2-a2d1-a8963a927fd3-d51db4-6e94196b-7957-42e3-a692-14b4b2d1a024-fc4a2eb9-6d32-4b6b-b164-054faeb376d8-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.547 1.397c-.845-.331-1.72-.884-2.385-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.026-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.547-1.397c.649-.255 1.274-.66 1.736-1.27.456-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886M7.05 18.957a.75.75 0 0 0 0 1.06l1.768 1.768a4.75 4.75 0 0 0 6.718 0l.353-.353a.75.75 0 1 0-1.06-1.06l-.354.353a3.25 3.25 0 0 1-4.596 0L8.11 18.957a.75.75 0 0 0-1.06 0" }),
      n("path", { d: "M7.05 18.957a.75.75 0 0 0-.212.636l.354 2.475a.75.75 0 0 0 1.272.425l2.122-2.122a.75.75 0 0 0-.425-1.272l-2.474-.354a.75.75 0 0 0-.637.212m9.778-1.525a.75.75 0 0 0 0-1.06l-1.767-1.768a4.75 4.75 0 0 0-6.718 0l-.353.353a.75.75 0 0 0 1.06 1.06l.354-.353a3.25 3.25 0 0 1 4.596 0l1.768 1.768a.75.75 0 0 0 1.06 0" }),
      n("path", { d: "M16.828 17.432a.75.75 0 0 0 .213-.636l-.354-2.475a.75.75 0 0 0-1.273-.425l-2.121 2.122a.75.75 0 0 0 .424 1.273l2.475.353a.75.75 0 0 0 .636-.212" })
    ], -1)
  ]));
}
const l9 = { render: e9 }, t9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n9(l, e) {
  return s(), d("svg", t9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 12.47a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 1 1-1.06 1.06l-2.22-2.22V22a.75.75 0 0 1-1.5 0v-7.19l-2.22 2.22a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.547 1.397c-.845-.331-1.72-.884-2.385-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.026-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.547-1.397c.649-.255 1.274-.66 1.736-1.27.456-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a9 = { render: n9 }, r9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function o9(l, e) {
  return s(), d("svg", r9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 5.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319q.861 0 1.572-.059a.75.75 0 0 1 .119 1.496q-.776.061-1.69.063c-3.59 0-5.548-.767-6.614-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25m14 0a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .023-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 0 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75m14.99 4.5c-1.378 0-2.617.989-3.077 2.472a.75.75 0 1 1-1.433-.444c.623-2.008 2.372-3.528 4.51-3.528 1.998 0 3.66 1.33 4.374 3.142a.75.75 0 0 1-1.395.55c-.524-1.329-1.689-2.192-2.979-2.192",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M23 14.694a.75.75 0 0 1 .75.75v1.889c0 .598-.485 1.084-1.084 1.084h-1.67a.75.75 0 0 1 0-1.5h1.254v-1.473a.75.75 0 0 1 .75-.75m-3.99 7.556c1.378 0 2.617-.989 3.077-2.472a.75.75 0 1 1 1.433.444c-.622 2.008-2.372 3.528-4.51 3.528-1.998 0-3.66-1.33-4.374-3.142a.75.75 0 1 1 1.396-.55c.523 1.329 1.688 2.192 2.978 2.192",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M15 23.305a.75.75 0 0 1-.75-.75v-1.888c0-.599.485-1.084 1.084-1.084h1.67a.75.75 0 1 1 0 1.5H15.75v1.472a.75.75 0 0 1-.75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i9 = { render: o9 }, s9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function d9(l, e) {
  return s(), d("svg", s9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.47 22.53a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V16a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06zM4 5.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 1 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .023-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 0 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c9 = { render: d9 }, u9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function v9(l, e) {
  return s(), d("svg", u9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 5.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 1 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .023-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 0 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75m14.47 4.22a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06l-1.72-1.72V22a.75.75 0 0 1-1.5 0v-4.19l-1.72 1.72a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const p9 = { render: v9 }, h9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function f9(l, e) {
  return s(), d("svg", h9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 6A3.75 3.75 0 0 1 9 2.25h10A3.75 3.75 0 0 1 22.75 6v8a.75.75 0 0 1-1.5 0V6A2.25 2.25 0 0 0 19 3.75H9A2.25 2.25 0 0 0 6.75 6v7a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6 13.75a3.25 3.25 0 0 0 0 6.5h6a.75.75 0 0 1 0 1.5H6a4.75 4.75 0 1 1 0-9.5h12a.75.75 0 0 1 0 1.5A3.25 3.25 0 1 0 21.25 17v-3a.75.75 0 0 1 1.5 0v3a4.75 4.75 0 1 1-8.214-3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const m9 = { render: f9 }, w9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function g9(l, e) {
  return s(), d("svg", w9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.25 18v-6h1.5v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V12h1.5v6H19c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C4.25 18 4.25 18 5 18z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.25 12V6h1.5v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6h1.5v6H19c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C4.25 12 4.25 12 5 12z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.387 3.93C6.453 3.018 8.41 2.25 12 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C19.75 6 19.75 6 19 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C17.547 8.983 15.59 9.75 12 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C4.25 6 4.25 6 5 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .023-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM5.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C7.047 7.517 8.59 8.25 12 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C16.953 4.483 15.41 3.75 12 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 5.753 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const b9 = { render: g9 }, M9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function x9(l, e) {
  return s(), d("svg", M9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M13.47 18.47a.75.75 0 0 1 1.06 0L17 20.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06M4 5.25a.75.75 0 0 1 .75.75v5.981l.003.025c.007.036.021.103.055.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 0 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035l-.004.055a2.5 2.5 0 0 1-.156.649c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035l-.004.055a2.5 2.5 0 0 1-.156.649c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .024-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.003.025c.007.036.021.103.055.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 0 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const y9 = { render: x9 }, A9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function V9(l, e) {
  return s(), d("svg", A9, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#32cfb42a-a1c2-47da-93a8-1cafdb857c4c-6fb5c334-9a15-4af8-97b6-dd2b22ba9243-9c111fac-82a9-4077-b71e-baa6f7b54ddd-0cd5e41d-c015-49c4-9191-8abec410a006-c9928a19-648e-4e46-b4d6-151864dfa29a-1fd25f89-1106-4534-8dd9-6f7a3d18665c-9714b3-3a60ae4e-6c8a-4068-ae64-72af5c42a158-14155628-431d-4aae-9fc0-7c324fa443ac-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M16.59 16.591a.75.75 0 0 1 1.062 0l1.59 1.591 1.592-1.591a.75.75 0 1 1 1.06 1.06l-1.59 1.592 1.59 1.59a.75.75 0 1 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06l1.59-1.591-1.59-1.591a.75.75 0 0 1 0-1.061ZM4 5.25a.75.75 0 0 1 .75.75v5.981l.003.025a1 1 0 0 0 .055.19c.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 0 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25" }),
      n("path", { d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.035C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.023.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .024-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6a1 1 0 0 0 .056.197c.066.172.215.443.554.734C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.003.025a1 1 0 0 0 .055.19c.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 1 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75" })
    ], -1)
  ]));
}
const H9 = { render: V9 }, B9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function z9(l, e) {
  return s(), d("svg", B9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M20 15.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m.512 6.191a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057M4 5.25a.75.75 0 0 1 .75.75v5.981l.003.025a1 1 0 0 0 .055.19c.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 0 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.035C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.023.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .024-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6a1 1 0 0 0 .056.197c.066.172.215.443.554.734C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.003.025a1 1 0 0 0 .055.19c.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 1 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const C9 = { render: z9 }, L9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function S9(l, e) {
  return s(), d("svg", L9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.625 3c-1.19 0-2.156 1.007-2.156 2.25v7c0 .414-.322.75-.719.75s-.719-.336-.719-.75v-7c0-2.071 1.61-3.75 3.594-3.75h4.792c.397 0 .718.336.718.75s-.321.75-.718.75zm12.458 4c.397 0 .72.336.72.75v5.5c0 .414-.323.75-.72.75s-.718-.336-.718-.75v-5.5c0-.414.321-.75.718-.75m-4.552-3.75c0-.414.322-.75.719-.75h3.833c.397 0 .72.336.72.75s-.323.75-.72.75H17.25c-.397 0-.719-.336-.719-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.75 13c-1.72 0-3.115 1.455-3.115 3.25S4.03 19.5 5.75 19.5h5.75c.397 0 .719.336.719.75s-.322.75-.719.75H5.75c-2.514 0-4.552-2.127-4.552-4.75S3.236 11.5 5.75 11.5h11.5c.397 0 .719.336.719.75s-.322.75-.719.75c-1.72 0-3.115 1.455-3.115 3.25s1.395 3.25 3.115 3.25 3.115-1.455 3.115-3.25v-3c0-.414.321-.75.718-.75s.72.336.72.75v3c0 2.623-2.039 4.75-4.553 4.75s-4.552-2.127-4.552-4.75c0-1.257.468-2.4 1.232-3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const E9 = { render: S9 }, T9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _9(l, e) {
  return s(), d("svg", T9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M20 3.25a.75.75 0 0 1 .75.75v1.25H22a.75.75 0 0 1 0 1.5h-1.25V8a.75.75 0 0 1-1.5 0V6.75H18a.75.75 0 0 1 0-1.5h1.25V4a.75.75 0 0 1 .75-.75M1.25 11a.75.75 0 0 1 .75-.75h19.4c.746 0 1.35.604 1.35 1.35v7.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.75v7.5h18.5v-7.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H14a.75.75 0 0 1 0 1.5h-1.278a1.35 1.35 0 0 1-.879-.325L8.723 4.75H2.75V11a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const R9 = { render: _9 }, k9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function O9(l, e) {
  return s(), d("svg", k9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $9 = { render: O9 }, N9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function F9(l, e) {
  return s(), d("svg", N9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H11a.75.75 0 0 1 0-1.5h8.25V5.81l-3.06-3.06H4.75V12a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75m-11.008 14a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25V22a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25V16a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D9 = { render: F9 }, I9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function j9(l, e) {
  return s(), d("svg", I9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 6A.75.75 0 0 1 7 5.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 6m0 3A.75.75 0 0 1 7 8.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 9m2 8a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 2.75v8.5h16.5v-8.5zm18 8.546V2.6a1.35 1.35 0 0 0-1.35-1.35H3.6A1.35 1.35 0 0 0 2.25 2.6v8.696c-.576.154-1 .68-1 1.304v8.8c0 .746.604 1.35 1.35 1.35h18.8a1.35 1.35 0 0 0 1.35-1.35v-8.8a1.35 1.35 0 0 0-1-1.304m-19 1.454v8.5h18.5v-8.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q9 = { render: j9 }, P9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function U9(l, e) {
  return s(), d("svg", P9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.778 2.75c-.862 0-1.69.343-2.3.953l-9.19 9.19a5.253 5.253 0 1 0 7.43 7.429l9.19-9.19a.75.75 0 0 1 1.06 1.06l-9.19 9.19a6.754 6.754 0 0 1-9.55-9.55l9.19-9.19a4.752 4.752 0 0 1 6.72 6.72l-9.2 9.19a2.751 2.751 0 0 1-3.89-3.89l8.49-8.48a.75.75 0 0 1 1.06 1.06l-8.49 8.48a1.252 1.252 0 0 0 1.77 1.77l9.2-9.19a3.252 3.252 0 0 0-2.3-5.552",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z9 = { render: U9 }, W9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function K9(l, e) {
  return s(), d("svg", W9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M19.97 19.97a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.25 18a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M18 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 2.6c0-.745.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.396l3.149 3.148c.253.253.395.597.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06H4.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35zm12.895.106",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const J9 = { render: K9 }, G9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function X9(l, e) {
  return s(), d("svg", G9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M13.47 14.47a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.75 12.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m3.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.745.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.396l3.149 3.148c.253.253.395.597.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y9 = { render: X9 }, Q9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ev(l, e) {
  return s(), d("svg", Q9, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "m17.5 16.339-.516 1.094a.75.75 0 0 1-.565.422l-1.223.187.907.924a.75.75 0 0 1 .204.647l-.206 1.261 1.037-.57a.75.75 0 0 1 .724 0l1.037.57-.207-1.261a.75.75 0 0 1 .205-.646l.907-.925-1.223-.187a.75.75 0 0 1-.565-.422L17.5 16.34Zm-.964-1.473a1.062 1.062 0 0 1 1.928 0l.739 1.566 1.638.25c.91.14 1.182 1.24.598 1.835l-1.205 1.229.286 1.743c.133.81-.712 1.598-1.564 1.129l-1.456-.802-1.456.802c-.852.469-1.697-.32-1.564-1.13l.286-1.742-1.205-1.229c-.584-.595-.313-1.695.598-1.834l1.638-.25.74-1.567Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const lv = { render: ev }, tv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nv(l, e) {
  return s(), d("svg", tv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "m12 9.279-.687 1.456a.75.75 0 0 1-.565.421l-1.604.246 1.183 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.184-1.206-1.605-.245a.75.75 0 0 1-.565-.422zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916l-1.415 1.442.335 2.046c.14.849-.744 1.666-1.629 1.18L12 15.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295zM16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const av = { render: nv }, rv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ov(l, e) {
  return s(), d("svg", rv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75M8.47 11.47a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V9a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 0m-.22 6.343c0-.311.336-.563.75-.563h6c.414 0 .75.252.75.563s-.336.562-.75.562H9c-.414 0-.75-.252-.75-.563Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const iv = { render: ov }, sv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function dv(l, e) {
  return s(), d("svg", sv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H14a.75.75 0 1 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.65c.358 0 .702.142.955.395l3.149 3.149c.253.253.395.596.395.955V13a.75.75 0 1 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 1 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75m.472 17.22a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V16a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cv = { render: dv }, uv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vv(l, e) {
  return s(), d("svg", uv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const pv = { render: vv }, hv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fv(l, e) {
  return s(), d("svg", hv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H21.4c.746 0 1.35.604 1.35 1.35v11.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v5.5h18.5v-2.5h-8.528a1.35 1.35 0 0 1-.879-.325L8.723 4.75zm18.5 7H2.75v7.5h18.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mv = { render: fv }, wv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gv(l, e) {
  return s(), d("svg", wv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18 2.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75m.512 8.191a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M22 6.25a.75.75 0 0 1 .75.75v12.4a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35V11a.75.75 0 0 1 1.5 0v8.25h18.5V7a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H14a.75.75 0 0 1 0 1.5h-1.278a1.35 1.35 0 0 1-.879-.325L8.723 4.75H2.75v5.5H14a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bv = { render: gv }, Mv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xv(l, e) {
  return s(), d("svg", Mv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H21.4c.746 0 1.35.604 1.35 1.35v2.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v5.5h18.5v-2.5h-8.528a1.35 1.35 0 0 1-.879-.325L8.723 4.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M22 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75m-20 0a.75.75 0 0 1 .75.75v9.25H13a.75.75 0 0 1 0 1.5H2.6a1.35 1.35 0 0 1-1.35-1.35V10A.75.75 0 0 1 2 9.25m17 8.5a1.25 1.25 0 1 0-.002 2.498A1.25 1.25 0 0 0 19 17.75m-1.375-1.132a2.75 2.75 0 1 1 2.751 4.763 2.75 2.75 0 0 1-2.752-4.763Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.809 15.255a4 4 0 0 1 .382 0 .75.75 0 0 1-.075 1.498 2 2 0 0 0-.232 0 .75.75 0 0 1-.075-1.498m1.644 1.015a.75.75 0 0 1 1.06-.054q.142.129.27.271a.75.75 0 1 1-1.113 1.006 2 2 0 0 0-.163-.163.75.75 0 0 1-.054-1.06m-2.906 0a.75.75 0 0 1-.054 1.06 2 2 0 0 0-.163.163.75.75 0 0 1-1.114-1.006q.129-.142.271-.27a.75.75 0 0 1 1.06.053m4.411 1.827a.75.75 0 0 1 .787.712 4 4 0 0 1 0 .382.75.75 0 0 1-1.498-.075 2 2 0 0 0 0-.232.75.75 0 0 1 .711-.787m-5.916 0a.75.75 0 0 1 .71.787 2 2 0 0 0 0 .232.75.75 0 0 1-1.497.075 4 4 0 0 1 0-.382.75.75 0 0 1 .787-.712m5.688 2.356a.75.75 0 0 1 .054 1.06 4 4 0 0 1-.271.27.75.75 0 1 1-1.006-1.113q.086-.077.163-.163a.75.75 0 0 1 1.06-.054m-5.46 0a.75.75 0 0 1 1.06.054q.077.086.163.163a.75.75 0 0 1-1.006 1.114 4 4 0 0 1-.27-.271.75.75 0 0 1 .053-1.06m1.827 1.505a.75.75 0 0 1 .787-.71 2 2 0 0 0 .232 0 .75.75 0 0 1 .075 1.497 4 4 0 0 1-.382 0 .75.75 0 0 1-.712-.787",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yv = { render: xv }, Av = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vv(l, e) {
  return s(), d("svg", Av, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 5c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v14c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25zM5 2.25A2.75 2.75 0 0 0 2.25 5v14A2.75 2.75 0 0 0 5 21.75h14A2.75 2.75 0 0 0 21.75 19V5A2.75 2.75 0 0 0 19 2.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 7A.75.75 0 0 1 7 6.25h10a.75.75 0 1 1 0 1.5H7A.75.75 0 0 1 6.25 7m0 5a.75.75 0 0 1 .75-.75h10a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h6a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hv = { render: Vv }, Bv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zv(l, e) {
  return s(), d("svg", Bv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 6A.75.75 0 0 1 6 5.25h12a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6m0 4A.75.75 0 0 1 6 9.25h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m7 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.75 2.75v18.5h18.5V2.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v18.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75zm1.5.75v2.5h1.5v-2.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cv = { render: zv }, Lv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Sv(l, e) {
  return s(), d("svg", Lv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 6A.75.75 0 0 1 6 5.25h8a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6m0 4A.75.75 0 0 1 6 9.25h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m7 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.75 2.75v18.5h18.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h15.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75zm1.5.75v2.5h1.5v-2.5zM18 1.25a.75.75 0 0 1 .75.75v3.25H22a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ev = { render: Sv }, Tv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _v(l, e) {
  return s(), d("svg", Tv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.514 5.444a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 0 1-1.109-1.008l.01-.011a.75.75 0 0 1 1.06-.05ZM8.25 6A.75.75 0 0 1 9 5.25h11a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 6m-2.736 5.444a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.109-1.008l.01-.011a.75.75 0 0 1 1.06-.05ZM8.25 12a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m-1.12 4.07a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0l-.8-.8a.75.75 0 0 1 1.06-1.06l.27.27 1.47-1.47a.75.75 0 0 1 1.06 0M8.25 18a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Rv = { render: _v }, kv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ov(l, e) {
  return s(), d("svg", kv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 18a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m0-4a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m0-4A.75.75 0 0 1 7 9.25h3a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m0-8A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.5 5.75a.75.75 0 0 0-.75.75v14c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06zm-2.25.75A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25h-12a2.25 2.25 0 0 1-2.25-2.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $v = { render: Ov }, Nv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fv(l, e) {
  return s(), d("svg", Nv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.992 15.25a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25V22a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25V16a.75.75 0 0 1 .75-.75M6.25 2A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 6.5A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25H11a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06H4.5a.75.75 0 0 0-.75.75V13a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dv = { render: Fv }, Iv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jv(l, e) {
  return s(), d("svg", Iv, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#4a31379d-75fe-4b5c-8a80-c764aa88d500-e3036c65-5e1a-4948-a551-1d22ed10b8ad-3aa45eda-0916-4735-b33a-10e14689202c-2449d607-0d1f-4275-933d-f4957313ad80-4b97f3bf-0e81-447d-8ef1-67243334768a-081cf1fc-efbe-4eef-9c8e-373e890edcce-d858a4-7c16e3f0-d917-4d8b-883c-c1cda38d8c76-086e172e-d0dd-4cb9-8ab4-6ce4cf76e840-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M2.34 16.348a.75.75 0 0 1 1.061 0l1.591 1.591 1.591-1.59a.75.75 0 0 1 1.06 1.06L6.054 19l1.59 1.591a.75.75 0 0 1-1.06 1.06l-1.59-1.59L3.4 21.65a.75.75 0 0 1-1.06-1.06L3.93 19l-1.59-1.591a.75.75 0 0 1 0-1.06ZM6.25 2A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2" }),
      n("path", { d: "M2.25 6.5A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25H11a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06H4.5a.75.75 0 0 0-.75.75V13a.75.75 0 0 1-1.5 0z" }),
      n("path", { d: "M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75" })
    ], -1)
  ]));
}
const qv = { render: jv }, Pv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Uv(l, e) {
  return s(), d("svg", Pv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 2A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.5 5.75a.75.75 0 0 0-.75.75v14c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06zm-2.25.75A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25h-12a2.25 2.25 0 0 1-2.25-2.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zv = { render: Uv }, Wv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kv(l, e) {
  return s(), d("svg", Wv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 2A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 6.5A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25H11a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06H4.5a.75.75 0 0 0-.75.75V13a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.242 19a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jv = { render: Kv }, Gv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xv(l, e) {
  return s(), d("svg", Gv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 10A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 8a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0-4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Yv = { render: Xv }, Qv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ep(l, e) {
  return s(), d("svg", Qv, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v7h-1.5V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V9.75h1.75a.75.75 0 0 1 .75.75V18a.75.75 0 0 1-.75.75h-1.75v2.65a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35v-2.65h1.5v2.5h14.5v-2.5H4.75v-1.861q.045.032.093.062.612.39 1.452.391.632 0 1.077-.174a1.95 1.95 0 0 0 .729-.479q.282-.304.436-.69a3.4 3.4 0 0 0 .208-.82H7.472q-.058.316-.212.582a1.26 1.26 0 0 1-.403.425 1.1 1.1 0 0 1-.6.158q-.631 0-.994-.5-.357-.503-.358-1.626 0-.745.163-1.198.162-.454.466-.658.303-.204.724-.204a1.2 1.2 0 0 1 .599.142q.249.137.403.383.155.24.212.553h1.273a2.2 2.2 0 0 0-.387-1.06 2.3 2.3 0 0 0-.857-.741 2.6 2.6 0 0 0-1.206-.275q-.844 0-1.456.366l-.089.056V9.75h14.5V5.81l-3.06-3.06zm15.67 8.493-1.17 3.39-.906 2.626h-1.377l-2.06-6.016h1.161l1.59 4.606 1.592-4.58.01-.026zm-8.344 6.1a3.4 3.4 0 0 1-.874-.113 2.8 2.8 0 0 1-.782-.337 2 2 0 0 1-.587-.562 1.7 1.7 0 0 1-.274-.79h1.244a1 1 0 0 0 .237.462q.174.186.44.287.267.1.592.1.333 0 .607-.084a1 1 0 0 0 .441-.25.58.58 0 0 0 .167-.424.52.52 0 0 0-.138-.374 1 1 0 0 0-.362-.237 3 3 0 0 0-.52-.15l-1.04-.212q-.682-.129-1.082-.541-.399-.416-.411-1.107a1.58 1.58 0 0 1 .3-.977q.307-.416.831-.641a3 3 0 0 1 1.182-.225q.777 0 1.306.246.533.24.807.657.28.412.287.92h-1.219a.9.9 0 0 0-.191-.504.9.9 0 0 0-.408-.27 1.8 1.8 0 0 0-.561-.084q-.242 0-.441.055-.196.054-.333.154a.7.7 0 0 0-.212.228.6.6 0 0 0-.075.3q0 .262.174.424.176.162.654.266l1.031.213q.554.108.878.32a1.53 1.53 0 0 1 .707 1.024q.054.274.054.507 0 .486-.307.878-.304.387-.85.616-.544.224-1.272.224Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M3.899 15.853q-.33-.708-.329-1.652 0-.948.329-1.627.304-.631.851-.992V9.75h-1.5v9h1.5v-1.861a2.6 2.6 0 0 1-.851-1.036M1.5 9.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75h1.75v-9z" }, null, -1)
  ]));
}
const lp = { render: ep }, tp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function np(l, e) {
  return s(), d("svg", tp, e[0] || (e[0] = [
    h5('<path fill-rule="evenodd" d="M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75" clip-rule="evenodd"></path><path d="M4.635 12.226v4.058h.558q.517 0 .937-.2a1.5 1.5 0 0 0 .68-.654q.253-.454.253-1.212 0-.704-.225-1.142a1.4 1.4 0 0 0-.641-.645 2.2 2.2 0 0 0-.987-.205z"></path><path fill-rule="evenodd" d="M.75 10.5a.75.75 0 0 1 .75-.75h21a.75.75 0 0 1 .75.75V18a.75.75 0 0 1-.75.75h-21A.75.75 0 0 1 .75 18zm2.914.743H3.41v6.024h1.758q1.08 0 1.779-.371a2.37 2.37 0 0 0 1.045-1.05q.342-.682.342-1.62 0-.9-.325-1.558a2.27 2.27 0 0 0-1.012-1.025q-.692-.367-1.787-.391a22 22 0 0 0-.46-.005h-.02l-.57-.004zm6.767 5.736q.625.372 1.479.371.845 0 1.466-.37a2.46 2.46 0 0 0 .954-1.067q.337-.692.337-1.645 0-.967-.341-1.663a2.5 2.5 0 0 0-.958-1.07q-.621-.375-1.458-.375-.841 0-1.467.38-.624.374-.97 1.07-.342.695-.342 1.658 0 .957.338 1.65.34.686.962 1.061m8.918-5.544a2.6 2.6 0 0 0-1.208-.275q-.846 0-1.458.367a2.4 2.4 0 0 0-.942 1.05q-.33.678-.329 1.628 0 .945.33 1.654.332.708.945 1.1.613.39 1.453.391.634 0 1.08-.175l.03-.012q.425-.173.698-.467.284-.304.438-.691.154-.392.208-.821h-1.275a1.8 1.8 0 0 1-.213.583 1.26 1.26 0 0 1-.403.425 1.1 1.1 0 0 1-.6.158q-.633 0-.995-.5-.36-.504-.359-1.628 0-.745.163-1.2t.466-.658a1.27 1.27 0 0 1 .725-.204q.35 0 .6.141.25.138.404.384.087.135.143.294.044.123.07.26h1.274a2.2 2.2 0 0 0-.387-1.063 2.3 2.3 0 0 0-.858-.741" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4.75 11.248V2.75h11.44l3.06 3.06v5.577l.099.048q.532.27.858.742.329.47.387 1.062h-1.275a2 2 0 0 0-.069-.26v2.473a2 2 0 0 0 .07-.268h1.274q-.055.43-.208.82a2.2 2.2 0 0 1-.438.692 1.9 1.9 0 0 1-.698.467v4.087H4.75v-3.983H3.41v-6.024h.75q.287 0 .57.005zm0 .978h-.115v4.058h.115zM4.6 1.25A1.35 1.35 0 0 0 3.25 2.6v18.8c0 .746.604 1.35 1.35 1.35h14.8a1.35 1.35 0 0 0 1.35-1.35V5.749a1.35 1.35 0 0 0-.395-.955l-3.149-3.149a1.35 1.35 0 0 0-.954-.395z" clip-rule="evenodd"></path><path d="M11.91 16.35q.441 0 .762-.208.324-.213.5-.666.175-.459.175-1.192 0-.754-.18-1.22-.174-.467-.5-.683a1.3 1.3 0 0 0-.757-.221q-.438 0-.763.22-.324.217-.504.688-.18.466-.179 1.216 0 .738.18 1.192.179.453.503.666.325.208.763.208"></path>', 5)
  ]));
}
const ap = { render: np }, rp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function op(l, e) {
  return s(), d("svg", rp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 6A.75.75 0 0 1 8 5.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6m0 4A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m13.82 4.055a1.871 1.871 0 1 0-2.646-2.646L14.433 19.4a1.75 1.75 0 0 0-.492.968l-.243 1.556a.75.75 0 0 0 .857.857l1.556-.243a1.75 1.75 0 0 0 .968-.491zm-1.06-1.585a.37.37 0 0 1 0 .525l-.47.47-.525-.526.47-.47a.37.37 0 0 1 .524 0ZM17.953 18l.525.525-2.46 2.461a.25.25 0 0 1-.139.07l-.541.085.084-.542a.25.25 0 0 1 .07-.138L17.954 18ZM16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ip = { render: op }, sp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function dp(l, e) {
  return s(), d("svg", sp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75M1.5 9.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75h21a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75zm2.25 1.406v6.188h1.301v-2.208h1.222q.69 0 1.2-.231.512-.231.796-.668.283-.436.283-1.053 0-.654-.323-1.108a1.96 1.96 0 0 0-.872-.684 3.2 3.2 0 0 0-1.252-.236zm1.288 3.013h1.2q.487 0 .796-.3.31-.303.31-.749 0-.462-.328-.731a1.2 1.2 0 0 0-.796-.274H5.038zm4.486-3.013h.797q.306 0 .606.005.305 0 .51.004 1.163.025 1.898.402c.735.377.848.602 1.075 1.053q.346.675.346 1.6 0 .963-.363 1.665a2.48 2.48 0 0 1-1.111 1.078q-.744.38-1.89.38H9.524zm1.302 5.178v-4.168h.61q.606 0 1.05.21.441.21.68.663.24.45.24 1.172 0 .78-.27 1.246t-.722.671q-.447.206-.995.206zm9.424-5.178h-4.355v6.188h1.301v-2.568h2.642v-1.022h-2.642V12.2h3.05z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 11.156V2.75h11.44l3.06 3.06v5.346h1l-.004 1.044h-.996v1.554h.588v1.022h-.588v6.474H4.75v-3.906h-1v-6.188zM4.6 1.25A1.35 1.35 0 0 0 3.25 2.6v18.8c0 .746.604 1.35 1.35 1.35h14.8a1.35 1.35 0 0 0 1.35-1.35V5.749a1.35 1.35 0 0 0-.395-.955l-3.149-3.149a1.35 1.35 0 0 0-.954-.395z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cp = { render: dp }, up = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vp(l, e) {
  return s(), d("svg", up, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 2.6c0-.745.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.396l3.149 3.148c.253.253.395.597.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06H4.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35zm12.895.106",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 6A.75.75 0 0 1 8 5.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6m0 4A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m12.72 5.97a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.25 18a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M18 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-2-14.5a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const pp = { render: vp }, hp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fp(l, e) {
  return s(), d("svg", hp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 6A.75.75 0 0 1 8 5.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6m0 4A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m10.25 2.339-.516 1.094a.75.75 0 0 1-.565.422l-1.223.187.907.924a.75.75 0 0 1 .204.647l-.206 1.261 1.037-.57a.75.75 0 0 1 .724 0l1.037.57-.207-1.261a.75.75 0 0 1 .205-.646l.907-.925-1.223-.187a.75.75 0 0 1-.565-.422L17.5 16.34Zm-.964-1.473a1.062 1.062 0 0 1 1.928 0l.739 1.566 1.638.25c.91.14 1.182 1.24.598 1.835l-1.205 1.229.286 1.743c.133.81-.712 1.598-1.564 1.129l-1.456-.802-1.456.802c-.852.469-1.697-.32-1.564-1.13l.286-1.742-1.205-1.229c-.584-.595-.313-1.695.598-1.834l1.638-.25.74-1.567ZM16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mp = { render: fp }, wp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gp(l, e) {
  return s(), d("svg", wp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75M1.5 9.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75h21a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75zm6.426 7.507h1.516l-2.12-3.215 1.857-2.807H7.89l-1.192 1.949-1.204-1.95H3.99l.76 1.162L5.93 14.2l-1.18 1.802-.823 1.255h1.308l1.333-2.174zm2.418-6.022h1.224v4.993h2.616v1.029h-3.84zm6.422 5.993q.429.112.874.112.729 0 1.275-.225.18-.076.335-.169.311-.188.514-.447.309-.392.309-.879 0-.233-.055-.508a1.53 1.53 0 0 0-.768-1.062 2.6 2.6 0 0 0-.818-.283l-1.033-.212q-.48-.105-.654-.267a.55.55 0 0 1-.175-.425q0-.165.075-.3a.7.7 0 0 1 .212-.229 1 1 0 0 1 .334-.154q.2-.054.441-.054.316 0 .562.083a.9.9 0 0 1 .408.271.9.9 0 0 1 .192.504h1.22a1.7 1.7 0 0 0-.764-1.395q-.15-.103-.331-.184-.53-.245-1.308-.245-.654 0-1.183.225a2 2 0 0 0-.833.641 1.6 1.6 0 0 0-.3.979q.013.69.413 1.108.399.411 1.083.541l1.04.212q.293.06.521.15a.96.96 0 0 1 .363.238.52.52 0 0 1 .137.375q0 .253-.166.424a1 1 0 0 1-.442.25 2.1 2.1 0 0 1-.608.084q-.324 0-.591-.1a1.14 1.14 0 0 1-.442-.288 1 1 0 0 1-.237-.462H15.12q.046.454.274.791.234.338.588.563t.783.337Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v8.485h-.76l.76 1.161v3.606l-.823 1.255h.823v3.993h14.5v-4.304q.311-.187.514-.447.309-.391.309-.879 0-.233-.055-.508a1.53 1.53 0 0 0-.768-1.062v-1.066h.764a1.7 1.7 0 0 0-.764-1.395V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bp = { render: gp }, Mp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xp(l, e) {
  return s(), d("svg", Mp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H13a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 6A.75.75 0 0 1 8 5.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6m0 4A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75m2.823 13.148a2.75 2.75 0 0 1 1.354 0l2.555.65c.597.15 1.03.696 1.01 1.332-.09 3.032-1.016 4.87-2.004 5.962-.488.539-.977.88-1.355 1.087a4 4 0 0 1-.615.273l-.047.015-.017.005-.006.001-.003.001c-.002 0-.002 0-.195-.724-.193.725-.194.725-.194.724h-.004l-.006-.002-.017-.005a2 2 0 0 1-.194-.067 4 4 0 0 1-.468-.221 5.3 5.3 0 0 1-1.355-1.087c-.988-1.091-1.914-2.93-2.005-5.962a1.34 1.34 0 0 1 1.01-1.333zM19.5 23l-.193.725a.75.75 0 0 0 .386 0zm0-.804a4 4 0 0 0 .16-.081c.25-.138.603-.379.966-.78.704-.778 1.509-2.225 1.613-4.866l-2.431-.617a1.25 1.25 0 0 0-.616 0l-2.43.617c.103 2.641.908 4.088 1.612 4.866.363.401.715.642.966.78q.09.05.16.081",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yp = { render: xp }, Ap = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vp(l, e) {
  return s(), d("svg", Ap, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M17.25 6a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m-16 5a.75.75 0 0 1 .75-.75h19.4c.746 0 1.35.604 1.35 1.35v7.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.75v7.5h18.5v-7.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H14a.75.75 0 0 1 0 1.5h-1.278a1.35 1.35 0 0 1-.879-.325L8.723 4.75H2.75V11a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hp = { render: Vp }, Bp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zp(l, e) {
  return s(), d("svg", Bp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.605-1.35 1.35-1.35h11.652c.358 0 .701.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cp = { render: zp }, Lp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Sp(l, e) {
  return s(), d("svg", Lp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 2.6c0-.746.605-1.35 1.35-1.35h11.652c.358 0 .701.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H11a.75.75 0 0 1 0-1.5h8.25V5.81l-3.06-3.06H4.75V12a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75M1.242 19a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ep = { render: Sp }, Tp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _p(l, e) {
  return s(), d("svg", Tp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H14a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V13a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75m2.47 21.28a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H16a.75.75 0 0 0 0 1.5h4.19l-1.72 1.72a.75.75 0 0 0 0 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Rp = { render: _p }, kp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Op(l, e) {
  return s(), d("svg", kp, e[0] || (e[0] = [
    n("path", { d: "M20.5 8.2c-1.2 0-2.2 1-2.2 2.2v2.8c-1-.3-2.1-.1-2.8.7l-.9.9c-.5.5-.8 1.2-.8 1.9V20c0 .4.3.8.8.8s.8-.3.8-.8v-3.2c0-.3.1-.6.4-.9l.9-.9c.4-.4 1-.5 1.4-.2l.1.1-.6.6c-.3.3-.3.8 0 1.1s.8.3 1.1 0l.9-.9s0-.1.1-.1q.3-.15.3-.6v-4.5c0-.4.3-.8.8-.8s.8.3.8.8v5.2l-3.8 3.8c-.3.3-.3.8 0 1.1s.8.3 1.1 0l3.8-3.8c.3-.3.4-.6.4-1v-5.3c-.3-1.2-1.4-2.3-2.6-2.3M8.5 14c-.7-.7-1.8-1-2.8-.7v-2.8c0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2v5.3c0 .4.1.7.4 1l3.8 3.8c.3.3.8.3 1.1 0s.3-.8 0-1.1l-3.8-3.8v-5.2c0-.4.3-.8.8-.8s.8.3.8.8V15c0 .2.1.5.3.6 0 0 0 .1.1.1l.9.9c.3.3.8.3 1.1 0s.3-.8 0-1.1l-.6-.6-.2-.1c.5-.2 1.1-.1 1.4.2l.9.9c.2.2.4.6.4.9V20c0 .4.3.8.8.8s.8-.3.8-.8v-3.2c0-.7-.3-1.4-.8-1.9zm6.4-5.6c.3-.3.6-.7 1-1q.9-.9.9-2.1c0-1.2-.3-1.6-.9-2.1-.6-.6-1.3-.9-2.2-.9-.4 0-.8.1-1.2.2l-.6.3-.6-.3c-.7-.3-1.6-.3-2.3 0-.4.2-.7.4-1 .7-1 1.1-1 3 .1 4.2l2.9 2.9c.3.3.6.4 1 .4.3 0 .7-.1.9-.4.7-.6 1.4-1.2 2-1.9m-2.9.8L9.2 6.4c-.6-.6-.6-1.6 0-2.2.1-.1.3-.3.5-.3.2-.1.4-.1.6-.1s.4 0 .6.1.4.2.5.3l.1.1c.1.1.3.2.5.2s.4-.1.5-.2l.1-.1c.1-.1.3-.3.5-.3.6-.2 1.2-.1 1.7.3.3.3.4.7.4 1.1s-.2.8-.4 1.1c-.3.3-.6.7-1 1z" }, null, -1)
  ]));
}
const $p = { render: Op }, Np = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fp(l, e) {
  return s(), d("svg", Np, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5M5.25 9a6.75 6.75 0 1 1 7.5 6.709v2.541H14a.75.75 0 0 1 0 1.5h-1.25V21a.75.75 0 0 1-1.5 0v-1.25H10a.75.75 0 0 1 0-1.5h1.25v-2.541A6.75 6.75 0 0 1 5.25 9",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dp = { render: Fp }, Ip = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jp(l, e) {
  return s(), d("svg", Ip, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.583 8a.75.75 0 0 1 .75-.75h3.334a.75.75 0 0 1 .75.75v1.583H16a.75.75 0 0 1 .75.75v3.334a.75.75 0 0 1-.75.75h-1.583V16a.75.75 0 0 1-.75.75h-3.334a.75.75 0 0 1-.75-.75v-1.583H8a.75.75 0 0 1-.75-.75v-3.334a.75.75 0 0 1 .75-.75h1.583zm1.5.75v1.583a.75.75 0 0 1-.75.75H8.75v1.834h1.583a.75.75 0 0 1 .75.75v1.583h1.834v-1.583a.75.75 0 0 1 .75-.75h1.583v-1.834h-1.583a.75.75 0 0 1-.75-.75V8.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.403 1.364a2.75 2.75 0 0 1 1.194 0l7.662 1.703a1.746 1.746 0 0 1 1.353 1.952l-1.87 13.087c-.045.32-.21 1.408-1.337 2.394-1.113.975-3.05 1.75-6.405 1.75s-5.292-.775-6.405-1.75c-1.126-.986-1.292-2.074-1.337-2.394L2.388 5.02A1.746 1.746 0 0 1 3.74 3.067zm.868 1.465a1.25 1.25 0 0 0-.542 0L4.067 4.53a.246.246 0 0 0-.194.276l1.87 13.095c.027.186.12.839.84 1.47.744.65 2.273 1.378 5.417 1.378s4.673-.727 5.417-1.379c.72-.63.813-1.283.84-1.47l1.87-13.095a.246.246 0 0 0-.194-.275z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qp = { render: jp }, Pp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Up(l, e) {
  return s(), d("svg", Pp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.25 10.5a2.25 2.25 0 0 1 4.5 0v5.252c0 .357-.142.7-.395.954L18.53 20.53a.75.75 0 1 1-1.06-1.06l3.78-3.78V10.5a.75.75 0 0 0-1.5 0V15a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.45 13.989a2.75 2.75 0 0 1 3.175-.515l.443.221a1.234 1.234 0 0 1 .32 1.977l-.858.858a.75.75 0 0 1-1.06-1.06l.597-.598-.113-.056a1.25 1.25 0 0 0-1.443.234l-.895.895a1.25 1.25 0 0 0-.366.883V20a.75.75 0 0 1-1.5 0v-3.172c0-.729.29-1.428.806-1.944zM3.5 9.75a.75.75 0 0 0-.75.75v5.19l3.78 3.78a.75.75 0 1 1-1.06 1.06l-3.825-3.824a1.35 1.35 0 0 1-.395-.954V10.5a2.25 2.25 0 0 1 4.5 0V15a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.489 15.05a1.25 1.25 0 0 0-1.443-.235l-.113.057.597.598a.75.75 0 0 1-1.06 1.06l-.858-.858a1.234 1.234 0 0 1 .32-1.977l.443-.221a2.75 2.75 0 0 1 3.175.515l.895.895a2.75 2.75 0 0 1 .805 1.944V20a.75.75 0 0 1-1.5 0v-3.172a1.25 1.25 0 0 0-.366-.883zM9.583 4a.75.75 0 0 1 .75-.75h3.334a.75.75 0 0 1 .75.75v1.583H16a.75.75 0 0 1 .75.75v3.334a.75.75 0 0 1-.75.75h-1.583V12a.75.75 0 0 1-.75.75h-3.334a.75.75 0 0 1-.75-.75v-1.583H8a.75.75 0 0 1-.75-.75V6.333a.75.75 0 0 1 .75-.75h1.583zm1.5.75v1.583a.75.75 0 0 1-.75.75H8.75v1.834h1.583a.75.75 0 0 1 .75.75v1.583h1.834V9.667a.75.75 0 0 1 .75-.75h1.583V7.083h-1.583a.75.75 0 0 1-.75-.75V4.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zp = { render: Up }, Wp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kp(l, e) {
  return s(), d("svg", Wp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16.305 3.75c-1.311 0-2.572.54-3.5 1.502l-.265.275a.75.75 0 0 1-1.08 0l-.265-.275a4.83 4.83 0 0 0-7.001 0c-1.925 1.995-1.925 5.225 0 7.22l7.295 7.562a.71.71 0 0 0 .998.023c1.679-1.616 3.274-3.31 4.881-5.017.806-.855 1.614-1.714 2.438-2.568a5.2 5.2 0 0 0 1.444-3.61 5.2 5.2 0 0 0-1.444-3.61 4.86 4.86 0 0 0-3.5-1.502ZM12 3.942a6.35 6.35 0 0 1 4.305-1.692c1.726 0 3.374.71 4.58 1.96a6.7 6.7 0 0 1 1.865 4.652 6.7 6.7 0 0 1-1.865 4.652c-.796.825-1.591 1.67-2.39 2.518-1.624 1.724-3.265 3.466-4.97 5.108l-.003.004a2.213 2.213 0 0 1-3.113-.069l-7.295-7.561c-2.485-2.577-2.485-6.727 0-9.303A6.33 6.33 0 0 1 12 3.942",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jp = { render: Kp }, Gp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xp(l, e) {
  return s(), d("svg", Gp, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.36 9.891a.75.75 0 0 1 .249-1.031l9-5.5a.75.75 0 0 1 .782 0l9 5.5a.75.75 0 0 1-.782 1.28L12 4.879 3.391 10.14a.75.75 0 0 1-1.031-.249M5 12.25a.75.75 0 0 1 .75.75v6.25h12.5V13a.75.75 0 0 1 1.5 0v6.4a1.35 1.35 0 0 1-1.35 1.35H5.6a1.35 1.35 0 0 1-1.35-1.35V13a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.583 9a.75.75 0 0 1 .75-.75h3.334a.75.75 0 0 1 .75.75v1.583H16a.75.75 0 0 1 .75.75v3.334a.75.75 0 0 1-.75.75h-1.583V17a.75.75 0 0 1-.75.75h-3.334a.75.75 0 0 1-.75-.75v-1.583H8a.75.75 0 0 1-.75-.75v-3.334a.75.75 0 0 1 .75-.75h1.583zm1.5.75v1.583a.75.75 0 0 1-.75.75H8.75v1.834h1.583a.75.75 0 0 1 .75.75v1.583h1.834v-1.583a.75.75 0 0 1 .75-.75h1.583v-1.834h-1.583a.75.75 0 0 1-.75-.75V9.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Yp = { render: Xp }, Qp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function eh(l, e) {
  return s(), d("svg", Qp, e[0] || (e[0] = [
    n("path", { d: "M12.7 6a.7.7 0 1 0-1.4 0v1.3H10a.7.7 0 1 0 0 1.4h1.3V10a.7.7 0 1 0 1.4 0V8.7H14a.7.7 0 1 0 0-1.4h-1.3zM10 13.3a.7.7 0 1 0 0 1.4h4a.7.7 0 1 0 0-1.4zM9.3 18a.7.7 0 0 1 .7-.7h4a.7.7 0 1 1 0 1.4h-4a.7.7 0 0 1-.7-.7" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 1.3A2.7 2.7 0 0 0 5.3 4v4.3H4A2.7 2.7 0 0 0 1.3 11v9A2.7 2.7 0 0 0 4 22.7h16a2.7 2.7 0 0 0 2.7-2.7v-6a2.7 2.7 0 0 0-2.7-2.7h-1.3V4A2.7 2.7 0 0 0 16 1.3zM17.3 4A1.3 1.3 0 0 0 16 2.7H8A1.3 1.3 0 0 0 6.7 4v17.3h10.6zm1.4 17.3v-8.6H20a1.3 1.3 0 0 1 1.3 1.3v6a1.3 1.3 0 0 1-1.3 1.3zm-13.4 0V9.7H4A1.3 1.3 0 0 0 2.7 11v9A1.3 1.3 0 0 0 4 21.3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const lh = { render: eh }, th = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nh(l, e) {
  return s(), d("svg", th, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 6.25a.75.75 0 0 1 .75.75v4.25h6.5V7a.75.75 0 0 1 1.5 0v10a.75.75 0 0 1-1.5 0v-4.25h-6.5V17a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 8 6.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ah = { render: nh }, rh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function oh(l, e) {
  return s(), d("svg", rh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.25 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5.806l-3.985 3.97a6.75 6.75 0 1 1-1.063-1.059l3.983-3.967H16a.75.75 0 0 1-.75-.75M10 8.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ih = { render: oh }, sh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function dh(l, e) {
  return s(), d("svg", sh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 20.25a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5M5.25 15a6.75 6.75 0 1 0 7.5-6.709V3a.75.75 0 0 0-1.5 0v5.291a6.75 6.75 0 0 0-6 6.709",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.33 3.665a.75.75 0 0 1 1.005-.336l6 3a.75.75 0 0 1-.67 1.342l-6-3a.75.75 0 0 1-.336-1.006Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.67 3.665a.75.75 0 0 0-1.005-.336l-6 3a.75.75 0 1 0 .67 1.342l6-3a.75.75 0 0 0 .336-1.006Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ch = { render: dh }, uh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vh(l, e) {
  return s(), d("svg", uh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 20.25A4.25 4.25 0 0 0 20.25 16V8A4.25 4.25 0 0 0 16 3.75H8A4.25 4.25 0 0 0 3.75 8v8A4.25 4.25 0 0 0 8 20.25zM21.75 16A5.75 5.75 0 0 1 16 21.75H8A5.75 5.75 0 0 1 2.25 16V8A5.75 5.75 0 0 1 8 2.25h8A5.75 5.75 0 0 1 21.75 8z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.75 6.6c0-.746.604-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v2.15h2.15c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-2.15v2.15a1.35 1.35 0 0 1-1.35 1.35h-3.8a1.35 1.35 0 0 1-1.35-1.35v-2.15H6.6a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h2.15zm1.5.15V8.9a1.35 1.35 0 0 1-1.35 1.35H6.75v3.5H8.9c.746 0 1.35.604 1.35 1.35v2.15h3.5V15.1c0-.746.604-1.35 1.35-1.35h2.15v-3.5H15.1a1.35 1.35 0 0 1-1.35-1.35V6.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ph = { render: vh }, hh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fh(l, e) {
  return s(), d("svg", hh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.75 6.6c0-.746.604-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v2.15h2.15c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-2.15v2.15a1.35 1.35 0 0 1-1.35 1.35h-3.8a1.35 1.35 0 0 1-1.35-1.35v-2.15H6.6a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h2.15zm1.5.15V8.9a1.35 1.35 0 0 1-1.35 1.35H6.75v3.5H8.9c.746 0 1.35.604 1.35 1.35v2.15h3.5V15.1c0-.746.604-1.35 1.35-1.35h2.15v-3.5H15.1a1.35 1.35 0 0 1-1.35-1.35V6.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mh = { render: fh }, wh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gh(l, e) {
  return s(), d("svg", wh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.47 2.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06L8 4.06 4.06 8l1.47 1.47a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06zm8 0a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1 0 1.06l-13 13a.75.75 0 0 1-1.06 0l-5-5a.75.75 0 0 1 0-1.06zM13.06 7 17 10.94 19.94 8 16 4.06zm2.88 5L12 8.06 8.06 12 12 15.94zm-5 5L7 13.06 4.06 16 8 19.94zM12 9.75a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75m1.5 2a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75m-2.5.5a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0V13a.75.75 0 0 1 .75-.75m7.47 1.22a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06L16 19.94 19.94 16l-1.47-1.47a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bh = { render: gh }, Mh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xh(l, e) {
  return s(), d("svg", Mh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.5 3.75a7.75 7.75 0 0 0-6.577 11.852.75.75 0 1 1-1.271.796A9.25 9.25 0 0 1 11.5 2.25a.75.75 0 0 1 0 1.5m7.75 5.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-1.75v1.25a9.2 9.2 0 0 1-1.402 4.898.75.75 0 0 1-1.271-.796A7.7 7.7 0 0 0 19.25 11.5zM8 17.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M10.75 19a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0M15 17.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M17.75 19a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.5 2.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.75 12a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5h-16a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yh = { render: xh }, Ah = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vh(l, e) {
  return s(), d("svg", Ah, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 1.25a5.75 5.75 0 0 0-5.716 5.118A6.25 6.25 0 0 0 7.5 18.75h3.75V22a.75.75 0 0 0 1.5 0v-3.25h3.75a6.25 6.25 0 0 0 1.216-12.382A5.75 5.75 0 0 0 12 1.25m4.25 5.76V7a4.25 4.25 0 0 0-8.434-.75H9a.75.75 0 0 1 0 1.5H7.5a4.75 4.75 0 1 0 0 9.5h3.75V10a.75.75 0 0 1 1.5 0v2.787l2.915-1.458a.75.75 0 1 1 .67 1.342l-3.585 1.793v2.786h3.75a4.75 4.75 0 0 0 .433-9.48.75.75 0 0 1-.683-.76",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hh = { render: Vh }, Bh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zh(l, e) {
  return s(), d("svg", Bh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.25 20.25V5.75H16.5a.75.75 0 0 1 0-1.5h3.9c.746 0 1.35.604 1.35 1.35v14.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V5.6c0-.746.604-1.35 1.35-1.35h3.9a.75.75 0 0 1 0 1.5H3.75v14.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.306 7.25a1.25 1.25 0 0 0 1.233-1.045l.2-1.205-.2-1.205a1.25 1.25 0 0 0-1.233-1.045H9.694a1.25 1.25 0 0 0-1.233 1.045L8.261 5l.2 1.205A1.25 1.25 0 0 0 9.694 7.25zm2.712-.798a2.75 2.75 0 0 1-2.712 2.298H9.694a2.75 2.75 0 0 1-2.712-2.298l-.205-1.23a1.4 1.4 0 0 1 0-.444l.205-1.23A2.75 2.75 0 0 1 9.694 1.25h4.612a2.75 2.75 0 0 1 2.712 2.298l.205 1.23a1.4 1.4 0 0 1 0 .444z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.278 8.696a.75.75 0 0 1-.974-.417l-1-2.5a.75.75 0 0 1 1.392-.558l1 2.5a.75.75 0 0 1-.418.975",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ch = { render: zh }, Lh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Sh(l, e) {
  return s(), d("svg", Lh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.25 20.25V5.75H16.5a.75.75 0 0 1 0-1.5h3.9c.746 0 1.35.604 1.35 1.35v14.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V5.6c0-.746.604-1.35 1.35-1.35h3.9a.75.75 0 0 1 0 1.5H3.75v14.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.306 7.25a1.25 1.25 0 0 0 1.233-1.045l.2-1.205-.2-1.205a1.25 1.25 0 0 0-1.233-1.045H9.694a1.25 1.25 0 0 0-1.233 1.045L8.261 5l.2 1.205A1.25 1.25 0 0 0 9.694 7.25zm2.712-.798a2.75 2.75 0 0 1-2.712 2.298H9.694a2.75 2.75 0 0 1-2.712-2.298l-.205-1.23a1.4 1.4 0 0 1 0-.444l.205-1.23A2.75 2.75 0 0 1 9.694 1.25h4.612a2.75 2.75 0 0 1 2.712 2.298l.205 1.23a1.4 1.4 0 0 1 0 .444z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.278 8.696a.75.75 0 0 1-.974-.417l-1-2.5a.75.75 0 0 1 1.392-.558l1 2.5a.75.75 0 0 1-.418.975M6.25 17a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Eh = { render: Sh }, Th = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _h(l, e) {
  return s(), d("svg", Th, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.452 1.923a1.35 1.35 0 0 1 1.096 0l8.4 3.733c.488.217.802.7.802 1.234v10.22a1.35 1.35 0 0 1-.802 1.234l-8.4 3.733a1.35 1.35 0 0 1-1.096 0l-8.4-3.733a1.35 1.35 0 0 1-.802-1.234V6.89c0-.534.314-1.017.802-1.234L7.184 3.82l.023-.01zM7.5 5.321 4.847 6.5 12 9.678 14.653 8.5zm9 2.359-.05-.024L9.346 4.5 12 3.32l7.153 3.18zm-.749 1.974V12.5a.75.75 0 1 0 1.5 0V8.987l3-1.333v9.359l-7.5 3.333v-9.358zm-12 7.359V7.654l7.5 3.334v9.358z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Rh = { render: _h }, kh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Oh(l, e) {
  return s(), d("svg", kh, e[0] || (e[0] = [
    n("path", { d: "M22.5 19.5H21V9a1.5 1.5 0 0 0-1.5-1.5h-6V3a1.5 1.5 0 0 0-2.332-1.249l-7.5 4.999A1.5 1.5 0 0 0 3 8v11.5H1.5a.75.75 0 1 0 0 1.5h21a.75.75 0 1 0 0-1.5M19.5 9v10.5h-6V9zm-15-1L12 3v16.5H4.5zm6 2.5V12A.75.75 0 1 1 9 12v-1.5a.75.75 0 1 1 1.5 0m-3 0V12A.75.75 0 1 1 6 12v-1.5a.75.75 0 1 1 1.5 0m0 5.25v1.5a.75.75 0 1 1-1.5 0v-1.5a.75.75 0 1 1 1.5 0m3 0v1.5a.75.75 0 1 1-1.5 0v-1.5a.75.75 0 1 1 1.5 0" }, null, -1)
  ]));
}
const $h = { render: Oh }, Nh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fh(l, e) {
  return s(), d("svg", Nh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m.512 7.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 1 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336ZM4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dh = { render: Fh }, Ih = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jh(l, e) {
  return s(), d("svg", Ih, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 1 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336ZM4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qh = { render: jh }, Ph = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Uh(l, e) {
  return s(), d("svg", Ph, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 13.75c-.69 0-1.25.56-1.25 1.25v3a.75.75 0 0 1-1.5 0v-3a2.75 2.75 0 1 1 5.5 0v3a.75.75 0 0 1-1.5 0v-3c0-.69-.56-1.25-1.25-1.25M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 0 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zh = { render: Uh }, Wh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kh(l, e) {
  return s(), d("svg", Wh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 12.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 0 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jh = { render: Kh }, Gh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xh(l, e) {
  return s(), d("svg", Gh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.75 16a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 1 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Yh = { render: Xh }, Qh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ef(l, e) {
  return s(), d("svg", Qh, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.31 8.404a2.75 2.75 0 0 1 1.38 0l2.049.531c.59.153 1.024.695 1.003 1.333-.088 2.643-.888 4.258-1.748 5.224a4.6 4.6 0 0 1-1.183.964 3.5 3.5 0 0 1-.544.246l-.043.014-.016.005-.006.001-.003.001h-.001L12 16.76l-.198-.037h-.004l-.006-.002-.016-.005a2 2 0 0 1-.174-.061 4 4 0 0 1-.413-.199 4.6 4.6 0 0 1-1.183-.964c-.86-.966-1.66-2.58-1.748-5.224a1.334 1.334 0 0 1 1.003-1.333l2.049-.53ZM12 16.76l-.197-.036a.75.75 0 0 0 .394 0zm0-1.57a3.1 3.1 0 0 0 .874-.696c.583-.654 1.263-1.881 1.364-4.14l-1.924-.498a1.25 1.25 0 0 0-.628 0l-1.923.499c.1 2.258.78 3.485 1.363 4.138a3.1 3.1 0 0 0 .874.696Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 1 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336ZM4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const lf = { render: ef }, tf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nf(l, e) {
  return s(), d("svg", tf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.538 3.615a4.75 4.75 0 0 1 4.924 0l5 3.03a4.75 4.75 0 0 1 2.288 4.063V17A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17v-6.292a4.75 4.75 0 0 1 2.288-4.063zm4.146 1.283a3.25 3.25 0 0 0-3.368 0l-5 3.03a3.25 3.25 0 0 0-1.566 2.78V17A3.25 3.25 0 0 0 7 20.25h10A3.25 3.25 0 0 0 20.25 17v-6.292a3.25 3.25 0 0 0-1.566-2.78z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.75 17a.75.75 0 0 1-.75.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const af = { render: nf }, rf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function of(l, e) {
  return s(), d("svg", rf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.538 3.615a4.75 4.75 0 0 1 4.924 0l5 3.03a4.75 4.75 0 0 1 2.288 4.063V17A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17v-6.292a4.75 4.75 0 0 1 2.288-4.063zm4.146 1.283a3.25 3.25 0 0 0-3.368 0l-5 3.03a3.25 3.25 0 0 0-1.566 2.78V17A3.25 3.25 0 0 0 7 20.25h1.25V17a3.75 3.75 0 1 1 7.5 0v3.25H17A3.25 3.25 0 0 0 20.25 17v-6.292a3.25 3.25 0 0 0-1.566-2.78zm.566 15.352V17a2.25 2.25 0 1 0-4.5 0v3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sf = { render: of }, df = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cf(l, e) {
  return s(), d("svg", df, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.624 3.35a.75.75 0 0 1 .752 0l9.5 5.5a.75.75 0 1 1-.752 1.3L12 4.866l-9.124 5.282a.75.75 0 0 1-.752-1.298zM12 15.75A4.25 4.25 0 0 0 7.75 20v.25a.75.75 0 0 1-1.5 0V20a5.75 5.75 0 0 1 11.5 0v.25a.75.75 0 0 1-1.5 0V20A4.25 4.25 0 0 0 12 15.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 12a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const uf = { render: cf }, vf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pf(l, e) {
  return s(), d("svg", vf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m1 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M7.972 4.924c-.808.698-1.243 1.72-1.222 3.064.02 1.28.408 2.11 1.28 2.982l.043.042c.466.466.918.918 1.223 1.528.323.646.454 1.403.454 2.46a.75.75 0 1 1-1.5 0c0-.943-.119-1.436-.296-1.79-.185-.371-.465-.66-.984-1.18-1.129-1.128-1.693-2.324-1.72-4.018-.027-1.705.538-3.184 1.742-4.223C8.178 2.764 9.888 2.25 12 2.25s3.822.514 5.008 1.539c1.204 1.039 1.769 2.518 1.742 4.223-.027 1.695-.592 2.89-1.72 4.018-.518.52-.798.809-.984 1.18-.177.354-.296.847-.296 1.79a.75.75 0 0 1-1.5 0c0-1.057.131-1.814.454-2.46.305-.61.757-1.062 1.223-1.528l.043-.042c.871-.872 1.26-1.703 1.28-2.982.021-1.345-.414-2.366-1.222-3.064-.826-.713-2.14-1.174-4.028-1.174-1.889 0-3.202.46-4.028 1.174",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hf = { render: pf }, ff = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mf(l, e) {
  return s(), d("svg", ff, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l2.934 2.935a6.5 6.5 0 0 0-.154 1.547c.027 1.694.591 2.89 1.72 4.018.518.52.798.809.984 1.18.177.354.296.847.296 1.79a.75.75 0 0 0 1.5 0c0-1.057-.13-1.814-.454-2.46-.305-.61-.757-1.062-1.223-1.528l-.043-.042c-.872-.872-1.26-1.703-1.28-2.982V7.81l13.72 13.72a.75.75 0 1 0 1.06-1.06zm5.733 1.71c.73-.273 1.638-.43 2.737-.43 1.888 0 3.202.46 4.028 1.174.808.698 1.243 1.72 1.222 3.064-.02 1.28-.409 2.11-1.28 2.982a.75.75 0 1 0 1.06 1.06c1.128-1.128 1.693-2.323 1.72-4.018.027-1.705-.538-3.184-1.742-4.223C15.822 2.764 14.112 2.25 12 2.25c-1.236 0-2.33.176-3.263.525a.75.75 0 0 0 .526 1.405M8.25 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M10 21.75a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wf = { render: mf }, gf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bf(l, e) {
  return s(), d("svg", gf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M21.53 1.47a.75.75 0 0 0-1.06 0l-1 1a.75.75 0 0 0 1.06 1.06l1-1a.75.75 0 0 0 0-1.06m-19.06 0a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m19.06 15.06a.75.75 0 0 1-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l1 1a.75.75 0 0 1 0 1.06m-19.06 0a.75.75 0 0 0 1.06 0l1-1a.75.75 0 1 0-1.06-1.06l-1 1a.75.75 0 0 0 0 1.06M8.25 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m1 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M7.972 4.924c-.809.698-1.243 1.72-1.222 3.064.02 1.28.408 2.11 1.28 2.982l.042.042c.467.466.919.918 1.224 1.528.241.482.375 1.026.428 1.71h4.552c.053-.684.187-1.228.428-1.71.305-.61.757-1.062 1.223-1.528l.043-.042c.871-.872 1.26-1.703 1.28-2.982.021-1.345-.414-2.366-1.222-3.064-.826-.713-2.14-1.174-4.028-1.174-1.889 0-3.202.46-4.028 1.174m-.98-1.135C8.178 2.764 9.888 2.25 12 2.25s3.822.514 5.008 1.539c1.204 1.039 1.769 2.518 1.742 4.223-.027 1.695-.592 2.89-1.72 4.018-.518.52-.799.809-.984 1.18-.177.354-.296.847-.296 1.79a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75c0-.943-.12-1.436-.296-1.79-.186-.371-.466-.66-.984-1.18-1.129-1.128-1.693-2.324-1.72-4.018-.027-1.705.538-3.184 1.742-4.223",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mf = { render: bf }, xf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yf(l, e) {
  return s(), d("svg", xf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.155 3.22c.17-.555.676-.97 1.296-.97h4.872v.01h5.355l-.001-.01h4.862a1.35 1.35 0 0 1 1.301.988l1.532 5.379h.006l.158.538a1.32 1.32 0 0 1-.8 1.614v8.233a2.754 2.754 0 0 1-2.747 2.748H5.001a2.754 2.754 0 0 1-2.748-2.748v-8.236a1.323 1.323 0 0 1-.79-1.608l1.576-5.49-.016-.018zm.597 7.72v8.062c0 .685.563 1.249 1.249 1.249h3.077v-5.247a2.754 2.754 0 0 1 2.748-2.749h1.998a2.754 2.754 0 0 1 2.748 2.749v5.247h3.417c.685 0 1.25-.564 1.25-1.25v-8.063c-.79.033-1.71.002-2.457-.225l-.008-.002c-.617-.196-1.343-.593-1.764-.837-.415.246-1.162.659-1.799.85-.79.243-1.493.377-2.216.377s-1.426-.134-2.216-.378c-.634-.19-1.375-.598-1.792-.845-.434.257-1.158.648-1.766.834-.617.193-1.33.244-1.962.241q-.259 0-.507-.013m5.444-7.18-.408 4.85c.4.235.987.548 1.423.678l.007.002c.697.215 1.247.311 1.777.311s1.08-.096 1.777-.311l.007-.002c.437-.13 1.027-.445 1.427-.68l-.403-4.849zm-4.62-.01h3.108l-.4 4.802c-.393.236-1.04.586-1.503.727l-.005.002c-.402.126-.937.175-1.51.173a13 13 0 0 1-1.306-.078zm14.851 0 1.604 5.627c-.852.088-2.03.138-2.809-.097-.475-.151-1.108-.498-1.51-.733l-.405-4.798zm-5.354 16.5H9.577v-5.247c0-.686.564-1.25 1.249-1.25h1.998c.685 0 1.25.564 1.25 1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Af = { render: yf }, Vf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hf(l, e) {
  return s(), d("svg", Vf, e[0] || (e[0] = [
    n("path", { d: "m13.28 12.53-3.75 3.75a.75.75 0 1 1-1.06-1.06l2.47-2.47H2.25a.75.75 0 1 1 0-1.5h8.69L8.47 8.78a.75.75 0 0 1 1.06-1.06l3.75 3.75a.747.747 0 0 1 0 1.06M18 3h-5.25a.75.75 0 1 0 0 1.5H18v15h-5.25a.75.75 0 1 0 0 1.5H18a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 18 3" }, null, -1)
  ]));
}
const Bf = { render: Hf }, zf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cf(l, e) {
  return s(), d("svg", zf, e[0] || (e[0] = [
    n("path", { d: "M10.5 20.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-15A1.5 1.5 0 0 1 4.5 3h5.25a.75.75 0 1 1 0 1.5H4.5v15h5.25a.75.75 0 0 1 .75.75m10.28-8.78-3.75-3.75a.75.75 0 1 0-1.06 1.06l2.47 2.47H9.75a.75.75 0 1 0 0 1.5h8.69l-2.47 2.47a.75.75 0 1 0 1.06 1.06l3.75-3.75a.747.747 0 0 0 0-1.06" }, null, -1)
  ]));
}
const Lf = { render: Cf }, Sf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ef(l, e) {
  return s(), d("svg", Sf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 2.75c-3.432 0-6.25 2.868-6.25 6.45 0 .802.363 1.839 1.002 3.005.628 1.147 1.474 2.336 2.335 3.42A46 46 0 0 0 9 18.933a46 46 0 0 0 2.913-3.309c.86-1.083 1.707-2.272 2.335-3.419.639-1.166 1.002-2.203 1.002-3.005 0-3.582-2.818-6.45-6.25-6.45M9 20l-.524.537-.006-.006-.016-.016-.061-.06-.228-.23a47 47 0 0 1-3.252-3.668c-.89-1.118-1.793-2.381-2.477-3.632C1.762 11.694 1.25 10.386 1.25 9.2 1.25 4.83 4.7 1.25 9 1.25s7.75 3.58 7.75 7.95c0 1.186-.512 2.494-1.186 3.725-.684 1.25-1.588 2.514-2.477 3.633a47 47 0 0 1-3.48 3.896l-.06.06-.017.017-.006.005zm0 0 .524.536-.524.511-.524-.51z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M9 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 8.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M7.25 9a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0M19 15.25a.75.75 0 0 1 .75.75v2.25H22a.75.75 0 0 1 0 1.5h-2.25V22a.75.75 0 0 1-1.5 0v-2.25H16a.75.75 0 0 1 0-1.5h2.25V16a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tf = { render: Ef }, _f = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rf(l, e) {
  return s(), d("svg", _f, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M19.973 2.552a1.35 1.35 0 0 1 1.777 1.28v14.735a1.35 1.35 0 0 1-.923 1.281l-5.59 1.864a.75.75 0 0 1-.474 0L9 19.79l-4.973 1.657a1.35 1.35 0 0 1-1.777-1.28V5.431c0-.58.372-1.097.923-1.28l5.59-1.864a.75.75 0 0 1 .474 0L15 4.21zM14.25 5.54l-4.5-1.5v14.418l4.5 1.5V5.541Zm1.5 14.418V5.541l4.5-1.5v14.418l-4.5 1.5Zm-7.5-1.5V4.041l-4.5 1.5v14.418l4.5-1.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kf = { render: Rf }, Of = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $f(l, e) {
  return s(), d("svg", Of, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "m14.25 5.54-4.5-1.5v14.42l4.5 1.5zm-6 12.92V4.04l-4.5 1.5v14.42zM9 19.79l-4.973 1.658a1.35 1.35 0 0 1-1.777-1.28V5.431c0-.58.372-1.097.923-1.28l5.59-1.864a.75.75 0 0 1 .474 0l5.59 1.864c.551.183.923.7.923 1.28v14.736a1.35 1.35 0 0 1-1.777 1.28L9 19.791Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.25 4.04V15a.75.75 0 0 0 1.5 0V3.832a1.35 1.35 0 0 0-1.777-1.28l-5.21 1.737a.75.75 0 0 0 .474 1.423zm-3.659 13.551a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.591a.75.75 0 0 1 1.061 1.06l-1.59 1.592 1.59 1.59a.75.75 0 0 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06l1.591-1.591-1.591-1.591a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nf = { render: $f }, Ff = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Df(l, e) {
  return s(), d("svg", Ff, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 5.53 4.68 18.542l6.867-2.67a1.25 1.25 0 0 1 .906 0l6.866 2.67zm-1.09-1.123a1.25 1.25 0 0 1 2.18 0l7.879 14.008c.575 1.023-.449 2.203-1.543 1.778L12 17.305l-7.426 2.888c-1.094.425-2.118-.755-1.543-1.778z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const If = { render: Df }, jf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qf(l, e) {
  return s(), d("svg", jf, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#9d418e4c-305e-4933-b9a4-cb8222578f85-3ba06969-6473-4871-b519-68ce1a800223-8a9f089b-a512-488c-8ba5-9049375697a2-629e664e-865e-4451-b406-f179853ee9da-a2e9d8d8-35c8-4083-a6d1-d9b9d456f58d-9bf9236b-61ab-49b0-9662-c6598db3afa8-7e7264-e69b7238-66f7-40aa-9ce5-87373b2250a6-a35e89d8-6d0a-4b5c-8620-eab4c24fb78b-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M19.282 5.425 4.906 9.451l6.743 2.967c.286.126.515.354.64.64l2.968 6.744zm.024-1.564a1.25 1.25 0 0 1 1.54 1.54l-4.333 15.477c-.316 1.13-1.875 1.241-2.348.167l-3.209-7.294-7.293-3.209c-1.075-.472-.964-2.031.166-2.347L19.306 3.86Z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const Pf = { render: qf }, Uf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zf(l, e) {
  return s(), d("svg", Uf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "m12 5.53 5.846 10.393a.75.75 0 0 0 1.308-.735l-6.065-10.78a1.25 1.25 0 0 0-2.178 0L3.03 18.414c-.575 1.023.449 2.203 1.543 1.778L12 17.305l1.728.672a.75.75 0 1 0 .544-1.398l-1.819-.708a1.25 1.25 0 0 0-.906 0l-6.866 2.67zm4.591 12.061a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.591a.75.75 0 0 1 1.061 1.06l-1.59 1.592 1.59 1.59a.75.75 0 0 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06l1.591-1.591-1.591-1.591a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wf = { render: Zf }, Kf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Jf(l, e) {
  return s(), d("svg", Kf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 2.75c-3.432 0-6.25 2.868-6.25 6.45 0 .802.363 1.839 1.002 3.005.628 1.147 1.474 2.336 2.335 3.42A46 46 0 0 0 9 18.933a46 46 0 0 0 2.913-3.309c.86-1.083 1.707-2.272 2.335-3.419.639-1.166 1.002-2.203 1.002-3.005 0-3.582-2.818-6.45-6.25-6.45M9 20l-.524.537-.006-.006-.016-.016-.061-.06-.228-.23a47 47 0 0 1-3.252-3.668c-.89-1.118-1.793-2.381-2.477-3.632C1.762 11.694 1.25 10.386 1.25 9.2 1.25 4.83 4.7 1.25 9 1.25s7.75 3.58 7.75 7.95c0 1.186-.512 2.494-1.186 3.725-.684 1.25-1.588 2.514-2.477 3.633a47 47 0 0 1-3.48 3.896l-.06.06-.017.017-.006.005zm0 0 .524.536-.524.511-.524-.51zm6.25-1a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M9 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 8.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M7.25 9a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gf = { render: Jf }, Xf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yf(l, e) {
  return s(), d("svg", Xf, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A7.25 7.25 0 0 0 4.75 10c0 .907.422 2.07 1.154 3.371.72 1.28 1.69 2.605 2.677 3.811A51 51 0 0 0 12 20.95a51 51 0 0 0 3.42-3.768c.985-1.206 1.956-2.531 2.676-3.811.732-1.3 1.154-2.464 1.154-3.371A7.25 7.25 0 0 0 12 2.75M12 22l-.516.544-.007-.006-.018-.018-.07-.067-.26-.254a53 53 0 0 1-3.71-4.068c-1.014-1.24-2.043-2.64-2.823-4.024C3.828 12.743 3.25 11.302 3.25 10a8.75 8.75 0 0 1 17.5 0c0 1.302-.578 2.743-1.346 4.107-.78 1.384-1.81 2.783-2.823 4.024a53 53 0 0 1-3.97 4.322l-.07.067-.018.018-.005.004-.001.002zm0 0 .517.544-.517.49-.516-.49z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M12 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 9.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m-1.75.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qf = { render: Yf }, em = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lm(l, e) {
  return s(), d("svg", em, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#c0507a6b-3daa-4741-a2ae-c049e3828ee7-2d07ae9a-6587-4d05-9c53-7d45fe249280-0a21b772-3ac2-4a9c-9b2f-10ae7f8542eb-e263b35e-3174-4a63-8b22-b81c830b5fc5-47022390-8f7e-4400-8573-5aaaf5d03172-3e3afc02-37d4-474a-9653-616b34cd0549-3aae5f-34ade95e-9c51-4d37-be8b-42fec5d9c920-531f1370-252c-40f2-9424-48a8cdb08199-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M9 2.75c-3.432 0-6.25 2.868-6.25 6.45 0 .802.363 1.839 1.002 3.005.628 1.147 1.474 2.336 2.335 3.42A46 46 0 0 0 9 18.933a46 46 0 0 0 2.913-3.309c.86-1.083 1.707-2.272 2.335-3.419.639-1.166 1.002-2.203 1.002-3.005 0-3.582-2.818-6.45-6.25-6.45M9 20l-.524.537-.006-.006-.016-.016-.061-.06-.228-.23a47 47 0 0 1-3.252-3.668c-.89-1.118-1.793-2.381-2.477-3.632C1.762 11.694 1.25 10.386 1.25 9.2 1.25 4.83 4.7 1.25 9 1.25s7.75 3.58 7.75 7.95c0 1.186-.512 2.494-1.186 3.725-.684 1.25-1.588 2.514-2.477 3.633a47 47 0 0 1-3.48 3.896l-.06.06-.017.017-.006.005zm0 0 .524.536-.524.511-.524-.51z",
        "clip-rule": "evenodd"
      }),
      n("path", { d: "M9 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }),
      n("path", {
        "fill-rule": "evenodd",
        d: "M9 8.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M7.25 9a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m9.098 7.348a.75.75 0 0 1 1.061 0L19 17.94l1.591-1.59a.75.75 0 0 1 1.06 1.06L20.062 19l1.59 1.591a.75.75 0 0 1-1.06 1.06L19 20.062l-1.591 1.59a.75.75 0 0 1-1.06-1.06L17.938 19l-1.59-1.591a.75.75 0 0 1 0-1.06Z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const tm = { render: lm }, nm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function am(l, e) {
  return s(), d("svg", nm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M19.53 5.47a.75.75 0 0 1 0 1.06L7.81 18.25h10.67a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75V6.52a.75.75 0 0 1 1.5 0v10.67L18.47 5.47a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rm = { render: am }, om = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function im(l, e) {
  return s(), d("svg", om, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.359 8.641a.75.75 0 0 0-1.061 0L9.92 13.018v-3.14a.75.75 0 0 0-1.5 0v4.95a.747.747 0 0 0 .75.75h4.95a.75.75 0 1 0 0-1.5h-3.139l4.377-4.376a.75.75 0 0 0 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sm = { render: im }, dm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cm(l, e) {
  return s(), d("svg", dm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.77 19c0 .414.336.75.75.75H19a.75.75 0 0 0 .75-.75V6.52a.75.75 0 1 0-1.5 0v10.67L6.53 5.47a.75.75 0 0 0-1.06 1.06l11.72 11.72H6.52a.75.75 0 0 0-.75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const um = { render: cm }, vm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pm(l, e) {
  return s(), d("svg", vm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.641 8.641a.75.75 0 0 1 1.06 0l4.377 4.377v-3.14a.75.75 0 0 1 1.5 0v4.95a.747.747 0 0 1-.75.75h-4.95a.75.75 0 0 1 0-1.5h3.14L8.64 9.703a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hm = { render: pm }, fm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mm(l, e) {
  return s(), d("svg", fm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.72 11.47a.75.75 0 0 1 1.06 0l4.72 4.72V5.5a.75.75 0 0 1 1.5 0v10.69l4.72-4.72a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wm = { render: mm }, gm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bm(l, e) {
  return s(), d("svg", gm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 16.53a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22V8a.75.75 0 0 0-1.5 0v6.19l-2.22-2.22a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mm = { render: bm }, xm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ym(l, e) {
  return s(), d("svg", xm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.53 5.47a.75.75 0 0 1 0 1.06l-4.72 4.72H18.5a.75.75 0 0 1 0 1.5H7.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Am = { render: ym }, Vm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hm(l, e) {
  return s(), d("svg", Vm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.47 11.47a.75.75 0 0 0 0 1.06l3.5 3.5a.75.75 0 1 0 1.06-1.06l-2.22-2.22H16a.75.75 0 0 0 0-1.5H9.81l2.22-2.22a.75.75 0 0 0-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bm = { render: Hm }, zm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cm(l, e) {
  return s(), d("svg", zm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.97 5.47a.75.75 0 0 0 0 1.06l4.72 4.72H6a.75.75 0 0 0 0 1.5h10.69l-4.72 4.72a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06l-6-6a.75.75 0 0 0-1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Lm = { render: Cm }, Sm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Em(l, e) {
  return s(), d("svg", Sm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16.53 12.53a.75.75 0 0 0 0-1.06l-3.5-3.5a.75.75 0 1 0-1.06 1.06l2.22 2.22H8a.75.75 0 0 0 0 1.5h6.19l-2.22 2.22a.75.75 0 1 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tm = { render: Em }, _m = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rm(l, e) {
  return s(), d("svg", _m, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.47 12.53a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 1.06L4.06 12l4.47 4.47a.75.75 0 1 1-1.06 1.06zm19.06 0a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 1 0-1.06 1.06L19.94 12l-4.47 4.47a.75.75 0 1 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const km = { render: Rm }, Om = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $m(l, e) {
  return s(), d("svg", Om, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1-1.06 1.06L12 4.06 7.53 8.53a.75.75 0 0 1-1.06-1.06zm0 19.06a.75.75 0 0 0 1.06 0l5-5a.75.75 0 1 0-1.06-1.06L12 19.94l-4.47-4.47a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nm = { render: $m }, Fm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Dm(l, e) {
  return s(), d("svg", Fm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M19.53 19.53a.75.75 0 0 0 0-1.06L7.81 6.75h10.67a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0-.75.75v12.48a.75.75 0 0 0 1.5 0V7.81l11.72 11.72a.75.75 0 0 0 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Im = { render: Dm }, jm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qm(l, e) {
  return s(), d("svg", jm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.172 8.422h4.95a.75.75 0 0 1 0 1.5h-3.14l4.377 4.376a.75.75 0 1 1-1.061 1.06l-4.376-4.376v3.14a.75.75 0 0 1-1.5 0v-4.95a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Pm = { render: qm }, Um = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zm(l, e) {
  return s(), d("svg", Um, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.77 6a.75.75 0 0 1 .75-.75H19a.75.75 0 0 1 .75.75v12.48a.75.75 0 0 1-1.5 0V7.81L6.53 19.53a.75.75 0 0 1-1.06-1.06L17.19 6.75H6.52A.75.75 0 0 1 5.77 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wm = { render: Zm }, Km = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Jm(l, e) {
  return s(), d("svg", Km, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.828 8.422h-4.95a.75.75 0 0 0 0 1.5h3.14L8.64 14.298a.75.75 0 1 0 1.06 1.06l4.377-4.376v3.14a.75.75 0 0 0 1.5 0v-4.95a.75.75 0 0 0-.75-.75Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gm = { render: Jm }, Xm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ym(l, e) {
  return s(), d("svg", Xm, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.47 12.53a.75.75 0 0 1 0-1.06l5-5a.75.75 0 1 1 1.06 1.06L16.06 12l4.47 4.47a.75.75 0 1 1-1.06 1.06zm-4.94 0a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 0 0-1.06 1.06L7.94 12l-4.47 4.47a.75.75 0 1 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qm = { render: Ym }, ew = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lw(l, e) {
  return s(), d("svg", ew, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 9.53a.75.75 0 0 0 1.06 0l5-5a.75.75 0 0 0-1.06-1.06L12 7.94 7.53 3.47a.75.75 0 0 0-1.06 1.06zm0 4.94a.75.75 0 0 1 1.06 0l5 5a.75.75 0 1 1-1.06 1.06L12 16.06l-4.47 4.47a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tw = { render: lw }, nw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function aw(l, e) {
  return s(), d("svg", nw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.78 12.53a.75.75 0 0 1-1.06 0L13 7.81V18.5a.75.75 0 0 1-1.5 0V7.81l-4.72 4.72a.75.75 0 0 1-1.06-1.06l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rw = { render: aw }, ow = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iw(l, e) {
  return s(), d("svg", ow, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 7.47a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 1 1-1.06 1.06l-2.22-2.22V16a.75.75 0 0 1-1.5 0V9.81l-2.22 2.22a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sw = { render: iw }, dw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cw(l, e) {
  return s(), d("svg", dw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 3.25h4a.75.75 0 0 1 0 1.5H5.81l6.72 6.72a.75.75 0 1 1-1.06 1.06L4.75 5.81V8a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .218-.529l.002-.001.001-.002A.75.75 0 0 1 4 3.25",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 4.75a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5.81l-6.72 6.72a.75.75 0 1 1-1.06-1.06l6.72-6.72z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.53 11.47a.75.75 0 0 1 0 1.06l-6.72 6.72H8a.75.75 0 0 1 0 1.5H4a.747.747 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v2.19l6.72-6.72a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 11.47a.75.75 0 0 1 1.06 0l6.72 6.72V16a.75.75 0 0 1 1.5 0v4a.747.747 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h2.19l-6.72-6.72a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const uw = { render: cw }, vw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pw(l, e) {
  return s(), d("svg", vw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.47 12.47a.75.75 0 0 1 1.06 0L12 17.94l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06m0-8a.75.75 0 0 1 1.06 0L12 9.94l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hw = { render: pw }, fw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mw(l, e) {
  return s(), d("svg", fw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.53 5.47a.75.75 0 0 1 0 1.06L6.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0m8 0a.75.75 0 0 1 0 1.06L14.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ww = { render: mw }, gw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bw(l, e) {
  return s(), d("svg", gw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.47 5.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 1 1-1.06-1.06L17.94 12l-5.47-5.47a.75.75 0 0 1 0-1.06m-8 0a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06-1.06L9.94 12 4.47 6.53a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mw = { render: bw }, xw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yw(l, e) {
  return s(), d("svg", xw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 4.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06L12 6.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06zm0 8a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06L12 14.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Aw = { render: yw }, Vw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hw(l, e) {
  return s(), d("svg", Vw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 6A.75.75 0 0 1 3 5.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 6m4 6a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m4 6a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bw = { render: Hw }, zw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cw(l, e) {
  return s(), d("svg", zw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 9A.75.75 0 0 1 6 8.25h12a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 9m2 4a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m2 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 1 0 18.5 9.25 9.25 0 0 1 0-18.5M22.75 12c0-5.937-4.813-10.75-10.75-10.75S1.25 6.063 1.25 12 6.063 22.75 12 22.75 22.75 17.937 22.75 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Lw = { render: Cw }, Sw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ew(l, e) {
  return s(), d("svg", Sw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.72 11.72a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06-1.06l2.97-2.97-2.97-2.97a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.75 4a.75.75 0 0 1 .75.75v7A3.25 3.25 0 0 0 10.75 15h6a.75.75 0 0 1 0 1.5h-6A4.75 4.75 0 0 1 6 11.75v-7A.75.75 0 0 1 6.75 4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tw = { render: Ew }, _w = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rw(l, e) {
  return s(), d("svg", _w, e[0] || (e[0] = [
    h5('<path d="M18 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M18 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M16.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M6 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M6 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M4.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path>', 6)
  ]));
}
const kw = { render: Rw }, Ow = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $w(l, e) {
  return s(), d("svg", Ow, e[0] || (e[0] = [
    h5('<path d="M7 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M7 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M5.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M17 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M17 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M15.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12" clip-rule="evenodd"></path>', 7)
  ]));
}
const Nw = { render: $w }, Fw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Dw(l, e) {
  return s(), d("svg", Fw, e[0] || (e[0] = [
    h5('<path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 18.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 18.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 18a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 6.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 6.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path>', 6)
  ]));
}
const Iw = { render: Dw }, jw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qw(l, e) {
  return s(), d("svg", jw, e[0] || (e[0] = [
    h5('<path d="M12 7.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 7.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 7a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 17.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 17.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 17a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12" clip-rule="evenodd"></path>', 7)
  ]));
}
const Pw = { render: qw }, Uw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zw(l, e) {
  return s(), d("svg", Uw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.47 8.47a.75.75 0 0 1 1.06 0L12 13.94l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ww = { render: Zw }, Kw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Jw(l, e) {
  return s(), d("svg", Kw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.53 5.47a.75.75 0 0 1 0 1.06L10.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gw = { render: Jw }, Xw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yw(l, e) {
  return s(), d("svg", Xw, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.47 5.47a.75.75 0 0 0 0 1.06L13.94 12l-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06l-6-6a.75.75 0 0 0-1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qw = { render: Yw }, eg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lg(l, e) {
  return s(), d("svg", eg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.47 15.53a.75.75 0 0 0 1.06 0L12 10.06l5.47 5.47a.75.75 0 1 0 1.06-1.06l-6-6a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 0 0 0 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tg = { render: lg }, ng = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ag(l, e) {
  return s(), d("svg", ng, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.97 10.47a.75.75 0 0 1 1.06 0L12 13.44l2.97-2.97a.75.75 0 1 1 1.06 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rg = { render: ag }, og = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ig(l, e) {
  return s(), d("svg", og, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M13.53 7.97a.75.75 0 0 1 0 1.06L10.56 12l2.97 2.97a.75.75 0 1 1-1.06 1.06l-3.5-3.5a.75.75 0 0 1 0-1.06l3.5-3.5a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sg = { render: ig }, dg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cg(l, e) {
  return s(), d("svg", dg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.47 7.97a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 1 1-1.06-1.06L13.44 12l-2.97-2.97a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ug = { render: cg }, vg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pg(l, e) {
  return s(), d("svg", vg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.47 8.97a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 1 1-1.06 1.06L12 10.56l-2.97 2.97a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hg = { render: pg }, fg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mg(l, e) {
  return s(), d("svg", fg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "m17.47 2.47-3.5 3.5a.75.75 0 0 0 1.06 1.06l2.22-2.22V16.5a.75.75 0 0 0 1.5 0V4.81l2.22 2.22a.75.75 0 1 0 1.06-1.06l-3.5-3.5a.75.75 0 0 0-1.06 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11 6.75a.75.75 0 0 1 .75.75v9a2.75 2.75 0 1 0 5.5 0 .75.75 0 0 1 1.5 0 4.25 4.25 0 0 1-8.5 0v-9a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 7.5a4.25 4.25 0 0 1 8.5 0 .75.75 0 0 1-1.5 0 2.75 2.75 0 1 0-5.5 0v12a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wg = { render: mg }, gg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bg(l, e) {
  return s(), d("svg", gg, e[0] || (e[0] = [
    n("path", { d: "M21 13.3H3c-.4 0-.8.3-.8.8s.3.8.8.8h7.2L8 17c-.3.3-.3.8 0 1.1s.8.3 1.1 0l2.2-2.2V22c0 .4.3.8.8.8s.8-.3.8-.8v-6.2L15 18c.3.3.8.3 1.1 0s.3-.8 0-1.1l-2.2-2.2H21c.4 0 .8-.3.8-.8s-.4-.6-.8-.6M3 10.7h18c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-7.2L16 7c.3-.3.3-.8 0-1.1s-.7-.2-1 .1l-2.2 2.2V2c0-.4-.3-.8-.8-.8s-.8.4-.8.8v6.2L9 6c-.3-.3-.7-.3-1 0s-.3.7 0 1l2.2 2.2H3c-.4 0-.8.3-.8.8s.4.7.8.7" }, null, -1)
  ]));
}
const Mg = { render: bg }, xg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yg(l, e) {
  return s(), d("svg", xg, e[0] || (e[0] = [
    n("path", { d: "M21 13.3H3c-.4 0-.8.3-.8.8s.3.8.8.8h8.2v5.4L9 18c-.3-.3-.8-.3-1.1 0s-.2.7.1 1l3.5 3.5c.1.1.2.1.2.2.1 0 .2.1.3.1s.2 0 .3-.1c.1 0 .2-.1.2-.2L16 19c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.2 2.2v-5.4H21c.4 0 .8-.3.8-.8s-.4-.6-.8-.6M3 10.7h18c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-8.2V3.8L15 6c.3.3.8.3 1.1 0s.3-.8 0-1.1l-3.5-3.5c-.1-.1-.2-.1-.2-.2q-.3-.15-.6 0c-.1 0-.2.1-.2.2L8 5c-.3.3-.3.7 0 1s.7.3 1 0l2.2-2.2v5.4H3c-.4 0-.8.3-.8.8s.4.7.8.7" }, null, -1)
  ]));
}
const Ag = { render: yg }, Vg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hg(l, e) {
  return s(), d("svg", Vg, e[0] || (e[0] = [
    n("path", { d: "M22.2 13.9q0-.15 0 0l-1.5-5.1c-.2-.8-1-2.2-2.6-2.5-.2-1-1-2.1-2.7-2.1-1.6 0-2.4 1-2.6 2h-1.7c-.3-1-1.1-2-2.6-2-1.6 0-2.4 1.1-2.7 2.1-1.6.3-2.3 1.7-2.5 2.5l-1.5 5v.1c-.3.6-.5 1.4-.5 2.1 0 2.6 2.1 4.8 4.8 4.8 2.5 0 4.5-1.9 4.7-4.3.4.2.8.3 1.3.3s.9-.1 1.3-.3c.2 2.4 2.2 4.3 4.7 4.3 2.6 0 4.8-2.1 4.8-4.8-.1-.8-.3-1.5-.7-2.1M4.7 9.2c0-.1.4-1.4 1.8-1.4.4 0 .7-.3.8-.7 0-.3.1-1.3 1.2-1.3s1.2 1 1.2 1.2c0 .4.3.8.8.8h3c.4 0 .7-.3.8-.7 0-.3.1-1.3 1.2-1.3s1.2 1 1.2 1.2c0 .4.3.8.8.8 1.4 0 1.7 1.3 1.8 1.5l.8 2.5c-.6-.3-1.3-.5-2-.5-1.4 0-2.6.6-3.5 1.6-.4-.9-1.4-1.6-2.5-1.6s-2 .7-2.5 1.6c-.9-1-2.1-1.6-3.5-1.6-.7 0-1.4.2-2 .5zM6 19.3c-1.8 0-3.2-1.5-3.2-3.2s1.5-3.3 3.2-3.3 3.2 1.5 3.2 3.3-1.4 3.2-3.2 3.2m6-4c-.7 0-1.2-.6-1.2-1.2s.6-1.3 1.2-1.3 1.2.6 1.2 1.3-.5 1.2-1.2 1.2m6 4c-1.8 0-3.2-1.5-3.2-3.2s1.5-3.3 3.2-3.3 3.2 1.5 3.2 3.3-1.4 3.2-3.2 3.2" }, null, -1)
  ]));
}
const Bg = { render: Hg }, zg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cg(l, e) {
  return s(), d("svg", zg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.489 1.431 12 2l-.489-.569a.75.75 0 0 1 .978 0m.261 7.222a2.44 2.44 0 0 0 1.32-.89c.475-.623.68-1.461.68-2.388 0-1.095-.64-2.11-1.16-2.772a9.4 9.4 0 0 0-1.07-1.144l-.021-.02-.007-.005-.002-.002L12 2l-.489-.569-.001.001-.002.002-.007.006-.021.019a9 9 0 0 0-.322.305 9 9 0 0 0-.748.839c-.52.661-1.16 1.677-1.16 2.772 0 .927.205 1.764.68 2.388.342.45.795.748 1.32.89v1.597H5A2.75 2.75 0 0 0 2.25 13v1a3.75 3.75 0 0 0 1 2.55V20A2.75 2.75 0 0 0 6 22.75h12A2.75 2.75 0 0 0 20.75 20v-3.45a3.75 3.75 0 0 0 1-2.55v-1A2.75 2.75 0 0 0 19 10.25h-6.25zM5 11.75A1.25 1.25 0 0 0 3.75 13v1a2.25 2.25 0 0 0 4.5 0 .75.75 0 0 1 1.5 0 2.25 2.25 0 0 0 4.5 0 .75.75 0 0 1 1.5 0 2.25 2.25 0 0 0 4.5 0v-1A1.25 1.25 0 0 0 19 11.75zm10 4.5a3.75 3.75 0 0 1-6 0 3.75 3.75 0 0 1-3 1.5c-.43 0-.852-.074-1.25-.215V20A1.25 1.25 0 0 0 6 21.25h12A1.25 1.25 0 0 0 19.25 20v-2.465A3.75 3.75 0 0 1 15 16.25m-3-13.2c-.128.138-.27.3-.41.48-.48.611-.84 1.283-.84 1.845 0 .73.164 1.205.373 1.48.189.246.46.395.877.395.418 0 .688-.149.877-.396.209-.274.373-.749.373-1.479 0-.562-.36-1.234-.84-1.846A8 8 0 0 0 12 3.05",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Lg = { render: Cg }, Sg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Eg(l, e) {
  return s(), d("svg", Sg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11 8.75c-.69 0-1.25.56-1.25 1.25v4.599l.725-.483a2.75 2.75 0 0 1 3.05 0l.725.483V10c0-.69-.56-1.25-1.25-1.25zM8.25 10A2.75 2.75 0 0 1 11 7.25h2A2.75 2.75 0 0 1 15.75 10v6a.75.75 0 0 1-1.166.624l-1.89-1.26a1.25 1.25 0 0 0-1.387 0l-1.891 1.26A.75.75 0 0 1 8.25 16z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tg = { render: Eg }, _g = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rg(l, e) {
  return s(), d("svg", _g, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7 3.75c-.69 0-1.25.56-1.25 1.25v14.626l4.763-3.062a2.75 2.75 0 0 1 2.974 0l4.763 3.062V5c0-.69-.56-1.25-1.25-1.25zM4.25 5A2.75 2.75 0 0 1 7 2.25h10A2.75 2.75 0 0 1 19.75 5v16a.75.75 0 0 1-1.156.63l-5.918-3.804a1.25 1.25 0 0 0-1.352 0l-5.918 3.805A.75.75 0 0 1 4.25 21z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kg = { render: Rg }, Og = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $g(l, e) {
  return s(), d("svg", Og, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.565 1.5h12.87a1.51 1.51 0 0 1 1.284.717l3.303 5.331a1.53 1.53 0 0 1-.087 1.731l-.001.001-9.738 12.63a1.508 1.508 0 0 1-2.392 0L1.066 9.28a1.52 1.52 0 0 1-.088-1.73L4.28 2.217v-.001A1.51 1.51 0 0 1 5.565 1.5M5.566 3a.01.01 0 0 0-.008.005l-.001.001L2.773 7.5h18.454l-2.785-4.495A.01.01 0 0 0 18.434 3zm15.69 6H2.744l9.25 11.997L12 21h.004l.002-.003.002-.002L21.255 9Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a.75.75 0 0 1 .6.3l3.722 4.962 1.739-4.057a.75.75 0 0 1 1.378.59L17.2 8.523 12.707 21.25a.75.75 0 0 1-1.414 0L6.8 8.523 4.56 3.295a.75.75 0 0 1 1.378-.59l1.74 4.057L11.4 1.8a.75.75 0 0 1 .6-.3M8.34 8.379 12 18.747l3.66-10.368L12 3.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ng = { render: $g }, Fg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Dg(l, e) {
  return s(), d("svg", Fg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M21.75 4A1.75 1.75 0 0 0 20 2.25H4A1.75 1.75 0 0 0 2.25 4v1.586c0 .464.184.909.513 1.237l6.414 6.414a.25.25 0 0 1 .073.177v5.805a1.75 1.75 0 0 0 1.326 1.698l2 .5a1.75 1.75 0 0 0 2.174-1.698v-6.305a.25.25 0 0 1 .073-.177l6.415-6.414a1.75 1.75 0 0 0 .512-1.237zM20 3.75a.25.25 0 0 1 .25.25v1.586a.25.25 0 0 1-.073.177l-6.414 6.414a1.75 1.75 0 0 0-.513 1.237v6.305a.25.25 0 0 1-.31.243l-2-.5a.25.25 0 0 1-.19-.243v-5.805c0-.464-.184-.909-.513-1.237L3.823 5.763a.25.25 0 0 1-.073-.177V4A.25.25 0 0 1 4 3.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ig = { render: Dg }, jg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qg(l, e) {
  return s(), d("svg", jg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M21.75 4A1.75 1.75 0 0 0 20 2.25H4A1.75 1.75 0 0 0 2.25 4v3a.75.75 0 0 0 .262.57l6.65 5.7a.25.25 0 0 1 .088.19v6.26a1.75 1.75 0 0 0 2.174 1.697l2-.5a1.75 1.75 0 0 0 1.326-1.698V13.46a.25.25 0 0 1 .087-.19l6.651-5.7A.75.75 0 0 0 21.75 7zM20 3.75a.25.25 0 0 1 .25.25v2.25H3.75V4A.25.25 0 0 1 4 3.75zm-14.973 4h13.946l-5.112 4.381a1.75 1.75 0 0 0-.611 1.329v5.76a.25.25 0 0 1-.19.242l-2 .5a.25.25 0 0 1-.31-.243v-6.26c0-.51-.223-.995-.611-1.328z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Pg = { render: qg }, Ug = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zg(l, e) {
  return s(), d("svg", Ug, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2 5.25a.75.75 0 0 1 .75.75v4.536a4.75 4.75 0 0 1 7.94 2.714h2.62a4.75 4.75 0 0 1 7.94-2.714V6a.75.75 0 0 1 1.5 0v8a4.75 4.75 0 0 1-9.44.75h-2.62A4.75 4.75 0 0 1 1.25 14V6A.75.75 0 0 1 2 5.25M21.25 14a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0m-18.5 0a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 0 0-6.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wg = { render: Zg }, Kg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Jg(l, e) {
  return s(), d("svg", Kg, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6 1.3a3.7 3.7 0 1 0 0 7.4 3.7 3.7 0 0 0 0-7.4M3.7 5a2.3 2.3 0 1 1 4.6 0 2.3 2.3 0 0 1-4.6 0m8.7 4c0 .458.086.897.242 1.3H10c-.728 0-1.45.24-1.922.831l-5.07 4.888-.513-.514a.7.7 0 1 0-.99.99l6 6a.7.7 0 1 0 .99-.99l-.47-.47 1.036-.908a.7.7 0 0 0 .099-.107c.13-.173.388-.32.84-.32h4c1.262 0 2.456-.459 3.305-1.415l4.576-4.376.002-.002a2.701 2.701 0 0 0-2.294-4.628A3.6 3.6 0 1 0 12.4 9M16 6.8a2.2 2.2 0 1 0 1.386 3.909l.215-.2A2.2 2.2 0 0 0 16 6.8m-1.074 8.103 3.383-3.14a4 4 0 0 0 .274-.255l.543-.505.005-.004a1.302 1.302 0 1 1 1.788 1.892l-4.603 4.403-.043.045c-.549.628-1.346.961-2.273.961h-4c-.722 0-1.439.236-1.91.817l-1.058.925-3.033-3.033 5.087-4.905a1 1 0 0 0 .074-.084c.13-.173.388-.32.84-.32h3a1.3 1.3 0 1 1 0 2.6h-2a.7.7 0 1 0 0 1.4h2a2.7 2.7 0 0 0 1.858-.741z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gg = { render: Jg }, Xg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yg(l, e) {
  return s(), d("svg", Xg, e[0] || (e[0] = [
    n("path", { d: "M23.84 10.117 21.449 5.33a1.5 1.5 0 0 0-2.013-.67l-2.331 1.165-4.912-1.3a.76.76 0 0 0-.384 0l-4.912 1.3L4.565 4.66a1.5 1.5 0 0 0-2.013.67L.159 10.116a1.5 1.5 0 0 0 .67 2.013l2.532 1.266 5.202 3.715a.8.8 0 0 0 .254.118l6 1.5a.75.75 0 0 0 .713-.197l5.163-5.164 2.476-1.238a1.5 1.5 0 0 0 .67-2.012zm-5.145 3.128-3.226-2.584a.75.75 0 0 0-1.001.058c-1.67 1.681-3.531 1.469-4.718.719L13.804 7.5h2.982l2.55 5.101zM3.893 6l1.92.958-2.398 4.786-1.915-.957zm10.875 11.17-5.447-1.362-4.613-3.294 2.625-5.25L12 6.026l.919.243L8.7 10.364l-.008.009a1.5 1.5 0 0 0 .255 2.326c1.928 1.23 4.254 1.03 6.086-.47l2.592 2.083zm5.813-5.426-2.393-4.781L20.107 6l2.393 4.787zm-8.227 8.688a.75.75 0 0 1-.909.546L7.538 20a.7.7 0 0 1-.254-.117l-2.47-1.765a.75.75 0 0 1 .872-1.218l2.354 1.68 3.773.942a.75.75 0 0 1 .545.909z" }, null, -1)
  ]));
}
const Qg = { render: Yg }, eb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lb(l, e) {
  return s(), d("svg", eb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 6.75v10.5h12.849l3.5-5.25-3.5-5.25zm-1.5-.15c0-.746.604-1.35 1.35-1.35h13.079c.451 0 .873.226 1.123.601l3.6 5.4a1.35 1.35 0 0 1 0 1.498l-3.6 5.4a1.35 1.35 0 0 1-1.123.601H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tb = { render: lb }, nb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ab(l, e) {
  return s(), d("svg", nb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.75 9A6.245 6.245 0 0 1 12 2.75 6.245 6.245 0 0 1 18.25 9a6.2 6.2 0 0 1-1.043 3.472 6.24 6.24 0 0 1-4.265 2.696l-.008.001-.014.002a5.3 5.3 0 0 1-.92.079q-.476 0-.92-.079l-.012-.002-.01-.001a6.24 6.24 0 0 1-4.265-2.696A6.2 6.2 0 0 1 5.75 9M12 1.25A7.745 7.745 0 0 0 4.25 9c0 1.38.354 2.666.976 3.783L1.74 16.27c-.968.967-.491 2.625.837 2.94l1.65.39.01.002c.07.016.148.081.174.184v.001l.35 1.467c.332 1.4 2.113 1.816 3.039.724l4.2-4.835 4.2 4.825c.926 1.092 2.707.676 3.04-.725l.35-1.47.003-.014c.015-.07.072-.142.183-.17h.001l1.646-.39c1.319-.312 1.813-1.967.835-2.931l-3.484-3.485A7.7 7.7 0 0 0 19.75 9 7.745 7.745 0 0 0 12 1.25m5.344 19.747-3.827-4.396a7.72 7.72 0 0 0 4.389-2.565L21.2 17.33l.005.005c.118.117.072.358-.128.405l-1.65.39-.004.001a1.73 1.73 0 0 0-1.294 1.302l-.349 1.464a.25.25 0 0 1-.436.1m-11.25-6.96a7.72 7.72 0 0 0 4.39 2.564l-3.82 4.397-.008.01a.25.25 0 0 1-.436-.102l-.35-1.47-.001-.003a1.75 1.75 0 0 0-1.3-1.294l-1.646-.389a.253.253 0 0 1-.123-.42l3.294-3.294Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rb = { render: ab }, ob = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ib(l, e) {
  return s(), d("svg", ob, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#4bf2ebbc-3e24-41a5-b776-12ad25b4edc1-15bee4ba-c598-4d18-b02a-be267a881f86-51459fcb-72ee-4191-90ac-bf271ac95f9d-39ed2493-2db1-4872-9c7b-8428716e37e3-b4daebc3-2362-4210-bf29-26ae7d40f22c-a90ed63c-bde7-4c38-9608-d3bddd4a9739-b08cda-ce0f986d-d6d8-4000-ab88-ecfc9161a228-766330ab-c8cd-4054-9f61-24a6441201fb-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M2.47 21.53a.75.75 0 0 0 1.06 0l6.5-6.5a.75.75 0 1 0-1.06-1.06l-6.5 6.5a.75.75 0 0 0 0 1.06" }),
      n("path", { d: "M15.126 1.922a.75.75 0 0 1 .561.22l5.85 5.849a.75.75 0 0 1-.045 1.102l-5.208 4.418.352 3.392a.75.75 0 0 1-.216.608l-1.697 1.697a.75.75 0 0 1-1.06 0L4.47 10.016a.75.75 0 0 1 0-1.06l1.697-1.698a.75.75 0 0 1 .607-.216l3.393.352 4.418-5.208a.75.75 0 0 1 .541-.264m.076 1.855-4.147 4.889a.75.75 0 0 1-.649.26l-3.431-.355-.914.914 8.131 8.132.915-.914-.356-3.431a.75.75 0 0 1 .261-.65l4.889-4.146z" })
    ], -1)
  ]));
}
const sb = { render: ib }, db = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cb(l, e) {
  return s(), d("svg", db, e[0] || (e[0] = [
    n("path", { d: "M8 7.3a.7.7 0 1 0 0 1.4h6a.7.7 0 1 0 0-1.4zM7.3 12a.7.7 0 0 1 .7-.7h8a.7.7 0 1 1 0 1.4H8a.7.7 0 0 1-.7-.7m.7 3.3a.7.7 0 1 0 0 1.4h5a.7.7 0 1 0 0-1.4z" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.313 1.374A.7.7 0 0 0 3.3 2v20a.7.7 0 0 0 1.013.626L6 21.783l1.687.843a.7.7 0 0 0 .626 0L10 21.783l1.687.843a.7.7 0 0 0 .626 0L14 21.783l1.687.843a.7.7 0 0 0 .626 0L18 21.783l1.687.843A.7.7 0 0 0 20.7 22V2a.7.7 0 0 0-1.013-.626L18 2.218l-1.687-.844a.7.7 0 0 0-.626 0L14 2.218l-1.687-.844a.7.7 0 0 0-.626 0L10 2.218l-1.687-.844a.7.7 0 0 0-.626 0L6 2.218zM4.7 20.868V3.133l.987.493a.7.7 0 0 0 .626 0L8 2.783l1.687.843a.7.7 0 0 0 .626 0L12 2.783l1.687.843a.7.7 0 0 0 .626 0L16 2.783l1.687.843a.7.7 0 0 0 .626 0l.987-.493v17.735l-.987-.494a.7.7 0 0 0-.626 0L16 21.218l-1.687-.844a.7.7 0 0 0-.626 0L12 21.218l-1.687-.844a.7.7 0 0 0-.626 0L8 21.218l-1.687-.844a.7.7 0 0 0-.626 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ub = { render: cb }, vb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pb(l, e) {
  return s(), d("svg", vb, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#ec01bf1c-fc87-4340-a4e4-c89cd1297874-f5678f0c-c529-4057-b9a4-46632cfaa9af-60e9401b-b50a-4fed-9e0c-50961f35727b-8338d231-9d96-47ec-a400-6ece9407263f-2f0e1d3f-67dc-4835-9e16-9b2ee5a10511-1e24820a-02ef-4a9e-aa15-d3b803501ef3-a0d29a-1125ea44-a43f-4fc8-b3b9-423c4f742ccc-20989955-a525-425f-8424-27027f74a3fd-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M2.47 21.53a.75.75 0 0 0 1.06 0l6.5-6.5a.75.75 0 1 0-1.06-1.06l-6.5 6.5a.75.75 0 0 0 0 1.06" }),
      n("path", { d: "M15.126 1.922a.75.75 0 0 1 .561.22l5.85 5.849a.75.75 0 0 1-.045 1.102l-4.308 3.654a.75.75 0 1 1-.97-1.144L19.9 8.476l-4.699-4.699-3.145 3.708a.75.75 0 1 1-1.144-.97l3.672-4.329a.75.75 0 0 1 .541-.264Zm.585 13.332a.75.75 0 0 1 .823.669l.102.98a.75.75 0 0 1-.216.608l-1.697 1.697a.75.75 0 0 1-1.06 0L4.47 10.016a.75.75 0 0 1 0-1.06l1.697-1.698a.75.75 0 0 1 .607-.216l.98.102a.75.75 0 1 1-.155 1.492l-.624-.065-.914.914 8.131 8.132.915-.914-.065-.626a.75.75 0 0 1 .669-.823" }),
      n("path", { d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 1 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06" })
    ], -1)
  ]));
}
const hb = { render: pb }, fb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mb(l, e) {
  return s(), d("svg", fb, e[0] || (e[0] = [
    n("path", { d: "M5.994 15.289a2.88 2.88 0 0 1 1.7.621l.2.174.008.008c1.068 1.055 1.06 2.759.133 3.857v.001c-.404.482-.972.846-1.541 1.124a11 11 0 0 1-1.775.661 17 17 0 0 1-1.947.432l-.13.02-.035.005-.01.001-.003.001h-.002a.7.7 0 0 1-.786-.787v-.004l.002-.01.005-.036q.006-.046.02-.13a17 17 0 0 1 .432-1.947c.162-.57.379-1.197.66-1.774.278-.57.643-1.138 1.125-1.542a2.88 2.88 0 0 1 1.944-.675m16.01-13.99a.7.7 0 0 1 .696.7c0 2.784-.787 7.645-5.895 11.293l.026.094c.088.36.197.86.268 1.417.072.554.11 1.183.053 1.796-.056.608-.212 1.252-.57 1.79-.621.928-1.818 1.49-2.707 1.813a12 12 0 0 1-1.599.456l-.107.023-.03.005-.01.001-.002.001h-.002A.7.7 0 0 1 11.3 20v-4.71L8.71 12.7H4a.7.7 0 0 1-.689-.825v-.001l.001-.003.001-.009.006-.03.023-.109a12 12 0 0 1 .456-1.598c.322-.889.885-2.085 1.812-2.706l.001-.001c.538-.359 1.182-.514 1.79-.57a8.3 8.3 0 0 1 1.796.053 13 13 0 0 1 1.417.268q.056.016.11.028A13.58 13.58 0 0 1 22.003 1.3M5.95 16.69a1.48 1.48 0 0 0-1 .346v.001c-.269.226-.53.598-.767 1.084a9.6 9.6 0 0 0-.573 1.545c-.099.345-.176.675-.238.962a15 15 0 0 0 .963-.237 9.6 9.6 0 0 0 1.545-.574c.486-.237.858-.498 1.084-.766l.002-.001c.491-.582.462-1.456-.048-1.96h-.001a1.48 1.48 0 0 0-.967-.4m9.603-2.604q-1.38.794-2.853 1.391v3.631c.212-.06.45-.132.697-.221.868-.315 1.671-.754 2.02-1.276.182-.272.297-.658.341-1.14a7 7 0 0 0-.047-1.488 11 11 0 0 0-.159-.897m5.725-11.367a12.18 12.18 0 0 0-9.684 5.704l-.004.006A21.3 21.3 0 0 0 9.82 11.83l2.349 2.349a21.7 21.7 0 0 0 3.456-1.772c4.512-3.033 5.511-7.05 5.652-9.69M7.529 8.242c-.482.045-.869.16-1.14.34-.522.35-.96 1.153-1.275 2.02-.09.248-.162.487-.223.699h3.635a23 23 0 0 1 1.408-2.85 11 11 0 0 0-.917-.161 7 7 0 0 0-1.488-.048m8.47-2.342A2.1 2.1 0 1 1 16 10.1a2.1 2.1 0 0 1 0-4.2m0 1.2a.901.901 0 1 0 .002 1.802A.901.901 0 0 0 16 7.1" }, null, -1)
  ]));
}
const wb = { render: mb }, gb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bb(l, e) {
  return s(), d("svg", gb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.813 4.813a8.75 8.75 0 0 1 12.882 11.821l3.835 3.836a.75.75 0 0 1-1.06 1.06l-3.836-3.835A8.75 8.75 0 0 1 4.813 4.813M11 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mb = { render: bb }, xb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yb(l, e) {
  return s(), d("svg", xb, e[0] || (e[0] = [
    n("path", { d: "M21.975 14.325 21 12l.975-2.325c.15-.3.15-.6.075-.975-.075-.3-.3-.6-.6-.75l-2.175-1.275-.525-2.4c-.075-.3-.225-.6-.525-.825q-.45-.337-.9-.225l-2.475.225-1.875-1.65a1.37 1.37 0 0 0-1.8 0L9.3 3.45l-2.625-.225c-.3 0-.675.075-.9.225-.225.225-.45.45-.525.825l-.525 2.4L2.55 7.95c-.3.15-.45.45-.6.75-.075.3-.075.675.075.975L3 12l-.975 2.325c-.15.3-.15.6-.075.975.075.3.3.6.6.75l2.175 1.275.525 2.4c.075.3.225.6.525.825q.45.338.9.225l2.475-.225 1.875 1.65c.225.225.525.3.9.3s.675-.15.9-.3l1.875-1.65 2.475.225c.3 0 .675-.075.9-.225.3-.225.45-.45.525-.825l.6-2.475 2.175-1.275c.3-.15.45-.45.6-.75q.225-.45 0-.9m-2.4-1.8.975 2.25-2.1 1.275a.9.9 0 0 0-.375.375c-.075.15-.15.3-.225.525l-.525 2.4-2.4-.225c-.15 0-.375 0-.525.075s-.3.15-.45.3L12 21l-1.875-1.575c-.15-.15-.3-.225-.45-.3s-.3-.075-.45-.075h-.15l-2.475.225-.525-2.4c-.075-.15-.15-.375-.225-.525a.9.9 0 0 0-.375-.375l-2.1-1.275.975-2.25c.075-.075.15-.3.15-.45s0-.375-.075-.525l-.975-2.25 2.1-1.275c.15-.075.3-.225.375-.375s.15-.3.225-.525l.525-2.4 2.475.225c.15 0 .375 0 .525-.075s.3-.15.45-.3L12 3l1.875 1.575c.15.15.3.225.45.3s.375.075.525.075l2.475-.225.525 2.4c.075.15.15.375.225.525s.225.3.375.375l2.1 1.275-.975 2.25c-.075.075-.075.3-.075.45s0 .375.075.525" }, null, -1),
    n("path", { d: "m15.45 9.45-4.5 4.5-1.5-1.5c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05l2.025 2.025c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225L16.5 10.5c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0" }, null, -1)
  ]));
}
const Ab = { render: yb }, Vb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hb(l, e) {
  return s(), d("svg", Vb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.914 3.272a.15.15 0 0 0-.057.065L9.259 8.57a.75.75 0 0 1-.564.41l-5.809.843a.153.153 0 0 0-.089.261L7 14.153a.75.75 0 0 1 .217.666l-.991 5.75a.14.14 0 0 0 .061.148.15.15 0 0 0 .17.012l5.195-2.716a.75.75 0 0 1 .696 0l5.194 2.716a.15.15 0 0 0 .17-.012.14.14 0 0 0 .062-.149l-.991-5.749a.75.75 0 0 1 .217-.666l4.203-4.07a.153.153 0 0 0-.09-.26l-5.808-.845a.75.75 0 0 1-.564-.409l-2.598-5.232a.15.15 0 0 0-.057-.065A.2.2 0 0 0 12 3.25a.2.2 0 0 0-.086.022m-1.4-.602c.608-1.227 2.364-1.227 2.973 0l2.422 4.88 5.42.788c1.356.197 1.908 1.863.917 2.823l-3.918 3.794.925 5.359c.234 1.36-1.197 2.377-2.406 1.745L12 19.524 7.153 22.06c-1.209.632-2.64-.385-2.406-1.745l.925-5.36-3.918-3.793c-.991-.96-.439-2.626.917-2.823l5.42-.788z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bb = { render: Hb }, zb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cb(l, e) {
  return s(), d("svg", zb, e[0] || (e[0] = [
    n("path", { d: "m14.5 4.7-1-2c-.3-.6-.9-.9-1.5-.9s-1.2.4-1.5.9l-.5 1c-.2.4 0 .8.3 1 .4.2.8 0 1-.3l.5-1c0-.1.1-.1.1-.1.1 0 .1 0 .1.1l1 2c.1.3.4.4.7.4.1 0 .2 0 .3-.1.5-.2.7-.7.5-1m2.3 4.5h.1c.4 0 .7-.3.7-.6.1-.4-.2-.8-.6-.9l-1.1-.2-.2-.5c-.2-.4-.6-.5-1-.3s-.5.6-.3 1l.4.8c.1.2.3.4.6.4zm5.9.3c-.2-.6-.7-1-1.3-1.1l-1.5-.2c-.4-.1-.8.2-.8.6-.1.4.2.8.6.9l1.5.2c.1 0 .1 0 .1.1v.2l-1.1 1c-.3.3-.3.8 0 1.1.1.2.3.2.5.2s.4-.1.5-.2l1.1-1c.4-.6.6-1.2.4-1.8m-4.6 3.6-1.1 1c-.2.2-.3.4-.2.7l.2 1.4c.1.4.4.6.7.6h.1c.4-.1.7-.5.6-.9l-.2-1 .8-.7c.3-.3.3-.8 0-1.1-.2-.2-.7-.3-.9 0m.9 5.8c-.1-.4-.4-.7-.9-.6-.4.1-.7.5-.6.9l.2 1.4c0 .1 0 .1-.1.1 0 0-.1.1-.2 0l-1.3-.7c-.4-.2-.8 0-1 .3s0 .8.3 1l1.3.7c.2.1.5.2.8.2s.7-.1 1-.3c.5-.4.8-1 .7-1.6zm-5.4-.2-1.3-.7c-.2-.1-.5-.1-.7 0l-1.6.8c-.4.2-.5.6-.3 1 .1.3.4.4.7.4.1 0 .2 0 .3-.1l1.2-.6 1 .5c.4.2.8 0 1-.3.3-.4.1-.8-.3-1m-6.3 1.6-.8.4h-.2c-.1 0-.1-.1-.1-.1l.2-1.1c.1-.4-.2-.8-.6-.9s-.8.2-.9.6l-.2 1.1c-.1.6.1 1.2.7 1.6.3.2.6.3 1 .3.3 0 .5-.1.8-.2l.8-.4c.4-.2.5-.6.3-1s-.6-.5-1-.3M5.7 15l-.2.9c-.1.4.2.8.6.9h.1c.4 0 .7-.3.7-.6l.2-1.3c0-.2 0-.5-.2-.7l-.7-.7c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1zM3.8 8.2l-1.1.1c-.7.1-1.2.6-1.4 1.2s0 1.3.4 1.7l1.4 1.4c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.8 0-1.1l-1.4-1.4s-.1-.1 0-.2c0-.1.1-.1.1-.1L4 9.7c.4-.1.7-.4.6-.8s-.4-.8-.8-.7m5.9-2.3c-.4-.2-.8 0-1 .3l-.6 1.4-1.2.1c-.4.1-.7.5-.6.9 0 .3.3.6.7.6h.1L8.7 9c.2 0 .5-.2.6-.4l.8-1.6c.1-.4 0-.9-.4-1.1" }, null, -1)
  ]));
}
const Lb = { render: Cb }, Sb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Eb(l, e) {
  return s(), d("svg", Sb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 3.25a.2.2 0 0 0-.086.022.15.15 0 0 0-.057.065l-.672-.333.672.333-.496.998a.75.75 0 1 1-1.343-.667l.495-.998c.61-1.227 2.365-1.227 2.974 0a.75.75 0 0 1-1.344.667.15.15 0 0 0-.057-.065A.2.2 0 0 0 12 3.25m.665 15.08a.75.75 0 0 1-.317 1.013l-1.573.822a.75.75 0 1 1-.695-1.33l1.572-.822a.75.75 0 0 1 1.013.317m-6.866.3a.75.75 0 0 1 .612.866l-.185 1.073a.14.14 0 0 0 .061.148.15.15 0 0 0 .17.012l.848-.443A.75.75 0 1 1 8 21.616l-.847.443c-1.209.631-2.64-.385-2.406-1.745l.185-1.073a.75.75 0 0 1 .867-.611m-.554-5.133a.75.75 0 0 1 1.06-.017l.695.673a.75.75 0 0 1 .217.666l-.225 1.309a.75.75 0 1 1-1.478-.255l.158-.918-.41-.397a.75.75 0 0 1-.017-1.061M4.631 8.81a.75.75 0 0 1-.634.851l-1.11.161a.152.152 0 0 0-.09.261l1.423 1.378a.75.75 0 1 1-1.043 1.078L1.754 11.16c-.991-.96-.439-2.626.917-2.823l1.11-.161a.75.75 0 0 1 .85.634m5.093-2.864a.75.75 0 0 1 .338 1.005L9.26 8.57a.75.75 0 0 1-.564.409l-1.587.23a.75.75 0 1 1-.216-1.484L8.09 7.55l.629-1.266a.75.75 0 0 1 1.005-.338",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.25 2.5a.75.75 0 0 1 .75-.75 1.65 1.65 0 0 1 1.487.92l2.423 4.88 5.42.788c1.355.197 1.907 1.863.916 2.823l-3.918 3.794.925 5.359c.234 1.36-1.197 2.377-2.406 1.745l-5.195-2.716a.75.75 0 0 1-.402-.665zm1.5 2.06v13.664l4.792 2.506a.15.15 0 0 0 .17-.013.14.14 0 0 0 .062-.149l-.991-5.749a.75.75 0 0 1 .217-.666l4.203-4.07a.153.153 0 0 0-.09-.26l-5.808-.845a.75.75 0 0 1-.564-.409z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tb = { render: Eb }, _b = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rb(l, e) {
  return s(), d("svg", _b, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "m6 13.279-.687 1.456a.75.75 0 0 1-.565.421l-1.605.246 1.184 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.183-1.206-1.604-.245a.75.75 0 0 1-.565-.422zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916L9.01 17.387l.336 2.046c.139.849-.745 1.666-1.63 1.18L6 19.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295zM18 13.279l-.687 1.456a.75.75 0 0 1-.565.421l-1.605.246 1.184 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.184-1.206-1.605-.245a.75.75 0 0 1-.565-.422zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916l-1.415 1.442.335 2.046c.14.849-.744 1.666-1.629 1.18L18 19.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295zM12 4.279l-.687 1.456a.75.75 0 0 1-.565.422l-1.604.245 1.183 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.184-1.206-1.605-.245a.75.75 0 0 1-.565-.422L12 4.28Zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916L15.01 8.387l.335 2.046c.14.849-.744 1.666-1.629 1.18L12 10.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kb = { render: Rb }, Ob = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $b(l, e) {
  return s(), d("svg", Ob, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11 7.25a.75.75 0 0 1 .75.75v2.25H14a.75.75 0 0 1 0 1.5h-2.25V14a.75.75 0 0 1-1.5 0v-2.25H8a.75.75 0 0 1 0-1.5h2.25V8a.75.75 0 0 1 .75-.75m5.47 9.22a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5M2.25 11a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nb = { render: $b }, Fb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Db(l, e) {
  return s(), d("svg", Fb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16.47 16.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5M2.25 11a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 11a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ib = { render: Db }, jb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qb(l, e) {
  return s(), d("svg", jb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12a.75.75 0 0 1 .75-.75h2.46l2.828-8.487a.75.75 0 0 1 1.424 0L15 18.628l2.288-6.865A.75.75 0 0 1 18 11.25h3a.75.75 0 0 1 0 1.5h-2.46l-2.829 8.487a.75.75 0 0 1-1.422 0L9 5.372l-2.288 6.865A.75.75 0 0 1 6 12.75H3a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Pb = { render: qb }, Ub = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zb(l, e) {
  return s(), d("svg", Ub, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a.75.75 0 0 1 .75.75v3.25H16a.75.75 0 0 1 0 1.5h-3.25V16a.75.75 0 0 1-1.5 0v-3.25H8a.75.75 0 0 1 0-1.5h3.25V8a.75.75 0 0 1 .75-.75M3.25 4A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zM4 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M10.25 4a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 16a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M20 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M20.75 4a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zM3.25 20c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wb = { render: Zb }, Kb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Jb(l, e) {
  return s(), d("svg", Kb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.25 13c0 .414.336.75.75.75h5a.75.75 0 0 0 0-1.5h-4.25V8a.75.75 0 0 0-1.5 0zM4.4 3.95a.75.75 0 0 0 1.05.15l2-1.5a.75.75 0 1 0-.9-1.2l-2 1.5a.75.75 0 0 0-.15 1.05m15.2 0a.75.75 0 0 1-1.05.15l-2-1.5a.75.75 0 1 1 .9-1.2l2 1.5a.75.75 0 0 1 .15 1.05",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 13c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 18.385 2.25 13",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gb = { render: Jb }, Xb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yb(l, e) {
  return s(), d("svg", Xb, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M13.25 13a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M8 10.25a.75.75 0 0 1 .75.75v1.25H10a.75.75 0 0 1 0 1.5H8.75V15a.75.75 0 0 1-1.5 0v-1.25H6a.75.75 0 0 1 0-1.5h1.25V11a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.25 5A.75.75 0 0 1 6 4.25h2a.75.75 0 0 1 .75.75v1.25h6.5V5a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 .75.75v1.25h2.65c.746 0 1.35.604 1.35 1.35v10.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35V7.6c0-.746.604-1.35 1.35-1.35h2.65zm1.5 1.25h.5v-.5h-.5zm10.5 0v-.5h-.5v.5zm-14.5 1.5v10.5h18.5V7.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qb = { render: Yb }, eM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lM(l, e) {
  return s(), d("svg", eM, e[0] || (e[0] = [
    n("g", { "clip-path": "url(#c800aa64-7a2f-4751-9698-7adfdd821de0-619d1c99-be1e-494a-b7b5-3645623d36ea-e4784925-ea68-46de-96eb-2a9ebe850708-3b995a86-ff96-4801-87dd-6906db0b770d-b8b3924d-2355-4647-bdae-7db665c7ba83-c27eef87-a85d-4461-bd7d-11c6ea1bfb08-d743a3-e4fc5fb5-4357-4686-9adf-0e46c1d606f8-fa19ab4e-e6cb-4c48-8528-000b1dfef0a4-[object Object]-a)" }, [
      n("path", {
        "fill-rule": "evenodd",
        d: "M12 .25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 12 .25M3.47 3.47a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m17.06 0a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 1 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0M5.553 7.898a.75.75 0 0 1 .782-.069l3.677 1.838 1.419-1.655a.75.75 0 0 1 1.138 0l1.42 1.655 3.676-1.838a.75.75 0 0 1 1.074.798l-1.2 7a.75.75 0 0 1-.739.623H7.2a.75.75 0 0 1-.74-.623l-1.2-7a.75.75 0 0 1 .293-.73Zm1.436 1.935.843 4.917h8.336l.843-4.917-2.876 1.438a.75.75 0 0 1-.904-.183L12 9.652l-1.23 1.436a.75.75 0 0 1-.905.183zM.25 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 12m21 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M5.53 18.47a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 0 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0m12.94 0a.75.75 0 0 1 1.06 0l1 1a.75.75 0 1 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06M12 21.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const tM = { render: lM }, nM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function aM(l, e) {
  return s(), d("svg", nM, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#2d98afc9-0b48-417c-bc26-f0601f5ed716-ab9f1c10-87fb-4de7-8f0a-98a8d291ce46-98471ee1-2808-41e3-8c29-ace613306c23-110b27e7-0b2a-4714-9219-09d7daa3e72b-e2ca4306-2014-4879-bf8b-31b99a8ed63b-26351d2a-99fd-43c2-908c-77712d7c1535-26c6ae-a4de278b-c868-4d68-a6ef-4b693171f050-e2aed03e-5c7a-4a8c-bb31-9734fe1615e6-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M3 1.75A1.25 1.25 0 0 0 1.75 3v18A1.25 1.25 0 0 0 3 22.25h18A1.25 1.25 0 0 0 22.25 21V3A1.25 1.25 0 0 0 21 1.75zm-1.945-.695A2.75 2.75 0 0 1 3 .25h18A2.75 2.75 0 0 1 23.75 3v18A2.75 2.75 0 0 1 21 23.75H3A2.75 2.75 0 0 1 .25 21V3c0-.73.29-1.429.805-1.945" }),
      n("path", { d: "M7 4.25a.75.75 0 0 1 .75.75v1.25H9a.75.75 0 1 1 0 1.5H7.75V9a.75.75 0 0 1-1.5 0V7.75H5a.75.75 0 0 1 0-1.5h1.25V5A.75.75 0 0 1 7 4.25M14.25 7a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m0 8.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m-9.194-.444a.75.75 0 0 1 1.06 0L7 15.94l.885-.884a.75.75 0 0 1 1.06 1.06L8.061 17l.884.884a.75.75 0 1 1-1.06 1.06L7 18.062l-.884.883a.75.75 0 0 1-1.06-1.06L5.939 17l-.883-.884a.75.75 0 0 1 0-1.06M14.25 18.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75" })
    ], -1)
  ]));
}
const rM = { render: aM }, oM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iM(l, e) {
  return s(), d("svg", oM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75V6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sM = { render: iM }, dM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cM(l, e) {
  return s(), d("svg", dM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.8 9.403c-.825.413-1.05.844-1.05 1.097s.225.684 1.05 1.097c.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097s-.225-.684-1.05-1.097c-.78-.39-1.91-.653-3.2-.653s-2.42.263-3.2.653m-.67-1.341c1.029-.515 2.398-.812 3.87-.812s2.841.297 3.87.812c.985.492 1.88 1.31 1.88 2.438 0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812a4.6 4.6 0 0 1-1.018-.68c-.9.315-1.973.492-3.112.492-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438a.75.75 0 0 1 1.5 0c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.851 0 1.636-.115 2.298-.307a2 2 0 0 1-.048-.443c0-1.127.895-1.946 1.88-2.438M3 12.25a.75.75 0 0 1 .75.75c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.831 0 1.6-.11 2.251-.293a.75.75 0 0 1 1.499.043c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097a.75.75 0 0 1 1.5 0c0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.526-.262-1.027-.618-1.378-1.065A9.8 9.8 0 0 1 8 16.25c-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3 4.75a.75.75 0 0 1 .75.75v11c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.83 0 1.598-.11 2.25-.293V10.5a.75.75 0 0 1 1.5 0v8c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097v-8a.75.75 0 0 1 1.5 0v8c0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.684-.341-1.323-.84-1.651-1.49A10 10 0 0 1 8 19.75c-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438v-11A.75.75 0 0 1 3 4.75m10 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.8 4.403c-.825.413-1.05.844-1.05 1.097s.225.684 1.05 1.097c.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097s-.225-.684-1.05-1.097c-.78-.39-1.91-.653-3.2-.653s-2.42.263-3.2.653m-.67-1.341C5.158 2.547 6.527 2.25 8 2.25s2.841.297 3.87.812c.985.492 1.88 1.31 1.88 2.438 0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.985-.492-1.88-1.31-1.88-2.438 0-1.127.895-1.946 1.88-2.438",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const uM = { render: cM }, vM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pM(l, e) {
  return s(), d("svg", vM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.75 12a.75.75 0 0 1-.75.75H6a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75m-7.28 3.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06l-1.72-1.72V22a.75.75 0 0 1-1.5 0v-4.19l-1.72 1.72a.75.75 0 0 1-1.06-1.06zm0-6.94a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.72 1.72V2a.75.75 0 0 0-1.5 0v4.19L9.53 4.47a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hM = { render: pM }, fM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mM(l, e) {
  return s(), d("svg", fM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 5.75A1.25 1.25 0 0 0 2.75 7v10A1.25 1.25 0 0 0 4 18.25h16A1.25 1.25 0 0 0 21.25 17V9.75H6a.75.75 0 0 1 0-1.5h15.25V7A1.25 1.25 0 0 0 20 5.75zm-1.944-.695A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7c0-.73.29-1.429.806-1.945",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wM = { render: mM }, gM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bM(l, e) {
  return s(), d("svg", gM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.325 21.746a.75.75 0 0 1-.671-.82l.6-6 .95-10.448A1.35 1.35 0 0 1 6.548 3.25h13.795a1.35 1.35 0 0 1 1.345 1.472l-.891 9.8a1.35 1.35 0 0 1-1.345 1.228H5.68l-.533 5.325a.75.75 0 0 1-.82.671Zm1.496-7.496h13.494l.864-9.5H6.685z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.349 7.128a.75.75 0 0 1 1.023-.28l7 4a.75.75 0 0 1-.744 1.303l-7-4a.75.75 0 0 1-.28-1.023Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const MM = { render: bM }, xM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yM(l, e) {
  return s(), d("svg", xM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18.75 12a.75.75 0 0 1-.75.75H6a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75m-7.28 10.53a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V16a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06zm0-21.06a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V8a.75.75 0 0 1-1.5 0V3.81L9.53 5.53a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const AM = { render: yM }, VM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function HM(l, e) {
  return s(), d("svg", VM, e[0] || (e[0] = [
    h5('<path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M5.5 4.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M5.5 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M5.5 9.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M5.5 15a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M5.5 14.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M12 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M12 4.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M12 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M12 9.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M12 15a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M12 14.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M12 20a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M12 19.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M18.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M18.5 4.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M18.5 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M18.5 9.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M18.5 15a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M18.5 14.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path>', 20)
  ]));
}
const BM = { render: HM }, zM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function CM(l, e) {
  return s(), d("svg", zM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 20c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0-.75.75zm1.5-.75v-2.5h14.5v2.5zM1.25 12a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75m2-8A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zm7 0a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m10.5 0a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const LM = { render: CM }, SM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function EM(l, e) {
  return s(), d("svg", SM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75m2-8A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zm7 0a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m10.5 0a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zm-10.5 16a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m-7 0c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const TM = { render: EM }, _M = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function RM(l, e) {
  return s(), d("svg", _M, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.343 1.515a10.5 10.5 0 0 1 5.15 1.04.9.9 0 0 1-.786 1.62A8.7 8.7 0 0 0 7.856 8.7H17.1a.9.9 0 1 1 0 1.8H7.336a8.7 8.7 0 0 0 0 3H17.1a.9.9 0 1 1 0 1.8H7.856a8.7 8.7 0 0 0 7.584 5.387 8.7 8.7 0 0 0 4.267-.861.9.9 0 1 1 .786 1.619A10.5 10.5 0 0 1 5.938 15.3H3.9a.9.9 0 1 1 0-1.8h1.613a10.5 10.5 0 0 1 0-3H3.9a.9.9 0 1 1 0-1.8h2.038a10.5 10.5 0 0 1 9.405-7.185",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kM = { render: RM }, OM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $M(l, e) {
  return s(), d("svg", OM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75m.512 8.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057M3.25 3A.75.75 0 0 1 4 2.25h5a.75.75 0 0 1 0 1.5H4.75V6a.75.75 0 0 1-1.5 0zM4 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m16 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M20.75 3a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0 0 1.5h4.25V6a.75.75 0 0 0 1.5 0zM3.25 21c0 .414.336.75.75.75h5a.75.75 0 0 0 0-1.5H4.75V18a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1 0-1.5h4.25V18a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const NM = { render: $M }, FM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function DM(l, e) {
  return s(), d("svg", FM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M13.232 2.287A.75.75 0 0 1 13.75 3v6.25H19a.75.75 0 0 1 .607 1.191l-8 11a.75.75 0 0 1-1.357-.44v-6.25H5a.75.75 0 0 1-.607-1.192l8-11a.75.75 0 0 1 .839-.272M6.472 13.25H11a.75.75 0 0 1 .75.75v4.694l5.777-7.944H13a.75.75 0 0 1-.75-.75V5.307z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const IM = { render: DM }, jM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qM(l, e) {
  return s(), d("svg", jM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 5.75A2.25 2.25 0 0 0 9.75 8v13.25h4.5V8A2.25 2.25 0 0 0 12 5.75m0-1.5A3.75 3.75 0 0 1 15.75 8v13.4a1.35 1.35 0 0 1-1.35 1.35H9.6a1.35 1.35 0 0 1-1.35-1.35V8A3.75 3.75 0 0 1 12 4.25",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 11a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m2-9a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-.25V5a.75.75 0 0 1-1.5 0V2.75H11a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const PM = { render: qM }, UM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ZM(l, e) {
  return s(), d("svg", UM, e[0] || (e[0] = [
    h5('<path fill-rule="evenodd" d="M4 11.25a.75.75 0 0 1 .75.75v9.25h14.5V12a.75.75 0 0 1 1.5 0v9.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35V12a.75.75 0 0 1 .75-.75" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M1.25 7.6c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v3.5h18.5v-3.5z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 6.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M7.5 2.75a1.75 1.75 0 1 0 0 3.5h3.51a9 9 0 0 0-.605-1.389C9.762 3.691 8.833 2.75 7.5 2.75M12 7l.735-.148V6.85l-.001-.005-.003-.014a6 6 0 0 0-.053-.228c-.038-.15-.094-.36-.174-.61-.158-.5-.41-1.174-.784-1.854-.732-1.33-2.053-2.889-4.22-2.889a3.25 3.25 0 0 0 0 6.5H12a.75.75 0 0 0 .735-.897z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12.28 4.139c.732-1.33 2.053-2.889 4.22-2.889a3.25 3.25 0 1 1 0 6.5H12a.75.75 0 0 1-.735-.897L12 7l-.735-.148V6.85l.001-.005.003-.014a6 6 0 0 1 .053-.228c.038-.15.094-.36.174-.61.158-.5.41-1.174.784-1.854m.71 2.111h3.51a1.75 1.75 0 1 0 0-3.5c-1.333 0-2.262.941-2.905 2.111a9 9 0 0 0-.605 1.389" clip-rule="evenodd"></path>', 5)
  ]));
}
const WM = { render: ZM }, KM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function JM(l, e) {
  return s(), d("svg", KM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.67 2.362A.75.75 0 0 1 9.023 3c0 4.14 1.026 7.095 2.953 9.023 1.928 1.927 4.884 2.953 9.023 2.953a.75.75 0 0 1 .672 1.084 10.24 10.24 0 0 1-9.179 5.69c-5.657 0-10.243-4.586-10.243-10.243 0-4.023 2.32-7.503 5.69-9.179a.75.75 0 0 1 .73.034ZM7.556 4.29A8.743 8.743 0 1 0 19.71 16.444c-3.753-.197-6.717-1.283-8.794-3.36S7.754 8.043 7.556 4.29",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const GM = { render: JM }, XM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function YM(l, e) {
  return s(), d("svg", XM, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.164 10.526a.75.75 0 0 1 0 1.06L3.21 19.54l1.06 1.06 7.956-7.954a.75.75 0 0 1 1.06 1.06L4.8 22.191a.75.75 0 0 1-1.06 0l-2.122-2.12a.75.75 0 0 1 0-1.062l8.486-8.484a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.396 1.334a.75.75 0 0 1 .946-.094l8.486 5.656a.75.75 0 0 1 .114 1.154l-.53.53.354.354.53-.53a.75.75 0 0 1 1.06 0l2.475 2.475a.75.75 0 0 1 0 1.06l-4.95 4.95a.75.75 0 0 1-1.06 0l-2.475-2.475a.75.75 0 0 1 0-1.06l.53-.53-.353-.354-1.238 1.237a.75.75 0 0 1-1.06 0l-2.121-2.12a.75.75 0 0 1 0-1.061l1.203-1.205a4 4 0 0 0-.008-.186 6.3 6.3 0 0 0-.237-1.32c-.32-1.12-1.051-2.686-2.726-4.36a.75.75 0 0 1 0-1.061zm2.652 8.307.745.082V9.72l.001-.006.002-.014a2 2 0 0 0 .01-.18 5 5 0 0 0-.01-.478 7.8 7.8 0 0 0-.292-1.64c-.35-1.223-1.083-2.802-2.59-4.465l.108-.108 7.213 4.808-.413.413a.75.75 0 0 0 0 1.06l1.412 1.415a.75.75 0 0 0 1.061 0l.53-.53 1.415 1.414-3.889 3.89-1.414-1.415.53-.53a.75.75 0 0 0 0-1.06l-1.413-1.415a.75.75 0 0 0-1.061 0l-1.238 1.237-1.06-1.06.883-.885a.75.75 0 0 0 .215-.447z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const QM = { render: YM }, ex = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lx(l, e) {
  return s(), d("svg", ex, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4 12.25a.75.75 0 0 0-.75.75v6A2.75 2.75 0 0 0 6 21.75h12A2.75 2.75 0 0 0 20.75 19v-6a.75.75 0 0 0-1.5 0v6c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25v-6a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.53 15.53a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06l2.22 2.22V3a.75.75 0 0 1 1.5 0v10.19l2.22-2.22a.75.75 0 1 1 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tx = { render: lx }, nx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ax(l, e) {
  return s(), d("svg", nx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.546 1.452a.75.75 0 0 1 1.051.144L13 2.049l.598-.453.001.002.003.004.01.012a6 6 0 0 1 .136.193c.09.13.214.32.362.565.297.489.688 1.2 1.079 2.105A19 19 0 0 1 16.75 12c0 3.125-.781 5.715-1.561 7.523-.39.904-.782 1.616-1.079 2.105a12 12 0 0 1-.499.758l-.009.012-.003.004v.001h-.001L13 21.952l.597.453a.75.75 0 0 1-1.195-.906v-.001l.004-.005.02-.027q.028-.038.084-.12c.075-.109.184-.275.317-.494.266-.439.625-1.09.984-1.923A17.5 17.5 0 0 0 15.25 12c0-2.875-.719-5.26-1.439-6.928a16 16 0 0 0-.984-1.923 11 11 0 0 0-.401-.614l-.02-.028-.003-.004a.75.75 0 0 1 .143-1.05ZM11 2.05l-.598-.454-.001.002-.003.004-.01.012-.03.042a12 12 0 0 0-.469.716 17 17 0 0 0-1.078 2.105A19 19 0 0 0 7.25 12c0 3.125.781 5.715 1.561 7.523.39.904.782 1.616 1.079 2.105a12 12 0 0 0 .499.758l.009.012.003.004v.001h.001l.598-.452-.597.453a.75.75 0 0 0 1.195-.907l-.004-.005-.02-.027a11 11 0 0 1-.401-.615 16 16 0 0 1-.984-1.922A17.5 17.5 0 0 1 8.75 12c0-2.875.719-5.26 1.439-6.928.36-.833.718-1.484.984-1.923a11 11 0 0 1 .401-.615l.02-.027.004-.005z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.88 15.5a.75.75 0 0 1 .75-.75h18.74a.75.75 0 0 1 0 1.5H2.63a.75.75 0 0 1-.75-.75m0-7a.75.75 0 0 1 .75-.75h18.74a.75.75 0 0 1 0 1.5H2.63a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rx = { render: ax }, ox = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ix(l, e) {
  return s(), d("svg", ox, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 8.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 12a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.773 14.368a.75.75 0 0 1-.016 1.06l-4.235 4.11a.75.75 0 1 1-1.044-1.076l4.235-4.11a.75.75 0 0 1 1.06.016m4.454 0a.75.75 0 0 1 1.06-.016l4.235 4.11a.75.75 0 1 1-1.044 1.076l-4.235-4.11a.75.75 0 0 1-.016-1.06m5.311-9.89a.75.75 0 0 1-.016 1.06l-4.235 4.11a.75.75 0 0 1-1.044-1.077l4.235-4.11a.75.75 0 0 1 1.06.017m-15.076 0a.75.75 0 0 1 1.06-.016l4.235 4.11a.75.75 0 1 1-1.044 1.076l-4.235-4.11a.75.75 0 0 1-.016-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sx = { render: ix }, dx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cx(l, e) {
  return s(), d("svg", dx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.857 7.75H7.143c-2.447 0-4.393 1.922-4.393 4.248 0 2.005 1.443 3.707 3.412 4.141q.473.105.98.106a.75.75 0 0 1 0 1.5 6 6 0 0 1-1.304-.141c-2.612-.576-4.588-2.854-4.588-5.606 0-3.195 2.659-5.748 5.893-5.748h1.714c3.244 0 5.893 2.846 5.893 5.748a.75.75 0 0 1-1.5 0c0-2.082-1.985-4.248-4.393-4.248",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.143 16.245h1.714c2.447 0 4.393-1.922 4.393-4.248 0-2.004-1.444-3.707-3.412-4.14a4.6 4.6 0 0 0-.98-.107.75.75 0 0 1 0-1.5q.672.002 1.303.141c2.613.576 4.589 2.855 4.589 5.607 0 3.194-2.659 5.747-5.893 5.747h-1.714c-3.244 0-5.893-2.846-5.893-5.748a.75.75 0 0 1 1.5 0c0 2.082 1.985 4.248 4.393 4.248",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ux = { render: cx }, vx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function px(l, e) {
  return s(), d("svg", vx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 4A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zm17.5 0a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zM3.25 20c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hx = { render: px }, fx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mx(l, e) {
  return s(), d("svg", fx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.857 7.75H7.143c-2.447 0-4.393 1.922-4.393 4.248 0 2.005 1.443 3.707 3.412 4.141q.473.105.98.106a.75.75 0 0 1 0 1.5 6 6 0 0 1-1.304-.141c-2.612-.576-4.588-2.854-4.588-5.606 0-3.195 2.659-5.748 5.893-5.748h1.714c3.244 0 5.893 2.846 5.893 5.748a.75.75 0 0 1-1.5 0c0-2.082-1.985-4.248-4.393-4.248m10.954 8.405a.75.75 0 0 1 .051-1.06 4.17 4.17 0 0 0 1.388-3.097c0-2.005-1.444-3.708-3.412-4.142a4.6 4.6 0 0 0-.98-.106.75.75 0 0 1 0-1.5q.672.001 1.303.142c2.613.576 4.589 2.854 4.589 5.606a5.67 5.67 0 0 1-1.88 4.208.75.75 0 0 1-1.059-.05Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.893 16.995a.75.75 0 0 1-.75.75c-3.244 0-5.893-2.846-5.893-5.748a.75.75 0 0 1 1.5 0c0 2.082 1.986 4.248 4.393 4.248a.75.75 0 0 1 .75.75m1.577.475a.75.75 0 0 1 1.06 0l1.591 1.59 1.591-1.59a.75.75 0 0 1 1.061 1.06l-1.591 1.591 1.591 1.591a.75.75 0 0 1-1.06 1.061l-1.592-1.591-1.59 1.591a.75.75 0 1 1-1.061-1.06l1.59-1.592-1.59-1.59a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wx = { render: mx }, gx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bx(l, e) {
  return s(), d("svg", gx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 14a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0-4A.75.75 0 0 1 8 9.25h2a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 8a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10 .25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V3.75H6c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-3.5a.75.75 0 0 1 0-1.5H18A2.75 2.75 0 0 1 20.75 5v15A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20V5A2.75 2.75 0 0 1 6 2.25h3.25V1A.75.75 0 0 1 10 .25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mx = { render: bx }, xx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yx(l, e) {
  return s(), d("svg", xx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.25 11a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m0-4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M17 20.25A3.25 3.25 0 0 0 20.25 17V3.75H8.75V15a.75.75 0 0 1-1.5 0V3.6c0-.746.604-1.35 1.35-1.35h11.8c.746 0 1.35.604 1.35 1.35V17A4.75 4.75 0 0 1 17 21.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M17.75 21a.75.75 0 0 1-.75.75H8v-1.5h5.85a5.6 5.6 0 0 1-.668-1.05c-.614-1.24-.82-2.642-.892-3.45H5c-.69 0-1.25.56-1.25 1.25v1A2.25 2.25 0 0 0 6 20.25h2v1.5H6A3.75 3.75 0 0 1 2.25 18v-1A2.75 2.75 0 0 1 5 14.25h7.4c.748 0 1.321.593 1.377 1.287.06.727.238 1.965.749 2.998.5 1.009 1.25 1.715 2.474 1.715a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ax = { render: yx }, Vx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hx(l, e) {
  return s(), d("svg", Vx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M15 11.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75m-3-9a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75m6 9a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75M11.25 18a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75m6 3a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m-12-9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m1.262-6.557a.75.75 0 0 1 .055 1.059l-.01.01A.75.75 0 1 1 5.443 5.51l.01-.01a.75.75 0 0 1 1.059-.056Zm6 6a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m-9 0a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m9-3a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056m0 6a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m3 6a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m-3 0a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m9-9a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m0 3a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m-3-9a.75.75 0 0 1 .055 1.059l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v4.5h4.5v-4.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v4.8A1.35 1.35 0 0 1 8.4 9.75H3.6A1.35 1.35 0 0 1 2.25 8.4zm13.5.15v4.5h4.5v-4.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v4.8a1.35 1.35 0 0 1-1.35 1.35h-4.8a1.35 1.35 0 0 1-1.35-1.35zM6.512 17.443a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 0 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.75 15.75v4.5h4.5v-4.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v4.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bx = { render: Hx }, zx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cx(l, e) {
  return s(), d("svg", zx, e[0] || (e[0] = [
    n("path", { d: "M10.7 8.2c.8.4 1.5 1.1 2 1.8.1.2.4.4.6.4.1 0 .3 0 .4-.1.4-.2.5-.7.3-1-.6-1-1.6-1.9-2.6-2.4-.4-.2-.8 0-1 .3-.3.3-.1.8.3 1" }, null, -1),
    n("path", { d: "M18.6 17.5c2.4-.7 4.2-2.9 4.2-5.5 0-2.7-1.9-5-4.6-5.6-.4-.1-.9-.1-1.3-.1s-.8.3-.8.8.3.8.8.8c.3 0 .7 0 1 .1 2 .4 3.4 2.1 3.4 4.1 0 2.2-1.8 4-4 4.2L11 10 7.5 6.5l-4-4c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l3 3C3 7.2 1.2 9.4 1.2 12c0 2.7 1.9 5 4.6 5.6.4.1.9.1 1.3.1s.8-.3.8-.8-.3-.8-.8-.8c-.3 0-.7 0-1-.1-2-.4-3.4-2.1-3.4-4.1 0-2.2 1.7-4 4-4.2l2.8 2.8c-.3.6-.3 1.3-.3 1.4 0 3 2.8 5.7 5.9 5.7h1.5l3.8 3.8c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.8 0-1.1zm-3.5-1.3c-2.5 0-4.4-2.2-4.4-4.2v-.2z" }, null, -1)
  ]));
}
const Lx = { render: Cx }, Sx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ex(l, e) {
  return s(), d("svg", Sx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 4A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zm4 8a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M4 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M10.25 4a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 16a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M20 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M20.75 4a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zM3.25 20c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tx = { render: Ex }, _x = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rx(l, e) {
  return s(), d("svg", _x, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 2.25a.75.75 0 0 1 .75.75v4.292a6.75 6.75 0 1 1-1.5 0V3A.75.75 0 0 1 8 2.25m0 6.5a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 2.25a.75.75 0 0 1 .75.75v4.292a6.75 6.75 0 1 1-1.5 0V3a.75.75 0 0 1 .75-.75m0 6.5a5.25 5.25 0 1 0 0 10.501A5.25 5.25 0 0 0 16 8.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kx = { render: Rx }, Ox = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $x(l, e) {
  return s(), d("svg", Ox, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 8.25v-1.5h-1.5v1.5zm1.5.15A1.35 1.35 0 0 1 8.4 9.75H6.6A1.35 1.35 0 0 1 5.25 8.4V6.6c0-.746.604-1.35 1.35-1.35h1.8c.746 0 1.35.604 1.35 1.35zM5.25 12a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m9.75-.75a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75M11.25 18a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m1.262-6.557a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056m6 0a.75.75 0 0 1 .055 1.059l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056m-6 3a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056m6 0a.75.75 0 0 1 .055 1.059l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056m0 2.999a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056Zm-6-8.999a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056m0-3a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056M8.25 17.25v-1.5h-1.5v1.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35H6.6a1.35 1.35 0 0 1-1.35-1.35v-1.8c0-.746.604-1.35 1.35-1.35h1.8c.746 0 1.35.604 1.35 1.35zm7.5-9.15v-1.5h-1.5v1.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35h-1.8a1.35 1.35 0 0 1-1.35-1.35V6.6c0-.746.604-1.35 1.35-1.35h1.8c.746 0 1.35.604 1.35 1.35zM17.25 3a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V3.75H18a.75.75 0 0 1-.75-.75m0 18c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-1.5 0v2.25H18a.75.75 0 0 0-.75.75M6.75 3A.75.75 0 0 0 6 2.25H3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0V3.75H6A.75.75 0 0 0 6.75 3m0 18a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v2.25H6a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nx = { render: $x }, Fx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Dx(l, e) {
  return s(), d("svg", Fx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.25 4A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zM4 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M10.25 4a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 16a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M20 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M20.75 4a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zM3.25 20c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ix = { render: Dx }, jx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qx(l, e) {
  return s(), d("svg", jx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M17.25 2a.75.75 0 0 1 .75-.75c.892 0 2.058.291 3.02 1.03.991.763 1.73 1.98 1.73 3.72 0 1.698-.582 2.812-1.55 3.537a5 5 0 0 1-.96.551c.384.24.75.54 1.08.924.907 1.059 1.43 2.634 1.43 4.988a.75.75 0 0 1-1.5 0c0-2.146-.477-3.32-1.07-4.012-.596-.695-1.408-1.022-2.362-1.26a.75.75 0 0 1 0-1.456c1.038-.259 1.876-.48 2.482-.934.532-.4.95-1.036.95-2.338 0-1.26-.511-2.043-1.145-2.53A3.6 3.6 0 0 0 18 2.75a.75.75 0 0 1-.75-.75M13.5 6.75a1.75 1.75 0 0 0-1.75 1.75V11A2.25 2.25 0 0 0 14 13.25h1c2.2 0 3.75 1.15 3.75 2.75a.75.75 0 0 1-1.5 0c0-.4-.45-1.25-2.25-1.25h-1A3.75 3.75 0 0 1 10.25 11V8.5a3.25 3.25 0 0 1 3.25-3.25h.5a.75.75 0 0 1 0 1.5zm4.5 11.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75m4 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75m-19.25 1.5v1.5h10.5v-1.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h10.8c.746 0 1.35.604 1.35 1.35v1.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Px = { render: qx }, Ux = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zx(l, e) {
  return s(), d("svg", Ux, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 11A4.75 4.75 0 0 1 11 6.25h2A4.75 4.75 0 0 1 17.75 11v9.4a1.35 1.35 0 0 1-1.35 1.35H7.6a1.35 1.35 0 0 1-1.35-1.35zM11 7.75A3.25 3.25 0 0 0 7.75 11v9.25h8.5V11A3.25 3.25 0 0 0 13 7.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 13a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m2-10A.75.75 0 0 1 9 2.25h4a.75.75 0 0 1 0 1.5h-.25V7a.75.75 0 0 1-1.5 0V3.75H9A.75.75 0 0 1 8.25 3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wx = { render: Zx }, Kx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Jx(l, e) {
  return s(), d("svg", Kx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.75 3.75v2.5h6.5v-2.5zm8 2.5V3.6a1.35 1.35 0 0 0-1.35-1.35H8.6A1.35 1.35 0 0 0 7.25 3.6v2.65H4A2.75 2.75 0 0 0 1.25 9v10A2.75 2.75 0 0 0 4 21.75h16A2.75 2.75 0 0 0 22.75 19V9A2.75 2.75 0 0 0 20 6.25zM4 7.75A1.25 1.25 0 0 0 2.75 9v10A1.25 1.25 0 0 0 4 20.25h16A1.25 1.25 0 0 0 21.25 19V9A1.25 1.25 0 0 0 20 7.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gx = { render: Jx }, Xx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yx(l, e) {
  return s(), d("svg", Xx, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.72 4.441a.63.63 0 0 1 .56 0l10 5a.63.63 0 0 1 .345.559v6a.625.625 0 1 1-1.25 0v-4.989L12.28 15.56a.63.63 0 0 1-.56 0l-10-5a.625.625 0 0 1 0-1.118l10-5M20.603 10 12 14.301 3.398 10 12 5.699z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.625 12c.345 0 .625.28.625.625v4.733c1.356 1.242 3.343 1.892 5.375 1.892s4.02-.65 5.375-1.892v-4.733a.625.625 0 1 1 1.25 0v5a.62.62 0 0 1-.183.442c-1.644 1.644-4.068 2.433-6.442 2.433s-4.798-.79-6.442-2.433A.63.63 0 0 1 5 17.625v-5c0-.345.28-.625.625-.625",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qx = { render: Yx }, ey = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ly(l, e) {
  return s(), d("svg", ey, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 2A.75.75 0 0 1 9 1.25h6a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 2M12 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5M3.25 14a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ty = { render: ly }, ny = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ay(l, e) {
  return s(), d("svg", ny, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 2A.75.75 0 0 1 9 1.25h6a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 2M4.479 6.46a.75.75 0 0 1 1.06.02l14 14.5a.75.75 0 0 1-1.079 1.04l-14-14.5a.75.75 0 0 1 .02-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75c-.89 0-1.742.16-2.529.453a.75.75 0 0 1-.523-1.406 8.75 8.75 0 0 1 11.165 11.484.75.75 0 1 1-1.39-.562A7.25 7.25 0 0 0 12 6.75M6.706 7.955a.75.75 0 0 1 .029 1.06A7.25 7.25 0 0 0 16.75 19.478a.75.75 0 0 1 .983 1.133A8.75 8.75 0 0 1 5.646 7.984a.75.75 0 0 1 1.06-.029",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ry = { render: ay }, oy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iy(l, e) {
  return s(), d("svg", oy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.23 2.25c5.279.123 9.52 4.442 9.52 9.75 0 5.39-4.357 9.76-9.751 9.75-5.4-.01-9.809-4.447-9.749-9.852A9.74 9.74 0 0 1 4.734 5.5a.75.75 0 0 1 1.117 1 8.24 8.24 0 0 0-2.101 5.414c-.05 4.566 3.68 8.327 8.252 8.336 4.56.009 8.248-3.686 8.248-8.25a8.254 8.254 0 0 0-7.5-8.219v3.344a.75.75 0 0 1-1.5 0v-3.92",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M21.75 12c0-5.308-4.241-9.627-9.52-9.75-.744.022-.968.221-.98.956v3.919a.75.75 0 0 0 1.5 0V3.781A8.254 8.254 0 0 1 20.25 12c0 4.564-3.687 8.259-8.248 8.25-4.571-.009-8.303-3.77-8.252-8.336A8.24 8.24 0 0 1 5.851 6.5a.75.75 0 1 0-1.117-1 9.74 9.74 0 0 0-2.484 6.398C2.19 17.303 6.6 21.74 12 21.75c5.394.01 9.751-4.36 9.751-9.75Z" }, null, -1),
    n("path", { d: "M10.94 13.06 7.237 7.765a.381.381 0 0 1 .53-.53l5.297 3.702a1.523 1.523 0 0 1-1.746 2.497 1.6 1.6 0 0 1-.378-.372Z" }, null, -1)
  ]));
}
const sy = { render: iy }, dy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cy(l, e) {
  return s(), d("svg", dy, e[0] || (e[0] = [
    n("path", { d: "M21.6 17.1 18.5 14c.6-.3 1.1-.7 1.6-1.1 1.9-1.9 2.5-5.5 1.2-7.6-.1-.2-.3-.3-.6-.4-.2 0-.5.1-.6.2L17.3 8l-1.9.2.2-1.9 2.8-2.8c.2-.2.2-.4.2-.6s-.2-.4-.4-.6C16 1 12.5 1.6 10.6 3.5 9.6 4.4 9 5.7 8.9 7L7.6 5.7 8.2 4c.1-.3 0-.7-.3-.9L4.3 1c-.3-.2-.7-.1-.9.1L2 2.5c-.3.3-.3.7-.2 1L4 7q.3.45.9.3l1.7-.6L9 9.1c0 .5.1.9.2 1.3l-6.7 6.7q-.45.45-.6.9c-.1.3-.2.7-.2 1.1s.1.7.2 1.1.3.6.6.9c.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8l5.7-5.7 5.7 5.7c1 1 2.9 1 3.9 0 .5-.5.8-1.2.8-1.9s-.3-1.5-.8-2.1M6.1 5.3l-1.2.4-1.5-2.5.6-.6 2.5 1.5zM5.3 20c-.5.5-1.3.5-1.8 0-.1-.1-.2-.3-.3-.4-.1-.2-.1-.3-.1-.5s0-.3.1-.5.2-.3.3-.4l7.1-7.1s0-.1.1-.1c0 0 .1-.1.1-.2v-.6c-.7-1.7-.7-4.3.9-5.9C13 3 15.1 2.7 16.5 3l-2.2 2.2c-.1.1-.2.3-.2.5l-.3 3.1c0 .2.1.4.2.6.2.2.4.2.6.2l3.1-.3c.2 0 .3-.1.5-.2L20.4 7c.3 1.5-.1 3.6-1.3 4.8-1.6 1.6-4.2 1.6-5.9.9h-.6c-.1 0-.1.1-.1.1s-.1 0-.1.1zm15.2 0c-.5.5-1.3.5-1.8 0L13 14.3c.8.2 1.6.4 2.4.4.5 0 .9 0 1.4-.1l3.7 3.7c.2.2.4.5.4.9s-.1.5-.4.8" }, null, -1)
  ]));
}
const uy = { render: cy }, vy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function py(l, e) {
  return s(), d("svg", vy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 2.25a.75.75 0 0 1 .75.75v1.25H16a.75.75 0 0 1 0 1.5h-1.953c-.84 2.454-2.335 4.754-4.022 6.792l2.497 2.42a.75.75 0 1 1-1.044 1.077l-2.436-2.36c-1.51 1.675-3.12 3.161-4.554 4.39a.75.75 0 1 1-.976-1.138c1.429-1.225 3.017-2.695 4.49-4.34a33 33 0 0 1-1.332-1.712c-.574-.784-1.11-1.58-1.34-2.044a.75.75 0 0 1 1.34-.67c.17.337.634 1.04 1.21 1.829a33 33 0 0 0 1.113 1.441c1.45-1.772 2.693-3.692 3.458-5.685H2a.75.75 0 0 1 0-1.5h6.25V3A.75.75 0 0 1 9 2.25m8.5 7.5a.75.75 0 0 1 .7.483l4 10.5a.75.75 0 1 1-1.4.534l-.96-2.517h-4.68l-.96 2.517a.75.75 0 1 1-1.4-.534l4-10.5a.75.75 0 0 1 .7-.483m-1.769 7.5h3.538L17.5 12.607z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hy = { render: py }, fy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function my(l, e) {
  return s(), d("svg", fy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 3.577a1.35 1.35 0 0 1 2.06-1.148l8.79 5.442a1.35 1.35 0 0 1 .04 2.27l-9.39 6.26V21a.75.75 0 0 1-1.5 0zm1.5 11.021 8.363-5.575L8.75 3.846z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wy = { render: my }, gy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function by(l, e) {
  return s(), d("svg", gy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 0 0-3.75 17.708V6.997a1.35 1.35 0 0 1 1.982-1.194l6.67 3.531a1.35 1.35 0 0 1 .052 2.357L9.75 15.93v5.045A9.25 9.25 0 1 0 12 2.75M9.75 14.189l6.212-3.655L9.75 7.246zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const My = { render: by }, xy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yy(l, e) {
  return s(), d("svg", xy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M7.25 3.577a1.35 1.35 0 0 1 2.06-1.148l8.79 5.442a1.35 1.35 0 0 1 .04 2.27l-9.39 6.26V21a.75.75 0 0 1-1.5 0zm1.5 11.021 8.363-5.575L8.75 3.846z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.118 6.099a.75.75 0 0 1-.193 1.043l-6.5 4.476a.75.75 0 0 1-.85-1.236l6.5-4.476a.75.75 0 0 1 1.043.193",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ay = { render: yy }, Vy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hy(l, e) {
  return s(), d("svg", Vy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a.75.75 0 0 1 .75.75v.026c5.45.385 9.75 4.927 9.75 10.474a.75.75 0 0 1-1.28.53 2.434 2.434 0 0 0-3.44 0 .75.75 0 0 1-1.06 0 2.92 2.92 0 0 0-3.816-.27l-.154.115v7.125a2.25 2.25 0 0 1-4.5 0 .75.75 0 0 1 1.5 0 .75.75 0 1 0 1.5 0v-7.125l-.154-.116a2.92 2.92 0 0 0-3.816.271.75.75 0 0 1-1.06 0 2.43 2.43 0 0 0-3.44 0 .75.75 0 0 1-1.28-.53c0-5.547 4.3-10.09 9.75-10.474V2.25A.75.75 0 0 1 12 1.5m0 10.312.004-.003a4.42 4.42 0 0 1 5.252-.038 3.93 3.93 0 0 1 3.631-.45 9.002 9.002 0 0 0-17.774 0 3.93 3.93 0 0 1 3.631.45 4.42 4.42 0 0 1 5.252.038z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const By = { render: Hy }, zy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cy(l, e) {
  return s(), d("svg", zy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M3.52 9.52a7.75 7.75 0 1 1 10.96 10.96A7.75 7.75 0 0 1 3.52 9.52M9 8.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9.52 3.52a7.75 7.75 0 1 1 10.96 10.96A7.75 7.75 0 0 1 9.52 3.52M15 2.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ly = { render: Cy }, Sy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ey(l, e) {
  return s(), d("svg", Sy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5 7.75A1.25 1.25 0 0 0 3.75 9v9A1.25 1.25 0 0 0 5 19.25h14A1.25 1.25 0 0 0 20.25 18V9A1.25 1.25 0 0 0 19 7.75zm-1.945-.695A2.75 2.75 0 0 1 5 6.25h14A2.75 2.75 0 0 1 21.75 9v9A2.75 2.75 0 0 1 19 20.75H5A2.75 2.75 0 0 1 2.25 18V9c0-.73.29-1.429.805-1.945",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M16.5 14a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1" }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M16.5 13.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5m-.884-1.134a1.25 1.25 0 1 1 1.768 1.768 1.25 1.25 0 0 1-1.768-1.768m-.324-9.67a2.75 2.75 0 0 1 3.458 2.657V7h-1.5V5.603a1.252 1.252 0 0 0-1.572-1.207l-11 2.933a1.25 1.25 0 0 0-.928 1.208V9h-1.5v-.463A2.75 2.75 0 0 1 4.292 5.88z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ty = { render: Ey }, _y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ry(l, e) {
  return s(), d("svg", _y, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.325 21.746a.75.75 0 0 1-.671-.82l.6-6 .95-10.448A1.35 1.35 0 0 1 6.548 3.25h13.795a1.35 1.35 0 0 1 1.345 1.472l-.891 9.8a1.35 1.35 0 0 1-1.345 1.228H5.68l-.533 5.325a.75.75 0 0 1-.82.671Zm1.496-7.496h13.494l.864-9.5H6.685z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ky = { render: Ry }, Oy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $y(l, e) {
  return s(), d("svg", Oy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v12.778a3.25 3.25 0 0 0 1.797 2.907L12 21.162l5.453-2.727a3.25 3.25 0 0 0 1.797-2.907V2.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h14.8c.746 0 1.35.604 1.35 1.35v12.928a4.75 4.75 0 0 1-2.626 4.248l-5.52 2.76c-.38.19-.828.19-1.208 0l-5.52-2.76a4.75 4.75 0 0 1-2.626-4.248z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ny = { render: $y }, Fy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Dy(l, e) {
  return s(), d("svg", Fy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6 8.75a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m4.691 2.5a4.751 4.751 0 1 0 0 1.5H21.25V15a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M18 11.25a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Iy = { render: Dy }, jy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qy(l, e) {
  return s(), d("svg", jy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M18 8.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m-4.691 2.5a4.751 4.751 0 1 1 0 1.5H2.75V15a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6 11.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Py = { render: qy }, Uy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zy(l, e) {
  return s(), d("svg", Uy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.242 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75M12.943 5.217a3.25 3.25 0 1 0 4.596 4.596 3.25 3.25 0 0 0-4.596-4.596m-1.55 5.085A4.751 4.751 0 0 1 18.6 4.156a4.75 4.75 0 0 1-6.145 7.206l-7.466 7.466 1.59 1.591a.75.75 0 0 1-1.06 1.061l-2.122-2.12a.75.75 0 0 1 0-1.06l7.996-7.997Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.225 15.47a.75.75 0 0 1 1.06 0l2.122 2.121a.75.75 0 0 1-1.06 1.06l-2.122-2.12a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wy = { render: Zy }, Ky = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Jy(l, e) {
  return s(), d("svg", Ky, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M17.992 14.25a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25V21a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25V15a.75.75 0 0 1 .75-.75m-5.049-9.033a3.25 3.25 0 1 0 4.596 4.596 3.25 3.25 0 0 0-4.596-4.596m-1.55 5.085A4.751 4.751 0 0 1 18.6 4.156a4.75 4.75 0 0 1-6.145 7.206l-7.466 7.466 1.59 1.591a.75.75 0 0 1-1.06 1.061l-2.122-2.12a.75.75 0 0 1 0-1.06l7.996-7.997Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.225 15.47a.75.75 0 0 1 1.06 0l2.122 2.121a.75.75 0 0 1-1.06 1.06l-2.122-2.12a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gy = { render: Jy }, Xy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yy(l, e) {
  return s(), d("svg", Xy, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.34 15.348a.75.75 0 0 1 1.061 0l1.591 1.591 1.591-1.59a.75.75 0 0 1 1.06 1.06L19.054 18l1.59 1.591a.75.75 0 0 1-1.06 1.06l-1.59-1.59-1.592 1.59a.75.75 0 0 1-1.06-1.06L16.93 18l-1.59-1.591a.75.75 0 0 1 0-1.06ZM12.943 5.217a3.25 3.25 0 1 0 4.596 4.596 3.25 3.25 0 0 0-4.596-4.596m-1.55 5.085A4.751 4.751 0 0 1 18.6 4.156a4.75 4.75 0 0 1-6.145 7.206l-7.466 7.466 1.59 1.591a.75.75 0 0 1-1.06 1.061l-2.122-2.12a.75.75 0 0 1 0-1.06l7.996-7.997Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.225 15.47a.75.75 0 0 1 1.06 0l2.122 2.121a.75.75 0 0 1-1.06 1.06l-2.122-2.12a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qy = { render: Yy }, eA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lA(l, e) {
  return s(), d("svg", eA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.191 5.062C8.931 4.035 10.156 3.25 12 3.25s3.07.785 3.809 1.812c.711.988.941 2.151.941 2.938v3.25h.65c.746 0 1.35.604 1.35 1.35v6.8a1.35 1.35 0 0 1-1.35 1.35H6.6a1.35 1.35 0 0 1-1.35-1.35v-6.8c0-.746.604-1.35 1.35-1.35h.65V8c0-.787.23-1.95.941-2.938m.559 6.188h6.5V8c0-.547-.17-1.383-.659-2.062-.46-.64-1.235-1.188-2.591-1.188s-2.13.548-2.591 1.188C8.92 6.617 8.75 7.453 8.75 8zm-2 1.5v6.5h10.5v-6.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tA = { render: lA }, nA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function aA(l, e) {
  return s(), d("svg", nA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.75 12.75h4.75a.75.75 0 0 0 0-1.5H6.6a1.35 1.35 0 0 0-1.35 1.35v6.8c0 .746.604 1.35 1.35 1.35h10.8a1.35 1.35 0 0 0 1.35-1.35v-.9a.75.75 0 0 0-1.5 0v.75H6.75zm3.06-9.043c.616-.292 1.344-.457 2.19-.457 1.845 0 3.07.785 3.809 1.812.711.988.941 2.151.941 2.938v4a.75.75 0 0 1-1.5 0V8c0-.547-.17-1.383-.659-2.062-.46-.64-1.235-1.188-2.591-1.188-.647 0-1.152.125-1.547.313a.75.75 0 1 1-.643-1.356",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M15.25 12a.75.75 0 0 1 .75-.75h1.4c.746 0 1.35.604 1.35 1.35v.4a.75.75 0 0 1-1.5 0v-.25H16a.75.75 0 0 1-.75-.75M8 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 8 7.25",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 1 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rA = { render: aA }, oA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iA(l, e) {
  return s(), d("svg", oA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.75 16a.75.75 0 0 1-.75.75H5A2.75 2.75 0 0 1 2.25 14V8A2.75 2.75 0 0 1 5 5.25h14A2.75 2.75 0 0 1 21.75 8v5a.75.75 0 0 1-1.5 0V8c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.562 13.018c.424-.297.963-.275 1.392-.01l5.318 3.27c.488.3.73.823.71 1.313-.021.506-.357 1.092-1.064 1.172l-2.161.245-.97 1.948c-.317.637-.982.752-1.465.598a1.48 1.48 0 0 1-.99-1.116l-1.256-6.116c-.101-.494.063-1.007.486-1.304m1.1 1.57 1.057 5.148 1.058-2.126 2.361-.268zm1.14 5.55s0 .001 0 0m-4.29-9.697a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057m4 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057m-8 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sA = { render: iA }, dA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cA(l, e) {
  return s(), d("svg", dA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.591 15.591a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.591a.75.75 0 0 1 1.061 1.06l-1.59 1.592 1.59 1.59a.75.75 0 0 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06l1.591-1.591-1.591-1.591a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.75 16a.75.75 0 0 1-.75.75H5A2.75 2.75 0 0 1 2.25 14V8A2.75 2.75 0 0 1 5 5.25h14A2.75 2.75 0 0 1 21.75 8v5a.75.75 0 0 1-1.5 0V8c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.512 10.441a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057m4 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057m-8 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const uA = { render: cA }, vA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pA(l, e) {
  return s(), d("svg", vA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.75 16a.75.75 0 0 1-.75.75H5A2.75 2.75 0 0 1 2.25 14V8A2.75 2.75 0 0 1 5 5.25h14A2.75 2.75 0 0 1 21.75 8v5a.75.75 0 0 1-1.5 0V8c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 .75.75m1.22 1.97a.75.75 0 0 1 1.06 0l1.47 1.47 3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12.512 10.441a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057m4 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057m-8 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hA = { render: pA }, fA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mA(l, e) {
  return s(), d("svg", fA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 22a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M4 2.75c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25zM1.25 4A2.75 2.75 0 0 1 4 1.25h16A2.75 2.75 0 0 1 22.75 4v13A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.47 9.97a.75.75 0 0 1 1.06 0L11 11.44l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wA = { render: mA }, gA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bA(l, e) {
  return s(), d("svg", gA, e[0] || (e[0] = [
    n("path", { d: "M17 21.3H7c-.4 0-.8.3-.8.8s.3.8.8.8h10c.4 0 .8-.3.8-.8s-.4-.8-.8-.8m3-20.1H4C2.5 1.2 1.2 2.5 1.2 4v13c0 1.5 1.2 2.8 2.8 2.8h16c1.5 0 2.8-1.2 2.8-2.8V4c0-1.5-1.3-2.8-2.8-2.8M21.2 17c0 .7-.6 1.2-1.2 1.2H4c-.7 0-1.2-.6-1.2-1.2V4c0-.7.6-1.2 1.2-1.2h16c.7 0 1.2.6 1.2 1.2z" }, null, -1),
    n("path", { d: "m15.7 6.2-3.1-.8c-.4-.1-.9-.1-1.3 0l-3 .8c-.6.2-1 .7-1 1.3.2 7 4.4 8.2 4.6 8.2h.4c.2 0 4.4-1.2 4.6-8.2-.1-.6-.6-1.2-1.2-1.3m-3.7 8c-.7-.3-3.1-1.7-3.2-6.6l2.9-.7h.6l2.9.7c-.1 4.9-2.5 6.3-3.2 6.6" }, null, -1)
  ]));
}
const MA = { render: bA }, xA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yA(l, e) {
  return s(), d("svg", xA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 22a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M4 2.75c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25zM1.25 4A2.75 2.75 0 0 1 4 1.25h16A2.75 2.75 0 0 1 22.75 4v13A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a3.25 3.25 0 0 0-2.784 4.928l4.518-4.428A3.23 3.23 0 0 0 12 7.25m2.784 1.572-4.518 4.428a3.25 3.25 0 0 0 4.518-4.428M7.25 10.5a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const AA = { render: yA }, VA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function HA(l, e) {
  return s(), d("svg", VA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.25 22a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M4 2.75c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25zM1.25 4A2.75 2.75 0 0 1 4 1.25h16A2.75 2.75 0 0 1 22.75 4v13A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m.512 7.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const BA = { render: HA }, zA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function CA(l, e) {
  return s(), d("svg", zA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.47 10.47a.75.75 0 0 1 1.06 0L12 12.94l7.47-7.47a.75.75 0 1 1 1.06 1.06l-8 8a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75A7.25 7.25 0 1 0 19.25 12a.75.75 0 0 1 1.5 0 8.75 8.75 0 1 1-5.798-8.24.75.75 0 0 1-.506 1.413A7.2 7.2 0 0 0 12 4.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const LA = { render: CA }, SA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function EA(l, e) {
  return s(), d("svg", SA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.403 1.364a2.75 2.75 0 0 1 1.194 0l7.662 1.703a1.746 1.746 0 0 1 1.353 1.952l-1.87 13.087c-.045.32-.21 1.408-1.337 2.394-1.113.975-3.05 1.75-6.405 1.75s-5.292-.775-6.405-1.75c-1.126-.986-1.292-2.074-1.337-2.394L2.388 5.02A1.746 1.746 0 0 1 3.74 3.067zm.868 1.465a1.25 1.25 0 0 0-.542 0L4.067 4.53a.246.246 0 0 0-.194.276l1.87 13.095c.027.186.12.839.84 1.47.744.65 2.273 1.378 5.417 1.378s4.673-.727 5.417-1.379c.72-.63.813-1.283.84-1.47l1.87-13.095a.246.246 0 0 0-.194-.275z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const TA = { render: EA }, _A = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function RA(l, e) {
  return s(), d("svg", _A, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.403 1.364a2.75 2.75 0 0 1 1.194 0l7.662 1.703a1.746 1.746 0 0 1 1.353 1.952l-1.87 13.087c-.045.32-.21 1.408-1.337 2.394-1.113.975-3.05 1.75-6.405 1.75s-5.292-.775-6.405-1.75c-1.126-.986-1.292-2.074-1.337-2.394L2.388 5.02A1.746 1.746 0 0 1 3.74 3.067zm.868 1.465a1.25 1.25 0 0 0-.542 0L4.067 4.53a.246.246 0 0 0-.194.276l1.87 13.095c.027.186.12.839.84 1.47.744.65 2.273 1.378 5.417 1.378s4.673-.727 5.417-1.379c.72-.63.813-1.283.84-1.47l1.87-13.095a.246.246 0 0 0-.194-.275z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kA = { render: RA }, OA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $A(l, e) {
  return s(), d("svg", OA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m.512 9.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.403 1.364a2.75 2.75 0 0 1 1.194 0l7.662 1.703a1.746 1.746 0 0 1 1.353 1.952l-1.87 13.087c-.045.32-.21 1.408-1.337 2.394-1.113.975-3.05 1.75-6.405 1.75s-5.292-.775-6.405-1.75c-1.126-.986-1.292-2.074-1.337-2.394L2.388 5.02A1.746 1.746 0 0 1 3.74 3.067zm.868 1.465a1.25 1.25 0 0 0-.542 0L4.067 4.53a.246.246 0 0 0-.194.276l1.87 13.095c.027.186.12.839.84 1.47.744.65 2.273 1.378 5.417 1.378s4.673-.727 5.417-1.379c.72-.63.813-1.283.84-1.47l1.87-13.095a.246.246 0 0 0-.194-.275z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const NA = { render: $A }, FA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function DA(l, e) {
  return s(), d("svg", FA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M20 6.25a.75.75 0 0 1 .75.75v2.25H23a.75.75 0 0 1 0 1.5h-2.25V13a.75.75 0 0 1-1.5 0v-2.25H17a.75.75 0 0 1 0-1.5h2.25V7a.75.75 0 0 1 .75-.75m-12 6.5A6.25 6.25 0 0 0 1.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 15.5 0v1a.75.75 0 0 1-1.5 0v-1A6.25 6.25 0 0 0 8 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M3.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const IA = { render: DA }, jA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qA(l, e) {
  return s(), d("svg", jA, e[0] || (e[0] = [
    n("path", { d: "M7.8 16.35a.75.75 0 0 0 1.05-.15 4.874 4.874 0 0 1 7.8 0 .75.75 0 1 0 1.2-.9 6.36 6.36 0 0 0-2.569-2.033 3.75 3.75 0 1 0-5.057 0A6.36 6.36 0 0 0 7.65 15.3a.75.75 0 0 0 .15 1.05m2.7-5.85a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m9-8.25H6a1.5 1.5 0 0 0-1.5 1.5V6H3a.75.75 0 0 0 0 1.5h1.5v3.75H3a.75.75 0 1 0 0 1.5h1.5v3.75H3A.75.75 0 1 0 3 18h1.5v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5m0 18H6V3.75h13.5z" }, null, -1)
  ]));
}
const PA = { render: qA }, UA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ZA(l, e) {
  return s(), d("svg", UA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8.25 12a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m6 0a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75m-4.893 3.614a.75.75 0 0 1 1.029-.257c.369.222.932.393 1.614.393s1.245-.171 1.614-.393a.75.75 0 0 1 .772 1.286c-.631.379-1.468.607-2.386.607s-1.755-.228-2.386-.607a.75.75 0 0 1-.257-1.029",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.998 2.25H12c1.131 0 2.166.31 2.938.866.776.56 1.312 1.393 1.312 2.384 0 1.655-1.092 3.25-2.75 3.25-.514 0-1.036-.127-1.453-.392-.421-.269-.797-.729-.797-1.358a.75.75 0 0 1 1.5-.001l.003.006a.3.3 0 0 0 .1.087c.133.085.361.158.647.158.543 0 1.25-.605 1.25-1.75 0-.409-.214-.825-.688-1.166-.478-.344-1.193-.584-2.061-.584a8.25 8.25 0 0 0-8.066 6.6.75.75 0 0 1-.408.525 1.25 1.25 0 0 0 0 2.25.75.75 0 0 1 .406.518 8.25 8.25 0 0 0 16.134 0 .75.75 0 0 1 .406-.518 1.25 1.25 0 0 0 0-2.25.75.75 0 0 1-.41-.532 8.25 8.25 0 0 0-1.65-3.575.75.75 0 0 1 1.173-.936 9.75 9.75 0 0 1 1.879 3.887 2.75 2.75 0 0 1-.008 4.567 9.75 9.75 0 0 1-18.914 0 2.75 2.75 0 0 1-.004-4.57A9.75 9.75 0 0 1 12 2.25Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const WA = { render: ZA }, KA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function JA(l, e) {
  return s(), d("svg", KA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A4.25 4.25 0 0 0 7.75 17v1a.75.75 0 0 1-1.5 0v-1a5.75 5.75 0 0 1 11.5 0v1a.75.75 0 0 1-1.5 0v-1A4.25 4.25 0 0 0 12 12.75m-8 2A2.25 2.25 0 0 0 1.75 17v1a.75.75 0 0 1-1.5 0v-1A3.75 3.75 0 0 1 4 13.25zm16 0A2.25 2.25 0 0 1 22.25 17v1a.75.75 0 0 0 1.5 0v-1A3.75 3.75 0 0 0 20 13.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 9a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M4 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M1.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0M20 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M17.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const GA = { render: JA }, XA = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function YA(l, e) {
  return s(), d("svg", XA, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M16 3.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M14.25 4a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m5.274 7.463a.75.75 0 0 1 .218.643l-1 7a.75.75 0 0 1-1.485-.212l.856-5.986-4.99.832a.75.75 0 1 1-.246-1.48l6-1a.75.75 0 0 1 .647.204ZM7.47 4.47a.75.75 0 0 1 .89-.128l5.5 3a.75.75 0 0 1 .262 1.077l-2.36 3.5a.75.75 0 1 1-1.244-.838l1.9-2.817-4.284-2.337L5.53 8.53a.75.75 0 0 1-1.06-1.06zm-3.01 9.313a.75.75 0 0 1 .497.936 4.25 4.25 0 0 0 5.848 5.1.75.75 0 1 1 .63 1.362 5.75 5.75 0 0 1-7.912-6.9.75.75 0 0 1 .936-.498Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.565 10.82a5.75 5.75 0 0 1 7.912 6.9.75.75 0 1 1-1.434-.44 4.25 4.25 0 0 0-5.848-5.1.75.75 0 1 1-.63-1.36",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const QA = { render: YA }, eV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lV(l, e) {
  return s(), d("svg", eV, e[0] || (e[0] = [
    n("path", { d: "M3.277 11.861a.69.69 0 0 0 .97-.139 4.5 4.5 0 0 1 7.2 0 .692.692 0 0 0 1.107 0 4.5 4.5 0 0 1 7.2 0 .693.693 0 1 0 1.108-.831 5.9 5.9 0 0 0-2.37-1.876 3.462 3.462 0 1 0-4.669 0 5.8 5.8 0 0 0-1.817 1.238 5.8 5.8 0 0 0-1.818-1.238 3.462 3.462 0 1 0-4.668 0 5.9 5.9 0 0 0-2.382 1.877.693.693 0 0 0 .139.969m12.878-7.477a2.077 2.077 0 1 1 0 4.154 2.077 2.077 0 0 1 0-4.154m-8.309 0a2.077 2.077 0 1 1 0 4.154 2.077 2.077 0 0 1 0-4.154m10.645 13.631a3.462 3.462 0 1 0-4.668 0 5.8 5.8 0 0 0-1.817 1.239 5.8 5.8 0 0 0-1.818-1.239 3.462 3.462 0 1 0-4.668 0 5.9 5.9 0 0 0-2.382 1.877.693.693 0 0 0 1.108.831 4.5 4.5 0 0 1 7.2 0 .693.693 0 0 0 1.107 0 4.5 4.5 0 0 1 7.201 0 .693.693 0 0 0 1.108-.832 5.9 5.9 0 0 0-2.37-1.876Zm-10.645-4.63a2.077 2.077 0 1 1 0 4.154 2.077 2.077 0 0 1 0-4.155Zm8.309 0a2.077 2.077 0 1 1 0 4.154 2.077 2.077 0 0 1 0-4.155Z" }, null, -1)
  ]));
}
const tV = { render: lV }, nV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function aV(l, e) {
  return s(), d("svg", nV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.996 7.75a4.76 4.76 0 0 0-2.4.635.75.75 0 0 1-.748-1.3 6.26 6.26 0 0 1 3.154-.835c2.554 0 4.797 1.494 5.515 3.665a.75.75 0 0 1-1.424.47C15.607 8.917 14.005 7.75 12 7.75zM7.568 9.214a.75.75 0 0 1 .412.977c-.15.366-.23.76-.23 1.17v4.64a.75.75 0 0 1-1.5 0v-4.64c0-.61.12-1.194.34-1.736a.75.75 0 0 1 .978-.411m1.682 2.64c0-1.49 1.286-2.604 2.75-2.604s2.75 1.113 2.75 2.603V17a.75.75 0 0 1-1.5 0v-5.147c0-.556-.505-1.103-1.25-1.103s-1.25.547-1.25 1.103v.794a.75.75 0 0 1-1.5 0zm7.75.211a.75.75 0 0 1 .75.75V16a.75.75 0 0 1-1.5 0v-3.185a.75.75 0 0 1 .75-.75m-7 2.008a.75.75 0 0 1 .75.75V17a.75.75 0 0 1-1.5 0v-2.177a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75A9.25 9.25 0 0 0 2.75 12 9.25 9.25 0 0 0 12 21.25 9.25 9.25 0 0 0 21.25 12 9.25 9.25 0 0 0 12 2.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rV = { render: aV }, oV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iV(l, e) {
  return s(), d("svg", oV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "m11.5 4.839-8.323 4.16 8.323 4.162 8.323-4.16L11.5 4.838Zm-.603-1.376a1.35 1.35 0 0 1 1.206 0l8.66 4.33a1.351 1.351 0 0 1 0 2.415l-8.66 4.329a1.35 1.35 0 0 1-1.206 0l-8.66-4.33a1.352 1.352 0 0 1 0-2.415z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M19.83 8.165a.75.75 0 0 1 1.005-.336l2 1a.75.75 0 0 1 .415.67V13a.75.75 0 0 1-1.5 0V9.964l-1.585-.792a.75.75 0 0 1-.336-1.006ZM4.5 9.75a.75.75 0 0 1 .75.75v5.412a1.25 1.25 0 0 0 .714 1.13l5 2.373a1.25 1.25 0 0 0 1.072 0l5-2.374a1.25 1.25 0 0 0 .714-1.129V10.5a.75.75 0 0 1 1.5 0v5.412a2.75 2.75 0 0 1-1.57 2.484l-5 2.374a2.75 2.75 0 0 1-2.36 0l-5-2.374a2.75 2.75 0 0 1-1.57-2.484V10.5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sV = { render: iV }, dV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cV(l, e) {
  return s(), d("svg", dV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M8 12.75A6.25 6.25 0 0 0 1.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 15.5 0v1a.75.75 0 0 1-1.5 0v-1A6.25 6.25 0 0 0 8 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M18 9.75A4.25 4.25 0 0 0 13.75 14h-1.5a5.75 5.75 0 0 1 11.5 0v.5a.75.75 0 0 1-1.5 0V14A4.25 4.25 0 0 0 18 9.75m-10-5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M3.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M18 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14.25 6a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const uV = { render: cV }, vV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pV(l, e) {
  return s(), d("svg", vV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.75 2.25a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5zm-3 1.5a3 3 0 0 1 3-3h10.5a3 3 0 0 1 3 3v16.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 3.75A.75.75 0 0 1 9.75 3h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 9 3.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", { d: "M15.632 13.336a1.86 1.86 0 0 0-1.382-.586c-.544 0-1.036.207-1.385.583s-.525.896-.484 1.453c.08 1.1.918 1.995 1.869 1.995.95 0 1.788-.895 1.869-1.994a1.9 1.9 0 0 0-.487-1.45ZM17.423 21h-6.346a.565.565 0 0 1-.56-.437.6.6 0 0 1-.006-.27c.153-.823.627-1.515 1.374-2 .662-.43 1.502-.668 2.365-.668s1.703.237 2.365.668c.747.485 1.221 1.177 1.374 2a.61.61 0 0 1-.13.512.56.56 0 0 1-.436.195" }, null, -1)
  ]));
}
const hV = { render: pV }, fV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mV(l, e) {
  return s(), d("svg", fV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M6.744 16.724c.403.693.731 1.455.82 2.344q.004.037.004.075V22a.75.75 0 0 1-1.5 0v-2.817c-.065-.587-.286-1.13-.62-1.705-.248-.425-.533-.83-.847-1.277a48 48 0 0 1-.423-.608C3.228 14.203 2.25 12.51 2.25 10c0-2.43.727-4.646 2.252-6.252C6.035 2.135 8.295 1.22 11.19 1.251c2.094.022 4.176.63 5.752 1.894 1.549 1.243 2.564 3.086 2.623 5.49l2.068 3.248a.75.75 0 0 1 .117.403c0 .696-.168 1.268-.458 1.724-.289.453-.67.75-1.035.94a3.3 3.3 0 0 1-.672.26q-.001.135-.01.29a8.2 8.2 0 0 1-.386 2.166c-.268.801-.723 1.65-1.5 2.302-.64.536-1.46.905-2.485 1.025V22a.75.75 0 1 1-1.5 0v-1.714a.75.75 0 0 1 .75-.75c1.071 0 1.782-.307 2.272-.718.501-.42.83-1 1.04-1.627.21-.628.288-1.269.312-1.762a7 7 0 0 0-.006-.78v-.006a.75.75 0 0 1 .74-.821h.005l.039-.003a1.9 1.9 0 0 0 .705-.198c.181-.094.345-.227.465-.416.1-.156.19-.382.216-.713L18.186 9.26a.75.75 0 0 1-.118-.402c0-2.06-.824-3.548-2.064-4.543-1.26-1.01-2.997-1.545-4.83-1.564-2.56-.027-4.39.773-5.585 2.03-1.202 1.266-1.839 3.08-1.839 5.22 0 2.061.781 3.45 1.666 4.745q.181.264.373.536c.331.471.673.958.955 1.442m12.073-2.902",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11 8.75a1.25 1.25 0 1 0-.001 2.498A1.25 1.25 0 0 0 11 8.75M9.624 7.618a2.75 2.75 0 1 1 2.751 4.763 2.75 2.75 0 0 1-2.75-4.763Z",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M10.809 6.255a4 4 0 0 1 .382 0 .75.75 0 0 1-.075 1.498 2 2 0 0 0-.232 0 .75.75 0 0 1-.075-1.498m1.644 1.015a.75.75 0 0 1 1.06-.054q.143.129.27.271a.75.75 0 1 1-1.112 1.006 2 2 0 0 0-.164-.164.75.75 0 0 1-.054-1.059m-2.906 0a.75.75 0 0 1-.054 1.06 2 2 0 0 0-.164.163.75.75 0 1 1-1.113-1.006 4 4 0 0 1 .271-.27.75.75 0 0 1 1.06.053m4.411 1.827a.75.75 0 0 1 .787.712 4 4 0 0 1 0 .382.75.75 0 0 1-1.498-.075 2 2 0 0 0 0-.232.75.75 0 0 1 .711-.787m-5.916 0a.75.75 0 0 1 .71.787 2 2 0 0 0 0 .232.75.75 0 0 1-1.497.075 4 4 0 0 1 0-.382.75.75 0 0 1 .787-.712m5.688 2.356a.75.75 0 0 1 .054 1.06 4 4 0 0 1-.271.27.75.75 0 1 1-1.006-1.112q.086-.078.164-.164a.75.75 0 0 1 1.059-.054m-5.46 0a.75.75 0 0 1 1.06.054q.077.086.163.164a.75.75 0 0 1-1.006 1.113 4 4 0 0 1-.27-.271.75.75 0 0 1 .053-1.06m1.827 1.505a.75.75 0 0 1 .787-.71 2 2 0 0 0 .232 0 .75.75 0 0 1 .075 1.497 4 4 0 0 1-.382 0 .75.75 0 0 1-.712-.787",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wV = { render: mV }, gV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bV(l, e) {
  return s(), d("svg", gV, e[0] || (e[0] = [
    n("path", { d: "M16 2.2H8C4.8 2.2 2.2 4.8 2.2 8v8c0 3.2 2.6 5.8 5.8 5.8h8c3.2 0 5.8-2.6 5.8-5.8V8c0-3.2-2.6-5.8-5.8-5.8M20.2 16c0 2.3-1.9 4.2-4.2 4.2H8c-2.3 0-4.2-1.9-4.2-4.2V8c0-2.3 1.9-4.2 4.2-4.2h8c2.3 0 4.2 1.9 4.2 4.2z" }, null, -1),
    n("path", { d: "M15.9 14c-.1.1-1.3 1.7-3.9 1.7S8.2 14.1 8.1 14c-.2-.3-.7-.4-1.1-.1-.3.2-.4.7-.1 1 .1.1 1.8 2.4 5.1 2.4s5-2.2 5.1-2.3c.2-.3.2-.8-.1-1-.4-.3-.8-.3-1.1 0m-7.4-3.3a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m7 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4" }, null, -1)
  ]));
}
const MV = { render: bV }, xV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yV(l, e) {
  return s(), d("svg", xV, e[0] || (e[0] = [
    n("path", { d: "M20.4 18.7c1.5-1.8 2.4-4.2 2.4-6.7C22.8 6.1 18 1.2 12 1.2S1.2 6.1 1.2 12 6 22.8 12 22.8c3.4 0 6.4-1.6 8.4-4.1M12 2.7c5.1 0 9.2 4.1 9.2 9.2 0 1.9-.6 3.7-1.6 5.2-1.1-.9-3.5-2.5-7.6-2.5s-6.6 1.5-7.6 2.5c-1-1.5-1.6-3.3-1.6-5.2 0-5 4.1-9.2 9.2-9.2m0 18.6c-2.6 0-5-1.1-6.7-2.9.8-.7 2.9-2.1 6.7-2.1s5.9 1.4 6.7 2.1c-1.7 1.7-4.1 2.9-6.7 2.9" }, null, -1),
    n("path", { d: "M12 12.7c2.1 0 3.8-1.7 3.8-3.8S14.1 5.2 12 5.2 8.2 6.9 8.2 9s1.7 3.7 3.8 3.7m0-6c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2" }, null, -1)
  ]));
}
const AV = { render: yV }, VV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function HV(l, e) {
  return s(), d("svg", VV, e[0] || (e[0] = [
    n("g", {
      "fill-rule": "evenodd",
      "clip-path": "url(#7ec6ceae-57f9-4091-a792-bc7dbb79c9ad-4bb21094-7219-4c9d-b7f4-c1bfacc9ddf8-e8a9ac4c-e492-487d-b7f3-88fc1fb0b9e5-69a4edd0-05d3-4a13-b969-2632d23b2aa0-4bb0fa48-c712-4067-9221-eb5efa9c7e6e-13c05cb6-e78b-4d74-9592-b8b894c124ad-e0de4d-39030c57-ba1f-4ff9-b2c1-36b3ed4cb048-a5a2c608-3622-44b5-a951-57258d8bb9e9-[object Object]-a)",
      "clip-rule": "evenodd"
    }, [
      n("path", { d: "M18.091 7.348a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.59a.75.75 0 0 1 1.061 1.06L21.804 10l1.59 1.591a.75.75 0 0 1-1.06 1.06l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06L19.682 10l-1.591-1.591a.75.75 0 0 1 0-1.06ZM8 12.75A6.25 6.25 0 0 0 1.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 15.5 0v1a.75.75 0 0 1-1.5 0v-1A6.25 6.25 0 0 0 8 12.75" }),
      n("path", { d: "M8 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M3.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0" })
    ], -1)
  ]));
}
const BV = { render: HV }, zV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function CV(l, e) {
  return s(), d("svg", zV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A6.25 6.25 0 0 0 5.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 15.5 0v1a.75.75 0 0 1-1.5 0v-1A6.25 6.25 0 0 0 12 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const LV = { render: CV }, SV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function EV(l, e) {
  return s(), d("svg", SV, e[0] || (e[0] = [
    n("path", { d: "M19.7 21.8h-3.4c-.4 0-.8-.1-1.1-.2-.4-.2-.7-.4-.9-.7-.3-.3-.5-.7-.6-1-.1-.4-.1-.8-.1-1.2l.3-2c.1-.7.4-1.2.9-1.7s1.1-.7 1.8-.7h2.8c.7 0 1.3.2 1.8.7s.8 1 .9 1.7l.3 2c.1.4 0 .8-.1 1.2s-.3.7-.6 1-.6.5-.9.7c-.3.1-.7.2-1.1.2m-3.1-6c-.3 0-.6.1-.8.3s-.4.5-.4.8l-.3 2v.5c.1.2.1.3.3.5.1.1.3.2.4.3.2.1.3.1.5.1h3.4c.2 0 .4 0 .5-.1.2-.1.3-.2.4-.3s.2-.3.3-.5c0-.2.1-.4 0-.5l-.3-2c0-.3-.2-.6-.4-.8s-.5-.3-.8-.3zM2 18.8c-.4 0-.8-.3-.8-.8 0-1.5.4-2.9 1.2-4.1s1.9-2.2 3.2-2.9c.2-.1.3-.2.5-.2-.2-.1-.3-.3-.5-.4-.9-.9-1.4-2.1-1.4-3.4s.5-2.5 1.4-3.4S7.7 2.2 9 2.2s2.5.5 3.4 1.4 1.4 2.1 1.4 3.4-.5 2.5-1.4 3.4c-.2.2-.3.3-.5.4.7.3 1.3.6 1.9 1.1.3.3.4.7.1 1.1-.3.3-.7.4-1.1.1-.9-.7-2-1.2-3.2-1.3h-.7c-.9 0-1.9.2-2.7.6-1.1.5-1.9 1.3-2.6 2.3-.6 1-1 2.1-1 3.3.2.4-.2.8-.6.8m7-8.6c.9 0 1.7-.3 2.3-1 .6-.6 1-1.4 1-2.3s-.3-1.7-1-2.3c-1.2-1.2-3.4-1.2-4.6 0-.6.6-1 1.4-1 2.3s.3 1.7 1 2.3c.6.7 1.4 1 2.3 1m10 3.6h-2c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h2c.4 0 .8.3.8.8s-.4.8-.8.8" }, null, -1)
  ]));
}
const TV = { render: EV }, _V = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function RV(l, e) {
  return s(), d("svg", _V, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M5.641 3.641a4.75 4.75 0 1 1 6.215 7.155 7.7 7.7 0 0 1 1.938 1.115.75.75 0 1 1-.928 1.178A6.25 6.25 0 0 0 2.75 18a.75.75 0 0 1-1.5 0 7.75 7.75 0 0 1 4.894-7.204 4.75 4.75 0 0 1-.503-7.154ZM9 3.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m13.237 8.039a.75.75 0 0 1 .475.948l-.834 2.5-1.166 3.5a.75.75 0 0 1-.712.513h-4.5a.75.75 0 0 1-.721-.544l-1-3.5a.75.75 0 0 1 .721-.956h6.126l.662-1.987a.75.75 0 0 1 .95-.474Zm-2.11 3.961h-4.633l.572 2h3.393zm-3.112 4.194a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.11-1.008l.01-.012a.75.75 0 0 1 1.06-.05m3 0a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.11-1.008l.01-.012a.75.75 0 0 1 1.06-.05",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kV = { render: RV }, OV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $V(l, e) {
  return s(), d("svg", OV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A4.25 4.25 0 0 0 7.75 17v1a.75.75 0 0 1-1.5 0v-1a5.75 5.75 0 0 1 11.5 0v1a.75.75 0 0 1-1.5 0v-1A4.25 4.25 0 0 0 12 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 9a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const NV = { render: $V }, FV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function DV(l, e) {
  return s(), d("svg", FV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A6.25 6.25 0 0 0 5.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 11.072-7.004.75.75 0 1 1-.644 1.355A6.2 6.2 0 0 0 12 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M11.558 15.394a.75.75 0 0 0-.298.73l1 6a.75.75 0 0 0 .74.626h8a.75.75 0 0 0 .74-.627l1-6a.75.75 0 0 0-1.083-.79l-2.965 1.525-1.116-1.338a.75.75 0 0 0-1.152 0l-1.115 1.338-2.966-1.525a.75.75 0 0 0-.785.061m1.427 1.956 2.172 1.117a.75.75 0 0 0 .92-.187L17 17.172l.924 1.108a.75.75 0 0 0 .919.187l2.172-1.117-.65 3.9h-6.73z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const IV = { render: DV }, jV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qV(l, e) {
  return s(), d("svg", jV, e[0] || (e[0] = [
    n("path", { d: "M21.9 15.1c-1-1-2.7-1.2-3.9-.4-1.2-.8-2.9-.7-3.9.4-1.2 1.2-1.2 3.1 0 4.3l2.9 2.9c.3.3.6.4 1 .4.3 0 .7-.1.9-.4.7-.7 1.4-1.3 2-2 .3-.3.6-.6.9-1q.9-.9.9-2.1c0-1.2-.3-1.5-.8-2.1m-1.1 3.3c-.3.3-.6.7-1 1-.6.6-1.2 1.3-1.8 1.9l-2.8-2.8c-.6-.6-.6-1.6 0-2.2.3-.3.7-.5 1.1-.5s.8.2 1.1.5l.1.1c.1.1.4.2.5.2.2 0 .4-.1.5-.2l.1-.1c.6-.6 1.6-.6 2.2 0 .3.3.4.7.4 1.1s-.1.7-.4 1M15.7 13c.2-.4 0-.8-.4-1-.2-.1-.3-.1-.5-.2 1.2-.9 1.9-2.2 1.9-3.8 0-2.6-2.1-4.8-4.8-4.8S7.2 5.4 7.2 8c0 1.6.8 2.9 1.9 3.8-2.9 1.1-4.9 3.9-4.9 7.2v1c0 .4.3.8.8.8s.8-.3.8-.8v-1c0-3.4 2.8-6.3 6.2-6.3q1.35 0 2.7.6c.4.2.8.1 1-.3M8.8 8c0-1.8 1.5-3.2 3.2-3.2s3.2 1.5 3.2 3.2-1.5 3.2-3.2 3.2S8.8 9.8 8.8 8" }, null, -1)
  ]));
}
const PV = { render: qV }, UV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ZV(l, e) {
  return s(), d("svg", UV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M2.25 3A.75.75 0 0 1 3 2.25h3a.75.75 0 0 1 0 1.5H3.75V6a.75.75 0 0 1-1.5 0zm15 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V3.75H18a.75.75 0 0 1-.75-.75M9.348 6.348a3.75 3.75 0 1 1 5.132 5.465A5.75 5.75 0 0 1 17.75 17v1a.75.75 0 0 1-1.5 0v-1a4.25 4.25 0 0 0-8.5 0v1a.75.75 0 0 1-1.5 0v-1a5.75 5.75 0 0 1 3.27-5.188 3.75 3.75 0 0 1-.171-5.464ZM12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-9 10.5a.75.75 0 0 1 .75.75v2.25H6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .75-.75m18 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V18a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const WV = { render: ZV }, KV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function JV(l, e) {
  return s(), d("svg", KV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A4.25 4.25 0 0 0 7.75 17v1a.75.75 0 0 1-1.5 0v-1a5.75 5.75 0 0 1 11.5 0v1a.75.75 0 0 1-1.5 0v-1A4.25 4.25 0 0 0 12 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 9a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M20.25 20.25V3.75H3.75v16.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V3.6c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const GV = { render: JV }, XV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function YV(l, e) {
  return s(), d("svg", XV, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A6.25 6.25 0 0 0 5.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 11.072-7.004.75.75 0 1 1-.644 1.355A6.2 6.2 0 0 0 12 12.75m6 2.529-.687 1.456a.75.75 0 0 1-.565.422l-1.605.245 1.184 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.184-1.206-1.605-.245a.75.75 0 0 1-.565-.422zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916l-1.415 1.442.335 2.046c.14.849-.744 1.666-1.629 1.18L18 21.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const QV = { render: YV }, eH = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lH(l, e) {
  return s(), d("svg", eH, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      d: "M9 12.75A6.25 6.25 0 0 0 2.75 19v1a.75.75 0 0 1-1.5 0v-1A7.75 7.75 0 0 1 9 11.25zm6.25-.941a2.37 2.37 0 0 1 3.5 0 .87.87 0 0 0 .683.282 2.37 2.37 0 0 1 2.476 2.476.87.87 0 0 0 .283.682 2.37 2.37 0 0 1 0 3.502.87.87 0 0 0-.283.682 2.37 2.37 0 0 1-2.476 2.476.87.87 0 0 0-.682.282 2.37 2.37 0 0 1-3.502 0 .87.87 0 0 0-.682-.282 2.37 2.37 0 0 1-2.476-2.476.87.87 0 0 0-.282-.682 2.37 2.37 0 0 1 0-3.502.87.87 0 0 0 .282-.682 2.37 2.37 0 0 1 2.476-2.476.87.87 0 0 0 .682-.282Zm2.392 1.01a.87.87 0 0 0-1.284 0 2.37 2.37 0 0 1-1.86.77.87.87 0 0 0-.909.908 2.37 2.37 0 0 1-.77 1.861.87.87 0 0 0 0 1.284 2.37 2.37 0 0 1 .77 1.86.87.87 0 0 0 .908.909 2.37 2.37 0 0 1 1.861.77.87.87 0 0 0 1.284 0 2.37 2.37 0 0 1 1.861-.77.87.87 0 0 0 .908-.908 2.37 2.37 0 0 1 .77-1.861.87.87 0 0 0 0-1.284 2.37 2.37 0 0 1-.77-1.861.87.87 0 0 0-.908-.908 2.37 2.37 0 0 1-1.861-.77",
      "clip-rule": "evenodd"
    }, null, -1),
    n("path", {
      "fill-rule": "evenodd",
      d: "M14.833 16.47a.75.75 0 0 1 1.061 0l.56.56 1.652-1.651a.75.75 0 0 1 1.06 1.06l-2.181 2.182a.75.75 0 0 1-1.06 0l-1.092-1.09a.75.75 0 0 1 0-1.061M9 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M4.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tH = { render: lH }, nH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function aH(l, e) {
  return s(), d("svg", nH, e[0] || (e[0] = [
    n("path", {
      fill: "#F93939",
      d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
    }, null, -1),
    n("path", {
      fill: "#FBFBFB",
      d: "M18 10h-4V6h-4v4H6v4h4v4h4v-4h4z"
    }, null, -1)
  ]));
}
const rH = { render: aH }, oH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function iH(l, e) {
  return s(), d("svg", oH, e[0] || (e[0] = [
    n("rect", {
      width: "24",
      height: "17.143",
      y: "3.428",
      fill: "#F93939",
      rx: "1.866"
    }, null, -1),
    n("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M10.286 10.286H6.857v3.428h3.429v3.429h3.428v-3.429h3.429v-3.428h-3.429V6.857h-3.428z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const sH = { render: iH }, dH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function cH(l, e) {
  return s(), d("svg", dH, e[0] || (e[0] = [
    h5('<g clip-path="url(#1f09d43e-ee04-4c80-972b-59266e4f8648-a)"><path fill="#1A47B8" d="M0 0h8v24H0z"></path><path fill="#fff" d="M8 0h8v24H8z"></path><path fill="#F93939" d="M16 0h8v24h-8z"></path></g><defs><clipPath id="1f09d43e-ee04-4c80-972b-59266e4f8648-a"><rect width="24" height="24" fill="#fff" rx="12"></rect></clipPath></defs>', 2)
  ]));
}
const uH = { render: cH }, vH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function pH(l, e) {
  return s(), d("svg", vH, e[0] || (e[0] = [
    h5('<g clip-path="url(#a6e2b93f-98a1-40b5-a678-a5eb8d13cec4-a)"><rect width="24" height="17.143" y="3.429" fill="#fff" rx="1.866"></rect><path fill="#F93939" fill-rule="evenodd" d="M16 3.429h8v17.143h-8z" clip-rule="evenodd"></path><path fill="#1A47B8" fill-rule="evenodd" d="M0 3.429h8v17.143H0z" clip-rule="evenodd"></path></g><defs><clipPath id="a6e2b93f-98a1-40b5-a678-a5eb8d13cec4-a"><rect width="24" height="17.143" y="3.429" fill="#fff" rx="1.866"></rect></clipPath></defs>', 2)
  ]));
}
const hH = { render: pH }, fH = {
  audition: xa,
  dentaire: Va,
  "frais-de-sante": za,
  hospitalisation: Sa,
  maternite: _a,
  "medecine-douce": Oa,
  medicaments: Fa,
  optique: ja,
  "soins-courants": Ua,
  surcomplementaire: Ka
}, mH = {
  "age1-circle": e4,
  age1: Xa,
  "age2-circle": o4,
  age2: n4,
  "collectif-circle": v4,
  collectif: d4,
  "emprunteur-circle": g4,
  emprunteur: f4,
  "epargne-retraite-circle": V4,
  "epargne-retraite": x4,
  "financements-circle": S4,
  financements: z4,
  "frontaliers-expatries-circle": O4,
  "frontaliers-expatries": _4,
  "iard-circle": j4,
  iard: F4,
  "independants-circle": K4,
  independants: U4,
  "particuliers-circle": e6,
  particuliers: X4,
  "prevoyance-circle": o6,
  prevoyance: n6,
  "salaries-circle": v6,
  salaries: d6,
  "sante-circle": g6,
  sante: f6
}, wH = {
  ...fH,
  ...mH
}, gH = {
  "add-circle": x6,
  "add-media-image": V6,
  brightness: z6,
  calendar: S6,
  cancel: _6,
  "check-circle": F6,
  check: O6,
  "clipboard-check": j6,
  combine: U6,
  "copy-plus": X6,
  copy: K6,
  "delete-circle": er,
  "design-nib": nr,
  "double-check": or,
  "download-circle": vr,
  download: dr,
  "edit-pencil": fr,
  erase: gr,
  "eye-alt": xr,
  "eye-close": Vr,
  "eye-empty": zr,
  "eye-off": Sr,
  "help-circle": _r,
  "hourglass-outline": Or,
  "info-empty": Fr,
  "line-space": jr,
  "load-action-floppy": Ur,
  medal: Kr,
  "media-image": Xr,
  "menu-scale": no,
  menu: eo,
  "minus-circle": co,
  minus: oo,
  "open-in-browser": po,
  "open-in-window": mo,
  "open-new-window": bo,
  "paste-clipboard": yo,
  plus: Ho,
  prohibition: Co,
  "question-mark": Eo,
  "radio-button-off": Ro,
  "radio-button-on": $o,
  "redo-action": qo,
  "redo-circle": Zo,
  redo: Do,
  "refresh-circular": Yo,
  "refresh-double": li,
  refresh: Jo,
  restart: ai,
  "save-action-floppy": ii,
  settings: ci,
  "share-android": pi,
  "share-ios": mi,
  "switch-off": bi,
  "switch-on": yi,
  trash: Hi,
  "undo-action": Ei,
  "undo-circle": Ri,
  undo: Ci,
  upload: $i,
  "warning-circle": Di,
  "warning-triangle": qi,
  "wrap-text": Zi
}, bH = {
  "control-slider": Ji,
  "dashboard-speed": l8,
  dashboard: Yi,
  "graph-down": a8,
  "graph-up": i8,
  "percentage-circle": p8,
  "percentage-square": m8,
  percentage: c8,
  "report-columns": b8,
  reports: y8,
  "stat-down": H8,
  "stat-up": C8,
  "stats-down-square": E8,
  "stats-report": R8,
  "stats-up-square": $8
}, MH = {
  "arrow-email-forward": D8,
  "at-sign": q8,
  "bell-off": J8,
  bell: Z8,
  "chat-add": Y8,
  "chat-bubble-check": as,
  "chat-bubble-empty": is,
  "chat-bubble-error": cs,
  "chat-bubble-question": ps,
  "chat-bubble-translate": ms,
  "chat-bubble-warning": bs,
  "chat-bubble": ls,
  "chat-lines": ys,
  "chat-remove": Hs,
  facetime: Cs,
  "forward-message": Es,
  globe: Rs,
  "headset-help": $s,
  internet: Ds,
  "mail-in": Zs,
  "mail-opened": Js,
  "mail-out": Ys,
  mail: qs,
  "message-alert": ad,
  "message-text": id,
  message: ld,
  "multi-bubble": cd,
  phone: pd,
  "quote-message": bd,
  quote: md,
  "reply-to-message": Hd,
  reply: yd,
  "send-diagonal": Ed,
  "send-mail": Rd,
  send: Cd,
  "sound-high": $d,
  "time-zone": Dd,
  video: qd,
  www: Zd
}, xH = {
  airplay: Jd,
  "antenna-off": lc,
  "antenna-signal-tag": ic,
  "antenna-signal": ac,
  antenna: Yd,
  "bluetooth-tag": pc,
  bluetooth: cc,
  "cable-tag": mc,
  "data-transfer-both": bc,
  "data-transfer-check": yc,
  "data-transfer-down": Hc,
  "data-transfer-up": Cc,
  "data-transfer-warning": Ec,
  "network-alt": $c,
  "network-left": Dc,
  "network-right": qc,
  network: Rc,
  "plug-type-a": Zc,
  "plug-type-c": Jc,
  "plug-type-g": Yc,
  "plug-type-l": lu,
  "private-wifi": au,
  "server-connection": cu,
  server: iu,
  "smartphone-device": pu,
  usb: mu,
  "wifi-error": yu,
  wifi: bu,
  "wifi-issue": Hu,
  "wifi-off": Cu,
  "wifi-signal-none": Eu,
  "wifi-tag": Ru
}, yH = {
  ch: rH,
  "ch-square": sH,
  "fr-square": hH,
  fr: uH
}, AH = {
  "add-database-script": $u,
  "cloud-book-alt": Du,
  "cloud-check": qu,
  "cloud-desync": Zu,
  "cloud-download": Ju,
  "cloud-error": Yu,
  "cloud-sync": l9,
  "cloud-upload": a9,
  "database-backup": i9,
  "database-export": c9,
  "database-restore": p9,
  "database-script": m9,
  "db-check": y9,
  "db-error": H9,
  "db-warning": C9,
  db: b9,
  "remove-database-script": E9
}, VH = {
  "add-folder": R9,
  "add-page-alt": D9,
  "add-page": $9,
  archive: q9,
  attachment: Z9,
  "doc-magnifying-glass-in": Y9,
  "doc-magnifying-glass": J9,
  "doc-star-alt": av,
  "doc-star": lv,
  "download-page-alt": cv,
  "download-page": iv,
  "empty-page": pv,
  "folder-alert": bv,
  "folder-settings": yv,
  folder: mv,
  "google-docs": Hv,
  "journal-page": Ev,
  journal: Cv,
  "list-select": Rv,
  "multiple-pages-add": Dv,
  "multiple-pages-delete": qv,
  "multiple-pages-empty": Zv,
  "multiple-pages-remove": Jv,
  "multiple-pages": $v,
  "page-csv": lp,
  "page-doc": ap,
  "page-edit": ip,
  "page-pdf": cp,
  "page-search": pp,
  "page-star": mp,
  "page-xls": bp,
  page: Yv,
  "privacy-policy": yp,
  "remove-folder": Hp,
  "remove-page-alt": Ep,
  "remove-page": Cp,
  "submit-document": Rp
}, HH = {
  donate: $p,
  female: Dp,
  "health-shield": qp,
  healthcare: Zp,
  heart: Jp,
  "home-hospital": Yp,
  "hospital-sign": ah,
  hospital: lh,
  male: ih,
  "non-binary": ch,
  "pharmacie-cross-square": ph,
  "pharmacy-cross-circle": mh,
  "plaster-2": bh,
  stroller: yh,
  tree: Hh,
  "weight-alt": Eh,
  weight: Ch
}, BH = {
  "box-iso": Rh,
  buildings: $h,
  "domotic-issue": Dh,
  "home-alt-slim-horiz": Yh,
  "home-alt-slim": Jh,
  "home-alt": Zh,
  "home-shield": lf,
  "home-simple-door": sf,
  "home-simple": af,
  "home-user": uf,
  home: qh,
  "light-bulb-off": wf,
  "light-bulb-on": Mf,
  "light-bulb": hf,
  shop: Af,
  "sign-in": Bf,
  "sign-out": Lf
}, zH = {
  "add-pin-alt": Tf,
  "map-issue": Nf,
  map: kf,
  "maps-arrow-diagonal": Pf,
  "maps-arrow-issue": Wf,
  "maps-arrow": If,
  "minus-pin-alt": Gf,
  "pin-alt": Qf,
  "remove-pin-alt": tm
}, CH = {
  "arrow-bl-circle": sm,
  "arrow-bl": rm,
  "arrow-br-circle": hm,
  "arrow-br": um,
  "arrow-down-circle": Mm,
  "arrow-down": wm,
  "arrow-left-circle": Bm,
  "arrow-left": Am,
  "arrow-right-circle": Tm,
  "arrow-right": Lm,
  "arrow-separate-vertical": Nm,
  "arrow-separate": km,
  "arrow-tl-circle": Pm,
  "arrow-tl": Im,
  "arrow-tr-circle": Gm,
  "arrow-tr": Wm,
  "arrow-union-vertical": tw,
  "arrow-union": Qm,
  "arrow-up-circle": sw,
  "arrow-up": rw,
  drag: uw,
  "fast-arrow-down": hw,
  "fast-arrow-left": ww,
  "fast-arrow-right": Mw,
  "fast-arrow-up": Aw,
  "filter-list-circle": Lw,
  "filter-list": Bw,
  "long-arrow-down-right": Tw,
  "more-horiz-circle": Nw,
  "more-horiz": kw,
  "more-vert-circle": Pw,
  "more-vert": Iw,
  "nav-arrow-down": Ww,
  "nav-arrow-left": Gw,
  "nav-arrow-right": Qw,
  "nav-arrow-up": tg,
  "page-down": rg,
  "page-left": sg,
  "page-right": ug,
  "page-up": hg,
  "path-arrow": wg,
  "vertical-merge": Mg,
  "vertical-split": Ag
}, LH = {
  binocular: Bg,
  "birthday-cake": Lg,
  "bookmark-circle": Tg,
  "bookmark-empty": kg,
  diamond: Ng,
  "filter-alt": Pg,
  filter: Ig,
  glasses: Wg,
  "hand-coins": Gg,
  handshake: Qg,
  label: tb,
  "medal-star": rb,
  pin: sb,
  "receipt-text": ub,
  "remove-pin": hb,
  rocket: wb,
  search: Mb,
  "settings-profiles": Ab,
  "star-dashed": Lb,
  star: Bb,
  "star-half-dashed": Tb,
  "three-stars": kb,
  "zoom-in": Nb,
  "zoom-out": Ib
}, SH = {
  activity: Pb,
  "add-selection": Wb,
  alarm: Gb,
  "battery-indicator": Qb,
  "bright-crown": tM,
  calculator: rM,
  clock: sM,
  coins: uM,
  compress: hM,
  "credit-card": wM,
  "dash-flag": MM,
  "de-compress": AM,
  dialpad: BM,
  "divide-selection-1": LM,
  "divide-selection-2": TM,
  euro: kM,
  "file-not-found": NM,
  flash: IM,
  gas: PM,
  gift: WM,
  "half-moon": GM,
  hammer: QM,
  import: tx,
  language: rx,
  lifebelt: sx,
  link: ux,
  maximize: hx,
  "no-link": wx,
  notes: Mx,
  "page-flip": Ax,
  "qr-code": Bx,
  "remove-link": Lx,
  "remove-selection": Tx,
  rings: kx,
  "scan-qr-code": Nx,
  selection: Ix,
  smoking: Px,
  soap: Wx,
  "suite-case": Gx,
  teach: Qx,
  "timer-off": ry,
  "timer-outline": sy,
  timer: ty,
  tools: uy,
  translate: hy,
  "triangle-flag-circle": My,
  "triangle-flag-two-stripes": Ay,
  "triangle-flag": wy,
  "umbrella-outline": By,
  "union-alt": Ly,
  walet: Ty,
  "white-flag": ky
}, EH = {
  "historic-shield": Ny,
  "key-alt-back": Py,
  "key-alt-minus": Wy,
  "key-alt-plus": Gy,
  "key-alt-remove": Qy,
  "key-alt": Iy,
  lock: tA,
  "no-lock": rA,
  "password-cursor": sA,
  "password-error": uA,
  "password-pass": hA,
  "pc-check": wA,
  "pc-firewall": MA,
  "pc-no-entry": AA,
  "pc-warning": BA,
  "security-pass": LA,
  "shield-add": kA,
  "shield-alert": NA,
  shield: TA
}, TH = {
  "add-user": IA,
  "address-book": PA,
  baby: WA,
  community: GA,
  disability: QA,
  family: tV,
  "fingerprint-circle": rV,
  "graduation-cap": sV,
  group: uV,
  "id-card": hV,
  learning: wV,
  "people-tag": MV,
  "profile-circle": AV,
  "remove-user": BV,
  "user-bag": TV,
  "user-cart": kV,
  "user-circle": NV,
  "user-crown": IV,
  "user-love": PV,
  "user-scan": WV,
  "user-square": GV,
  "user-star": QV,
  user: LV,
  "verified-user": tH
}, _H = {
  ...gH,
  ...bH,
  ...MH,
  ...xH,
  ...yH,
  ...AH,
  ...VH,
  ...HH,
  ...BH,
  ...zH,
  ...CH,
  ...LH,
  ...SH,
  ...EH,
  ...TH
}, RH = {
  ...wH,
  ..._H
}, U7 = 9, kH = /* @__PURE__ */ q({
  __name: "TotemBadge",
  props: {
    value: {}
  },
  setup(l) {
    const e = l, t = k(() => {
      if (!(!e.value || e.value < 0))
        return e.value <= U7 ? e.value.toString() : `+${U7}`;
    });
    return (a, r) => (B(), R("span", {
      class: Y(["totem-badge", {
        "totem-badge--no-value": !t.value
      }]),
      "data-test": "value"
    }, [
      t.value ? (B(), R(p5, { key: 0 }, [
        a5(Q(t.value), 1)
      ], 64)) : $("", !0)
    ], 2));
  }
}), OH = {
  key: 0,
  class: "totem-icon totem-icon--with-badge"
}, g5 = /* @__PURE__ */ q({
  __name: "TotemIcon",
  props: {
    name: {},
    badge: { type: Boolean },
    badgeValue: {},
    rotation: {}
  },
  setup(l) {
    const e = l, t = k(() => RH[e.name]), a = k(() => [
      "totem-icon__icon",
      {
        "totem-icon__icon--with-rotation": e.rotation !== void 0
      }
    ]), r = k(() => {
      const o = {};
      return e.rotation && (o["--totem-icon--rotation-degree"] = `${e.rotation}deg`), o;
    });
    return (o, i) => o.badge ? (B(), R("span", OH, [
      X(_(t), {
        class: Y(a.value),
        style: F5(r.value)
      }, null, 8, ["class", "style"]),
      o.badge ? (B(), F(kH, {
        key: 0,
        value: o.badgeValue,
        "data-test": "badge",
        class: "totem-icon__badge"
      }, null, 8, ["value"])) : $("", !0)
    ])) : (B(), F(_(t), {
      key: 1,
      class: Y(["totem-icon", a.value]),
      style: F5(r.value)
    }, null, 8, ["class", "style"]));
  }
}), l5 = [];
for (let l = 0; l < 256; ++l)
  l5.push((l + 256).toString(16).slice(1));
function $H(l, e = 0) {
  return (l5[l[e + 0]] + l5[l[e + 1]] + l5[l[e + 2]] + l5[l[e + 3]] + "-" + l5[l[e + 4]] + l5[l[e + 5]] + "-" + l5[l[e + 6]] + l5[l[e + 7]] + "-" + l5[l[e + 8]] + l5[l[e + 9]] + "-" + l5[l[e + 10]] + l5[l[e + 11]] + l5[l[e + 12]] + l5[l[e + 13]] + l5[l[e + 14]] + l5[l[e + 15]]).toLowerCase();
}
let y0;
const NH = new Uint8Array(16);
function FH() {
  if (!y0) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    y0 = crypto.getRandomValues.bind(crypto);
  }
  return y0(NH);
}
const DH = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Z7 = { randomUUID: DH };
function V7(l, e, t) {
  var a;
  if (Z7.randomUUID && !l)
    return Z7.randomUUID();
  l = l || {};
  const r = l.random ?? ((a = l.rng) == null ? void 0 : a.call(l)) ?? FH();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, $H(r);
}
const A0 = 1e3;
function W7(l, e) {
  return `${l.toLocaleString("fr-FR")} ${e}`;
}
function IH(l, e = 1) {
  if (Math.abs(l) < A0)
    return W7(l, "o");
  const t = ["ko", "Mo", "Go", "To", "Po", "Eo", "Zo", "Yo"];
  let a = l, r = -1;
  const o = 10 ** e;
  do
    a /= A0, r += 1;
  while (Math.round(Math.abs(a) * o) / o >= A0 && r < t.length - 1);
  return W7(parseFloat(a.toFixed(e)), t[r]);
}
function jH(l) {
  if (!(!l || !l.length))
    return Array.from(l);
}
function qH(l, e, t, a, r) {
  const o = k(() => s5(t) === !0), i = k(() => s5(e) === "file");
  return {
    isTypeFile: i,
    onStartUploadingFiles: () => {
      if (!o.value && i.value) {
        const c = s5(l);
        c && c.click();
      }
    },
    onUpdateUploadedFiles: (c) => {
      !o.value && i.value && c.target && (a.value = jH(c.target.files));
    },
    onRemoveFile: (c) => {
      !o.value && i.value && a.value && (a.value = a.value.filter((v) => v !== c), r.value = "");
    },
    onRemoveAllFiles: () => {
      !o.value && i.value && a.value && (a.value = [], r.value = "");
    }
  };
}
const vl = (l) => {
  const e = I(!1), t = (u = !0) => {
    e.value = u;
  }, a = () => {
    t(!0);
  }, r = () => {
    t(!1);
  }, o = I(), i = (u) => {
    u.addEventListener("focus", a), u.addEventListener("blur", r), o.value = !0;
  }, c = (u) => {
    u.removeEventListener("focus", a), u.removeEventListener("blur", r), o.value = !1;
  }, v = () => {
    var u;
    (u = l.value) == null || u.focus();
  };
  return r5(
    l,
    (u, h) => {
      h && c(h), u && !o.value && i(u);
    },
    { immediate: !0 }
  ), G1(() => {
    l.value && c(l.value);
  }), { isFocused: e, triggerFocus: v };
}, PH = /* @__PURE__ */ q({
  __name: "TotemClickableElement",
  props: {
    disabled: { type: Boolean },
    href: { default: () => {
    } },
    label: {},
    target: { default: "_self" },
    to: { default: () => {
    } },
    type: { default: "button" }
  },
  setup(l) {
    const e = k(() => l.to ? l.disabled ? "a" : "RouterLink" : l.href ? "a" : "button"), t = k(() => {
      const a = {};
      return e.value === "a" ? l.disabled || (a.href = l.href) : e.value === "RouterLink" ? a.to = l.to : e.value === "button" && (a.type = l.type, l.disabled && (a.disabled = l.disabled)), (e.value === "a" || e.value === "RouterLink") && l.target !== "_self" && (a.target = l.target), a;
    });
    return (a, r) => (B(), F(S5(e.value), X1(t.value, { class: "totem-clickable-element" }), {
      default: T(() => [
        L(a.$slots, "default", {}, () => [
          a5(Q(a.label), 1)
        ])
      ]),
      _: 3
    }, 16));
  }
}), UH = {}, ZH = { class: "totem-loader" };
function WH(l, e) {
  return B(), R("span", ZH);
}
const KH = /* @__PURE__ */ Ln(UH, [["render", WH]]), JH = ["hidden"], GH = ["hidden"], q1 = /* @__PURE__ */ q({
  __name: "TotemButtonIcon",
  props: {
    color: { default: "primary" },
    size: { default: "m" },
    loading: { type: Boolean },
    iconName: {},
    iconRotation: {},
    disabled: { type: Boolean },
    href: {},
    target: { default: "_self" },
    to: {},
    type: { default: "button" }
  },
  setup(l) {
    return (e, t) => (B(), F(PH, {
      disabled: e.disabled,
      href: e.href,
      target: e.target,
      to: e.to,
      type: e.type,
      class: Y(["totem-button-icon", {
        [`totem-button-icon--color-${e.color}`]: e.color,
        [`totem-button-icon--size-${e.size}`]: e.size,
        "totem-button-icon--disabled": e.disabled,
        "totem-button-icon--loading": e.loading
      }])
    }, {
      default: T(() => [
        U("span", {
          hidden: e.loading,
          class: "totem-button-icon__layer totem-button-icon__layer--body",
          "data-test": "body"
        }, [
          L(e.$slots, "default", {}, () => [
            e.iconName ? (B(), F(g5, {
              key: 0,
              name: e.iconName,
              rotation: e.iconRotation,
              class: "totem-button-icon__icon"
            }, null, 8, ["name", "rotation"])) : $("", !0)
          ])
        ], 8, JH),
        X(d7, { name: "totem-button-icon__layer-" }, {
          default: T(() => [
            e.$slots.loading || e.loading ? (B(), R("span", {
              key: 0,
              hidden: !e.loading,
              class: "totem-button-icon__layer totem-button-icon__layer--loader",
              "data-test": "loading"
            }, [
              L(e.$slots, "loading", {}, () => [
                X(KH)
              ])
            ], 8, GH)) : $("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["disabled", "href", "target", "to", "type", "class"]));
  }
}), XH = /* @__PURE__ */ q({
  __name: "TotemDivider",
  props: {
    vertical: { type: Boolean }
  },
  setup(l) {
    const e = l, t = k(() => e.vertical ? "div" : "hr");
    return (a, r) => (B(), F(S5(t.value), {
      class: Y(["totem-divider", {
        "totem-divider--vertical": a.vertical
      }])
    }, null, 8, ["class"]));
  }
}), YH = {
  key: 0,
  class: "totem-chip__icon",
  "data-test": "icon"
}, QH = {
  class: "totem-chip__label",
  "data-test": "label"
}, eB = {
  key: 1,
  class: "totem-chip__detail",
  "data-test": "detail"
}, lB = {
  key: 2,
  class: "totem-chip__close",
  "data-test": "close"
}, K7 = /* @__PURE__ */ q({
  __name: "TotemChip",
  props: {
    label: {},
    detail: {},
    color: { default: "default" },
    iconName: {},
    disabled: { type: Boolean },
    closable: { type: Boolean }
  },
  emits: ["close"],
  setup(l, { emit: e }) {
    const t = e, a = () => {
      t("close");
    };
    return (r, o) => (B(), R("div", {
      class: Y(["totem-chip", {
        [`totem-chip--color-${r.color}`]: r.color,
        "totem-chip--disabled": r.disabled
      }])
    }, [
      r.iconName || r.$slots.icon ? (B(), R("span", YH, [
        L(r.$slots, "icon", {}, () => [
          r.iconName ? (B(), F(g5, {
            key: 0,
            name: r.iconName
          }, null, 8, ["name"])) : $("", !0)
        ])
      ])) : $("", !0),
      U("span", QH, [
        L(r.$slots, "label", {}, () => [
          L(r.$slots, "default", {}, () => [
            a5(Q(r.label), 1)
          ])
        ])
      ]),
      r.detail || r.$slots.detail ? (B(), R("span", eB, [
        L(r.$slots, "detail", {}, () => [
          a5(Q(r.detail), 1)
        ])
      ])) : $("", !0),
      r.closable && !r.disabled ? (B(), R("span", lB, [
        X(g5, {
          name: "cancel",
          onClick: z3(a, ["stop"])
        })
      ])) : $("", !0)
    ], 2));
  }
}), J7 = 40, tB = /* @__PURE__ */ q({
  __name: "TotemChipList",
  props: {
    items: {},
    closable: { type: Boolean },
    disabled: { type: Boolean },
    oneLine: { type: Boolean },
    mapLabel: { type: Function },
    mapDetail: { type: Function },
    mapColor: { type: Function },
    mapIconName: { type: Function },
    mapDisabled: { type: Function },
    mapClosable: { type: Function }
  },
  emits: ["close"],
  setup(l, { emit: e }) {
    const t = l, a = e, r = (y) => {
      a("close", y);
    }, o = (y) => {
      var E, H, j, Z, K, J;
      return {
        key: V7(),
        label: ((E = t.mapLabel) == null ? void 0 : E.call(t, y)) ?? void 0,
        detail: ((H = t.mapDetail) == null ? void 0 : H.call(t, y)) ?? void 0,
        color: ((j = t.mapColor) == null ? void 0 : j.call(t, y)) ?? void 0,
        iconName: ((Z = t.mapIconName) == null ? void 0 : Z.call(t, y)) ?? void 0,
        disabled: ((K = t.mapDisabled) == null ? void 0 : K.call(t, y)) ?? t.disabled ?? void 0,
        closable: ((J = t.mapClosable) == null ? void 0 : J.call(t, y)) ?? t.closable,
        item: y
      };
    }, i = k(() => {
      var y;
      return ((y = t.items) == null ? void 0 : y.map(o)) ?? [];
    }), c = (y) => `label-${y.key}`, v = (y) => `detail-${y.key}`, u = (y) => `icon-${y.key}`, h = I(), p = I(), m = I(), g = I(), w = I(), x = I([]), f = () => {
      p.value && (w.value = {
        width: p.value.getBoundingClientRect().width
      }), w.value = void 0;
    }, M = () => g.value && h.value ? g.value.scrollWidth + J7 > h.value.clientWidth : !1, V = () => x.value.reduce((y, E, H) => (h.value && E.$el.offsetLeft + E.$el.offsetWidth + J7 > h.value.clientWidth && y.push(H), y), []), C = (y) => ({
      key: "plus-n",
      label: `+${y}`,
      item: void 0
    }), S = () => {
      const y = V(), E = i.value.reduce((H, j, Z) => (y.includes(Z) || H.push(j), H), []);
      return E.push(C(y.length)), E;
    }, A = () => {
      q2(() => {
        t.oneLine && M() ? m.value = S() : m.value = i.value;
      });
    };
    return r5(
      [i, () => t.oneLine],
      () => {
        f(), A();
      },
      { immediate: !0 }
    ), K3(h, () => {
      f(), A();
    }), (y, E) => (B(), R("div", {
      ref_key: "chipList",
      ref: h,
      class: Y(["totem-chip-list", {
        "totem-chip-list--one-line": y.oneLine
      }])
    }, [
      y.$slots.default || m.value && m.value.length ? (B(), R("div", {
        key: 0,
        ref_key: "visibleWrapper",
        ref: p,
        class: "totem-chip-list__wrapper"
      }, [
        L(y.$slots, "default", {}, () => [
          (B(!0), R(p5, null, J5(m.value, (H) => (B(), F(K7, {
            key: H.key,
            label: H.label,
            detail: H.detail,
            color: H.color,
            "icon-name": H.iconName,
            disabled: H.disabled,
            closable: H.closable,
            class: "totem-chip-list__chip",
            onClose: (j) => r(H)
          }, N5({ _: 2 }, [
            y.$slots.label || y.$slots[c(H)] ? {
              name: "label",
              fn: T(() => [
                L(y.$slots, "label", {
                  item: H.item,
                  metadataItem: H
                }, () => [
                  L(y.$slots, c(H), {
                    item: H.item,
                    metadataItem: H
                  })
                ])
              ]),
              key: "0"
            } : void 0,
            y.$slots.detail || y.$slots[v(H)] ? {
              name: "detail",
              fn: T(() => [
                L(y.$slots, "detail", {
                  item: H.item,
                  metadataItem: H
                }, () => [
                  L(y.$slots, v(H), {
                    item: H.item,
                    metadataItem: H
                  })
                ])
              ]),
              key: "1"
            } : void 0,
            y.$slots.icon || y.$slots[u(H)] ? {
              name: "icon",
              fn: T(() => [
                L(y.$slots, "icon", {
                  item: H.item,
                  metadataItem: H
                }, () => [
                  L(y.$slots, u(H), {
                    item: H.item,
                    metadataItem: H
                  })
                ])
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["label", "detail", "color", "icon-name", "disabled", "closable", "onClose"]))), 128))
        ])
      ], 512)) : $("", !0),
      y.oneLine && i.value && i.value.length ? (B(), F(g7, { key: 1 }, {
        default: T(() => [
          U("div", {
            ref_key: "hiddenWrapper",
            ref: g,
            style: F5(w.value),
            class: "totem-chip-list__wrapper totem-chip-list__wrapper--hidden"
          }, [
            (B(!0), R(p5, null, J5(i.value, (H) => (B(), F(K7, {
              ref_for: !0,
              ref_key: "hiddenChips",
              ref: x,
              key: H.key,
              label: H.label,
              detail: H.detail,
              "icon-name": H.iconName,
              disabled: H.disabled,
              closable: H.closable,
              class: "totem-chip-list__chip"
            }, N5({ _: 2 }, [
              y.$slots.label || y.$slots[c(H)] ? {
                name: "label",
                fn: T(() => [
                  L(y.$slots, "label", {
                    item: H.item,
                    metadataItem: H
                  }, () => [
                    L(y.$slots, c(H), {
                      item: H.item,
                      metadataItem: H
                    })
                  ])
                ]),
                key: "0"
              } : void 0,
              y.$slots.detail || y.$slots[v(H)] ? {
                name: "detail",
                fn: T(() => [
                  L(y.$slots, "detail", {
                    item: H.item,
                    metadataItem: H
                  }, () => [
                    L(y.$slots, v(H), {
                      item: H.item,
                      metadataItem: H
                    })
                  ])
                ]),
                key: "1"
              } : void 0,
              y.$slots.icon || y.$slots[u(H)] ? {
                name: "icon",
                fn: T(() => [
                  L(y.$slots, "icon", {
                    item: H.item,
                    metadataItem: H
                  }, () => [
                    L(y.$slots, u(H), {
                      item: H.item,
                      metadataItem: H
                    })
                  ])
                ]),
                key: "2"
              } : void 0
            ]), 1032, ["label", "detail", "icon-name", "disabled", "closable"]))), 128))
          ], 4)
        ]),
        _: 3
      })) : $("", !0)
    ], 2));
  }
}), nB = { class: "totem-input__upload" }, aB = ["for"], rB = /* @__PURE__ */ q({
  __name: "TotemInputUploadChipList",
  props: {
    inputId: {},
    files: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean }
  },
  emits: ["remove:file"],
  setup(l, { emit: e }) {
    const t = l, a = e, r = k(() => t.disabled || t.readonly), o = (v) => {
      !r.value && v && a("remove:file", v);
    }, i = (v) => {
      if (r.value) {
        v.preventDefault();
        return;
      }
    }, c = k(() => t.multiple ? "Sélectionner des fichiers" : "Sélectionner un fichier");
    return (v, u) => (B(), R("div", nB, [
      v.files && v.files.length ? (B(), F(tB, {
        key: 0,
        disabled: r.value,
        items: v.files,
        "map-label": (h) => h.name,
        "map-detail": (h) => _(IH)(h.size),
        "map-closable": () => v.multiple ?? !1,
        onClose: u[0] || (u[0] = ({ item: h }) => o(h))
      }, null, 8, ["disabled", "items", "map-label", "map-detail", "map-closable"])) : $("", !0),
      U("label", {
        for: v.inputId,
        class: "totem-input__upload-label",
        onClick: i
      }, Q(c.value), 9, aB)
    ]));
  }
}), oB = ["id", "type", "name", "disabled", "readonly", "placeholder", "minlength", "maxlength", "accept", "multiple"], P1 = /* @__PURE__ */ q({
  __name: "TotemInput",
  props: /* @__PURE__ */ c5({
    color: {},
    inline: { type: Boolean },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    disabledTyping: { type: Boolean },
    disabledAutoFocus: { type: Boolean },
    noDivider: { type: Boolean },
    prefixIconName: {},
    affixIconName: {},
    suffixIconName: {},
    type: {},
    id: {},
    name: {},
    placeholder: {},
    minlength: {},
    maxlength: {},
    accept: {},
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {},
    files: {},
    filesModifiers: {}
  }),
  emits: /* @__PURE__ */ c5(["blur", "focus", "change"], ["update:modelValue", "update:files"]),
  setup(l, { emit: e }) {
    const t = l, a = e, r = H5(l, "modelValue"), o = H5(l, "files"), i = R5("input"), c = k(() => t.id ?? V7()), v = k(() => t.inline ? "span" : "div"), u = k(() => t.readonly || t.disabledTyping), { isTypeFile: h, onStartUploadingFiles: p, onUpdateUploadedFiles: m, onRemoveFile: g, onRemoveAllFiles: w } = qH(
      i,
      () => t.type,
      () => t.disabled || t.readonly,
      o,
      r
    ), x = (A) => {
      m(A), a("change", A);
    }, f = (A) => {
      a("focus", A);
    }, M = (A) => {
      a("blur", A);
    }, { isFocused: V, triggerFocus: C } = vl(i), S = () => {
      t.disabledAutoFocus || C();
    };
    return (A, y) => (B(), F(S5(v.value), {
      "data-test": "root",
      class: Y(["totem-input", [
        {
          "totem-input--inline": A.inline,
          "totem-input--focused": _(V),
          "totem-input--readonly": A.readonly,
          "totem-input--disabled": A.disabled,
          "totem-input--disabled-typing": A.disabledTyping,
          [`totem-input--color-${A.color}`]: A.color
        }
      ]]),
      tabindex: "-1"
    }, {
      default: T(() => {
        var E;
        return [
          A.$slots.prefix || A.prefixIconName ? (B(), F(S5(v.value), {
            key: 0,
            class: "totem-input__prefix",
            "data-test": "prefix",
            onClick: S
          }, {
            default: T(() => [
              L(A.$slots, "prefix", {}, () => [
                A.prefixIconName ? (B(), F(g5, {
                  key: 0,
                  name: A.prefixIconName
                }, null, 8, ["name"])) : $("", !0)
              ])
            ]),
            _: 3
          })) : $("", !0),
          L(A.$slots, "upload", {}, () => [
            _(h) ? (B(), F(rB, {
              key: 0,
              "input-id": c.value,
              multiple: A.multiple,
              files: l.files,
              disabled: A.disabled,
              readonly: A.readonly,
              "onRemove:file": _(g)
            }, null, 8, ["input-id", "multiple", "files", "disabled", "readonly", "onRemove:file"])) : $("", !0)
          ]),
          L(A.$slots, "default", {}, () => [
            B3(U("input", {
              id: c.value,
              ref: "input",
              "onUpdate:modelValue": y[0] || (y[0] = (H) => r.value = H),
              tabindex: "0",
              type: A.type,
              name: A.name,
              disabled: A.disabled,
              readonly: u.value,
              placeholder: A.placeholder,
              minlength: A.minlength,
              maxlength: A.maxlength,
              accept: A.accept,
              multiple: A.multiple,
              class: "totem-input__input",
              "data-test": "input",
              onFocus: f,
              onBlur: M,
              onChange: x
            }, null, 40, oB), [
              [vt, r.value]
            ])
          ]),
          A.$slots.affix || A.affixIconName || (E = l.files) != null && E.length ? (B(), F(S5(v.value), {
            key: 1,
            class: "totem-input__affix",
            "data-test": "affix",
            onClick: S
          }, {
            default: T(() => [
              L(A.$slots, "affix", {}, () => {
                var H;
                return [
                  A.affixIconName ? (B(), F(g5, {
                    key: 0,
                    name: A.affixIconName
                  }, null, 8, ["name"])) : $("", !0),
                  (H = l.files) != null && H.length ? (B(), F(q1, {
                    key: 1,
                    size: "s",
                    color: "text",
                    "icon-name": "cancel",
                    onClick: _(w)
                  }, null, 8, ["onClick"])) : $("", !0)
                ];
              })
            ]),
            _: 3
          })) : $("", !0),
          !A.noDivider && (A.$slots.suffix || A.suffixIconName || _(h)) ? (B(), F(XH, {
            key: 2,
            vertical: "",
            class: "totem-input__suffix-divider"
          })) : $("", !0),
          A.$slots.suffix || A.suffixIconName || _(h) ? (B(), F(S5(v.value), {
            key: 3,
            class: "totem-input__suffix",
            "data-test": "suffix",
            onClick: S
          }, {
            default: T(() => [
              L(A.$slots, "suffix", {}, () => [
                A.suffixIconName ? (B(), F(g5, {
                  key: 0,
                  name: A.suffixIconName
                }, null, 8, ["name"])) : $("", !0),
                _(h) ? (B(), F(q1, {
                  key: 1,
                  disabled: A.disabled || A.readonly,
                  size: "s",
                  color: "text",
                  "icon-name": "upload",
                  onClick: _(p)
                }, null, 8, ["disabled", "onClick"])) : $("", !0)
              ])
            ]),
            _: 3
          })) : $("", !0)
        ];
      }),
      _: 3
    }, 8, ["class"]));
  }
}), iB = { class: "totem-checkbox__input-wrapper" }, sB = ["id", "disabled", "readonly"], dB = ["for"], cB = /* @__PURE__ */ q({
  __name: "TotemCheckbox",
  props: /* @__PURE__ */ c5({
    id: {},
    label: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    error: { type: Boolean },
    indeterminate: { type: Boolean }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const e = l, t = H5(l, "modelValue"), a = R5("input"), { isFocused: r } = vl(a), o = k(() => e.indeterminate ? "minus" : "check"), i = k(() => e.id ?? V7());
    return (c, v) => (B(), R("span", {
      class: Y(["totem-checkbox", {
        "totem-checkbox--checked": l.modelValue,
        "totem-checkbox--indeterminate": c.indeterminate,
        "totem-checkbox--focused": _(r),
        "totem-checkbox--readonly": c.readonly,
        "totem-checkbox--disabled": c.disabled,
        "totem-checkbox--error": c.error
      }])
    }, [
      U("span", iB, [
        B3(U("input", {
          id: i.value,
          ref: "input",
          "onUpdate:modelValue": v[0] || (v[0] = (u) => t.value = u),
          type: "checkbox",
          class: "totem-checkbox__input",
          disabled: c.disabled,
          readonly: c.readonly
        }, null, 8, sB), [
          [bt, t.value]
        ]),
        o.value ? (B(), F(g5, {
          key: 0,
          class: "totem-checkbox__input-checkmark",
          name: o.value
        }, null, 8, ["name"])) : $("", !0)
      ]),
      c.label || c.$slots.default || c.$slots.label ? (B(), R("label", {
        key: 0,
        class: "totem-checkbox__label",
        for: i.value,
        "data-test": "label"
      }, [
        L(c.$slots, "default", {}, () => [
          L(c.$slots, "label", {}, () => [
            a5(Q(c.label), 1)
          ])
        ])
      ], 8, dB)) : $("", !0)
    ], 2));
  }
}), uB = (l, e, t, a, r) => {
  const o = I(!1), i = () => {
    o.value || (o.value = !0);
  }, c = () => {
    o.value && (o.value = !1);
  }, v = k(() => s5(l)), u = k(() => s5(r) ?? !1), h = U3(v, e, {
    open: o,
    placement: a,
    middleware: [un({ element: t }), an(4), q3()],
    whileElementsMounted: j3
  }), p = I(), m = (f) => {
    f.addEventListener("mouseover", i), f.addEventListener("mouseleave", c), p.value = !0;
  }, g = (f) => {
    f.removeEventListener("mouseover", i), f.removeEventListener("mouseleave", c), p.value = !1;
  }, w = k(() => {
    var f, M;
    const { x: V, y: C } = h.middlewareData.value.arrow ?? {}, S = ((f = h.middlewareData.value.shift) == null ? void 0 : f.x) ?? 0, A = ((M = h.middlewareData.value.shift) == null ? void 0 : M.y) ?? 0;
    return {
      left: V !== void 0 ? J2(V - S) : "",
      top: C !== void 0 ? J2(C - A) : ""
    };
  }), x = (f) => (f == null ? void 0 : f.$el) || f;
  return r5(
    [v, u],
    ([f, M], [V]) => {
      const C = x(f), S = x(V);
      S && g(S), !M && C && !p.value && m(C);
    },
    { immediate: !0 }
  ), G1(() => {
    const f = x(v.value);
    f && g(f);
  }), {
    floatingStyles: h.floatingStyles,
    arrowStyles: w,
    placement: h.placement,
    isOpen: wt(o),
    open: i,
    close: c
  };
}, vB = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 4"
};
function pB(l, e) {
  return B(), R("svg", vB, e[0] || (e[0] = [
    U("path", { d: "M3.293 3.293a1 1 0 0 0 1.414 0L8 0H0l3.293 3.293Z" }, null, -1)
  ]));
}
const hB = { render: pB }, fB = {
  class: "totem-tooltip__body",
  "data-test": "message"
}, mB = /* @__PURE__ */ q({
  __name: "TotemTooltip",
  props: {
    message: {},
    target: {},
    side: {},
    maxSize: {}
  },
  setup(l) {
    const e = l, t = R5("floating"), a = R5("arrow"), r = k(() => e.maxSize ?? "s"), { floatingStyles: o, arrowStyles: i, placement: c, isOpen: v } = uB(
      () => e.target,
      t,
      a,
      () => e.side ?? "top"
    );
    return (u, h) => (B(), F(g7, null, {
      default: T(() => [
        X(d7, { name: "totem-tooltip-" }, {
          default: T(() => [
            _(v) ? (B(), R("div", {
              key: 0,
              ref: "floating",
              style: F5(_(o)),
              class: Y(["totem-tooltip", {
                [`totem-tooltip--placement-${_(c)}`]: _(c),
                [`totem-tooltip--max-size-${r.value}`]: r.value
              }]),
              "data-test": "tooltip"
            }, [
              U("div", {
                ref: "arrow",
                class: "totem-tooltip__arrow",
                style: F5(_(i))
              }, [
                X(_(hB), { class: "totem-tooltip__arrow-icon" })
              ], 4),
              U("div", fB, [
                L(u.$slots, "default", {}, () => [
                  a5(Q(u.message), 1)
                ])
              ])
            ], 6)) : $("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), wB = { class: "totem-form-element__header-and-body" }, gB = {
  key: 0,
  class: "totem-form-element__header-left",
  "data-test": "header-left"
}, bB = ["for"], MB = {
  key: 1,
  class: "totem-form-element__header-right",
  "data-test": "header-right"
}, xB = {
  class: "totem-form-element__header-description",
  "data-test": "header-description"
}, yB = {
  class: "totem-form-element__body",
  "data-test": "body"
}, AB = {
  key: 0,
  class: "totem-form-element__bottom",
  "data-test": "bottom"
}, VB = {
  key: 0,
  class: "totem-form-element__bottom-details",
  "data-test": "bottom-details"
}, HB = {
  key: 0,
  class: "totem-form-element__bottom-details-single"
}, BB = {
  key: 1,
  class: "totem-form-element__bottom-details-list"
}, zB = {
  key: 1,
  class: "totem-form-element__bottom-link",
  "data-test": "bottom-link"
}, U1 = /* @__PURE__ */ q({
  __name: "TotemFormElement",
  props: {
    color: {},
    label: {},
    labelFor: {},
    description: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    slim: { type: Boolean }
  },
  setup(l) {
    const e = R5("iconHelp");
    return (t, a) => {
      var r;
      return B(), R("div", {
        class: Y(["totem-form-element", {
          [`totem-form-element--color-${t.color}`]: t.color,
          "totem-form-element--slim": t.slim
        }])
      }, [
        U("div", wB, [
          t.$slots.header || t.$slots.headerLabelText || t.label || t.$slots.headerFlags || t.optionalFlag || t.requiredFlag || t.$slots.headerDescription || t.description || t.$slots.headerHelp || t.help ? (B(), R("div", {
            key: 0,
            class: Y(["totem-form-element__header", { "totem-form-element--default": !t.$slots.header }]),
            "data-test": "header"
          }, [
            L(t.$slots, "header", {}, () => [
              t.label || t.$slots.headerLabelText || t.$slots.headerFlags || t.optionalFlag || t.requiredFlag || t.help || t.$slots.headerHelp ? (B(), R("div", gB, [
                t.label || t.$slots.headerLabelText ? (B(), R("label", {
                  key: 0,
                  for: t.labelFor,
                  class: "totem-form-element__header-label",
                  "data-test": "header-label"
                }, [
                  L(t.$slots, "headerLabelText", {}, () => [
                    a5(Q(t.label), 1)
                  ])
                ], 8, bB)) : $("", !0),
                L(t.$slots, "headerFlags", {}, () => [
                  t.optionalFlag || t.requiredFlag || t.$slots.headerFlags ? (B(), R("span", {
                    key: 0,
                    class: Y(["totem-form-element__flag", {
                      "totem-form-element__flag--optional": t.optionalFlag,
                      "totem-form-element__flag--required": t.requiredFlag
                    }]),
                    "data-test": "header-flag"
                  }, [
                    t.optionalFlag && !t.requiredFlag ? (B(), R(p5, { key: 0 }, [
                      a5("(facultatif)")
                    ], 64)) : !t.optionalFlag && t.requiredFlag ? (B(), R(p5, { key: 1 }, [
                      a5("*")
                    ], 64)) : $("", !0)
                  ], 2)) : $("", !0)
                ]),
                L(t.$slots, "headerHelp", {}, () => [
                  t.help ? (B(), R(p5, { key: 0 }, [
                    X(g5, {
                      ref: "iconHelp",
                      name: "help-circle",
                      class: "totem-form-element__header-help"
                    }, null, 512),
                    X(mB, {
                      target: e.value,
                      side: "right"
                    }, {
                      default: T(() => [
                        a5(Q(t.help), 1)
                      ]),
                      _: 1
                    }, 8, ["target"])
                  ], 64)) : $("", !0)
                ])
              ])) : $("", !0),
              t.$slots.headerDescription || t.description ? (B(), R("div", MB, [
                U("span", xB, [
                  L(t.$slots, "headerDescription", {}, () => [
                    a5(Q(t.description), 1)
                  ])
                ])
              ])) : $("", !0)
            ])
          ], 2)) : $("", !0),
          U("div", yB, [
            L(t.$slots, "default")
          ])
        ]),
        t.$slots.bottom || t.$slots.bottomDetails || t.$slots.bottomLink || (r = t.details) != null && r.length ? (B(), R("div", AB, [
          L(t.$slots, "bottom", {}, () => {
            var o;
            return [
              (o = t.details) != null && o.length || t.$slots.bottomDetails ? (B(), R("div", VB, [
                L(t.$slots, "bottomDetails", {}, () => {
                  var i;
                  return [
                    ((i = t.details) == null ? void 0 : i.length) === 1 ? (B(), R("p", HB, Q(t.details[0]), 1)) : (B(), R("ul", BB, [
                      (B(!0), R(p5, null, J5(t.details, (c, v) => (B(), R("li", {
                        key: v,
                        class: "totem-form-element__bottom-details-item"
                      }, Q(c), 1))), 128))
                    ]))
                  ];
                })
              ])) : $("", !0),
              t.$slots.bottomLink ? (B(), R("div", zB, [
                L(t.$slots, "bottomLink")
              ])) : $("", !0)
            ];
          })
        ])) : $("", !0)
      ], 2);
    };
  }
}), CB = 180, LB = 0, SB = (l, e = {}) => {
  const t = e.activeAngle ?? CB, a = e.inactiveAngle ?? LB;
  return k(() => s5(l) ? t : a);
}, EB = { class: "totem-select-option__description" }, TB = { class: "totem-select-option__label" }, _B = { class: "totem-select-option__detail" }, RB = /* @__PURE__ */ q({
  __name: "TotemSelectOption",
  props: {
    label: { default: void 0 },
    detail: { default: void 0 },
    disabled: { type: Boolean },
    selected: { type: Boolean },
    multiple: { type: Boolean },
    highlighted: { type: Boolean },
    prefixIconName: { default: void 0 }
  },
  setup(l) {
    return (e, t) => (B(), R("div", {
      class: Y(["totem-select-option", {
        "totem-select-option--selected": e.selected,
        "totem-select-option--disabled": e.disabled,
        "totem-select-option--multiple": e.multiple,
        "totem-select-option--highlighted": e.highlighted
      }])
    }, [
      e.multiple ? (B(), F(cB, {
        key: 0,
        "model-value": e.selected,
        class: "totem-select-option__checkbox"
      }, null, 8, ["model-value"])) : $("", !0),
      U("span", EB, [
        U("span", TB, [
          e.prefixIconName ? (B(), F(g5, {
            key: 0,
            name: e.prefixIconName,
            class: "totem-select-option__icon"
          }, null, 8, ["name"])) : $("", !0),
          a5(" " + Q(e.label), 1)
        ]),
        U("span", _B, Q(e.detail), 1)
      ])
    ], 2));
  }
}), kB = {
  ref: "dropdownContent",
  class: "totem-select__dropdown-content",
  tabindex: "-1"
}, OB = {
  key: 0,
  class: "totem-select__empty-message"
}, $B = { class: "totem-select__empty-message-title" }, NB = { class: "totem-select__empty-message-text" }, FB = ["id", "name"], DB = ["value", "disabled", "selected"], IB = /* @__PURE__ */ q({
  __name: "TotemSelect",
  props: /* @__PURE__ */ c5({
    options: {},
    color: { default: "default" },
    id: {},
    name: {},
    placeholder: { default: "Sélectionnez une option" },
    emptyTitle: { default: "Aucun résultat" },
    emptyMessage: { default: "Essayez de modifier votre recherche." },
    mapValue: { type: Function },
    mapLabel: { type: Function },
    mapDetail: { type: Function },
    mapDisabled: { type: Function },
    mapPrefixIconName: { type: Function },
    mapInputValue: { type: Function, default: (l) => l.label },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    disabledFilterOptions: { type: Boolean },
    disabledSearch: { type: Boolean },
    disabledSortOptions: { type: Boolean },
    disabledSameWidth: { type: Boolean },
    noDivider: { type: Boolean },
    preventClear: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ c5(["search"], ["update:modelValue"]),
  setup(l, { emit: e }) {
    const t = e, a = H5(l, "modelValue"), r = R5("input"), o = R5("dropdownContent"), i = I(!1), c = I(), v = k({
      get: () => {
        var z;
        return i.value ? c.value : (z = h.value) == null ? void 0 : z.inputValue;
      },
      set: (z) => {
        c.value = z, t("search", z);
      }
    }), u = k(() => {
      var z;
      return ((z = l.options) == null ? void 0 : z.map((O) => {
        var D, P, G, e5, f5, A1;
        return {
          value: ((D = l.mapValue) == null ? void 0 : D.call(l, O)) ?? O.value ?? void 0,
          label: ((P = l.mapLabel) == null ? void 0 : P.call(l, O)) ?? O.label ?? void 0,
          detail: ((G = l.mapDetail) == null ? void 0 : G.call(l, O)) ?? O.detail ?? void 0,
          disabled: ((e5 = l.mapDisabled) == null ? void 0 : e5.call(l, O)) ?? O.disabled ?? l.disabled,
          prefixIconName: ((f5 = l.mapPrefixIconName) == null ? void 0 : f5.call(l, O)) ?? O.prefixIconName ?? void 0,
          inputValue: ((A1 = l.mapInputValue) == null ? void 0 : A1.call(l, O)) ?? void 0,
          option: O
        };
      })) ?? [];
    }), h = k(() => u.value.find((z) => z.value === a.value)), p = k(() => {
      const z = (P) => P.sort((G, e5) => !G.label || !e5.label ? 0 : G.label.localeCompare(e5.label)), O = (P) => P.reduce((G, e5) => (e5.value === a.value ? G.unshift(e5) : G.push(e5), G), []), D = l.disabledFilterOptions ? u.value : Bt(u.value, c.value);
      return l.disabledSortOptions ? D : O(z(D));
    }), m = () => {
      q2(() => {
        var z;
        ((z = r.value) == null ? void 0 : z.$refs.input).focus();
      });
    }, g = () => {
      S();
    }, w = () => {
      m();
    }, x = (z) => {
      a.value = z.value, A();
    }, f = () => {
      if (i.value) {
        v.value = void 0, m();
        return;
      }
      a.value = void 0, S();
    }, M = k(() => {
      const z = {
        danger: "warning-triangle",
        warning: "warning-triangle",
        default: void 0
      };
      if (!l.disabled && !l.readonly && !i.value)
        return z[l.color];
    }), V = I(-1);
    function C(z) {
      const O = [
        { keys: ["Tab"], execute: A },
        { keys: ["Enter", " "], execute: () => {
          i.value ? (j(V.value), A()) : S();
        } },
        { keys: ["Escape"], execute: A },
        { keys: ["ArrowDown"], execute: E },
        { keys: ["ArrowUp"], execute: H }
      ].find((D) => D.keys.includes(z.key));
      O == null || O.execute();
    }
    function S() {
      l.disabled || l.readonly || i.value || (v.value = void 0, i.value = !0);
    }
    function A() {
      i.value = !1;
    }
    function y() {
      i.value ? A() : (S(), m());
    }
    function E() {
      let z = V.value;
      do
        z = (z + 1) % p.value.length;
      while (p.value[z].disabled && z !== V.value);
      p.value[z].disabled || (V.value = z, Z());
    }
    function H() {
      let z = V.value;
      do
        z = (z - 1 + p.value.length) % p.value.length;
      while (p.value[z].disabled && z !== V.value);
      p.value[z].disabled || (V.value = z, Z());
    }
    function j(z) {
      p.value[z] && !p.value[z].disabled && (a.value = p.value[z].value);
    }
    function Z() {
      q2(() => {
        if (o.value) {
          const z = o.value.querySelectorAll(".totem-select__dropdown-content > *")[V.value];
          z && z.scrollIntoView({ block: "nearest" });
        }
      });
    }
    r5(p, () => {
      V.value = -1;
    });
    const K = SB(i), J = {
      onButtonCleanClick: f,
      onButtonArrowClick: y,
      onOptionClick: x,
      onInputKeydown: C
    };
    return (z, O) => (B(), R("div", {
      class: Y(["totem-select", {
        [`totem-select--color-${z.color}`]: z.color
      }]),
      tabindex: "-1"
    }, [
      L(z.$slots, "default", {}, () => [
        X(Cn, {
          modelValue: i.value,
          "onUpdate:modelValue": O[1] || (O[1] = (D) => i.value = D),
          "same-width": !z.disabledSameWidth,
          class: "totem-select__dropdown"
        }, {
          trigger: T(() => [
            L(z.$slots, "trigger", {
              actions: J,
              visibleOptionsMetadata: p.value
            }, () => {
              var D;
              return [
                X(P1, {
                  ref: "input",
                  modelValue: v.value,
                  "onUpdate:modelValue": O[0] || (O[0] = (P) => v.value = P),
                  placeholder: z.placeholder,
                  color: z.color,
                  readonly: z.readonly,
                  disabled: z.disabled,
                  "disabled-typing": z.disabledSearch,
                  "disabled-auto-focus": "",
                  "no-divider": z.noDivider,
                  class: "totem-select__input",
                  onFocus: g,
                  onKeydown: C
                }, N5({
                  suffix: T(() => [
                    X(q1, {
                      tabindex: "-1",
                      "icon-rotation": _(K),
                      size: "s",
                      color: "text",
                      "icon-name": "nav-arrow-down",
                      disabled: z.disabled || z.readonly,
                      "data-test": "arrow-button",
                      onClick: y
                    }, null, 8, ["icon-rotation", "disabled"])
                  ]),
                  _: 2
                }, [
                  (D = h.value) != null && D.prefixIconName ? {
                    name: "prefix",
                    fn: T(() => [
                      X(g5, {
                        name: h.value.prefixIconName,
                        onClick: w
                      }, null, 8, ["name"])
                    ]),
                    key: "0"
                  } : void 0,
                  !z.disabled && !z.readonly && v.value && (M.value || !z.preventClear) ? {
                    name: "affix",
                    fn: T(() => [
                      M.value ? (B(), F(g5, {
                        key: 0,
                        tabindex: "-1",
                        size: "s",
                        color: "text",
                        name: M.value,
                        class: "totem-select__color-icon",
                        onClick: w
                      }, null, 8, ["name"])) : z.preventClear ? $("", !0) : (B(), F(q1, {
                        key: 1,
                        size: "s",
                        color: "text",
                        "icon-name": "cancel",
                        class: "totem-select__clean-button",
                        onClick: f
                      }))
                    ]),
                    key: "1"
                  } : void 0
                ]), 1032, ["modelValue", "placeholder", "color", "readonly", "disabled", "disabled-typing", "no-divider"])
              ];
            })
          ]),
          target: T(() => [
            L(z.$slots, "target", {
              actions: J,
              visibleOptionsMetadata: p.value
            }, () => [
              U("div", kB, [
                (B(!0), R(p5, null, J5(p.value, (D, P) => (B(), F(RB, {
                  key: `option-${P}-${D.value}`,
                  tabindex: "-1",
                  label: D.label,
                  detail: D.detail,
                  disabled: D.disabled,
                  selected: D.value === a.value,
                  highlighted: V.value === P,
                  "prefix-icon-name": D.prefixIconName,
                  onClick: (G) => x(D)
                }, null, 8, ["label", "detail", "disabled", "selected", "highlighted", "prefix-icon-name", "onClick"]))), 128)),
                p.value.length === 0 ? (B(), R("div", OB, [
                  U("div", $B, Q(z.emptyTitle), 1),
                  U("div", NB, Q(z.emptyMessage), 1)
                ])) : $("", !0)
              ], 512)
            ])
          ]),
          _: 3
        }, 8, ["modelValue", "same-width"]),
        U("select", {
          id: z.id,
          name: z.name,
          class: "totem-select__native-select"
        }, [
          (B(!0), R(p5, null, J5(p.value, (D, P) => (B(), R("option", {
            key: `native-select-${P}-${D.value}`,
            value: D.value,
            disabled: D.disabled,
            selected: D.value === a.value
          }, Q(D.label), 9, DB))), 128))
        ], 8, FB)
      ])
    ], 2));
  }
}), jB = /* @__PURE__ */ q({
  __name: "TotemFormElementText",
  props: /* @__PURE__ */ c5({
    color: {},
    label: {},
    description: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    inline: { type: Boolean },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    disabledTyping: { type: Boolean },
    noDivider: { type: Boolean },
    prefixIconName: {},
    affixIconName: {},
    suffixIconName: {},
    id: {},
    name: {},
    placeholder: {},
    minlength: {},
    maxlength: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ c5(["blur", "focus"], ["update:modelValue"]),
  setup(l, { emit: e }) {
    const t = e, a = H5(l, "modelValue"), r = (i) => {
      t("blur", i);
    }, o = (i) => {
      t("focus", i);
    };
    return (i, c) => (B(), F(U1, {
      details: i.details,
      description: i.description,
      help: i.help,
      color: i.color,
      label: i.label,
      "label-for": i.id,
      "optional-flag": i.optionalFlag,
      "required-flag": i.requiredFlag,
      class: "totem-form-element-text"
    }, N5({
      default: T(() => [
        L(i.$slots, "default", {}, () => [
          X(P1, {
            id: i.id,
            modelValue: a.value,
            "onUpdate:modelValue": c[0] || (c[0] = (v) => a.value = v),
            color: i.color,
            name: i.name,
            placeholder: i.placeholder,
            readonly: i.readonly,
            disabled: i.disabled,
            "prefix-icon-name": i.prefixIconName,
            "affix-icon-name": i.affixIconName,
            "suffix-icon-name": i.suffixIconName,
            minlength: i.minlength,
            maxlength: i.maxlength,
            inline: i.inline,
            "no-divider": i.noDivider,
            type: "text",
            "data-test": "totem-input",
            onBlur: r,
            onFocus: o
          }, N5({ _: 2 }, [
            i.$slots.prefix ? {
              name: "prefix",
              fn: T(() => [
                L(i.$slots, "prefix")
              ]),
              key: "0"
            } : void 0,
            i.$slots.affix ? {
              name: "affix",
              fn: T(() => [
                L(i.$slots, "affix")
              ]),
              key: "1"
            } : void 0,
            i.$slots.suffix ? {
              name: "suffix",
              fn: T(() => [
                L(i.$slots, "suffix")
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["id", "modelValue", "color", "name", "placeholder", "readonly", "disabled", "prefix-icon-name", "affix-icon-name", "suffix-icon-name", "minlength", "maxlength", "inline", "no-divider"])
        ])
      ]),
      _: 2
    }, [
      i.$slots.header ? {
        name: "header",
        fn: T(() => [
          L(i.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      i.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: T(() => [
          L(i.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      i.$slots.headerFlags ? {
        name: "headerFlags",
        fn: T(() => [
          L(i.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      i.$slots.headerDescription ? {
        name: "headerDescription",
        fn: T(() => [
          L(i.$slots, "headerDescription")
        ]),
        key: "3"
      } : void 0,
      i.$slots.headerHelp ? {
        name: "headerHelp",
        fn: T(() => [
          L(i.$slots, "headerHelp")
        ]),
        key: "4"
      } : void 0,
      i.$slots.bottom ? {
        name: "bottom",
        fn: T(() => [
          L(i.$slots, "bottom")
        ]),
        key: "5"
      } : void 0,
      i.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: T(() => [
          L(i.$slots, "bottomDetails")
        ]),
        key: "6"
      } : void 0,
      i.$slots.bottomLink ? {
        name: "bottomLink",
        fn: T(() => [
          L(i.$slots, "bottomLink")
        ]),
        key: "7"
      } : void 0
    ]), 1032, ["details", "description", "help", "color", "label", "label-for", "optional-flag", "required-flag"]));
  }
});
var B1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, V0, G7;
function H7() {
  if (G7) return V0;
  G7 = 1;
  var l = Array.isArray;
  return V0 = l, V0;
}
var H0, X7;
function qB() {
  if (X7) return H0;
  X7 = 1;
  var l = typeof B1 == "object" && B1 && B1.Object === Object && B1;
  return H0 = l, H0;
}
var B0, Y7;
function B7() {
  if (Y7) return B0;
  Y7 = 1;
  var l = qB(), e = typeof self == "object" && self && self.Object === Object && self, t = l || e || Function("return this")();
  return B0 = t, B0;
}
var z0, Q7;
function z7() {
  if (Q7) return z0;
  Q7 = 1;
  var l = B7(), e = l.Symbol;
  return z0 = e, z0;
}
var C0, ee;
function PB() {
  if (ee) return C0;
  ee = 1;
  var l = z7(), e = Object.prototype, t = e.hasOwnProperty, a = e.toString, r = l ? l.toStringTag : void 0;
  function o(i) {
    var c = t.call(i, r), v = i[r];
    try {
      i[r] = void 0;
      var u = !0;
    } catch {
    }
    var h = a.call(i);
    return u && (c ? i[r] = v : delete i[r]), h;
  }
  return C0 = o, C0;
}
var L0, le;
function UB() {
  if (le) return L0;
  le = 1;
  var l = Object.prototype, e = l.toString;
  function t(a) {
    return e.call(a);
  }
  return L0 = t, L0;
}
var S0, te;
function pl() {
  if (te) return S0;
  te = 1;
  var l = z7(), e = PB(), t = UB(), a = "[object Null]", r = "[object Undefined]", o = l ? l.toStringTag : void 0;
  function i(c) {
    return c == null ? c === void 0 ? r : a : o && o in Object(c) ? e(c) : t(c);
  }
  return S0 = i, S0;
}
var E0, ne;
function ZB() {
  if (ne) return E0;
  ne = 1;
  function l(e) {
    return e != null && typeof e == "object";
  }
  return E0 = l, E0;
}
var T0, ae;
function C7() {
  if (ae) return T0;
  ae = 1;
  var l = pl(), e = ZB(), t = "[object Symbol]";
  function a(r) {
    return typeof r == "symbol" || e(r) && l(r) == t;
  }
  return T0 = a, T0;
}
var _0, re;
function WB() {
  if (re) return _0;
  re = 1;
  var l = H7(), e = C7(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, a = /^\w*$/;
  function r(o, i) {
    if (l(o))
      return !1;
    var c = typeof o;
    return c == "number" || c == "symbol" || c == "boolean" || o == null || e(o) ? !0 : a.test(o) || !t.test(o) || i != null && o in Object(i);
  }
  return _0 = r, _0;
}
var R0, oe;
function hl() {
  if (oe) return R0;
  oe = 1;
  function l(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return R0 = l, R0;
}
var k0, ie;
function KB() {
  if (ie) return k0;
  ie = 1;
  var l = pl(), e = hl(), t = "[object AsyncFunction]", a = "[object Function]", r = "[object GeneratorFunction]", o = "[object Proxy]";
  function i(c) {
    if (!e(c))
      return !1;
    var v = l(c);
    return v == a || v == r || v == t || v == o;
  }
  return k0 = i, k0;
}
var O0, se;
function JB() {
  if (se) return O0;
  se = 1;
  var l = B7(), e = l["__core-js_shared__"];
  return O0 = e, O0;
}
var $0, de;
function GB() {
  if (de) return $0;
  de = 1;
  var l = JB(), e = function() {
    var a = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }();
  function t(a) {
    return !!e && e in a;
  }
  return $0 = t, $0;
}
var N0, ce;
function XB() {
  if (ce) return N0;
  ce = 1;
  var l = Function.prototype, e = l.toString;
  function t(a) {
    if (a != null) {
      try {
        return e.call(a);
      } catch {
      }
      try {
        return a + "";
      } catch {
      }
    }
    return "";
  }
  return N0 = t, N0;
}
var F0, ue;
function YB() {
  if (ue) return F0;
  ue = 1;
  var l = KB(), e = GB(), t = hl(), a = XB(), r = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, i = Function.prototype, c = Object.prototype, v = i.toString, u = c.hasOwnProperty, h = RegExp(
    "^" + v.call(u).replace(r, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function p(m) {
    if (!t(m) || e(m))
      return !1;
    var g = l(m) ? h : o;
    return g.test(a(m));
  }
  return F0 = p, F0;
}
var D0, ve;
function QB() {
  if (ve) return D0;
  ve = 1;
  function l(e, t) {
    return e == null ? void 0 : e[t];
  }
  return D0 = l, D0;
}
var I0, pe;
function fl() {
  if (pe) return I0;
  pe = 1;
  var l = YB(), e = QB();
  function t(a, r) {
    var o = e(a, r);
    return l(o) ? o : void 0;
  }
  return I0 = t, I0;
}
var j0, he;
function n0() {
  if (he) return j0;
  he = 1;
  var l = fl(), e = l(Object, "create");
  return j0 = e, j0;
}
var q0, fe;
function ez() {
  if (fe) return q0;
  fe = 1;
  var l = n0();
  function e() {
    this.__data__ = l ? l(null) : {}, this.size = 0;
  }
  return q0 = e, q0;
}
var P0, me;
function lz() {
  if (me) return P0;
  me = 1;
  function l(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  return P0 = l, P0;
}
var U0, we;
function tz() {
  if (we) return U0;
  we = 1;
  var l = n0(), e = "__lodash_hash_undefined__", t = Object.prototype, a = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    if (l) {
      var c = i[o];
      return c === e ? void 0 : c;
    }
    return a.call(i, o) ? i[o] : void 0;
  }
  return U0 = r, U0;
}
var Z0, ge;
function nz() {
  if (ge) return Z0;
  ge = 1;
  var l = n0(), e = Object.prototype, t = e.hasOwnProperty;
  function a(r) {
    var o = this.__data__;
    return l ? o[r] !== void 0 : t.call(o, r);
  }
  return Z0 = a, Z0;
}
var W0, be;
function az() {
  if (be) return W0;
  be = 1;
  var l = n0(), e = "__lodash_hash_undefined__";
  function t(a, r) {
    var o = this.__data__;
    return this.size += this.has(a) ? 0 : 1, o[a] = l && r === void 0 ? e : r, this;
  }
  return W0 = t, W0;
}
var K0, Me;
function rz() {
  if (Me) return K0;
  Me = 1;
  var l = ez(), e = lz(), t = tz(), a = nz(), r = az();
  function o(i) {
    var c = -1, v = i == null ? 0 : i.length;
    for (this.clear(); ++c < v; ) {
      var u = i[c];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = l, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = a, o.prototype.set = r, K0 = o, K0;
}
var J0, xe;
function oz() {
  if (xe) return J0;
  xe = 1;
  function l() {
    this.__data__ = [], this.size = 0;
  }
  return J0 = l, J0;
}
var G0, ye;
function iz() {
  if (ye) return G0;
  ye = 1;
  function l(e, t) {
    return e === t || e !== e && t !== t;
  }
  return G0 = l, G0;
}
var X0, Ae;
function a0() {
  if (Ae) return X0;
  Ae = 1;
  var l = iz();
  function e(t, a) {
    for (var r = t.length; r--; )
      if (l(t[r][0], a))
        return r;
    return -1;
  }
  return X0 = e, X0;
}
var Y0, Ve;
function sz() {
  if (Ve) return Y0;
  Ve = 1;
  var l = a0(), e = Array.prototype, t = e.splice;
  function a(r) {
    var o = this.__data__, i = l(o, r);
    if (i < 0)
      return !1;
    var c = o.length - 1;
    return i == c ? o.pop() : t.call(o, i, 1), --this.size, !0;
  }
  return Y0 = a, Y0;
}
var Q0, He;
function dz() {
  if (He) return Q0;
  He = 1;
  var l = a0();
  function e(t) {
    var a = this.__data__, r = l(a, t);
    return r < 0 ? void 0 : a[r][1];
  }
  return Q0 = e, Q0;
}
var e2, Be;
function cz() {
  if (Be) return e2;
  Be = 1;
  var l = a0();
  function e(t) {
    return l(this.__data__, t) > -1;
  }
  return e2 = e, e2;
}
var l2, ze;
function uz() {
  if (ze) return l2;
  ze = 1;
  var l = a0();
  function e(t, a) {
    var r = this.__data__, o = l(r, t);
    return o < 0 ? (++this.size, r.push([t, a])) : r[o][1] = a, this;
  }
  return l2 = e, l2;
}
var t2, Ce;
function vz() {
  if (Ce) return t2;
  Ce = 1;
  var l = oz(), e = sz(), t = dz(), a = cz(), r = uz();
  function o(i) {
    var c = -1, v = i == null ? 0 : i.length;
    for (this.clear(); ++c < v; ) {
      var u = i[c];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = l, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = a, o.prototype.set = r, t2 = o, t2;
}
var n2, Le;
function pz() {
  if (Le) return n2;
  Le = 1;
  var l = fl(), e = B7(), t = l(e, "Map");
  return n2 = t, n2;
}
var a2, Se;
function hz() {
  if (Se) return a2;
  Se = 1;
  var l = rz(), e = vz(), t = pz();
  function a() {
    this.size = 0, this.__data__ = {
      hash: new l(),
      map: new (t || e)(),
      string: new l()
    };
  }
  return a2 = a, a2;
}
var r2, Ee;
function fz() {
  if (Ee) return r2;
  Ee = 1;
  function l(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  return r2 = l, r2;
}
var o2, Te;
function r0() {
  if (Te) return o2;
  Te = 1;
  var l = fz();
  function e(t, a) {
    var r = t.__data__;
    return l(a) ? r[typeof a == "string" ? "string" : "hash"] : r.map;
  }
  return o2 = e, o2;
}
var i2, _e;
function mz() {
  if (_e) return i2;
  _e = 1;
  var l = r0();
  function e(t) {
    var a = l(this, t).delete(t);
    return this.size -= a ? 1 : 0, a;
  }
  return i2 = e, i2;
}
var s2, Re;
function wz() {
  if (Re) return s2;
  Re = 1;
  var l = r0();
  function e(t) {
    return l(this, t).get(t);
  }
  return s2 = e, s2;
}
var d2, ke;
function gz() {
  if (ke) return d2;
  ke = 1;
  var l = r0();
  function e(t) {
    return l(this, t).has(t);
  }
  return d2 = e, d2;
}
var c2, Oe;
function bz() {
  if (Oe) return c2;
  Oe = 1;
  var l = r0();
  function e(t, a) {
    var r = l(this, t), o = r.size;
    return r.set(t, a), this.size += r.size == o ? 0 : 1, this;
  }
  return c2 = e, c2;
}
var u2, $e;
function Mz() {
  if ($e) return u2;
  $e = 1;
  var l = hz(), e = mz(), t = wz(), a = gz(), r = bz();
  function o(i) {
    var c = -1, v = i == null ? 0 : i.length;
    for (this.clear(); ++c < v; ) {
      var u = i[c];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = l, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = a, o.prototype.set = r, u2 = o, u2;
}
var v2, Ne;
function xz() {
  if (Ne) return v2;
  Ne = 1;
  var l = Mz(), e = "Expected a function";
  function t(a, r) {
    if (typeof a != "function" || r != null && typeof r != "function")
      throw new TypeError(e);
    var o = function() {
      var i = arguments, c = r ? r.apply(this, i) : i[0], v = o.cache;
      if (v.has(c))
        return v.get(c);
      var u = a.apply(this, i);
      return o.cache = v.set(c, u) || v, u;
    };
    return o.cache = new (t.Cache || l)(), o;
  }
  return t.Cache = l, v2 = t, v2;
}
var p2, Fe;
function yz() {
  if (Fe) return p2;
  Fe = 1;
  var l = xz(), e = 500;
  function t(a) {
    var r = l(a, function(i) {
      return o.size === e && o.clear(), i;
    }), o = r.cache;
    return r;
  }
  return p2 = t, p2;
}
var h2, De;
function Az() {
  if (De) return h2;
  De = 1;
  var l = yz(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, a = l(function(r) {
    var o = [];
    return r.charCodeAt(0) === 46 && o.push(""), r.replace(e, function(i, c, v, u) {
      o.push(v ? u.replace(t, "$1") : c || i);
    }), o;
  });
  return h2 = a, h2;
}
var f2, Ie;
function Vz() {
  if (Ie) return f2;
  Ie = 1;
  function l(e, t) {
    for (var a = -1, r = e == null ? 0 : e.length, o = Array(r); ++a < r; )
      o[a] = t(e[a], a, e);
    return o;
  }
  return f2 = l, f2;
}
var m2, je;
function Hz() {
  if (je) return m2;
  je = 1;
  var l = z7(), e = Vz(), t = H7(), a = C7(), r = l ? l.prototype : void 0, o = r ? r.toString : void 0;
  function i(c) {
    if (typeof c == "string")
      return c;
    if (t(c))
      return e(c, i) + "";
    if (a(c))
      return o ? o.call(c) : "";
    var v = c + "";
    return v == "0" && 1 / c == -1 / 0 ? "-0" : v;
  }
  return m2 = i, m2;
}
var w2, qe;
function Bz() {
  if (qe) return w2;
  qe = 1;
  var l = Hz();
  function e(t) {
    return t == null ? "" : l(t);
  }
  return w2 = e, w2;
}
var g2, Pe;
function zz() {
  if (Pe) return g2;
  Pe = 1;
  var l = H7(), e = WB(), t = Az(), a = Bz();
  function r(o, i) {
    return l(o) ? o : e(o, i) ? [o] : t(a(o));
  }
  return g2 = r, g2;
}
var b2, Ue;
function Cz() {
  if (Ue) return b2;
  Ue = 1;
  var l = C7();
  function e(t) {
    if (typeof t == "string" || l(t))
      return t;
    var a = t + "";
    return a == "0" && 1 / t == -1 / 0 ? "-0" : a;
  }
  return b2 = e, b2;
}
var M2, Ze;
function Lz() {
  if (Ze) return M2;
  Ze = 1;
  var l = zz(), e = Cz();
  function t(a, r) {
    r = l(r, a);
    for (var o = 0, i = r.length; a != null && o < i; )
      a = a[e(r[o++])];
    return o && o == i ? a : void 0;
  }
  return M2 = t, M2;
}
var x2, We;
function Sz() {
  if (We) return x2;
  We = 1;
  var l = Lz();
  function e(t, a, r) {
    var o = t == null ? void 0 : l(t, a);
    return o === void 0 ? r : o;
  }
  return x2 = e, x2;
}
Sz();
var L7 = (l) => typeof l == "function", o0 = (l) => typeof l == "string", ml = (l) => o0(l) && l.trim().length > 0, Ez = (l) => typeof l == "number", r1 = (l) => typeof l > "u", m1 = (l) => typeof l == "object" && l !== null, Tz = (l) => T5(l, "tag") && ml(l.tag), wl = (l) => window.TouchEvent && l instanceof TouchEvent, gl = (l) => T5(l, "component") && bl(l.component), _z = (l) => L7(l) || m1(l), bl = (l) => !r1(l) && (o0(l) || _z(l) || gl(l)), Ke = (l) => m1(l) && ["height", "width", "right", "left", "top", "bottom"].every((e) => Ez(l[e])), T5 = (l, e) => (m1(l) || L7(l)) && e in l;
function y2(l) {
  return wl(l) ? l.targetTouches[0].clientX : l.clientX;
}
function Je(l) {
  return wl(l) ? l.targetTouches[0].clientY : l.clientY;
}
var Rz = (l) => {
  r1(l.remove) ? l.parentNode && l.parentNode.removeChild(l) : l.remove();
}, M1 = (l) => gl(l) ? M1(l.component) : Tz(l) ? q({
  render() {
    return l;
  }
}) : typeof l == "string" ? l : pt(_(l)), kz = (l) => {
  if (typeof l == "string")
    return l;
  const e = T5(l, "props") && m1(l.props) ? l.props : {}, t = T5(l, "listeners") && m1(l.listeners) ? l.listeners : {};
  return { component: M1(l), props: e, listeners: t };
}, Oz = class {
  constructor() {
    this.allHandlers = {};
  }
  getHandlers(l) {
    return this.allHandlers[l] || [];
  }
  on(l, e) {
    const t = this.getHandlers(l);
    t.push(e), this.allHandlers[l] = t;
  }
  off(l, e) {
    const t = this.getHandlers(l);
    t.splice(t.indexOf(e) >>> 0, 1);
  }
  emit(l, e) {
    this.getHandlers(l).forEach((t) => t(e));
  }
}, v5;
(function(l) {
  l.SUCCESS = "success", l.ERROR = "error", l.WARNING = "warning", l.INFO = "info", l.DEFAULT = "default";
})(v5 || (v5 = {}));
var Z1;
(function(l) {
  l.TOP_LEFT = "top-left", l.TOP_CENTER = "top-center", l.TOP_RIGHT = "top-right", l.BOTTOM_LEFT = "bottom-left", l.BOTTOM_CENTER = "bottom-center", l.BOTTOM_RIGHT = "bottom-right";
})(Z1 || (Z1 = {}));
var $5;
(function(l) {
  l.ADD = "add", l.DISMISS = "dismiss", l.UPDATE = "update", l.CLEAR = "clear", l.UPDATE_DEFAULTS = "update_defaults";
})($5 || ($5 = {}));
var E5 = "Vue-Toastification", m5 = {
  type: {
    type: String,
    default: v5.DEFAULT
  },
  classNames: {
    type: [String, Array],
    default: () => []
  },
  trueBoolean: {
    type: Boolean,
    default: !0
  }
}, Ml = {
  type: m5.type,
  customIcon: {
    type: [String, Boolean, Object, Function],
    default: !0
  }
}, E1 = {
  component: {
    type: [String, Object, Function, Boolean],
    default: "button"
  },
  classNames: m5.classNames,
  showOnHover: {
    type: Boolean,
    default: !1
  },
  ariaLabel: {
    type: String,
    default: "close"
  }
}, e7 = {
  timeout: {
    type: [Number, Boolean],
    default: 5e3
  },
  hideProgressBar: {
    type: Boolean,
    default: !1
  },
  isRunning: {
    type: Boolean,
    default: !1
  }
}, xl = {
  transition: {
    type: [Object, String],
    default: `${E5}__bounce`
  }
}, $z = {
  position: {
    type: String,
    default: Z1.TOP_RIGHT
  },
  draggable: m5.trueBoolean,
  draggablePercent: {
    type: Number,
    default: 0.6
  },
  pauseOnFocusLoss: m5.trueBoolean,
  pauseOnHover: m5.trueBoolean,
  closeOnClick: m5.trueBoolean,
  timeout: e7.timeout,
  hideProgressBar: e7.hideProgressBar,
  toastClassName: m5.classNames,
  bodyClassName: m5.classNames,
  icon: Ml.customIcon,
  closeButton: E1.component,
  closeButtonClassName: E1.classNames,
  showCloseButtonOnHover: E1.showOnHover,
  accessibility: {
    type: Object,
    default: () => ({
      toastRole: "alert",
      closeButtonLabel: "close"
    })
  },
  rtl: {
    type: Boolean,
    default: !1
  },
  eventBus: {
    type: Object,
    required: !1,
    default: () => new Oz()
  }
}, Nz = {
  id: {
    type: [String, Number],
    required: !0,
    default: 0
  },
  type: m5.type,
  content: {
    type: [String, Object, Function],
    required: !0,
    default: ""
  },
  onClick: {
    type: Function,
    default: void 0
  },
  onClose: {
    type: Function,
    default: void 0
  }
}, Fz = {
  container: {
    type: [
      Object,
      Function
    ],
    default: () => document.body
  },
  newestOnTop: m5.trueBoolean,
  maxToasts: {
    type: Number,
    default: 20
  },
  transition: xl.transition,
  toastDefaults: Object,
  filterBeforeCreate: {
    type: Function,
    default: (l) => l
  },
  filterToasts: {
    type: Function,
    default: (l) => l
  },
  containerClassName: m5.classNames,
  onMounted: Function,
  shareAppContext: [Boolean, Object]
}, _5 = {
  CORE_TOAST: $z,
  TOAST: Nz,
  CONTAINER: Fz,
  PROGRESS_BAR: e7,
  ICON: Ml,
  TRANSITION: xl,
  CLOSE_BUTTON: E1
}, yl = q({
  name: "VtProgressBar",
  props: _5.PROGRESS_BAR,
  data() {
    return {
      hasClass: !0
    };
  },
  computed: {
    style() {
      return {
        animationDuration: `${this.timeout}ms`,
        animationPlayState: this.isRunning ? "running" : "paused",
        opacity: this.hideProgressBar ? 0 : 1
      };
    },
    cpClass() {
      return this.hasClass ? `${E5}__progress-bar` : "";
    }
  },
  watch: {
    timeout() {
      this.hasClass = !1, this.$nextTick(() => this.hasClass = !0);
    }
  },
  mounted() {
    this.$el.addEventListener("animationend", this.animationEnded);
  },
  beforeUnmount() {
    this.$el.removeEventListener("animationend", this.animationEnded);
  },
  methods: {
    animationEnded() {
      this.$emit("close-toast");
    }
  }
});
function Dz(l, e) {
  return B(), R("div", {
    style: F5(l.style),
    class: Y(l.cpClass)
  }, null, 6);
}
yl.render = Dz;
var Iz = yl, Al = q({
  name: "VtCloseButton",
  props: _5.CLOSE_BUTTON,
  computed: {
    buttonComponent() {
      return this.component !== !1 ? M1(this.component) : "button";
    },
    classes() {
      const l = [`${E5}__close-button`];
      return this.showOnHover && l.push("show-on-hover"), l.concat(this.classNames);
    }
  }
}), jz = /* @__PURE__ */ a5(" × ");
function qz(l, e) {
  return B(), F(S5(l.buttonComponent), X1({
    "aria-label": l.ariaLabel,
    class: l.classes
  }, l.$attrs), {
    default: T(() => [
      jz
    ]),
    _: 1
  }, 16, ["aria-label", "class"]);
}
Al.render = qz;
var Pz = Al, Vl = {}, Uz = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "check-circle",
  class: "svg-inline--fa fa-check-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, Zz = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  d: "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
}, null, -1), Wz = [
  Zz
];
function Kz(l, e) {
  return B(), R("svg", Uz, Wz);
}
Vl.render = Kz;
var Jz = Vl, Hl = {}, Gz = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "info-circle",
  class: "svg-inline--fa fa-info-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, Xz = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
}, null, -1), Yz = [
  Xz
];
function Qz(l, e) {
  return B(), R("svg", Gz, Yz);
}
Hl.render = Qz;
var Ge = Hl, Bl = {}, eC = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "exclamation-circle",
  class: "svg-inline--fa fa-exclamation-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, lC = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  d: "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
}, null, -1), tC = [
  lC
];
function nC(l, e) {
  return B(), R("svg", eC, tC);
}
Bl.render = nC;
var aC = Bl, zl = {}, rC = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "exclamation-triangle",
  class: "svg-inline--fa fa-exclamation-triangle fa-w-18",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, oC = /* @__PURE__ */ U("path", {
  fill: "currentColor",
  d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
}, null, -1), iC = [
  oC
];
function sC(l, e) {
  return B(), R("svg", rC, iC);
}
zl.render = sC;
var dC = zl, Cl = q({
  name: "VtIcon",
  props: _5.ICON,
  computed: {
    customIconChildren() {
      return T5(this.customIcon, "iconChildren") ? this.trimValue(this.customIcon.iconChildren) : "";
    },
    customIconClass() {
      return o0(this.customIcon) ? this.trimValue(this.customIcon) : T5(this.customIcon, "iconClass") ? this.trimValue(this.customIcon.iconClass) : "";
    },
    customIconTag() {
      return T5(this.customIcon, "iconTag") ? this.trimValue(this.customIcon.iconTag, "i") : "i";
    },
    hasCustomIcon() {
      return this.customIconClass.length > 0;
    },
    component() {
      return this.hasCustomIcon ? this.customIconTag : bl(this.customIcon) ? M1(this.customIcon) : this.iconTypeComponent;
    },
    iconTypeComponent() {
      return {
        [v5.DEFAULT]: Ge,
        [v5.INFO]: Ge,
        [v5.SUCCESS]: Jz,
        [v5.ERROR]: dC,
        [v5.WARNING]: aC
      }[this.type];
    },
    iconClasses() {
      const l = [`${E5}__icon`];
      return this.hasCustomIcon ? l.concat(this.customIconClass) : l;
    }
  },
  methods: {
    trimValue(l, e = "") {
      return ml(l) ? l.trim() : e;
    }
  }
});
function cC(l, e) {
  return B(), F(S5(l.component), {
    class: Y(l.iconClasses)
  }, {
    default: T(() => [
      a5(Q(l.customIconChildren), 1)
    ]),
    _: 1
  }, 8, ["class"]);
}
Cl.render = cC;
var uC = Cl, Ll = q({
  name: "VtToast",
  components: { ProgressBar: Iz, CloseButton: Pz, Icon: uC },
  inheritAttrs: !1,
  props: Object.assign({}, _5.CORE_TOAST, _5.TOAST),
  data() {
    return {
      isRunning: !0,
      disableTransitions: !1,
      beingDragged: !1,
      dragStart: 0,
      dragPos: { x: 0, y: 0 },
      dragRect: {}
    };
  },
  computed: {
    classes() {
      const l = [
        `${E5}__toast`,
        `${E5}__toast--${this.type}`,
        `${this.position}`
      ].concat(this.toastClassName);
      return this.disableTransitions && l.push("disable-transition"), this.rtl && l.push(`${E5}__toast--rtl`), l;
    },
    bodyClasses() {
      return [
        `${E5}__toast-${o0(this.content) ? "body" : "component-body"}`
      ].concat(this.bodyClassName);
    },
    draggableStyle() {
      return this.dragStart === this.dragPos.x ? {} : this.beingDragged ? {
        transform: `translateX(${this.dragDelta}px)`,
        opacity: 1 - Math.abs(this.dragDelta / this.removalDistance)
      } : {
        transition: "transform 0.2s, opacity 0.2s",
        transform: "translateX(0)",
        opacity: 1
      };
    },
    dragDelta() {
      return this.beingDragged ? this.dragPos.x - this.dragStart : 0;
    },
    removalDistance() {
      return Ke(this.dragRect) ? (this.dragRect.right - this.dragRect.left) * this.draggablePercent : 0;
    }
  },
  mounted() {
    this.draggable && this.draggableSetup(), this.pauseOnFocusLoss && this.focusSetup();
  },
  beforeUnmount() {
    this.draggable && this.draggableCleanup(), this.pauseOnFocusLoss && this.focusCleanup();
  },
  methods: {
    hasProp: T5,
    getVueComponentFromObj: M1,
    closeToast() {
      this.eventBus.emit($5.DISMISS, this.id);
    },
    clickHandler() {
      this.onClick && this.onClick(this.closeToast), this.closeOnClick && (!this.beingDragged || this.dragStart === this.dragPos.x) && this.closeToast();
    },
    timeoutHandler() {
      this.closeToast();
    },
    hoverPause() {
      this.pauseOnHover && (this.isRunning = !1);
    },
    hoverPlay() {
      this.pauseOnHover && (this.isRunning = !0);
    },
    focusPause() {
      this.isRunning = !1;
    },
    focusPlay() {
      this.isRunning = !0;
    },
    focusSetup() {
      addEventListener("blur", this.focusPause), addEventListener("focus", this.focusPlay);
    },
    focusCleanup() {
      removeEventListener("blur", this.focusPause), removeEventListener("focus", this.focusPlay);
    },
    draggableSetup() {
      const l = this.$el;
      l.addEventListener("touchstart", this.onDragStart, {
        passive: !0
      }), l.addEventListener("mousedown", this.onDragStart), addEventListener("touchmove", this.onDragMove, { passive: !1 }), addEventListener("mousemove", this.onDragMove), addEventListener("touchend", this.onDragEnd), addEventListener("mouseup", this.onDragEnd);
    },
    draggableCleanup() {
      const l = this.$el;
      l.removeEventListener("touchstart", this.onDragStart), l.removeEventListener("mousedown", this.onDragStart), removeEventListener("touchmove", this.onDragMove), removeEventListener("mousemove", this.onDragMove), removeEventListener("touchend", this.onDragEnd), removeEventListener("mouseup", this.onDragEnd);
    },
    onDragStart(l) {
      this.beingDragged = !0, this.dragPos = { x: y2(l), y: Je(l) }, this.dragStart = y2(l), this.dragRect = this.$el.getBoundingClientRect();
    },
    onDragMove(l) {
      this.beingDragged && (l.preventDefault(), this.isRunning && (this.isRunning = !1), this.dragPos = { x: y2(l), y: Je(l) });
    },
    onDragEnd() {
      this.beingDragged && (Math.abs(this.dragDelta) >= this.removalDistance ? (this.disableTransitions = !0, this.$nextTick(() => this.closeToast())) : setTimeout(() => {
        this.beingDragged = !1, Ke(this.dragRect) && this.pauseOnHover && this.dragRect.bottom >= this.dragPos.y && this.dragPos.y >= this.dragRect.top && this.dragRect.left <= this.dragPos.x && this.dragPos.x <= this.dragRect.right ? this.isRunning = !1 : this.isRunning = !0;
      }));
    }
  }
}), vC = ["role"];
function pC(l, e) {
  const t = p1("Icon"), a = p1("CloseButton"), r = p1("ProgressBar");
  return B(), R("div", {
    class: Y(l.classes),
    style: F5(l.draggableStyle),
    onClick: e[0] || (e[0] = (...o) => l.clickHandler && l.clickHandler(...o)),
    onMouseenter: e[1] || (e[1] = (...o) => l.hoverPause && l.hoverPause(...o)),
    onMouseleave: e[2] || (e[2] = (...o) => l.hoverPlay && l.hoverPlay(...o))
  }, [
    l.icon ? (B(), F(t, {
      key: 0,
      "custom-icon": l.icon,
      type: l.type
    }, null, 8, ["custom-icon", "type"])) : $("v-if", !0),
    U("div", {
      role: l.accessibility.toastRole || "alert",
      class: Y(l.bodyClasses)
    }, [
      typeof l.content == "string" ? (B(), R(p5, { key: 0 }, [
        a5(Q(l.content), 1)
      ], 2112)) : (B(), F(S5(l.getVueComponentFromObj(l.content)), X1({
        key: 1,
        "toast-id": l.id
      }, l.hasProp(l.content, "props") ? l.content.props : {}, ft(l.hasProp(l.content, "listeners") ? l.content.listeners : {}), { onCloseToast: l.closeToast }), null, 16, ["toast-id", "onCloseToast"]))
    ], 10, vC),
    l.closeButton ? (B(), F(a, {
      key: 1,
      component: l.closeButton,
      "class-names": l.closeButtonClassName,
      "show-on-hover": l.showCloseButtonOnHover,
      "aria-label": l.accessibility.closeButtonLabel,
      onClick: z3(l.closeToast, ["stop"])
    }, null, 8, ["component", "class-names", "show-on-hover", "aria-label", "onClick"])) : $("v-if", !0),
    l.timeout ? (B(), F(r, {
      key: 2,
      "is-running": l.isRunning,
      "hide-progress-bar": l.hideProgressBar,
      timeout: l.timeout,
      onCloseToast: l.timeoutHandler
    }, null, 8, ["is-running", "hide-progress-bar", "timeout", "onCloseToast"])) : $("v-if", !0)
  ], 38);
}
Ll.render = pC;
var hC = Ll, Sl = q({
  name: "VtTransition",
  props: _5.TRANSITION,
  emits: ["leave"],
  methods: {
    hasProp: T5,
    leave(l) {
      l instanceof HTMLElement && (l.style.left = l.offsetLeft + "px", l.style.top = l.offsetTop + "px", l.style.width = getComputedStyle(l).width, l.style.position = "absolute");
    }
  }
});
function fC(l, e) {
  return B(), F(mt, {
    tag: "div",
    "enter-active-class": l.transition.enter ? l.transition.enter : `${l.transition}-enter-active`,
    "move-class": l.transition.move ? l.transition.move : `${l.transition}-move`,
    "leave-active-class": l.transition.leave ? l.transition.leave : `${l.transition}-leave-active`,
    onLeave: l.leave
  }, {
    default: T(() => [
      L(l.$slots, "default")
    ]),
    _: 3
  }, 8, ["enter-active-class", "move-class", "leave-active-class", "onLeave"]);
}
Sl.render = fC;
var mC = Sl, wC = q({
  name: "VueToastification",
  devtools: {
    hide: !0
  },
  components: { Toast: hC, VtTransition: mC },
  props: Object.assign({}, _5.CORE_TOAST, _5.CONTAINER, _5.TRANSITION),
  data() {
    return {
      count: 0,
      positions: Object.values(Z1),
      toasts: {},
      defaults: {}
    };
  },
  computed: {
    toastArray() {
      return Object.values(this.toasts);
    },
    filteredToasts() {
      return this.defaults.filterToasts(this.toastArray);
    }
  },
  beforeMount() {
    const l = this.eventBus;
    l.on($5.ADD, this.addToast), l.on($5.CLEAR, this.clearToasts), l.on($5.DISMISS, this.dismissToast), l.on($5.UPDATE, this.updateToast), l.on($5.UPDATE_DEFAULTS, this.updateDefaults), this.defaults = this.$props;
  },
  mounted() {
    this.setup(this.container);
  },
  methods: {
    async setup(l) {
      L7(l) && (l = await l()), Rz(this.$el), l.appendChild(this.$el);
    },
    setToast(l) {
      r1(l.id) || (this.toasts[l.id] = l);
    },
    addToast(l) {
      l.content = kz(l.content);
      const e = Object.assign({}, this.defaults, l.type && this.defaults.toastDefaults && this.defaults.toastDefaults[l.type], l), t = this.defaults.filterBeforeCreate(e, this.toastArray);
      t && this.setToast(t);
    },
    dismissToast(l) {
      const e = this.toasts[l];
      !r1(e) && !r1(e.onClose) && e.onClose(), delete this.toasts[l];
    },
    clearToasts() {
      Object.keys(this.toasts).forEach((l) => {
        this.dismissToast(l);
      });
    },
    getPositionToasts(l) {
      const e = this.filteredToasts.filter((t) => t.position === l).slice(0, this.defaults.maxToasts);
      return this.defaults.newestOnTop ? e.reverse() : e;
    },
    updateDefaults(l) {
      r1(l.container) || this.setup(l.container), this.defaults = Object.assign({}, this.defaults, l);
    },
    updateToast({
      id: l,
      options: e,
      create: t
    }) {
      this.toasts[l] ? (e.timeout && e.timeout === this.toasts[l].timeout && e.timeout++, this.setToast(Object.assign({}, this.toasts[l], e))) : t && this.addToast(Object.assign({}, { id: l }, e));
    },
    getClasses(l) {
      return [`${E5}__container`, l].concat(this.defaults.containerClassName);
    }
  }
});
function gC(l, e) {
  const t = p1("Toast"), a = p1("VtTransition");
  return B(), R("div", null, [
    (B(!0), R(p5, null, J5(l.positions, (r) => (B(), R("div", { key: r }, [
      X(a, {
        transition: l.defaults.transition,
        class: Y(l.getClasses(r))
      }, {
        default: T(() => [
          (B(!0), R(p5, null, J5(l.getPositionToasts(r), (o) => (B(), F(t, X1({
            key: o.id
          }, o), null, 16))), 128))
        ]),
        _: 2
      }, 1032, ["transition", "class"])
    ]))), 128))
  ]);
}
wC.render = gC;
const z1 = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info"
};
z1.success + "", v5.SUCCESS, z1.error + "", v5.ERROR, z1.warning + "", v5.WARNING, z1.info + "", v5.INFO;
function bC(l) {
  return l.toLowerCase().replace(/(^|[\s'-])\S/g, (e) => e.toUpperCase());
}
function MC(l, e = "\\s") {
  return l.replace(new RegExp(`^[${e}]*(.*?)[${e}]*$`), "$1");
}
const El = (l) => MC(l, "\\s'-").replaceAll(/\s\s+/g, " "), xC = (l) => bC(El(l)), Xe = (l) => El(l).toUpperCase(), S7 = (l) => l.replace(/(.)(?=.*\1)/g, "").replace(/(.)(?=.)/g, "$1 "), yC = (l, e) => l.replaceAll(new RegExp(`[${e}]+`, "ig"), "");
function AC(l, e) {
  const t = l ? yC(l, e.charsClass) : void 0;
  return t ? `Le champ contient des caractères non autorisés : ${S7(t)}` : !0;
}
const VC = (l, e) => {
  const t = e.split("").map((r) => `\\${r}\\${r}+`).join("|"), a = l == null ? void 0 : l.match(new RegExp(t, "g"));
  return a != null && a.length ? a.join("") : void 0;
};
function HC(l, e) {
  const t = l ? VC(l, e.chars) : void 0;
  return t ? `Les caractères suivants ne peuvent pas être présents plusieurs fois de suite : ${S7(t)}` : !0;
}
const BC = (l, e) => l.trim().length > e;
function zC(l, e) {
  return l && BC(l, e.maxLength) ? `Le champ doit contenir au maximum ${e.maxLength} caractères` : !0;
}
async function CC(l, { rules: e, bails: t = !0 }) {
  const a = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r], i = await Promise.resolve(o(l, void 0));
    if (!(typeof i != "string" && !Array.isArray(i) && i)) {
      if (Array.isArray(i))
        a.push(...i);
      else {
        const v = typeof i == "string" ? i : "Le champ est invalide";
        a.push(v);
      }
      if (t)
        return a.length > 0 ? a : !0;
    }
  }
  return a.length > 0 ? a : !0;
}
const LC = (l) => l == null, SC = (l) => Array.isArray(l) && l.length === 0, Tl = (l) => LC(l) || SC(l) || l === !1 ? !1 : !!String(l).trim().length;
function EC(l) {
  return Tl(l) ? !0 : "Le champ est obligatoire";
}
const TC = (l, e) => {
  const t = l.trim(), a = t.match(new RegExp(`^[${e}]+`, "g")), r = t.match(new RegExp(`[${e}]+$`, "g"));
  if (a != null && a.length || r != null && r.length) {
    const o = (a == null ? void 0 : a.join("")) ?? "", i = (r == null ? void 0 : r.join("")) ?? "";
    return `${o}${i}`;
  }
};
function _C(l, e) {
  const t = l ? TC(l, e.charsClass) : void 0;
  return t ? `Les caractères suivants ne peuvent pas être présents comme premier ou dernier caractère : ${S7(t)}` : !0;
}
const RC = 1, _l = 75;
async function DS(l, e = { isRequired: !1 }) {
  const t = "a-zàâäçéèêëîïôöùûüÿæœ'-\\s", a = "-'", r = "-'", o = [
    (i) => zC(i, { maxLength: _l }),
    (i) => AC(i, { charsClass: t }),
    (i) => HC(i, { chars: a }),
    (i) => _C(i, { charsClass: r })
  ];
  return e.isRequired && o.unshift(EC), CC(l, { rules: o, bails: !1 });
}
const IS = /* @__PURE__ */ q({
  __name: "TotemBusinessDenominationPersonnePhysique",
  props: /* @__PURE__ */ c5({
    color: { default: void 0 },
    details: { default: () => [] },
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    prefixIconName: { default: void 0 },
    affixIconName: { default: void 0 },
    suffixIconName: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: void 0 },
    typeDenomination: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ c5(["blur", "focus"], ["update:modelValue"]),
  setup(l, { emit: e }) {
    const t = l, a = e, r = H5(l, "modelValue"), o = /* @__PURE__ */ new Map([
      ["nom", "Nom"],
      ["nom-naissance", "Nom de naissance"],
      ["prenom", "Prénom"]
    ]), i = /* @__PURE__ */ new Map([
      ["nom", "DURAND"],
      ["nom-naissance", "LEROY"],
      ["prenom", "Camille"]
    ]), c = k(() => o.get(t.typeDenomination)), v = k(() => i.get(t.typeDenomination)), u = (p) => {
      a("blur", p);
    }, h = (p) => {
      a("focus", p);
    };
    return (p, m) => (B(), F(_(jB), {
      id: p.id,
      modelValue: r.value,
      "onUpdate:modelValue": m[0] || (m[0] = (g) => r.value = g),
      name: p.name,
      label: c.value,
      placeholder: v.value,
      color: p.color,
      details: p.details,
      "optional-flag": p.optionalFlag,
      "required-flag": p.requiredFlag,
      disabled: p.disabled,
      readonly: p.readonly,
      "prefix-icon-name": p.prefixIconName,
      "affix-icon-name": p.affixIconName,
      "suffix-icon-name": p.suffixIconName,
      minlength: _(RC),
      maxlength: _(_l),
      class: "totem-business-denomination-personne-physique",
      onBlur: u,
      onFocus: h
    }, null, 8, ["id", "modelValue", "name", "label", "placeholder", "color", "details", "optional-flag", "required-flag", "disabled", "readonly", "prefix-icon-name", "affix-icon-name", "suffix-icon-name", "minlength", "maxlength"]));
  }
});
function Rl(l, e) {
  return function() {
    return l.apply(e, arguments);
  };
}
const { toString: kC } = Object.prototype, { getPrototypeOf: E7 } = Object, { iterator: i0, toStringTag: kl } = Symbol, s0 = /* @__PURE__ */ ((l) => (e) => {
  const t = kC.call(e);
  return l[t] || (l[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), x5 = (l) => (l = l.toLowerCase(), (e) => s0(e) === l), d0 = (l) => (e) => typeof e === l, { isArray: c1 } = Array, w1 = d0("undefined");
function OC(l) {
  return l !== null && !w1(l) && l.constructor !== null && !w1(l.constructor) && o5(l.constructor.isBuffer) && l.constructor.isBuffer(l);
}
const Ol = x5("ArrayBuffer");
function $C(l) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(l) : e = l && l.buffer && Ol(l.buffer), e;
}
const NC = d0("string"), o5 = d0("function"), $l = d0("number"), c0 = (l) => l !== null && typeof l == "object", FC = (l) => l === !0 || l === !1, T1 = (l) => {
  if (s0(l) !== "object")
    return !1;
  const e = E7(l);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(kl in l) && !(i0 in l);
}, DC = x5("Date"), IC = x5("File"), jC = x5("Blob"), qC = x5("FileList"), PC = (l) => c0(l) && o5(l.pipe), UC = (l) => {
  let e;
  return l && (typeof FormData == "function" && l instanceof FormData || o5(l.append) && ((e = s0(l)) === "formdata" || // detect form-data instance
  e === "object" && o5(l.toString) && l.toString() === "[object FormData]"));
}, ZC = x5("URLSearchParams"), [WC, KC, JC, GC] = ["ReadableStream", "Request", "Response", "Headers"].map(x5), XC = (l) => l.trim ? l.trim() : l.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function x1(l, e, { allOwnKeys: t = !1 } = {}) {
  if (l === null || typeof l > "u")
    return;
  let a, r;
  if (typeof l != "object" && (l = [l]), c1(l))
    for (a = 0, r = l.length; a < r; a++)
      e.call(null, l[a], a, l);
  else {
    const o = t ? Object.getOwnPropertyNames(l) : Object.keys(l), i = o.length;
    let c;
    for (a = 0; a < i; a++)
      c = o[a], e.call(null, l[c], c, l);
  }
}
function Nl(l, e) {
  e = e.toLowerCase();
  const t = Object.keys(l);
  let a = t.length, r;
  for (; a-- > 0; )
    if (r = t[a], e === r.toLowerCase())
      return r;
  return null;
}
const q5 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Fl = (l) => !w1(l) && l !== q5;
function l7() {
  const { caseless: l } = Fl(this) && this || {}, e = {}, t = (a, r) => {
    const o = l && Nl(e, r) || r;
    T1(e[o]) && T1(a) ? e[o] = l7(e[o], a) : T1(a) ? e[o] = l7({}, a) : c1(a) ? e[o] = a.slice() : e[o] = a;
  };
  for (let a = 0, r = arguments.length; a < r; a++)
    arguments[a] && x1(arguments[a], t);
  return e;
}
const YC = (l, e, t, { allOwnKeys: a } = {}) => (x1(e, (r, o) => {
  t && o5(r) ? l[o] = Rl(r, t) : l[o] = r;
}, { allOwnKeys: a }), l), QC = (l) => (l.charCodeAt(0) === 65279 && (l = l.slice(1)), l), eL = (l, e, t, a) => {
  l.prototype = Object.create(e.prototype, a), l.prototype.constructor = l, Object.defineProperty(l, "super", {
    value: e.prototype
  }), t && Object.assign(l.prototype, t);
}, lL = (l, e, t, a) => {
  let r, o, i;
  const c = {};
  if (e = e || {}, l == null) return e;
  do {
    for (r = Object.getOwnPropertyNames(l), o = r.length; o-- > 0; )
      i = r[o], (!a || a(i, l, e)) && !c[i] && (e[i] = l[i], c[i] = !0);
    l = t !== !1 && E7(l);
  } while (l && (!t || t(l, e)) && l !== Object.prototype);
  return e;
}, tL = (l, e, t) => {
  l = String(l), (t === void 0 || t > l.length) && (t = l.length), t -= e.length;
  const a = l.indexOf(e, t);
  return a !== -1 && a === t;
}, nL = (l) => {
  if (!l) return null;
  if (c1(l)) return l;
  let e = l.length;
  if (!$l(e)) return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = l[e];
  return t;
}, aL = /* @__PURE__ */ ((l) => (e) => l && e instanceof l)(typeof Uint8Array < "u" && E7(Uint8Array)), rL = (l, e) => {
  const a = (l && l[i0]).call(l);
  let r;
  for (; (r = a.next()) && !r.done; ) {
    const o = r.value;
    e.call(l, o[0], o[1]);
  }
}, oL = (l, e) => {
  let t;
  const a = [];
  for (; (t = l.exec(e)) !== null; )
    a.push(t);
  return a;
}, iL = x5("HTMLFormElement"), sL = (l) => l.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, a, r) {
    return a.toUpperCase() + r;
  }
), Ye = (({ hasOwnProperty: l }) => (e, t) => l.call(e, t))(Object.prototype), dL = x5("RegExp"), Dl = (l, e) => {
  const t = Object.getOwnPropertyDescriptors(l), a = {};
  x1(t, (r, o) => {
    let i;
    (i = e(r, o, l)) !== !1 && (a[o] = i || r);
  }), Object.defineProperties(l, a);
}, cL = (l) => {
  Dl(l, (e, t) => {
    if (o5(l) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const a = l[t];
    if (o5(a)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, uL = (l, e) => {
  const t = {}, a = (r) => {
    r.forEach((o) => {
      t[o] = !0;
    });
  };
  return c1(l) ? a(l) : a(String(l).split(e)), t;
}, vL = () => {
}, pL = (l, e) => l != null && Number.isFinite(l = +l) ? l : e;
function hL(l) {
  return !!(l && o5(l.append) && l[kl] === "FormData" && l[i0]);
}
const fL = (l) => {
  const e = new Array(10), t = (a, r) => {
    if (c0(a)) {
      if (e.indexOf(a) >= 0)
        return;
      if (!("toJSON" in a)) {
        e[r] = a;
        const o = c1(a) ? [] : {};
        return x1(a, (i, c) => {
          const v = t(i, r + 1);
          !w1(v) && (o[c] = v);
        }), e[r] = void 0, o;
      }
    }
    return a;
  };
  return t(l, 0);
}, mL = x5("AsyncFunction"), wL = (l) => l && (c0(l) || o5(l)) && o5(l.then) && o5(l.catch), Il = ((l, e) => l ? setImmediate : e ? ((t, a) => (q5.addEventListener("message", ({ source: r, data: o }) => {
  r === q5 && o === t && a.length && a.shift()();
}, !1), (r) => {
  a.push(r), q5.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  o5(q5.postMessage)
), gL = typeof queueMicrotask < "u" ? queueMicrotask.bind(q5) : typeof process < "u" && process.nextTick || Il, bL = (l) => l != null && o5(l[i0]), b = {
  isArray: c1,
  isArrayBuffer: Ol,
  isBuffer: OC,
  isFormData: UC,
  isArrayBufferView: $C,
  isString: NC,
  isNumber: $l,
  isBoolean: FC,
  isObject: c0,
  isPlainObject: T1,
  isReadableStream: WC,
  isRequest: KC,
  isResponse: JC,
  isHeaders: GC,
  isUndefined: w1,
  isDate: DC,
  isFile: IC,
  isBlob: jC,
  isRegExp: dL,
  isFunction: o5,
  isStream: PC,
  isURLSearchParams: ZC,
  isTypedArray: aL,
  isFileList: qC,
  forEach: x1,
  merge: l7,
  extend: YC,
  trim: XC,
  stripBOM: QC,
  inherits: eL,
  toFlatObject: lL,
  kindOf: s0,
  kindOfTest: x5,
  endsWith: tL,
  toArray: nL,
  forEachEntry: rL,
  matchAll: oL,
  isHTMLForm: iL,
  hasOwnProperty: Ye,
  hasOwnProp: Ye,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Dl,
  freezeMethods: cL,
  toObjectSet: uL,
  toCamelCase: sL,
  noop: vL,
  toFiniteNumber: pL,
  findKey: Nl,
  global: q5,
  isContextDefined: Fl,
  isSpecCompliantForm: hL,
  toJSONObject: fL,
  isAsyncFn: mL,
  isThenable: wL,
  setImmediate: Il,
  asap: gL,
  isIterable: bL
};
function N(l, e, t, a, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = l, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), a && (this.request = a), r && (this.response = r, this.status = r.status ? r.status : null);
}
b.inherits(N, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: b.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const jl = N.prototype, ql = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((l) => {
  ql[l] = { value: l };
});
Object.defineProperties(N, ql);
Object.defineProperty(jl, "isAxiosError", { value: !0 });
N.from = (l, e, t, a, r, o) => {
  const i = Object.create(jl);
  return b.toFlatObject(l, i, function(v) {
    return v !== Error.prototype;
  }, (c) => c !== "isAxiosError"), N.call(i, l.message, e, t, a, r), i.cause = l, i.name = l.name, o && Object.assign(i, o), i;
};
const ML = null;
function t7(l) {
  return b.isPlainObject(l) || b.isArray(l);
}
function Pl(l) {
  return b.endsWith(l, "[]") ? l.slice(0, -2) : l;
}
function Qe(l, e, t) {
  return l ? l.concat(e).map(function(r, o) {
    return r = Pl(r), !t && o ? "[" + r + "]" : r;
  }).join(t ? "." : "") : e;
}
function xL(l) {
  return b.isArray(l) && !l.some(t7);
}
const yL = b.toFlatObject(b, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function u0(l, e, t) {
  if (!b.isObject(l))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = b.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(x, f) {
    return !b.isUndefined(f[x]);
  });
  const a = t.metaTokens, r = t.visitor || h, o = t.dots, i = t.indexes, v = (t.Blob || typeof Blob < "u" && Blob) && b.isSpecCompliantForm(e);
  if (!b.isFunction(r))
    throw new TypeError("visitor must be a function");
  function u(w) {
    if (w === null) return "";
    if (b.isDate(w))
      return w.toISOString();
    if (!v && b.isBlob(w))
      throw new N("Blob is not supported. Use a Buffer instead.");
    return b.isArrayBuffer(w) || b.isTypedArray(w) ? v && typeof Blob == "function" ? new Blob([w]) : Buffer.from(w) : w;
  }
  function h(w, x, f) {
    let M = w;
    if (w && !f && typeof w == "object") {
      if (b.endsWith(x, "{}"))
        x = a ? x : x.slice(0, -2), w = JSON.stringify(w);
      else if (b.isArray(w) && xL(w) || (b.isFileList(w) || b.endsWith(x, "[]")) && (M = b.toArray(w)))
        return x = Pl(x), M.forEach(function(C, S) {
          !(b.isUndefined(C) || C === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Qe([x], S, o) : i === null ? x : x + "[]",
            u(C)
          );
        }), !1;
    }
    return t7(w) ? !0 : (e.append(Qe(f, x, o), u(w)), !1);
  }
  const p = [], m = Object.assign(yL, {
    defaultVisitor: h,
    convertValue: u,
    isVisitable: t7
  });
  function g(w, x) {
    if (!b.isUndefined(w)) {
      if (p.indexOf(w) !== -1)
        throw Error("Circular reference detected in " + x.join("."));
      p.push(w), b.forEach(w, function(M, V) {
        (!(b.isUndefined(M) || M === null) && r.call(
          e,
          M,
          b.isString(V) ? V.trim() : V,
          x,
          m
        )) === !0 && g(M, x ? x.concat(V) : [V]);
      }), p.pop();
    }
  }
  if (!b.isObject(l))
    throw new TypeError("data must be an object");
  return g(l), e;
}
function e3(l) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(l).replace(/[!'()~]|%20|%00/g, function(a) {
    return e[a];
  });
}
function T7(l, e) {
  this._pairs = [], l && u0(l, this, e);
}
const Ul = T7.prototype;
Ul.append = function(e, t) {
  this._pairs.push([e, t]);
};
Ul.toString = function(e) {
  const t = e ? function(a) {
    return e.call(this, a, e3);
  } : e3;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
function AL(l) {
  return encodeURIComponent(l).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Zl(l, e, t) {
  if (!e)
    return l;
  const a = t && t.encode || AL;
  b.isFunction(t) && (t = {
    serialize: t
  });
  const r = t && t.serialize;
  let o;
  if (r ? o = r(e, t) : o = b.isURLSearchParams(e) ? e.toString() : new T7(e, t).toString(a), o) {
    const i = l.indexOf("#");
    i !== -1 && (l = l.slice(0, i)), l += (l.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return l;
}
class l3 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, a) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: a ? a.synchronous : !1,
      runWhen: a ? a.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    b.forEach(this.handlers, function(a) {
      a !== null && e(a);
    });
  }
}
const Wl = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, VL = typeof URLSearchParams < "u" ? URLSearchParams : T7, HL = typeof FormData < "u" ? FormData : null, BL = typeof Blob < "u" ? Blob : null, zL = {
  isBrowser: !0,
  classes: {
    URLSearchParams: VL,
    FormData: HL,
    Blob: BL
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, _7 = typeof window < "u" && typeof document < "u", n7 = typeof navigator == "object" && navigator || void 0, CL = _7 && (!n7 || ["ReactNative", "NativeScript", "NS"].indexOf(n7.product) < 0), LL = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", SL = _7 && window.location.href || "http://localhost", EL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: _7,
  hasStandardBrowserEnv: CL,
  hasStandardBrowserWebWorkerEnv: LL,
  navigator: n7,
  origin: SL
}, Symbol.toStringTag, { value: "Module" })), n5 = {
  ...EL,
  ...zL
};
function TL(l, e) {
  return u0(l, new n5.classes.URLSearchParams(), Object.assign({
    visitor: function(t, a, r, o) {
      return n5.isNode && b.isBuffer(t) ? (this.append(a, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function _L(l) {
  return b.matchAll(/\w+|\[(\w*)]/g, l).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function RL(l) {
  const e = {}, t = Object.keys(l);
  let a;
  const r = t.length;
  let o;
  for (a = 0; a < r; a++)
    o = t[a], e[o] = l[o];
  return e;
}
function Kl(l) {
  function e(t, a, r, o) {
    let i = t[o++];
    if (i === "__proto__") return !0;
    const c = Number.isFinite(+i), v = o >= t.length;
    return i = !i && b.isArray(r) ? r.length : i, v ? (b.hasOwnProp(r, i) ? r[i] = [r[i], a] : r[i] = a, !c) : ((!r[i] || !b.isObject(r[i])) && (r[i] = []), e(t, a, r[i], o) && b.isArray(r[i]) && (r[i] = RL(r[i])), !c);
  }
  if (b.isFormData(l) && b.isFunction(l.entries)) {
    const t = {};
    return b.forEachEntry(l, (a, r) => {
      e(_L(a), r, t, 0);
    }), t;
  }
  return null;
}
function kL(l, e, t) {
  if (b.isString(l))
    try {
      return (e || JSON.parse)(l), b.trim(l);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (t || JSON.stringify)(l);
}
const y1 = {
  transitional: Wl,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const a = t.getContentType() || "", r = a.indexOf("application/json") > -1, o = b.isObject(e);
    if (o && b.isHTMLForm(e) && (e = new FormData(e)), b.isFormData(e))
      return r ? JSON.stringify(Kl(e)) : e;
    if (b.isArrayBuffer(e) || b.isBuffer(e) || b.isStream(e) || b.isFile(e) || b.isBlob(e) || b.isReadableStream(e))
      return e;
    if (b.isArrayBufferView(e))
      return e.buffer;
    if (b.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let c;
    if (o) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return TL(e, this.formSerializer).toString();
      if ((c = b.isFileList(e)) || a.indexOf("multipart/form-data") > -1) {
        const v = this.env && this.env.FormData;
        return u0(
          c ? { "files[]": e } : e,
          v && new v(),
          this.formSerializer
        );
      }
    }
    return o || r ? (t.setContentType("application/json", !1), kL(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || y1.transitional, a = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (b.isResponse(e) || b.isReadableStream(e))
      return e;
    if (e && b.isString(e) && (a && !this.responseType || r)) {
      const i = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (c) {
        if (i)
          throw c.name === "SyntaxError" ? N.from(c, N.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: n5.classes.FormData,
    Blob: n5.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
b.forEach(["delete", "get", "head", "post", "put", "patch"], (l) => {
  y1.headers[l] = {};
});
const OL = b.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), $L = (l) => {
  const e = {};
  let t, a, r;
  return l && l.split(`
`).forEach(function(i) {
    r = i.indexOf(":"), t = i.substring(0, r).trim().toLowerCase(), a = i.substring(r + 1).trim(), !(!t || e[t] && OL[t]) && (t === "set-cookie" ? e[t] ? e[t].push(a) : e[t] = [a] : e[t] = e[t] ? e[t] + ", " + a : a);
  }), e;
}, t3 = Symbol("internals");
function v1(l) {
  return l && String(l).trim().toLowerCase();
}
function _1(l) {
  return l === !1 || l == null ? l : b.isArray(l) ? l.map(_1) : String(l);
}
function NL(l) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let a;
  for (; a = t.exec(l); )
    e[a[1]] = a[2];
  return e;
}
const FL = (l) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(l.trim());
function A2(l, e, t, a, r) {
  if (b.isFunction(a))
    return a.call(this, e, t);
  if (r && (e = t), !!b.isString(e)) {
    if (b.isString(a))
      return e.indexOf(a) !== -1;
    if (b.isRegExp(a))
      return a.test(e);
  }
}
function DL(l) {
  return l.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, a) => t.toUpperCase() + a);
}
function IL(l, e) {
  const t = b.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((a) => {
    Object.defineProperty(l, a + t, {
      value: function(r, o, i) {
        return this[a].call(this, e, r, o, i);
      },
      configurable: !0
    });
  });
}
let i5 = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, a) {
    const r = this;
    function o(c, v, u) {
      const h = v1(v);
      if (!h)
        throw new Error("header name must be a non-empty string");
      const p = b.findKey(r, h);
      (!p || r[p] === void 0 || u === !0 || u === void 0 && r[p] !== !1) && (r[p || v] = _1(c));
    }
    const i = (c, v) => b.forEach(c, (u, h) => o(u, h, v));
    if (b.isPlainObject(e) || e instanceof this.constructor)
      i(e, t);
    else if (b.isString(e) && (e = e.trim()) && !FL(e))
      i($L(e), t);
    else if (b.isObject(e) && b.isIterable(e)) {
      let c = {}, v, u;
      for (const h of e) {
        if (!b.isArray(h))
          throw TypeError("Object iterator must return a key-value pair");
        c[u = h[0]] = (v = c[u]) ? b.isArray(v) ? [...v, h[1]] : [v, h[1]] : h[1];
      }
      i(c, t);
    } else
      e != null && o(t, e, a);
    return this;
  }
  get(e, t) {
    if (e = v1(e), e) {
      const a = b.findKey(this, e);
      if (a) {
        const r = this[a];
        if (!t)
          return r;
        if (t === !0)
          return NL(r);
        if (b.isFunction(t))
          return t.call(this, r, a);
        if (b.isRegExp(t))
          return t.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = v1(e), e) {
      const a = b.findKey(this, e);
      return !!(a && this[a] !== void 0 && (!t || A2(this, this[a], a, t)));
    }
    return !1;
  }
  delete(e, t) {
    const a = this;
    let r = !1;
    function o(i) {
      if (i = v1(i), i) {
        const c = b.findKey(a, i);
        c && (!t || A2(a, a[c], c, t)) && (delete a[c], r = !0);
      }
    }
    return b.isArray(e) ? e.forEach(o) : o(e), r;
  }
  clear(e) {
    const t = Object.keys(this);
    let a = t.length, r = !1;
    for (; a--; ) {
      const o = t[a];
      (!e || A2(this, this[o], o, e, !0)) && (delete this[o], r = !0);
    }
    return r;
  }
  normalize(e) {
    const t = this, a = {};
    return b.forEach(this, (r, o) => {
      const i = b.findKey(a, o);
      if (i) {
        t[i] = _1(r), delete t[o];
        return;
      }
      const c = e ? DL(o) : String(o).trim();
      c !== o && delete t[o], t[c] = _1(r), a[c] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return b.forEach(this, (a, r) => {
      a != null && a !== !1 && (t[r] = e && b.isArray(a) ? a.join(", ") : a);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const a = new this(e);
    return t.forEach((r) => a.set(r)), a;
  }
  static accessor(e) {
    const a = (this[t3] = this[t3] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function o(i) {
      const c = v1(i);
      a[c] || (IL(r, i), a[c] = !0);
    }
    return b.isArray(e) ? e.forEach(o) : o(e), this;
  }
};
i5.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
b.reduceDescriptors(i5.prototype, ({ value: l }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => l,
    set(a) {
      this[t] = a;
    }
  };
});
b.freezeMethods(i5);
function V2(l, e) {
  const t = this || y1, a = e || t, r = i5.from(a.headers);
  let o = a.data;
  return b.forEach(l, function(c) {
    o = c.call(t, o, r.normalize(), e ? e.status : void 0);
  }), r.normalize(), o;
}
function Jl(l) {
  return !!(l && l.__CANCEL__);
}
function u1(l, e, t) {
  N.call(this, l ?? "canceled", N.ERR_CANCELED, e, t), this.name = "CanceledError";
}
b.inherits(u1, N, {
  __CANCEL__: !0
});
function Gl(l, e, t) {
  const a = t.config.validateStatus;
  !t.status || !a || a(t.status) ? l(t) : e(new N(
    "Request failed with status code " + t.status,
    [N.ERR_BAD_REQUEST, N.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function jL(l) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(l);
  return e && e[1] || "";
}
function qL(l, e) {
  l = l || 10;
  const t = new Array(l), a = new Array(l);
  let r = 0, o = 0, i;
  return e = e !== void 0 ? e : 1e3, function(v) {
    const u = Date.now(), h = a[o];
    i || (i = u), t[r] = v, a[r] = u;
    let p = o, m = 0;
    for (; p !== r; )
      m += t[p++], p = p % l;
    if (r = (r + 1) % l, r === o && (o = (o + 1) % l), u - i < e)
      return;
    const g = h && u - h;
    return g ? Math.round(m * 1e3 / g) : void 0;
  };
}
function PL(l, e) {
  let t = 0, a = 1e3 / e, r, o;
  const i = (u, h = Date.now()) => {
    t = h, r = null, o && (clearTimeout(o), o = null), l.apply(null, u);
  };
  return [(...u) => {
    const h = Date.now(), p = h - t;
    p >= a ? i(u, h) : (r = u, o || (o = setTimeout(() => {
      o = null, i(r);
    }, a - p)));
  }, () => r && i(r)];
}
const W1 = (l, e, t = 3) => {
  let a = 0;
  const r = qL(50, 250);
  return PL((o) => {
    const i = o.loaded, c = o.lengthComputable ? o.total : void 0, v = i - a, u = r(v), h = i <= c;
    a = i;
    const p = {
      loaded: i,
      total: c,
      progress: c ? i / c : void 0,
      bytes: v,
      rate: u || void 0,
      estimated: u && c && h ? (c - i) / u : void 0,
      event: o,
      lengthComputable: c != null,
      [e ? "download" : "upload"]: !0
    };
    l(p);
  }, t);
}, n3 = (l, e) => {
  const t = l != null;
  return [(a) => e[0]({
    lengthComputable: t,
    total: l,
    loaded: a
  }), e[1]];
}, a3 = (l) => (...e) => b.asap(() => l(...e)), UL = n5.hasStandardBrowserEnv ? /* @__PURE__ */ ((l, e) => (t) => (t = new URL(t, n5.origin), l.protocol === t.protocol && l.host === t.host && (e || l.port === t.port)))(
  new URL(n5.origin),
  n5.navigator && /(msie|trident)/i.test(n5.navigator.userAgent)
) : () => !0, ZL = n5.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(l, e, t, a, r, o) {
      const i = [l + "=" + encodeURIComponent(e)];
      b.isNumber(t) && i.push("expires=" + new Date(t).toGMTString()), b.isString(a) && i.push("path=" + a), b.isString(r) && i.push("domain=" + r), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(l) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + l + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(l) {
      this.write(l, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function WL(l) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(l);
}
function KL(l, e) {
  return e ? l.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : l;
}
function Xl(l, e, t) {
  let a = !WL(e);
  return l && (a || t == !1) ? KL(l, e) : e;
}
const r3 = (l) => l instanceof i5 ? { ...l } : l;
function Q5(l, e) {
  e = e || {};
  const t = {};
  function a(u, h, p, m) {
    return b.isPlainObject(u) && b.isPlainObject(h) ? b.merge.call({ caseless: m }, u, h) : b.isPlainObject(h) ? b.merge({}, h) : b.isArray(h) ? h.slice() : h;
  }
  function r(u, h, p, m) {
    if (b.isUndefined(h)) {
      if (!b.isUndefined(u))
        return a(void 0, u, p, m);
    } else return a(u, h, p, m);
  }
  function o(u, h) {
    if (!b.isUndefined(h))
      return a(void 0, h);
  }
  function i(u, h) {
    if (b.isUndefined(h)) {
      if (!b.isUndefined(u))
        return a(void 0, u);
    } else return a(void 0, h);
  }
  function c(u, h, p) {
    if (p in e)
      return a(u, h);
    if (p in l)
      return a(void 0, u);
  }
  const v = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: c,
    headers: (u, h, p) => r(r3(u), r3(h), p, !0)
  };
  return b.forEach(Object.keys(Object.assign({}, l, e)), function(h) {
    const p = v[h] || r, m = p(l[h], e[h], h);
    b.isUndefined(m) && p !== c || (t[h] = m);
  }), t;
}
const Yl = (l) => {
  const e = Q5({}, l);
  let { data: t, withXSRFToken: a, xsrfHeaderName: r, xsrfCookieName: o, headers: i, auth: c } = e;
  e.headers = i = i5.from(i), e.url = Zl(Xl(e.baseURL, e.url, e.allowAbsoluteUrls), l.params, l.paramsSerializer), c && i.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  );
  let v;
  if (b.isFormData(t)) {
    if (n5.hasStandardBrowserEnv || n5.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((v = i.getContentType()) !== !1) {
      const [u, ...h] = v ? v.split(";").map((p) => p.trim()).filter(Boolean) : [];
      i.setContentType([u || "multipart/form-data", ...h].join("; "));
    }
  }
  if (n5.hasStandardBrowserEnv && (a && b.isFunction(a) && (a = a(e)), a || a !== !1 && UL(e.url))) {
    const u = r && o && ZL.read(o);
    u && i.set(r, u);
  }
  return e;
}, JL = typeof XMLHttpRequest < "u", GL = JL && function(l) {
  return new Promise(function(t, a) {
    const r = Yl(l);
    let o = r.data;
    const i = i5.from(r.headers).normalize();
    let { responseType: c, onUploadProgress: v, onDownloadProgress: u } = r, h, p, m, g, w;
    function x() {
      g && g(), w && w(), r.cancelToken && r.cancelToken.unsubscribe(h), r.signal && r.signal.removeEventListener("abort", h);
    }
    let f = new XMLHttpRequest();
    f.open(r.method.toUpperCase(), r.url, !0), f.timeout = r.timeout;
    function M() {
      if (!f)
        return;
      const C = i5.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), A = {
        data: !c || c === "text" || c === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: C,
        config: l,
        request: f
      };
      Gl(function(E) {
        t(E), x();
      }, function(E) {
        a(E), x();
      }, A), f = null;
    }
    "onloadend" in f ? f.onloadend = M : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(M);
    }, f.onabort = function() {
      f && (a(new N("Request aborted", N.ECONNABORTED, l, f)), f = null);
    }, f.onerror = function() {
      a(new N("Network Error", N.ERR_NETWORK, l, f)), f = null;
    }, f.ontimeout = function() {
      let S = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const A = r.transitional || Wl;
      r.timeoutErrorMessage && (S = r.timeoutErrorMessage), a(new N(
        S,
        A.clarifyTimeoutError ? N.ETIMEDOUT : N.ECONNABORTED,
        l,
        f
      )), f = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in f && b.forEach(i.toJSON(), function(S, A) {
      f.setRequestHeader(A, S);
    }), b.isUndefined(r.withCredentials) || (f.withCredentials = !!r.withCredentials), c && c !== "json" && (f.responseType = r.responseType), u && ([m, w] = W1(u, !0), f.addEventListener("progress", m)), v && f.upload && ([p, g] = W1(v), f.upload.addEventListener("progress", p), f.upload.addEventListener("loadend", g)), (r.cancelToken || r.signal) && (h = (C) => {
      f && (a(!C || C.type ? new u1(null, l, f) : C), f.abort(), f = null);
    }, r.cancelToken && r.cancelToken.subscribe(h), r.signal && (r.signal.aborted ? h() : r.signal.addEventListener("abort", h)));
    const V = jL(r.url);
    if (V && n5.protocols.indexOf(V) === -1) {
      a(new N("Unsupported protocol " + V + ":", N.ERR_BAD_REQUEST, l));
      return;
    }
    f.send(o || null);
  });
}, XL = (l, e) => {
  const { length: t } = l = l ? l.filter(Boolean) : [];
  if (e || t) {
    let a = new AbortController(), r;
    const o = function(u) {
      if (!r) {
        r = !0, c();
        const h = u instanceof Error ? u : this.reason;
        a.abort(h instanceof N ? h : new u1(h instanceof Error ? h.message : h));
      }
    };
    let i = e && setTimeout(() => {
      i = null, o(new N(`timeout ${e} of ms exceeded`, N.ETIMEDOUT));
    }, e);
    const c = () => {
      l && (i && clearTimeout(i), i = null, l.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(o) : u.removeEventListener("abort", o);
      }), l = null);
    };
    l.forEach((u) => u.addEventListener("abort", o));
    const { signal: v } = a;
    return v.unsubscribe = () => b.asap(c), v;
  }
}, YL = function* (l, e) {
  let t = l.byteLength;
  if (t < e) {
    yield l;
    return;
  }
  let a = 0, r;
  for (; a < t; )
    r = a + e, yield l.slice(a, r), a = r;
}, QL = async function* (l, e) {
  for await (const t of eS(l))
    yield* YL(t, e);
}, eS = async function* (l) {
  if (l[Symbol.asyncIterator]) {
    yield* l;
    return;
  }
  const e = l.getReader();
  try {
    for (; ; ) {
      const { done: t, value: a } = await e.read();
      if (t)
        break;
      yield a;
    }
  } finally {
    await e.cancel();
  }
}, o3 = (l, e, t, a) => {
  const r = QL(l, e);
  let o = 0, i, c = (v) => {
    i || (i = !0, a && a(v));
  };
  return new ReadableStream({
    async pull(v) {
      try {
        const { done: u, value: h } = await r.next();
        if (u) {
          c(), v.close();
          return;
        }
        let p = h.byteLength;
        if (t) {
          let m = o += p;
          t(m);
        }
        v.enqueue(new Uint8Array(h));
      } catch (u) {
        throw c(u), u;
      }
    },
    cancel(v) {
      return c(v), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, v0 = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Ql = v0 && typeof ReadableStream == "function", lS = v0 && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((l) => (e) => l.encode(e))(new TextEncoder()) : async (l) => new Uint8Array(await new Response(l).arrayBuffer())), et = (l, ...e) => {
  try {
    return !!l(...e);
  } catch {
    return !1;
  }
}, tS = Ql && et(() => {
  let l = !1;
  const e = new Request(n5.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return l = !0, "half";
    }
  }).headers.has("Content-Type");
  return l && !e;
}), i3 = 64 * 1024, a7 = Ql && et(() => b.isReadableStream(new Response("").body)), K1 = {
  stream: a7 && ((l) => l.body)
};
v0 && ((l) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !K1[e] && (K1[e] = b.isFunction(l[e]) ? (t) => t[e]() : (t, a) => {
      throw new N(`Response type '${e}' is not supported`, N.ERR_NOT_SUPPORT, a);
    });
  });
})(new Response());
const nS = async (l) => {
  if (l == null)
    return 0;
  if (b.isBlob(l))
    return l.size;
  if (b.isSpecCompliantForm(l))
    return (await new Request(n5.origin, {
      method: "POST",
      body: l
    }).arrayBuffer()).byteLength;
  if (b.isArrayBufferView(l) || b.isArrayBuffer(l))
    return l.byteLength;
  if (b.isURLSearchParams(l) && (l = l + ""), b.isString(l))
    return (await lS(l)).byteLength;
}, aS = async (l, e) => {
  const t = b.toFiniteNumber(l.getContentLength());
  return t ?? nS(e);
}, rS = v0 && (async (l) => {
  let {
    url: e,
    method: t,
    data: a,
    signal: r,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: c,
    onUploadProgress: v,
    responseType: u,
    headers: h,
    withCredentials: p = "same-origin",
    fetchOptions: m
  } = Yl(l);
  u = u ? (u + "").toLowerCase() : "text";
  let g = XL([r, o && o.toAbortSignal()], i), w;
  const x = g && g.unsubscribe && (() => {
    g.unsubscribe();
  });
  let f;
  try {
    if (v && tS && t !== "get" && t !== "head" && (f = await aS(h, a)) !== 0) {
      let A = new Request(e, {
        method: "POST",
        body: a,
        duplex: "half"
      }), y;
      if (b.isFormData(a) && (y = A.headers.get("content-type")) && h.setContentType(y), A.body) {
        const [E, H] = n3(
          f,
          W1(a3(v))
        );
        a = o3(A.body, i3, E, H);
      }
    }
    b.isString(p) || (p = p ? "include" : "omit");
    const M = "credentials" in Request.prototype;
    w = new Request(e, {
      ...m,
      signal: g,
      method: t.toUpperCase(),
      headers: h.normalize().toJSON(),
      body: a,
      duplex: "half",
      credentials: M ? p : void 0
    });
    let V = await fetch(w);
    const C = a7 && (u === "stream" || u === "response");
    if (a7 && (c || C && x)) {
      const A = {};
      ["status", "statusText", "headers"].forEach((j) => {
        A[j] = V[j];
      });
      const y = b.toFiniteNumber(V.headers.get("content-length")), [E, H] = c && n3(
        y,
        W1(a3(c), !0)
      ) || [];
      V = new Response(
        o3(V.body, i3, E, () => {
          H && H(), x && x();
        }),
        A
      );
    }
    u = u || "text";
    let S = await K1[b.findKey(K1, u) || "text"](V, l);
    return !C && x && x(), await new Promise((A, y) => {
      Gl(A, y, {
        data: S,
        headers: i5.from(V.headers),
        status: V.status,
        statusText: V.statusText,
        config: l,
        request: w
      });
    });
  } catch (M) {
    throw x && x(), M && M.name === "TypeError" && /Load failed|fetch/i.test(M.message) ? Object.assign(
      new N("Network Error", N.ERR_NETWORK, l, w),
      {
        cause: M.cause || M
      }
    ) : N.from(M, M && M.code, l, w);
  }
}), r7 = {
  http: ML,
  xhr: GL,
  fetch: rS
};
b.forEach(r7, (l, e) => {
  if (l) {
    try {
      Object.defineProperty(l, "name", { value: e });
    } catch {
    }
    Object.defineProperty(l, "adapterName", { value: e });
  }
});
const s3 = (l) => `- ${l}`, oS = (l) => b.isFunction(l) || l === null || l === !1, lt = {
  getAdapter: (l) => {
    l = b.isArray(l) ? l : [l];
    const { length: e } = l;
    let t, a;
    const r = {};
    for (let o = 0; o < e; o++) {
      t = l[o];
      let i;
      if (a = t, !oS(t) && (a = r7[(i = String(t)).toLowerCase()], a === void 0))
        throw new N(`Unknown adapter '${i}'`);
      if (a)
        break;
      r[i || "#" + o] = a;
    }
    if (!a) {
      const o = Object.entries(r).map(
        ([c, v]) => `adapter ${c} ` + (v === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = e ? o.length > 1 ? `since :
` + o.map(s3).join(`
`) : " " + s3(o[0]) : "as no adapter specified";
      throw new N(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: r7
};
function H2(l) {
  if (l.cancelToken && l.cancelToken.throwIfRequested(), l.signal && l.signal.aborted)
    throw new u1(null, l);
}
function d3(l) {
  return H2(l), l.headers = i5.from(l.headers), l.data = V2.call(
    l,
    l.transformRequest
  ), ["post", "put", "patch"].indexOf(l.method) !== -1 && l.headers.setContentType("application/x-www-form-urlencoded", !1), lt.getAdapter(l.adapter || y1.adapter)(l).then(function(a) {
    return H2(l), a.data = V2.call(
      l,
      l.transformResponse,
      a
    ), a.headers = i5.from(a.headers), a;
  }, function(a) {
    return Jl(a) || (H2(l), a && a.response && (a.response.data = V2.call(
      l,
      l.transformResponse,
      a.response
    ), a.response.headers = i5.from(a.response.headers))), Promise.reject(a);
  });
}
const tt = "1.9.0", p0 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((l, e) => {
  p0[l] = function(a) {
    return typeof a === l || "a" + (e < 1 ? "n " : " ") + l;
  };
});
const c3 = {};
p0.transitional = function(e, t, a) {
  function r(o, i) {
    return "[Axios v" + tt + "] Transitional option '" + o + "'" + i + (a ? ". " + a : "");
  }
  return (o, i, c) => {
    if (e === !1)
      throw new N(
        r(i, " has been removed" + (t ? " in " + t : "")),
        N.ERR_DEPRECATED
      );
    return t && !c3[i] && (c3[i] = !0, console.warn(
      r(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, i, c) : !0;
  };
};
p0.spelling = function(e) {
  return (t, a) => (console.warn(`${a} is likely a misspelling of ${e}`), !0);
};
function iS(l, e, t) {
  if (typeof l != "object")
    throw new N("options must be an object", N.ERR_BAD_OPTION_VALUE);
  const a = Object.keys(l);
  let r = a.length;
  for (; r-- > 0; ) {
    const o = a[r], i = e[o];
    if (i) {
      const c = l[o], v = c === void 0 || i(c, o, l);
      if (v !== !0)
        throw new N("option " + o + " must be " + v, N.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new N("Unknown option " + o, N.ERR_BAD_OPTION);
  }
}
const R1 = {
  assertOptions: iS,
  validators: p0
}, y5 = R1.validators;
let K5 = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new l3(),
      response: new l3()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (a) {
      if (a instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const o = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          a.stack ? o && !String(a.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (a.stack += `
` + o) : a.stack = o;
        } catch {
        }
      }
      throw a;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Q5(this.defaults, t);
    const { transitional: a, paramsSerializer: r, headers: o } = t;
    a !== void 0 && R1.assertOptions(a, {
      silentJSONParsing: y5.transitional(y5.boolean),
      forcedJSONParsing: y5.transitional(y5.boolean),
      clarifyTimeoutError: y5.transitional(y5.boolean)
    }, !1), r != null && (b.isFunction(r) ? t.paramsSerializer = {
      serialize: r
    } : R1.assertOptions(r, {
      encode: y5.function,
      serialize: y5.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), R1.assertOptions(t, {
      baseUrl: y5.spelling("baseURL"),
      withXsrfToken: y5.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = o && b.merge(
      o.common,
      o[t.method]
    );
    o && b.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (w) => {
        delete o[w];
      }
    ), t.headers = i5.concat(i, o);
    const c = [];
    let v = !0;
    this.interceptors.request.forEach(function(x) {
      typeof x.runWhen == "function" && x.runWhen(t) === !1 || (v = v && x.synchronous, c.unshift(x.fulfilled, x.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(x) {
      u.push(x.fulfilled, x.rejected);
    });
    let h, p = 0, m;
    if (!v) {
      const w = [d3.bind(this), void 0];
      for (w.unshift.apply(w, c), w.push.apply(w, u), m = w.length, h = Promise.resolve(t); p < m; )
        h = h.then(w[p++], w[p++]);
      return h;
    }
    m = c.length;
    let g = t;
    for (p = 0; p < m; ) {
      const w = c[p++], x = c[p++];
      try {
        g = w(g);
      } catch (f) {
        x.call(this, f);
        break;
      }
    }
    try {
      h = d3.call(this, g);
    } catch (w) {
      return Promise.reject(w);
    }
    for (p = 0, m = u.length; p < m; )
      h = h.then(u[p++], u[p++]);
    return h;
  }
  getUri(e) {
    e = Q5(this.defaults, e);
    const t = Xl(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Zl(t, e.params, e.paramsSerializer);
  }
};
b.forEach(["delete", "get", "head", "options"], function(e) {
  K5.prototype[e] = function(t, a) {
    return this.request(Q5(a || {}, {
      method: e,
      url: t,
      data: (a || {}).data
    }));
  };
});
b.forEach(["post", "put", "patch"], function(e) {
  function t(a) {
    return function(o, i, c) {
      return this.request(Q5(c || {}, {
        method: e,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  K5.prototype[e] = t(), K5.prototype[e + "Form"] = t(!0);
});
let sS = class nt {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const a = this;
    this.promise.then((r) => {
      if (!a._listeners) return;
      let o = a._listeners.length;
      for (; o-- > 0; )
        a._listeners[o](r);
      a._listeners = null;
    }), this.promise.then = (r) => {
      let o;
      const i = new Promise((c) => {
        a.subscribe(c), o = c;
      }).then(r);
      return i.cancel = function() {
        a.unsubscribe(o);
      }, i;
    }, e(function(o, i, c) {
      a.reason || (a.reason = new u1(o, i, c), t(a.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), t = (a) => {
      e.abort(a);
    };
    return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new nt(function(r) {
        e = r;
      }),
      cancel: e
    };
  }
};
function dS(l) {
  return function(t) {
    return l.apply(null, t);
  };
}
function cS(l) {
  return b.isObject(l) && l.isAxiosError === !0;
}
const o7 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(o7).forEach(([l, e]) => {
  o7[e] = l;
});
function at(l) {
  const e = new K5(l), t = Rl(K5.prototype.request, e);
  return b.extend(t, K5.prototype, e, { allOwnKeys: !0 }), b.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(r) {
    return at(Q5(l, r));
  }, t;
}
const W = at(y1);
W.Axios = K5;
W.CanceledError = u1;
W.CancelToken = sS;
W.isCancel = Jl;
W.VERSION = tt;
W.toFormData = u0;
W.AxiosError = N;
W.Cancel = W.CanceledError;
W.all = function(e) {
  return Promise.all(e);
};
W.spread = dS;
W.isAxiosError = cS;
W.mergeConfig = Q5;
W.AxiosHeaders = i5;
W.formToJSON = (l) => Kl(b.isHTMLForm(l) ? new FormData(l) : l);
W.getAdapter = lt.getAdapter;
W.HttpStatusCode = o7;
W.default = W;
const {
  Axios: PS,
  AxiosError: US,
  CanceledError: ZS,
  isCancel: WS,
  CancelToken: KS,
  VERSION: JS,
  all: GS,
  Cancel: XS,
  isAxiosError: YS,
  spread: QS,
  toFormData: eE,
  AxiosHeaders: lE,
  HttpStatusCode: tE,
  formToJSON: nE,
  getAdapter: aE,
  mergeConfig: rE
} = W, t5 = [];
for (let l = 0; l < 256; ++l)
  t5.push((l + 256).toString(16).slice(1));
function uS(l, e = 0) {
  return (t5[l[e + 0]] + t5[l[e + 1]] + t5[l[e + 2]] + t5[l[e + 3]] + "-" + t5[l[e + 4]] + t5[l[e + 5]] + "-" + t5[l[e + 6]] + t5[l[e + 7]] + "-" + t5[l[e + 8]] + t5[l[e + 9]] + "-" + t5[l[e + 10]] + t5[l[e + 11]] + t5[l[e + 12]] + t5[l[e + 13]] + t5[l[e + 14]] + t5[l[e + 15]]).toLowerCase();
}
let B2;
const vS = new Uint8Array(16);
function pS() {
  if (!B2) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    B2 = crypto.getRandomValues.bind(crypto);
  }
  return B2(vS);
}
const hS = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), u3 = { randomUUID: hS };
function i7(l, e, t) {
  var r;
  if (u3.randomUUID && !l)
    return u3.randomUUID();
  l = l || {};
  const a = l.random ?? ((r = l.rng) == null ? void 0 : r.call(l)) ?? pS();
  if (a.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, uS(a);
}
const rt = Symbol(), fS = (l, e) => {
  const t = I((e == null ? void 0 : e.bffUri) || ""), a = I((e == null ? void 0 : e.token) || ""), r = (i) => {
    t.value = i;
  }, o = (i) => {
    a.value = i;
  };
  l.provide(rt, {
    bffUri: t,
    token: a,
    updateBffUri: r,
    updateToken: o
  });
}, R7 = () => {
  const l = E3(rt);
  if (!l)
    throw new Error("use plugin PluginTotemBusiness before using this composition function");
  return l;
};
function mS(l, e) {
  l.interceptors.request.use((t) => (t.headers.set("Authorization", `Bearer ${e}`), t));
}
function wS(l) {
  const e = W.create({ baseURL: l.baseUrl });
  return l.bearer && mS(e, l.bearer), e;
}
function J1(l) {
  return k(() => wS({ bearer: l == null ? void 0 : l.value }));
}
var C1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function gS(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var z2, v3;
function ot() {
  if (v3) return z2;
  v3 = 1;
  function l(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return z2 = l, z2;
}
var C2, p3;
function bS() {
  if (p3) return C2;
  p3 = 1;
  var l = typeof C1 == "object" && C1 && C1.Object === Object && C1;
  return C2 = l, C2;
}
var L2, h3;
function it() {
  if (h3) return L2;
  h3 = 1;
  var l = bS(), e = typeof self == "object" && self && self.Object === Object && self, t = l || e || Function("return this")();
  return L2 = t, L2;
}
var S2, f3;
function MS() {
  if (f3) return S2;
  f3 = 1;
  var l = it(), e = function() {
    return l.Date.now();
  };
  return S2 = e, S2;
}
var E2, m3;
function xS() {
  if (m3) return E2;
  m3 = 1;
  var l = /\s/;
  function e(t) {
    for (var a = t.length; a-- && l.test(t.charAt(a)); )
      ;
    return a;
  }
  return E2 = e, E2;
}
var T2, w3;
function yS() {
  if (w3) return T2;
  w3 = 1;
  var l = xS(), e = /^\s+/;
  function t(a) {
    return a && a.slice(0, l(a) + 1).replace(e, "");
  }
  return T2 = t, T2;
}
var _2, g3;
function st() {
  if (g3) return _2;
  g3 = 1;
  var l = it(), e = l.Symbol;
  return _2 = e, _2;
}
var R2, b3;
function AS() {
  if (b3) return R2;
  b3 = 1;
  var l = st(), e = Object.prototype, t = e.hasOwnProperty, a = e.toString, r = l ? l.toStringTag : void 0;
  function o(i) {
    var c = t.call(i, r), v = i[r];
    try {
      i[r] = void 0;
      var u = !0;
    } catch {
    }
    var h = a.call(i);
    return u && (c ? i[r] = v : delete i[r]), h;
  }
  return R2 = o, R2;
}
var k2, M3;
function VS() {
  if (M3) return k2;
  M3 = 1;
  var l = Object.prototype, e = l.toString;
  function t(a) {
    return e.call(a);
  }
  return k2 = t, k2;
}
var O2, x3;
function HS() {
  if (x3) return O2;
  x3 = 1;
  var l = st(), e = AS(), t = VS(), a = "[object Null]", r = "[object Undefined]", o = l ? l.toStringTag : void 0;
  function i(c) {
    return c == null ? c === void 0 ? r : a : o && o in Object(c) ? e(c) : t(c);
  }
  return O2 = i, O2;
}
var $2, y3;
function BS() {
  if (y3) return $2;
  y3 = 1;
  function l(e) {
    return e != null && typeof e == "object";
  }
  return $2 = l, $2;
}
var N2, A3;
function zS() {
  if (A3) return N2;
  A3 = 1;
  var l = HS(), e = BS(), t = "[object Symbol]";
  function a(r) {
    return typeof r == "symbol" || e(r) && l(r) == t;
  }
  return N2 = a, N2;
}
var F2, V3;
function CS() {
  if (V3) return F2;
  V3 = 1;
  var l = yS(), e = ot(), t = zS(), a = NaN, r = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, i = /^0o[0-7]+$/i, c = parseInt;
  function v(u) {
    if (typeof u == "number")
      return u;
    if (t(u))
      return a;
    if (e(u)) {
      var h = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = e(h) ? h + "" : h;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = l(u);
    var p = o.test(u);
    return p || i.test(u) ? c(u.slice(2), p ? 2 : 8) : r.test(u) ? a : +u;
  }
  return F2 = v, F2;
}
var D2, H3;
function LS() {
  if (H3) return D2;
  H3 = 1;
  var l = ot(), e = MS(), t = CS(), a = "Expected a function", r = Math.max, o = Math.min;
  function i(c, v, u) {
    var h, p, m, g, w, x, f = 0, M = !1, V = !1, C = !0;
    if (typeof c != "function")
      throw new TypeError(a);
    v = t(v) || 0, l(u) && (M = !!u.leading, V = "maxWait" in u, m = V ? r(t(u.maxWait) || 0, v) : m, C = "trailing" in u ? !!u.trailing : C);
    function S(z) {
      var O = h, D = p;
      return h = p = void 0, f = z, g = c.apply(D, O), g;
    }
    function A(z) {
      return f = z, w = setTimeout(H, v), M ? S(z) : g;
    }
    function y(z) {
      var O = z - x, D = z - f, P = v - O;
      return V ? o(P, m - D) : P;
    }
    function E(z) {
      var O = z - x, D = z - f;
      return x === void 0 || O >= v || O < 0 || V && D >= m;
    }
    function H() {
      var z = e();
      if (E(z))
        return j(z);
      w = setTimeout(H, y(z));
    }
    function j(z) {
      return w = void 0, C && h ? S(z) : (h = p = void 0, g);
    }
    function Z() {
      w !== void 0 && clearTimeout(w), f = 0, h = x = p = w = void 0;
    }
    function K() {
      return w === void 0 ? g : j(e());
    }
    function J() {
      var z = e(), O = E(z);
      if (h = arguments, p = this, x = z, O) {
        if (w === void 0)
          return A(x);
        if (V)
          return clearTimeout(w), w = setTimeout(H, v), S(x);
      }
      return w === void 0 && (w = setTimeout(H, v)), g;
    }
    return J.cancel = Z, J.flush = K, J;
  }
  return D2 = i, D2;
}
var SS = LS();
const dt = /* @__PURE__ */ gS(SS), ct = Symbol(), s7 = (l, e, t, a = I({
  autoValidate: !0,
  immediate: !1,
  disabled: !1,
  debounceTime: void 0,
  firstErrorOnly: !1
})) => {
  const r = I([]), o = I(!1), i = I(!1), c = k(() => s5(a)), v = async () => {
    if (c.value.disabled)
      return;
    const f = [];
    try {
      o.value = !0;
      for (const M of t.value)
        try {
          const V = await M.validator(e);
          if (V === !0)
            i.value = !0;
          else if (f.push(typeof V == "string" ? V : "Ce champ est invalide."), i.value = !1, c.value.firstErrorOnly)
            break;
        } catch (V) {
          console.error(V);
        }
    } finally {
      o.value = !1, r.value = f;
    }
  }, u = c.value.debounceTime !== void 0 ? dt(v, c.value.debounceTime) : v, h = (f) => {
    r.value = f, i.value = !1;
  }, p = () => {
    i.value = !0, r.value = [];
  }, m = r5(
    e,
    async () => {
      await u();
    },
    { immediate: c.value.immediate }
  );
  r5(
    () => c.value.autoValidate,
    () => {
      c.value.autoValidate ? m.resume() : m.pause();
    },
    { immediate: !0 }
  );
  const g = E3(ct);
  if (!g)
    throw new Error("useTotemFieldValidator must be used inside a useTotemForm");
  const { addField: w, removeField: x } = g;
  return w({ [l]: { errors: r, isValidating: o, validate: v, isValid: i, setErrors: h } }), G1(() => {
    x(l);
  }), {
    errors: r,
    isValidating: o,
    validate: v,
    setErrors: h,
    forceValidationTrue: p
  };
}, oE = () => {
  const l = T3({});
  yt(ct, { addField: (o) => {
    for (const i in o)
      l[i] = o[i];
  }, removeField: (o) => {
    delete l[o];
  } });
  const a = k(() => Object.values(l).every((o) => o.isValid));
  return { totemFormState: l, isFormValid: a, validateForm: async () => {
    for (const o in l)
      await l[o].validate();
  } };
}, ES = { class: "totem-business-iban-bic" }, iE = /* @__PURE__ */ q({
  __name: "TotemBusinessIbanBic",
  props: /* @__PURE__ */ c5({
    ibanId: { default: `iban-${i7()}` },
    ibanLabel: { default: "IBAN" },
    ibanLabelFor: { default: "iban" },
    ibanDescription: { default: "" },
    ibanDetails: { default: () => [] },
    ibanOptionalFlag: { type: Boolean },
    ibanRequiredFlag: { type: Boolean },
    ibanDisabled: { type: Boolean },
    ibanReadonly: { type: Boolean },
    ibanDisabledValidate: { type: Boolean },
    ibanEnableImmediateValidate: { type: Boolean },
    ibanPlaceholder: { default: "Ex: FR76 3002 0550 0028 9000 7400 021" },
    bicId: { default: `bic-${i7()}` },
    bicLabel: { default: "BIC" },
    bicLabelFor: { default: "bic" },
    bicDescription: { default: "" },
    bicDetails: { default: () => [] },
    bicOptionalFlag: { type: Boolean },
    bicRequiredFlag: { type: Boolean },
    bicDisabled: { type: Boolean },
    bicReadonly: { type: Boolean },
    bicDisabledValidate: { type: Boolean },
    bicEnableImmediateValidate: { type: Boolean },
    bicPlaceholder: { default: "Ex: PSST FR PP LIL" }
  }, {
    iban: {},
    ibanModifiers: {},
    bic: {},
    bicModifiers: {}
  }),
  emits: ["update:iban", "update:bic"],
  setup(l) {
    const e = H5(l, "iban"), t = H5(l, "bic");
    function a(f) {
      return f ? f.replace(/\s+/g, "").toUpperCase().replace(/(.{4})/g, "$1 ").trim() : "";
    }
    function r(f) {
      return f ? f.replace(/\s+/g, "").toUpperCase() : "";
    }
    const o = () => {
      const f = I(!1);
      return {
        handleError: (S, A) => {
          var y, E, H, j, Z, K;
          if (W.isAxiosError(S)) {
            if (((y = S.response) == null ? void 0 : y.status) === 400) {
              const J = (H = (E = S.response) == null ? void 0 : E.data) == null ? void 0 : H.causes;
              return J && J.length > 0 ? J.filter((z) => z.champ === A).map((z) => `${z.message}`).join(" ") : ((Z = (j = S.response) == null ? void 0 : j.data) == null ? void 0 : Z.message) || "Erreur lors de la validation des données.";
            } else if (((K = S.response) == null ? void 0 : K.status) === 500)
              return "Le service de validation de l'iban et du bic est actuellement indisponible.";
          }
          return "Le serveur est actuellement indisponible.";
        },
        getErrorColor: (S) => S && S.length > 0 ? "danger" : void 0,
        getErrorIcon: (S) => {
          if (S)
            return S === "danger" ? "warning-triangle" : void 0;
        },
        skipBicValidation: f
      };
    }, i = () => {
      const f = /^.{16,31}$/, M = k(() => e.value ? f.test(e.value.replace(/\s/g, "")) : !1), V = I([
        {
          validator: async (y) => !!y.value
        },
        {
          validator: async () => M.value ? !0 : "La longueur de l’IBAN est incorrecte."
        },
        {
          validator: async (y) => {
            if (!M.value)
              return !1;
            try {
              const E = await J1(g).value.post(`${m.value}/recuperer-iban-bic-valide`, {
                iban: y.value ?? void 0
              });
              return E.status === 200 && E.data.bic && (p.value = !0, t.value = E.data.bic), !0;
            } catch (E) {
              return v(E, "iban");
            }
          }
        }
      ]), C = k(() => ({
        disabled: l.ibanDisabledValidate,
        autoValidate: !0,
        immediate: l.ibanEnableImmediateValidate,
        debounceTime: 300,
        firstErrorOnly: !0
      })), { errors: S, validate: A } = s7(
        l.ibanId,
        e,
        V,
        C
      );
      return {
        ibanValidate: A,
        ibanErrors: S
      };
    }, c = () => {
      const f = /^.{8,11}$/, M = k(() => {
        var y;
        return t.value ? f.test((y = t.value) == null ? void 0 : y.replace(/\s/g, "")) : !1;
      }), V = I([
        {
          validator: async (y) => !!y.value
        },
        {
          validator: async () => M.value ? !0 : "La longueur du BIC est incorrecte. Le BIC doit contenir 8 ou 11 caractères."
        },
        {
          validator: async (y) => {
            if (p.value)
              return p.value, !0;
            try {
              return await J1(g).value.post(`${m.value}/recuperer-iban-bic-valide`, {
                bic: y.value ?? void 0
              }), !0;
            } catch (E) {
              return v(E, "bic");
            }
          }
        }
      ]), C = k(() => ({
        disabled: l.bicDisabledValidate,
        autoValidate: !0,
        immediate: l.bicEnableImmediateValidate,
        debounceTime: 300,
        firstErrorOnly: !0
      })), { errors: S, validate: A } = s7(
        l.bicId,
        t,
        V,
        C
      );
      return {
        bicValidate: A,
        bicErrors: S
      };
    }, { handleError: v, getErrorColor: u, getErrorIcon: h, skipBicValidation: p } = o(), { bffUri: m, token: g } = R7(), { ibanErrors: w } = i(), { bicErrors: x } = c();
    return (f, M) => (B(), R("div", ES, [
      X(_(U1), {
        details: _(w) || f.ibanDetails,
        description: f.ibanDescription,
        color: _(u)(_(w)),
        label: f.ibanLabel,
        "label-for": f.ibanLabelFor,
        "optional-flag": f.ibanOptionalFlag,
        "required-flag": f.ibanRequiredFlag,
        class: "totem-form-element-iban"
      }, N5({
        default: T(() => [
          X(_(P1), {
            id: f.ibanId,
            modelValue: e.value,
            "onUpdate:modelValue": M[0] || (M[0] = (V) => e.value = V),
            type: "text",
            placeholder: f.ibanPlaceholder,
            disable: f.ibanDisabled,
            readonly: f.ibanReadonly,
            class: "totem-input",
            color: _(u)(_(w)),
            "suffix-icon-name": _(h)(_(u)(_(w))),
            onBlur: M[1] || (M[1] = (V) => e.value = a(e.value))
          }, null, 8, ["id", "modelValue", "placeholder", "disable", "readonly", "color", "suffix-icon-name"])
        ]),
        _: 2
      }, [
        f.$slots.ibanHeader ? {
          name: "header",
          fn: T(() => [
            L(f.$slots, "ibanHeader")
          ]),
          key: "0"
        } : void 0,
        f.$slots.ibanHeaderLabelText ? {
          name: "headerLabelText",
          fn: T(() => [
            L(f.$slots, "ibanHeaderLabelText")
          ]),
          key: "1"
        } : void 0,
        f.$slots.ibanHeaderFlags ? {
          name: "headerFlags",
          fn: T(() => [
            L(f.$slots, "ibanHeaderFlags")
          ]),
          key: "2"
        } : void 0,
        f.$slots.ibanHeaderDescription ? {
          name: "headerDescription",
          fn: T(() => [
            L(f.$slots, "ibanHeaderDescription")
          ]),
          key: "3"
        } : void 0,
        f.$slots.ibanBottom ? {
          name: "bottom",
          fn: T(() => [
            L(f.$slots, "ibanBottom")
          ]),
          key: "4"
        } : void 0,
        f.$slots.ibanBottomDetails ? {
          name: "bottomDetails",
          fn: T(() => [
            L(f.$slots, "ibanBottomDetails")
          ]),
          key: "5"
        } : void 0,
        f.$slots.ibanBottomLink ? {
          name: "bottomLink",
          fn: T(() => [
            L(f.$slots, "ibanBottomLink")
          ]),
          key: "6"
        } : void 0
      ]), 1032, ["details", "description", "color", "label", "label-for", "optional-flag", "required-flag"]),
      X(_(U1), {
        details: _(x) || f.bicDetails,
        description: f.bicDescription,
        color: _(u)(_(x)),
        label: f.bicLabel,
        "label-for": f.bicLabelFor,
        "optional-flag": f.bicOptionalFlag,
        "required-flag": f.bicRequiredFlag,
        class: "totem-form-element-bic"
      }, N5({
        default: T(() => [
          X(_(P1), {
            id: f.bicId,
            modelValue: t.value,
            "onUpdate:modelValue": M[2] || (M[2] = (V) => t.value = V),
            type: "text",
            placeholder: f.bicPlaceholder,
            disable: f.bicDisabled,
            readonly: f.bicReadonly,
            class: "totem-input",
            color: _(u)(_(x)),
            "suffix-icon-name": _(h)(_(u)(_(x))),
            onBlur: M[3] || (M[3] = (V) => t.value = r(t.value))
          }, null, 8, ["id", "modelValue", "placeholder", "disable", "readonly", "color", "suffix-icon-name"])
        ]),
        _: 2
      }, [
        f.$slots.bicHeader ? {
          name: "header",
          fn: T(() => [
            L(f.$slots, "bicHeader")
          ]),
          key: "0"
        } : void 0,
        f.$slots.bicHeaderLabelText ? {
          name: "headerLabelText",
          fn: T(() => [
            L(f.$slots, "bicHeaderLabelText")
          ]),
          key: "1"
        } : void 0,
        f.$slots.bicHeaderFlags ? {
          name: "headerFlags",
          fn: T(() => [
            L(f.$slots, "bicHeaderFlags")
          ]),
          key: "2"
        } : void 0,
        f.$slots.bicHeaderDescription ? {
          name: "headerDescription",
          fn: T(() => [
            L(f.$slots, "bicHeaderDescription")
          ]),
          key: "3"
        } : void 0,
        f.$slots.bicBottom ? {
          name: "bottom",
          fn: T(() => [
            L(f.$slots, "bicBottom")
          ]),
          key: "4"
        } : void 0,
        f.$slots.bicBottomDetails ? {
          name: "bottomDetails",
          fn: T(() => [
            L(f.$slots, "bicBottomDetails")
          ]),
          key: "5"
        } : void 0,
        f.$slots.bicBottomLink ? {
          name: "bottomLink",
          fn: T(() => [
            L(f.$slots, "bicBottomLink")
          ]),
          key: "6"
        } : void 0
      ]), 1032, ["details", "description", "color", "label", "label-for", "optional-flag", "required-flag"])
    ]));
  }
});
class TS extends Error {
}
class I2 extends TS {
}
const j2 = ":";
function _S(...l) {
  if (!l.length)
    throw new I2("No parts to assemble");
  return l.forEach((e) => {
    if (e.trim().length === 0)
      throw new I2("Unable to assemble cache key. One of the parts to assemble is empty");
    if (e.includes(j2))
      throw new I2(
        `Unable to assemble cache key. The separator "${j2}" has been found in a part to assemble ("${e}")`
      );
  }), l.join(j2);
}
var A5;
class RS {
  constructor() {
    O7(this, A5, /* @__PURE__ */ new Map());
  }
  has(e) {
    return k5(this, A5).has(e);
  }
  get(e) {
    const t = k5(this, A5).get(e);
    return t !== void 0 ? t : void 0;
  }
  set(e, t) {
    k5(this, A5).set(e, t);
  }
  getOrSet(e, t) {
    let a = this.get(e);
    return a === void 0 && (a = t(), this.set(e, a)), a;
  }
  clear(e) {
    k5(this, A5).delete(e);
  }
  clearRegExp(e) {
    const t = new RegExp(e);
    Array.from(k5(this, A5).keys()).forEach((a) => {
      a.match(t) && k5(this, A5).delete(a);
    });
  }
  clearAll() {
    k5(this, A5).clear();
  }
}
A5 = new WeakMap();
const kS = new RS(), OS = (l) => {
  const { bffUri: e, token: t } = R7(), a = J1(t), r = I([]), o = I(!1), i = (v) => v.map(({ code_postal: u, ville: h }) => ({
    value: `${u}-${h}`,
    label: `${h} (${u})`,
    codePostal: u,
    ville: h
  })), c = (v) => {
    const u = encodeURIComponent(v), h = _S("ville-de-residence-list", u);
    return kS.getOrSet(
      h,
      () => a.value.get(`${e.value}/localites?query=${u}`).then(({ data: p }) => i(p))
    );
  };
  return r5(l, async () => {
    if (l.value && l.value.length >= 2)
      try {
        if (o.value)
          return;
        o.value = !0, r.value = await c(l.value);
      } finally {
        o.value = !1;
      }
    else
      r.value = [];
  }), { villesDeResidence: r, isSearchingVillesDeResidence: o };
}, sE = /* @__PURE__ */ q({
  __name: "TotemBusinessVilleDeResidence",
  props: /* @__PURE__ */ c5({
    id: { default: `ville-de-residence-${i7()}` },
    name: { default: "ville-de-residence" },
    description: {},
    disabled: { type: Boolean },
    disabledValidate: { type: Boolean },
    enableImmediateValidate: { type: Boolean },
    readonly: { type: Boolean },
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    placeholder: { default: "Saisissez la ville ou le code postal" },
    emptyTitle: {},
    emptyMessage: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ c5(["search"], ["update:modelValue"]),
  setup(l, { expose: e, emit: t }) {
    const a = t, r = H5(l, "modelValue"), o = () => {
      const M = I(), V = (y) => {
        M.value = y, a("search", y);
      }, C = k(
        () => {
          var y;
          return x.value && ((y = x.value) == null ? void 0 : y.length) > 0 ? "danger" : void 0;
        }
      ), S = k({
        get: () => {
          if (!(!r.value || !r.value.codePostal || !r.value.ville))
            return `${r.value.codePostal}-${r.value.ville}`;
        },
        set: (y) => {
          const { codePostal: E, ville: H } = m.value.find((j) => j.value === y) ?? {
            codePostal: void 0,
            ville: void 0
          };
          r.value = { codePostal: E, ville: H };
        }
      }), A = k(() => {
        const y = [...m.value];
        return r.value && r.value.codePostal && r.value.ville && !m.value.find((E) => E.value === S.value) && y.push({
          value: `${r.value.codePostal}-${r.value.ville}`,
          label: `${r.value.ville} (${r.value.codePostal})`,
          codePostal: r.value.codePostal,
          ville: r.value.ville
        }), y;
      });
      return {
        localSearch: M,
        updateSearch: V,
        color: C,
        internalLocalValue: S,
        internalOptions: A
      };
    }, i = () => {
      const M = I([
        {
          validator: async (A) => {
            var y, E, H, j, Z;
            try {
              return await J1(w).value.post(`${g.value}/validation/ville-de-residence`, {
                code_postal: A.value.codePostal,
                ville: A.value.ville
              }), !0;
            } catch (K) {
              if (W.isAxiosError(K) && ((y = K.response) != null && y.status) && ((E = K.response) == null ? void 0 : E.status) === 400)
                try {
                  return (Z = (j = (H = K.response) == null ? void 0 : H.data) == null ? void 0 : j.causes[0]) == null ? void 0 : Z.message;
                } catch {
                  console.error("Mauvais format d'erreur", K);
                }
              return "Le référentiel des villes est actuellement indisponible.";
            }
          }
        }
      ]), V = k(() => ({
        disabled: l.disabled || l.readonly,
        autoValidate: !l.disabledValidate,
        immediate: l.enableImmediateValidate
      })), { errors: C, forceValidationTrue: S } = s7(
        l.id,
        r,
        M,
        V
      );
      return {
        errors: C,
        forceValidationTrue: S
      };
    }, { localSearch: c, updateSearch: v, color: u, internalLocalValue: h, internalOptions: p } = o(), { villesDeResidence: m } = OS(c), { bffUri: g, token: w } = R7(), { errors: x, forceValidationTrue: f } = i();
    return e({
      forceValidationTrue: f
    }), (M, V) => (B(), F(_(U1), {
      details: _(x),
      description: M.description,
      color: _(u),
      label: "Ville de résidence",
      "label-for": M.id,
      "optional-flag": M.optionalFlag,
      "required-flag": M.requiredFlag,
      class: "totem-form-element-ville-de-residence"
    }, N5({
      default: T(() => [
        L(M.$slots, "default", {}, () => [
          X(_(IB), {
            id: M.id,
            modelValue: _(h),
            "onUpdate:modelValue": V[0] || (V[0] = (C) => At(h) ? h.value = C : null),
            options: _(p),
            disabled: M.disabled,
            readonly: M.readonly,
            color: _(u),
            name: M.name,
            placeholder: M.placeholder,
            "empty-title": M.emptyTitle,
            "empty-message": M.emptyMessage,
            "disabled-filter-options": "",
            onSearch: _(v)
          }, null, 8, ["id", "modelValue", "options", "disabled", "readonly", "color", "name", "placeholder", "empty-title", "empty-message", "onSearch"])
        ])
      ]),
      _: 2
    }, [
      M.$slots.header ? {
        name: "header",
        fn: T(() => [
          L(M.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      M.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: T(() => [
          L(M.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      M.$slots.headerFlags ? {
        name: "headerFlags",
        fn: T(() => [
          L(M.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      M.$slots.headerDescription ? {
        name: "headerDescription",
        fn: T(() => [
          L(M.$slots, "headerDescription")
        ]),
        key: "3"
      } : void 0,
      M.$slots.bottom ? {
        name: "bottom",
        fn: T(() => [
          L(M.$slots, "bottom")
        ]),
        key: "4"
      } : void 0,
      M.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: T(() => [
          L(M.$slots, "bottomDetails")
        ]),
        key: "5"
      } : void 0,
      M.$slots.bottomLink ? {
        name: "bottomLink",
        fn: T(() => [
          L(M.$slots, "bottomLink")
        ]),
        key: "6"
      } : void 0
    ]), 1032, ["details", "description", "color", "label-for", "optional-flag", "required-flag"]));
  }
}), dE = ["nom", "nom-naissance", "prenom"];
function cE(l, e) {
  const a = (/* @__PURE__ */ new Map([
    ["nom", Xe],
    ["nom-naissance", Xe],
    ["prenom", xC]
  ])).get(l);
  if (!a)
    throw new Error("Type de dénomination invalide.");
  return a(e);
}
const $S = 300, uE = (l) => {
  const e = T3({
    errors: [],
    suffixIconName: void 0,
    colorCode: void 0
  }), t = () => {
    e.errors = [], e.suffixIconName = void 0, e.colorCode = void 0;
  }, a = (i) => {
    e.errors = i, e.suffixIconName = "warning-triangle", e.colorCode = "danger";
  }, r = () => {
    e.errors = [], e.suffixIconName = void 0, e.colorCode = void 0;
  }, o = dt(() => {
    const { value: i, errors: c, isDisabled: v, isReadonly: u, isRequired: h, isValidated: p } = l.value, m = !Tl(i);
    v || u || m && !h ? t() : p && c.length > 0 ? a(c) : p && r();
  }, $S);
  return r5(l, o, { deep: !0 }), {
    state: k(() => e),
    reset: t,
    saveFailure: a,
    saveSuccess: r
  };
}, vE = {
  install: (l, e) => {
    fS(l, e);
  }
};
export {
  vE as PluginTotemBusiness,
  $S as TOTEM_VALIDATION_DELAY,
  IS as TotemBusinessDenominationPersonnePhysique,
  iE as TotemBusinessIbanBic,
  sE as TotemBusinessVilleDeResidence,
  cE as formatFromTotemTypeDenomination,
  rt as totemApiContextProviderKey,
  AC as totemRuleAllowedChars,
  HC as totemRuleDedupChars,
  DS as totemRuleDenominationPersonnePhysique,
  zC as totemRuleMaxLength,
  CC as totemRuleMultiple,
  EC as totemRuleRequired,
  _C as totemRuleTrimChars,
  dE as totemTypeDenominationCodes,
  J1 as useAxiosInstance,
  R7 as useTotemApiContext,
  uE as useTotemDebouncedValidation,
  s7 as useTotemFieldValidator,
  oE as useTotemForm
};
//# sourceMappingURL=totem-business.es.js.map
